var excludeWords = [
    "MRS",
    "MR",
    "CO",
    "DR",
    "MS",
    "NG",
    "PTY",
    "LTD",
    "IAN",
    "TIM",
    "LEO",
    "NIC",
    "ONG",
    "TU",
    "GUO",
    "DAI",
    "JON",
    "JEZ",
    "LIM",
    "ZOE",
    "DEA",
    "ZYL",
    "EVA",
    "AMY",
    "ROY",
    "AA",
    "AAH",
    "AAL",
    "AAS",
    "AB",
    "ABA",
    "ABB",
    "ABO",
    "ABS",
    "ABY",
    "ACE",
    "ACH",
    "ACT",
    "AD",
    "ADD",
    "ADO",
    "ADS",
    "ADZ",
    "AE",
    "AFF",
    "AFT",
    "AG",
    "AGA",
    "AGE",
    "AGO",
    "AGS",
    "AH",
    "AHA",
    "AHI",
    "AHS",
    "AI",
    "AIA",
    "AID",
    "AIL",
    "AIM",
    "AIN",
    "AIR",
    "AIS",
    "AIT",
    "AKA",
    "AKE",
    "AL",
    "ALA",
    "ALB",
    "ALE",
    "ALF",
    "ALL",
    "ALP",
    "ALS",
    "ALT",
    "ALU",
    "AM",
    "AMA",
    "AME",
    "AMI",
    "AMP",
    "AMU",
    "AN",
    "ANA",
    "AND",
    "ANE",
    "ANI",
    "ANN",
    "ANS",
    "ANT",
    "ANY",
    "APE",
    "APO",
    "APP",
    "APT",
    "AR",
    "ARB",
    "ARC",
    "ARD",
    "ARE",
    "ARF",
    "ARK",
    "ARM",
    "ARS",
    "ART",
    "ARY",
    "AS",
    "ASH",
    "ASK",
    "ASP",
    "AT",
    "ATE",
    "ATS",
    "ATT",
    "AUA",
    "AUE",
    "AUF",
    "AUK",
    "AVA",
    "AVE",
    "AVO",
    "AW",
    "AWA",
    "AWE",
    "AWK",
    "AWL",
    "AWN",
    "AX",
    "AXE",
    "AY",
    "AYE",
    "AYS",
    "AYU",
    "AZO",
    "BA",
    "BAA",
    "BAC",
    "BAD",
    "BAG",
    "BAH",
    "BAL",
    "BAM",
    "BAN",
    "BAP",
    "BAR",
    "BAS",
    "BAT",
    "BAY",
    "BE",
    "BED",
    "BEE",
    "BEG",
    "BEL",
    "BEN",
    "BES",
    "BET",
    "BEY",
    "BEZ",
    "BI",
    "BIB",
    "BID",
    "BIG",
    "BIN",
    "BIO",
    "BIS",
    "BIT",
    "BIZ",
    "BO",
    "BOA",
    "BOB",
    "BOD",
    "BOG",
    "BOH",
    "BOI",
    "BOK",
    "BON",
    "BOO",
    "BOP",
    "BOR",
    "BOS",
    "BOT",
    "BOW",
    "BOX",
    "BOY",
    "BRA",
    "BRO",
    "BRR",
    "BRU",
    "BUB",
    "BUD",
    "BUG",
    "BUN",
    "BUR",
    "BUS",
    "BUT",
    "BUY",
    "BY",
    "BYE",
    "BYS",
    "CAA",
    "CAB",
    "CAD",
    "CAG",
    "CAM",
    "CAN",
    "CAP",
    "CAR",
    "CAT",
    "CAW",
    "CAY",
    "CAZ",
    "CEE",
    "CEL",
    "CEP",
    "CH",
    "CHA",
    "CHE",
    "CHI",
    "CID",
    "CIG",
    "CIS",
    "CIT",
    "CLY",
    "COB",
    "COD",
    "COG",
    "COL",
    "CON",
    "COO",
    "COP",
    "COR",
    "COS",
    "COT",
    "COW",
    "COY",
    "COZ",
    "CRU",
    "CRY",
    "CUB",
    "CUD",
    "CUE",
    "CUP",
    "CUR",
    "CUT",
    "CUZ",
    "CWM",
    "DA",
    "DAB",
    "DAD",
    "DAE",
    "DAG",
    "DAH",
    "DAK",
    "DAL",
    "DAM",
    "DAN",
    "DAP",
    "DAS",
    "DAW",
    "DAY",
    "DE",
    "DEB",
    "DEE",
    "DEF",
    "DEG",
    "DEI",
    "DEL",
    "DEN",
    "DEV",
    "DEW",
    "DEX",
    "DEY",
    "DI",
    "DIB",
    "DID",
    "DIE",
    "DIF",
    "DIG",
    "DIM",
    "DIN",
    "DIP",
    "DIS",
    "DIT",
    "DIV",
    "DO",
    "DOB",
    "DOC",
    "DOD",
    "DOE",
    "DOF",
    "DOG",
    "DOH",
    "DOL",
    "DOM",
    "DON",
    "DOO",
    "DOP",
    "DOR",
    "DOS",
    "DOT",
    "DOW",
    "DOY",
    "DRY",
    "DSO",
    "DUB",
    "DUD",
    "DUE",
    "DUG",
    "DUH",
    "DUI",
    "DUN",
    "DUO",
    "DUP",
    "DUX",
    "DYE",
    "DZO",
    "EA",
    "EAN",
    "EAR",
    "EAS",
    "EAT",
    "EAU",
    "EBB",
    "ECH",
    "ECO",
    "ECU",
    "ED",
    "EDH",
    "EDS",
    "EE",
    "EEK",
    "EEL",
    "EEN",
    "EF",
    "EFF",
    "EFS",
    "EFT",
    "EGG",
    "EGO",
    "EH",
    "EHS",
    "EIK",
    "EKE",
    "EL",
    "ELD",
    "ELF",
    "ELK",
    "ELL",
    "ELM",
    "ELS",
    "ELT",
    "EM",
    "EME",
    "EMF",
    "EMO",
    "EMS",
    "EMU",
    "EN",
    "END",
    "ENE",
    "ENG",
    "ENS",
    "EON",
    "ER",
    "ERA",
    "ERE",
    "ERF",
    "ERG",
    "ERK",
    "ERM",
    "ERN",
    "ERR",
    "ERS",
    "ES",
    "ESS",
    "EST",
    "ET",
    "ETA",
    "ETH",
    "EUK",
    "EVE",
    "EVO",
    "EWE",
    "EWK",
    "EWT",
    "EX",
    "EXO",
    "EYE",
    "FA",
    "FAA",
    "FAB",
    "FAD",
    "FAE",
    "FAH",
    "FAN",
    "FAP",
    "FAR",
    "FAS",
    "FAT",
    "FAW",
    "FAX",
    "FAY",
    "FE",
    "FED",
    "FEE",
    "FEG",
    "FEH",
    "FEM",
    "FEN",
    "FER",
    "FES",
    "FET",
    "FEU",
    "FEW",
    "FEY",
    "FEZ",
    "FIB",
    "FID",
    "FIE",
    "FIG",
    "FIL",
    "FIN",
    "FIR",
    "FIT",
    "FIX",
    "FIZ",
    "FLU",
    "FLY",
    "FOB",
    "FOE",
    "FOG",
    "FOH",
    "FON",
    "FOP",
    "FOR",
    "FOU",
    "FOX",
    "FOY",
    "FRA",
    "FRO",
    "FRY",
    "FUB",
    "FUD",
    "FUG",
    "FUM",
    "FUN",
    "FUR",
    "FY",
    "GAB",
    "GAD",
    "GAE",
    "GAG",
    "GAK",
    "GAL",
    "GAM",
    "GAN",
    "GAP",
    "GAR",
    "GAS",
    "GAT",
    "GAU",
    "GAW",
    "GAY",
    "GED",
    "GEE",
    "GEL",
    "GEM",
    "GEN",
    "GEO",
    "GER",
    "GET",
    "GEY",
    "GHI",
    "GI",
    "GIB",
    "GID",
    "GIE",
    "GIF",
    "GIG",
    "GIN",
    "GIO",
    "GIP",
    "GIS",
    "GIT",
    "GJU",
    "GNU",
    "GO",
    "GOA",
    "GOB",
    "GOD",
    "GOE",
    "GON",
    "GOO",
    "GOR",
    "GOS",
    "GOT",
    "GOV",
    "GOX",
    "GOY",
    "GU",
    "GUB",
    "GUE",
    "GUL",
    "GUM",
    "GUN",
    "GUP",
    "GUR",
    "GUS",
    "GUT",
    "GUV",
    "GUY",
    "GYM",
    "GYP",
    "HA",
    "HAD",
    "HAE",
    "HAG",
    "HAH",
    "HAJ",
    "HAM",
    "HAN",
    "HAO",
    "HAP",
    "HAS",
    "HAT",
    "HAW",
    "HAY",
    "HE",
    "HEH",
    "HEM",
    "HEN",
    "HEP",
    "HER",
    "HES",
    "HET",
    "HEW",
    "HEX",
    "HEY",
    "HI",
    "HIC",
    "HID",
    "HIE",
    "HIM",
    "HIN",
    "HIP",
    "HIS",
    "HIT",
    "HM",
    "HMM",
    "HO",
    "HOA",
    "HOB",
    "HOC",
    "HOD",
    "HOE",
    "HOG",
    "HOH",
    "HOI",
    "HOM",
    "HON",
    "HOO",
    "HOP",
    "HOS",
    "HOT",
    "HOW",
    "HOX",
    "HOY",
    "HUB",
    "HUE",
    "HUG",
    "HUH",
    "HUI",
    "HUM",
    "HUN",
    "HUP",
    "HUT",
    "HYE",
    "HYP",
    "ICE",
    "ICH",
    "ICK",
    "ICY",
    "ID",
    "IDE",
    "IDS",
    "IF",
    "IFF",
    "IFS",
    "IGG",
    "ILK",
    "ILL",
    "IMP",
    "IN",
    "ING",
    "INK",
    "INN",
    "INS",
    "IO",
    "ION",
    "IOS",
    "IRE",
    "IRK",
    "IS",
    "ISH",
    "ISM",
    "ISO",
    "IT",
    "ITA",
    "ITS",
    "IVY",
    "IWI",
    "JA",
    "JAB",
    "JAG",
    "JAI",
    "JAK",
    "JAM",
    "JAR",
    "JAW",
    "JAY",
    "JEE",
    "JET",
    "JEU",
    "JEW",
    "JIB",
    "JIG",
    "JIN",
    "JO",
    "JOB",
    "JOE",
    "JOG",
    "JOL",
    "JOR",
    "JOT",
    "JOW",
    "JOY",
    "JUD",
    "JUG",
    "JUN",
    "JUS",
    "JUT",
    "KA",
    "KAB",
    "KAE",
    "KAF",
    "KAI",
    "KAK",
    "KAM",
    "KAS",
    "KAT",
    "KAW",
    "KAY",
    "KEA",
    "KEB",
    "KED",
    "KEF",
    "KEG",
    "KEN",
    "KEP",
    "KET",
    "KEX",
    "KEY",
    "KHI",
    "KI",
    "KID",
    "KIF",
    "KIN",
    "KIP",
    "KIR",
    "KIS",
    "KIT",
    "KO",
    "KOA",
    "KOB",
    "KOI",
    "KON",
    "KOP",
    "KOR",
    "KOS",
    "KOW",
    "KUE",
    "KY",
    "KYE",
    "KYU",
    "LA",
    "LAB",
    "LAC",
    "LAD",
    "LAG",
    "LAH",
    "LAM",
    "LAP",
    "LAR",
    "LAS",
    "LAT",
    "LAV",
    "LAW",
    "LAX",
    "LAY",
    "LEA",
    "LED",
    "LEE",
    "LEG",
    "LEI",
    "LEK",
    "LEP",
    "LES",
    "LET",
    "LEU",
    "LEV",
    "LEW",
    "LEX",
    "LEY",
    "LEZ",
    "LI",
    "LIB",
    "LID",
    "LIE",
    "LIG",
    "LIN",
    "LIP",
    "LIS",
    "LIT",
    "LO",
    "LOB",
    "LOD",
    "LOG",
    "LOO",
    "LOP",
    "LOR",
    "LOS",
    "LOT",
    "LOU",
    "LOW",
    "LOX",
    "LOY",
    "LUD",
    "LUG",
    "LUM",
    "LUR",
    "LUV",
    "LUX",
    "LUZ",
    "LYE",
    "LYM",
    "MA",
    "MAA",
    "MAC",
    "MAD",
    "MAE",
    "MAG",
    "MAK",
    "MAL",
    "MAM",
    "MAN",
    "MAP",
    "MAR",
    "MAS",
    "MAT",
    "MAW",
    "MAX",
    "MAY",
    "ME",
    "MED",
    "MEE",
    "MEG",
    "MEH",
    "MEL",
    "MEM",
    "MEN",
    "MES",
    "MET",
    "MEU",
    "MEW",
    "MHO",
    "MI",
    "MIB",
    "MIC",
    "MID",
    "MIG",
    "MIL",
    "MIM",
    "MIR",
    "MIS",
    "MIX",
    "MIZ",
    "MM",
    "MNA",
    "MO",
    "MOA",
    "MOB",
    "MOC",
    "MOD",
    "MOE",
    "MOG",
    "MOI",
    "MOL",
    "MOM",
    "MON",
    "MOO",
    "MOP",
    "MOR",
    "MOS",
    "MOT",
    "MOU",
    "MOW",
    "MOY",
    "MOZ",
    "MU",
    "MUD",
    "MUG",
    "MUM",
    "MUN",
    "MUS",
    "MUT",
    "MUX",
    "MY",
    "MYC",
    "NA",
    "NAB",
    "NAE",
    "NAG",
    "NAH",
    "NAM",
    "NAN",
    "NAP",
    "NAS",
    "NAT",
    "NAW",
    "NAY",
    "NE",
    "NEB",
    "NED",
    "NEE",
    "NEF",
    "NEG",
    "NEK",
    "NEP",
    "NET",
    "NEW",
    "NIB",
    "NID",
    "NIE",
    "NIL",
    "NIM",
    "NIP",
    "NIS",
    "NIT",
    "NIX",
    "NO",
    "NOD",
    "NOG",
    "NOH",
    "NOM",
    "NON",
    "NOO",
    "NOR",
    "NOS",
    "NOT",
    "NOW",
    "NOX",
    "NOY",
    "NTH",
    "NU",
    "NUB",
    "NUN",
    "NUR",
    "NUS",
    "NUT",
    "NY",
    "NYE",
    "NYS",
    "OAF",
    "OAK",
    "OAR",
    "OAT",
    "OB",
    "OBA",
    "OBE",
    "OBI",
    "OBO",
    "OBS",
    "OCA",
    "OCH",
    "OD",
    "ODA",
    "ODD",
    "ODE",
    "ODS",
    "OE",
    "OES",
    "OF",
    "OFF",
    "OFT",
    "OH",
    "OHM",
    "OHO",
    "OHS",
    "OI",
    "OIK",
    "OIL",
    "OIS",
    "OKA",
    "OKE",
    "OLD",
    "OLE",
    "OLM",
    "OM",
    "OMS",
    "ON",
    "ONE",
    "ONO",
    "ONS",
    "ONY",
    "OO",
    "OOF",
    "OOH",
    "OOM",
    "OON",
    "OOP",
    "OOR",
    "OOS",
    "OOT",
    "OP",
    "OPE",
    "OPS",
    "OPT",
    "OR",
    "ORA",
    "ORB",
    "ORC",
    "ORD",
    "ORE",
    "ORF",
    "ORS",
    "ORT",
    "OS",
    "OSE",
    "OU",
    "OUD",
    "OUK",
    "OUP",
    "OUR",
    "OUS",
    "OUT",
    "OVA",
    "OW",
    "OWE",
    "OWL",
    "OWN",
    "OWT",
    "OX",
    "OXO",
    "OXY",
    "OY",
    "OYE",
    "OYS",
    "PA",
    "PAC",
    "PAD",
    "PAH",
    "PAL",
    "PAM",
    "PAN",
    "PAP",
    "PAR",
    "PAS",
    "PAT",
    "PAV",
    "PAW",
    "PAX",
    "PAY",
    "PE",
    "PEA",
    "PEC",
    "PED",
    "PEE",
    "PEG",
    "PEH",
    "PEL",
    "PEN",
    "PEP",
    "PER",
    "PES",
    "PET",
    "PEW",
    "PHI",
    "PHO",
    "PHT",
    "PI",
    "PIA",
    "PIC",
    "PIE",
    "PIG",
    "PIN",
    "PIP",
    "PIR",
    "PIS",
    "PIT",
    "PIU",
    "PIX",
    "PLU",
    "PLY",
    "PO",
    "POA",
    "POD",
    "POH",
    "POI",
    "POL",
    "POM",
    "POO",
    "POP",
    "POS",
    "POT",
    "POW",
    "POX",
    "POZ",
    "PRE",
    "PRO",
    "PRY",
    "PSI",
    "PST",
    "PUB",
    "PUD",
    "PUG",
    "PUH",
    "PUL",
    "PUN",
    "PUP",
    "PUR",
    "PUS",
    "PUT",
    "PUY",
    "PYA",
    "PYE",
    "PYX",
    "QAT",
    "QI",
    "QIN",
    "QIS",
    "QUA",
    "RAD",
    "RAG",
    "RAH",
    "RAI",
    "RAJ",
    "RAM",
    "RAN",
    "RAP",
    "RAS",
    "RAT",
    "RAV",
    "RAW",
    "RAX",
    "RAY",
    "RE",
    "REB",
    "REC",
    "RED",
    "REE",
    "REF",
    "REG",
    "REH",
    "REI",
    "REM",
    "REN",
    "REO",
    "REP",
    "RES",
    "RET",
    "REV",
    "REW",
    "REX",
    "REZ",
    "RHO",
    "RHY",
    "RIA",
    "RIB",
    "RID",
    "RIF",
    "RIG",
    "RIM",
    "RIN",
    "RIP",
    "RIT",
    "RIZ",
    "ROB",
    "ROC",
    "ROD",
    "ROE",
    "ROK",
    "ROM",
    "ROO",
    "ROT",
    "ROW",
    "RUB",
    "RUC",
    "RUD",
    "RUE",
    "RUG",
    "RUM",
    "RUN",
    "RUT",
    "RYA",
    "RYE",
    "SAB",
    "SAC",
    "SAD",
    "SAE",
    "SAG",
    "SAI",
    "SAL",
    "SAM",
    "SAN",
    "SAP",
    "SAR",
    "SAT",
    "SAU",
    "SAV",
    "SAW",
    "SAX",
    "SAY",
    "SAZ",
    "SEA",
    "SEC",
    "SED",
    "SEE",
    "SEG",
    "SEI",
    "SEL",
    "SEN",
    "SER",
    "SET",
    "SEW",
    "SEY",
    "SEZ",
    "SH",
    "SHA",
    "SHE",
    "SHH",
    "SHY",
    "SI",
    "SIB",
    "SIC",
    "SIF",
    "SIK",
    "SIM",
    "SIN",
    "SIP",
    "SIR",
    "SIS",
    "SIT",
    "SIX",
    "SKA",
    "SKI",
    "SKY",
    "SLY",
    "SMA",
    "SNY",
    "SO",
    "SOB",
    "SOC",
    "SOD",
    "SOG",
    "SOH",
    "SOL",
    "SOM",
    "SON",
    "SOP",
    "SOS",
    "SOT",
    "SOU",
    "SOV",
    "SOW",
    "SOX",
    "SOY",
    "SOZ",
    "SPA",
    "SPY",
    "SRI",
    "ST",
    "STY",
    "SUB",
    "SUD",
    "SUE",
    "SUG",
    "SUI",
    "SUK",
    "SUM",
    "SUN",
    "SUP",
    "SUQ",
    "SUR",
    "SUS",
    "SWY",
    "SYE",
    "SYN",
    "TA",
    "TAB",
    "TAD",
    "TAE",
    "TAG",
    "TAI",
    "TAJ",
    "TAK",
    "TAM",
    "TAN",
    "TAO",
    "TAP",
    "TAR",
    "TAS",
    "TAT",
    "TAU",
    "TAV",
    "TAW",
    "TAX",
    "TAY",
    "TE",
    "TEA",
    "TEC",
    "TED",
    "TEE",
    "TEF",
    "TEG",
    "TEL",
    "TEN",
    "TES",
    "TET",
    "TEW",
    "TEX",
    "THE",
    "THO",
    "THY",
    "TI",
    "TIC",
    "TID",
    "TIE",
    "TIG",
    "TIK",
    "TIL",
    "TIN",
    "TIP",
    "TIS",
    "TIX",
    "TO",
    "TOC",
    "TOD",
    "TOE",
    "TOG",
    "TOM",
    "TON",
    "TOO",
    "TOP",
    "TOR",
    "TOT",
    "TOW",
    "TOY",
    "TRY",
    "TSK",
    "TUB",
    "TUG",
    "TUI",
    "TUM",
    "TUN",
    "TUP",
    "TUT",
    "TUX",
    "TWA",
    "TWO",
    "TWP",
    "TYE",
    "TYG",
    "UDO",
    "UDS",
    "UEY",
    "UFO",
    "UG",
    "UGH",
    "UGS",
    "UH",
    "UKE",
    "ULE",
    "ULU",
    "UM",
    "UMM",
    "UMP",
    "UMS",
    "UMU",
    "UN",
    "UNI",
    "UNS",
    "UP",
    "UPO",
    "UPS",
    "UR",
    "URB",
    "URD",
    "URE",
    "URN",
    "URP",
    "US",
    "USE",
    "UT",
    "UTA",
    "UTE",
    "UTS",
    "UTU",
    "UVA",
    "VAC",
    "VAE",
    "VAG",
    "VAN",
    "VAR",
    "VAS",
    "VAT",
    "VAU",
    "VAV",
    "VAW",
    "VEE",
    "VEG",
    "VET",
    "VEX",
    "VIA",
    "VID",
    "VIE",
    "VIG",
    "VIM",
    "VIN",
    "VIS",
    "VLY",
    "VOE",
    "VOL",
    "VOR",
    "VOW",
    "VOX",
    "VUG",
    "VUM",
    "WAB",
    "WAD",
    "WAE",
    "WAG",
    "WAI",
    "WAN",
    "WAP",
    "WAR",
    "WAS",
    "WAT",
    "WAW",
    "WAX",
    "WAY",
    "WE",
    "WEB",
    "WED",
    "WEE",
    "WEM",
    "WEN",
    "WET",
    "WEX",
    "WEY",
    "WHA",
    "WHO",
    "WHY",
    "WIG",
    "WIN",
    "WIS",
    "WIT",
    "WIZ",
    "WO",
    "WOE",
    "WOF",
    "WOG",
    "WOK",
    "WON",
    "WOO",
    "WOP",
    "WOS",
    "WOT",
    "WOW",
    "WOX",
    "WRY",
    "WUD",
    "WUS",
    "WYE",
    "WYN",
    "XI",
    "XIS",
    "XU",
    "YA",
    "YAD",
    "YAE",
    "YAG",
    "YAH",
    "YAK",
    "YAM",
    "YAP",
    "YAR",
    "YAW",
    "YAY",
    "YE",
    "YEA",
    "YEH",
    "YEN",
    "YEP",
    "YES",
    "YET",
    "YEW",
    "YEX",
    "YGO",
    "YID",
    "YIN",
    "YIP",
    "YO",
    "YOB",
    "YOD",
    "YOK",
    "YOM",
    "YON",
    "YOU",
    "YOW",
    "YU",
    "YUG",
    "YUK",
    "YUM",
    "YUP",
    "YUS",
    "ZA",
    "ZAG",
    "ZAP",
    "ZAS",
    "ZAX",
    "ZEA",
    "ZED",
    "ZEE",
    "ZEK",
    "ZEL",
    "ZEP",
    "ZEX",
    "ZHO",
    "ZIG",
    "ZIN",
    "ZIP",
    "ZIT",
    "ZIZ",
    "ZO",
    "ZOA",
    "ZOL",
    "ZOO",
    "ZOS",
    "ZUZ",
    "ZZZ",
];

"use strict";
var toTitleCase = function (str) {
    return str.toLowerCase().replace(/\b\w/g, function (l) { return l.toUpperCase(); });
};
var capitalizeRegexp = new RegExp("(?!(" + excludeWords.join("|") + "))(\\b[A-Z]{2,3}\\b)", "gi");
var capitalizeAbbreviations = function (text) {
    //capitalize Abbreviations
    return text.replace(capitalizeRegexp, function (txt) {
        return txt.toUpperCase();
    });
};
var IdMgr;
(function (IdMgr) {
    function YesNo() {
        return function (input) {
            return input ? "Yes" : "No";
        };
    }
    IdMgr.YesNo = YesNo;
    function BuySell() {
        return function (input) {
            if (input == 'B') {
                return 'Buy';
            }
            else if (input == 'S') {
                return 'Sell';
            }
            else {
                return input;
            }
        };
    }
    IdMgr.BuySell = BuySell;
    function NotBefore() {
        return function (items, field, notBeforeDate) {
            var filtered = [];
            angular.forEach(items, function (item) {
                if (moment(item[field]).isAfter(notBeforeDate)) {
                    filtered.push(item);
                }
            });
            return filtered;
        };
    }
    IdMgr.NotBefore = NotBefore;
    function NotAfter() {
        return function (items, field, notAfterDate) {
            var filtered = [];
            angular.forEach(items, function (item) {
                if (moment(item[field]).isBefore(notAfterDate)) {
                    filtered.push(item);
                }
            });
            return filtered;
        };
    }
    IdMgr.NotAfter = NotAfter;
    function DateFilter() {
        return function (items, key, from, to) {
            if (!items) {
                return null;
            }
            var df = moment(from);
            var dt = moment(to);
            var result = [];
            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                var itemDateRaw = item[key];
                var itemDate = moment(itemDateRaw);
                if (itemDate.isSameOrAfter(df) && itemDate.isSameOrBefore(dt)) {
                    result.push(item);
                }
            }
            return result;
        };
    }
    IdMgr.DateFilter = DateFilter;
    function AccountName() {
        return function (input) {
            return capitalizeAbbreviations(toTitleCase(input));
        };
    }
    IdMgr.AccountName = AccountName;
    function TitleCase() {
        return function (items, filterOn) {
            if (filterOn === false) {
                return items;
            }
            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                angular.forEach(items, function (item) {
                    for (var i = 0; i < items.length; i++) {
                        items[i][filterOn] = items[i][filterOn].replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
                    }
                });
            }
            return items;
        };
    }
    IdMgr.TitleCase = TitleCase;
    function Unique() {
        return function (items, filterOn) {
            if (filterOn === false) {
                return items;
            }
            if ((filterOn || angular.isUndefined(filterOn)) && angular.isArray(items)) {
                var hashCheck = {}, newItems = [];
                var extractValueToCompare = function (item) {
                    if (angular.isObject(item) && angular.isString(filterOn)) {
                        return item[filterOn];
                    }
                    else {
                        return item;
                    }
                };
                angular.forEach(items, function (item) {
                    var valueToCheck, isDuplicate = false;
                    for (var i = 0; i < newItems.length; i++) {
                        if (angular.equals(extractValueToCompare(newItems[i]), extractValueToCompare(item))) {
                            isDuplicate = true;
                            break;
                        }
                    }
                    if (!isDuplicate) {
                        newItems.push(item);
                    }
                });
                items = newItems;
            }
            return items;
        };
    }
    IdMgr.Unique = Unique;
    ;
    function Percent() {
        return function (input, precision) {
            precision = precision || 0;
            return (input || 0.0).toFixed(precision) + "%";
        };
    }
    IdMgr.Percent = Percent;
    function PlusMinus() {
        return function (input) {
            return input >= 0 ? "+" : "";
        };
    }
    IdMgr.PlusMinus = PlusMinus;
    function StripHtml() {
        return function (input) {
            return input ? String(input).replace(/<[^>]+>/gm, '') : '';
        };
    }
    IdMgr.StripHtml = StripHtml;
    function ForAccountType() {
        return function (reportTypes, accountType) {
            var filteredList = [];
            angular.forEach(reportTypes, function (reportType, key) {
                if (accountType === "Accolade" || accountType === reportType.accountType) {
                    filteredList.push(reportType);
                }
            });
            return filteredList;
        };
    }
    IdMgr.ForAccountType = ForAccountType;
    function Abs() {
        return function (input) {
            if (input === null || input === undefined) {
                return input;
            }
            else {
                return Math.abs(input);
            }
        };
    }
    IdMgr.Abs = Abs;
    function ConvertNegative() {
        return function (input) {
            if (input && input.indexOf("-") === 0) {
                input = String(input).replace('-', '');
                var openingParethensis = "(";
                input = openingParethensis.concat(input, ")");
            }
            return input;
        };
    }
    IdMgr.ConvertNegative = ConvertNegative;
})(IdMgr || (IdMgr = {}));
var filtersModule = angular.module("app.filters", []);
filtersModule.filter("yesNo", IdMgr.YesNo);
filtersModule.filter("buySell", IdMgr.BuySell);
filtersModule.filter("notBefore", IdMgr.NotBefore);
filtersModule.filter("notAfter", IdMgr.NotAfter);
filtersModule.filter("unique", IdMgr.Unique);
filtersModule.filter("dateFilter", IdMgr.DateFilter);
filtersModule.filter("percent", IdMgr.Percent);
filtersModule.filter("plusMinus", IdMgr.PlusMinus);
filtersModule.filter("stripHtml", IdMgr.StripHtml);
filtersModule.filter("forAccountType", IdMgr.ForAccountType);
filtersModule.filter("abs", IdMgr.Abs);
filtersModule.filter("titleCase", IdMgr.TitleCase);
filtersModule.filter("accountName", IdMgr.AccountName);
filtersModule.filter("convertNegative", IdMgr.ConvertNegative);

'use strict';
var Patersons;
(function (Patersons) {
    (function (PdfFormatHint) {
        PdfFormatHint[PdfFormatHint["None"] = 0] = "None";
        PdfFormatHint[PdfFormatHint["Currency"] = 1] = "Currency";
        PdfFormatHint[PdfFormatHint["Currency4decPts"] = 2] = "Currency4decPts";
    })(Patersons.PdfFormatHint || (Patersons.PdfFormatHint = {}));
    var PdfFormatHint = Patersons.PdfFormatHint;
    var HeaderTable = (function () {
        function HeaderTable() {
            this.content = {
                style: { fontSize: 8 },
                margin: [-4, 8, 0, 5],
                table: {
                    widths: ['auto', '*', 'auto', 'auto'],
                    body: []
                }
            };
        }
        HeaderTable.prototype.addRow = function (nameLeft, valueLeft, nameRight, valueRight) {
            this.content.table.body.push([
                { border: [false, false, false, false], text: nameLeft, style: { bold: true, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: valueLeft, style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: nameRight, style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: valueRight, style: { bold: false, alignment: 'right', fontSize: 8.5 } }]);
            return this;
        };
        return HeaderTable;
    }());
    var PdfTable = (function () {
        function PdfTable(userCompany) {
            this.userCompany = userCompany;
        }
        PdfTable.prototype.setTitle = function (titleText) {
            var headerStyle = titleText ? 'filledHeader' : '';
            this.tableTitle = {
                style: "tableTitle",
                table: {
                    widths: ['*'],
                    body: [[{ text: titleText, style: headerStyle }]]
                },
                layout: 'noBorders'
            };
            return this;
        };
        PdfTable.prototype.setNormalText = function (titleText) {
            this.tableTitle = {
                table: {
                    widths: ['*'],
                    body: [[{ text: titleText }]]
                },
                layout: 'noBorders'
            };
            return this;
        };
        PdfTable.prototype.setContent = function (dataRows, fieldnames, headings, formatHints, lastRowIsFooter) {
            /*if (fieldnames.length !== headings.length) {
              throw new RangeError('Number of headings should match number of fields in the table.');
            }
      
            if (formatHints !== null && formatHints !== undefined && fieldnames.length !== formatHints.length) {
              throw new RangeError('Number of format hints should match number of fields in the table.');
            }*/
            var headerRow;
            var content = [];
            if (headings != null) {
                headerRow = this.buildHeadings(headings);
                content.push(headerRow);
            }
            var bodyRows = this.buildBody(dataRows, fieldnames, formatHints, lastRowIsFooter);
            content = content.concat(bodyRows);
            var columnWidths = this.calculateColumnWidths(fieldnames.length, content, lastRowIsFooter);
            if (content)
                this.tableBody = {
                    layout: this.getTableLayout(headings, lastRowIsFooter),
                    table: {
                        widths: columnWidths,
                        headerRows: 1,
                        body: content
                    }
                };
            return this;
        };
        PdfTable.prototype.getTableLayout = function (headings, lastRowIsFooter) {
            var _this = this;
            if (headings && lastRowIsFooter) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === node.table.body.length - 1) {
                            return _this.userCompany.colorSecondary;
                        }
                        else {
                            return 'lightgray';
                        }
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    }
                };
            }
            if (!lastRowIsFooter) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 1) {
                            return _this.userCompany.colorSecondary;
                        }
                        else {
                            return 'lightgray';
                        }
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    }
                };
            }
            else {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === node.table.body.length - 1) {
                            return 'lightgray';
                        }
                        else {
                            return 'lightgray';
                        }
                    },
                    vLineWidth: function (i, node) {
                        return 0;
                    }
                };
            }
        };
        PdfTable.prototype.setContentAligned = function (dataRows, fieldnames, headings, formatHints, lastRowIsFooter) {
            /*if (fieldnames.length !== headings.length) {
              throw new RangeError('Number of headings should match number of fields in the table.');
            }
      
            if (formatHints !== undefined && fieldnames.length !== formatHints.length) {
              throw new RangeError('Number of format hints should match number of fields in the table.');
            }*/
            var headerRow;
            var content = [];
            if (headings != null) {
                headerRow = this.buildHeadingsAligned(headings);
                content.push(headerRow);
            }
            var bodyRows = this.buildBody(dataRows, fieldnames, formatHints, lastRowIsFooter);
            content = content.concat(bodyRows);
            var columnWidths = this.calculateColumnWidths(fieldnames.length, content, lastRowIsFooter);
            if (content)
                this.tableBody = {
                    layout: this.getTableLayout(headings, lastRowIsFooter),
                    table: {
                        widths: columnWidths,
                        headerRows: 1,
                        body: content
                    }
                };
            return this;
        };
        PdfTable.prototype.hasTitle = function () {
            return this.tableTitle !== undefined;
        };
        PdfTable.prototype.hasBody = function () {
            return this.tableBody !== undefined;
        };
        PdfTable.prototype.getTitle = function () {
            return this.tableTitle;
        };
        PdfTable.prototype.getBody = function () {
            return this.tableBody;
        };
        PdfTable.prototype.buildHeadings = function (headings) {
            var headerRow = [];
            for (var _i = 0, headings_1 = headings; _i < headings_1.length; _i++) {
                var heading = headings_1[_i];
                headerRow.push({ border: [false, false, false, true], text: heading, style: 'tableHeader' });
            }
            return headerRow;
        };
        PdfTable.prototype.buildHeadingsAligned = function (headings) {
            var headerRow = [];
            for (var _i = 0, headings_2 = headings; _i < headings_2.length; _i++) {
                var heading = headings_2[_i];
                if (heading.type === "number")
                    headerRow.push({ border: [false, false, false, true], text: heading.text, style: 'tableHeaderNumeric' });
                else
                    headerRow.push({ border: [false, false, false, true], text: heading.text, style: 'tableHeader' });
            }
            return headerRow;
        };
        PdfTable.prototype.buildBody = function (dataRows, fieldnames, formatHints, lastRowIsFooter) {
            var tableContent = [];
            for (var i = 0; i < dataRows.length; i++) {
                var dataRow = dataRows[i];
                var tableRow = [];
                for (var j = 0; j < fieldnames.length; j++) {
                    var field = fieldnames[j];
                    var formatHint = (formatHints !== undefined && formatHints != null) ? formatHints[j] : PdfFormatHint.None;
                    var isFooterRow = lastRowIsFooter && i === dataRows.length - 1;
                    if (isFooterRow) {
                        if (j === 0) {
                            dataRow[field] = "Total";
                            formatHint = PdfFormatHint.None;
                        }
                        tableRow.push(this.buildTableFooterCell(dataRow[field], formatHint));
                    }
                    else {
                        tableRow.push(this.buildTableCell(dataRow[field], formatHint));
                    }
                }
                tableContent.push(tableRow);
            }
            return tableContent;
        };
        PdfTable.prototype.buildTableCell = function (dataField, formatHint) {
            var cell = {
                border: [false, false, false, true],
                text: this.interpretFormatHint(dataField, formatHint),
                style: 'tableCell'
            };
            if (typeof dataField === 'number') {
                cell.style = 'tableCellNumeric';
            }
            return cell;
        };
        PdfTable.prototype.buildTableFooterCell = function (dataField, formatHint) {
            if (!dataField) {
                dataField = "";
            }
            var cell = {
                text: this.interpretFormatHint(dataField, formatHint),
                "border": [false, true, false, false],
                style: 'footerCell'
            };
            if (typeof dataField === 'number') {
                cell.style = 'footerCellNumeric';
            }
            return cell;
        };
        PdfTable.prototype.interpretFormatHint = function (dataField, formatHint) {
            if (!dataField)
                return "";
            switch (formatHint) {
                case PdfFormatHint.None:
                    return dataField.toString();
                case PdfFormatHint.Currency:
                    return this.formatAsCurrency(dataField);
                case PdfFormatHint.Currency4decPts:
                    return this.formatAsCurrency4DecPts(dataField);
                default:
                    return this.toString();
            }
        };
        PdfTable.prototype.addCommas = function (nStr) {
            nStr = nStr + '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        };
        PdfTable.prototype.formatAsCurrency4DecPts = function (amount) {
            /*if (value === null || value === undefined) {
              return undefined;
            }
      
            if (typeof value === 'number') {
              return value.toFixed(2);
            } else {
              return value;
            }*/
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            return amount.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        };
        PdfTable.prototype.formatAsCurrency = function (amount) {
            /*if (value === null || value === undefined) {
              return undefined;
            }
      
            if (typeof value === 'number') {
              return value.toFixed(2);
            } else {
              return value;
            }*/
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            var i = parseFloat(amount);
            if (isNaN(i)) {
                i = 0.00;
            }
            var minus = '';
            if (i < 0) {
                minus = '-';
            }
            i = Math.abs(i);
            i = parseInt(((i + .005) * 100).toString());
            i = i / 100;
            var s = i.toString();
            if (s.indexOf('.') < 0) {
                s += '.00';
            }
            if (s.indexOf('.') === (s.length - 2)) {
                s += '0';
            }
            s = minus + s;
            return this.addCommas(s);
        };
        PdfTable.prototype.calculateColumnWidths = function (numberOfColumns, tableContent, lastRowIsFooter) {
            var columnWidths = this.initialiseColumnWidths(numberOfColumns);
            var widestColumn = 0;
            for (var rowIndex = 0; rowIndex < tableContent.length; rowIndex++) {
                var row = tableContent[rowIndex];
                if (lastRowIsFooter && rowIndex === tableContent.length - 1) {
                    continue;
                }
                for (var i = 0; i < row.length; i++) {
                    if (row[i].text && row[widestColumn].text) {
                        if (row[i].text.length > row[widestColumn].text.length) {
                            widestColumn = i;
                        }
                    }
                }
            }
            columnWidths[widestColumn] = '*';
            return columnWidths;
        };
        PdfTable.prototype.initialiseColumnWidths = function (numberOfColumns) {
            return Array.apply(null, Array(numberOfColumns)).map(function (v) { return 'auto'; });
        };
        return PdfTable;
    }());
    var PdfBuilder = (function () {
        function PdfBuilder(base64logo, userCompany) {
            this.filename = this.generateDefaultFilename();
            this.headings = new Array();
            this.footer = new Array();
            this.tables = new Array();
            this.headerTable = new HeaderTable();
            this.base64logo = base64logo;
            this.userCompany = userCompany;
            this.styles = {
                logo: {
                    margin: [0, 0, 0, 10],
                    alignment: 'right'
                },
                tableTitle: {
                    fontSize: 8,
                    margin: [0, 15, 0, 0]
                },
                header: {
                    fontSize: 16,
                    bold: false,
                    margin: [0, 0, 0, 0],
                    color: userCompany.colorSecondary
                },
                filledSubHeader: {
                    bold: true,
                    fontSize: 8,
                    color: 'black',
                    fillColor: '#D8D8D8',
                    margin: [5, 2, 2, 2],
                    alignment: 'left'
                },
                subHeader: {
                    fontSize: 13,
                    bold: false,
                    margin: [0, 5, 0, 10],
                    color: userCompany.colorSecondary
                },
                headerText: {
                    margin: [0, 0, 0, 3],
                    fontSize: 6,
                },
                footerText: {
                    fontSize: 5,
                    bold: false,
                    alignment: 'center'
                },
                tableHeader: {
                    fontSize: 8,
                    bold: true,
                    color: userCompany.colorSecondary,
                },
                tableHeaderNumeric: {
                    fontSize: 8,
                    bold: true,
                    color: userCompany.colorSecondary,
                    alignment: 'right'
                },
                filledHeader: {
                    bold: true,
                    fontSize: 8,
                    color: 'white',
                    fillColor: userCompany.colorSecondary,
                    margin: [5, 2, 2, 2],
                    alignment: 'left'
                },
                filledHoldingsHeader: {
                    bold: true,
                    fontSize: 8,
                    color: 'black',
                    fillColor: 'lightgray',
                    margin: [10, 2, 2, 2],
                },
                footerCell: {
                    bold: true,
                    border: [false, false, false, false],
                    fontSize: 8,
                    alignment: 'left'
                },
                tableCell: {
                    fontSize: 8,
                    margin: [0, 0, 0, 0],
                    alignment: 'left'
                },
                tableCellBold: {
                    fontSize: 8,
                    bold: true,
                    margin: [0, 0, 0, 0],
                    alignment: 'left'
                },
                tableCellNumeric: {
                    fontSize: 8,
                    margin: [0, 0, 0, 0],
                    alignment: 'right'
                },
                footerCellNumeric: {
                    bold: true,
                    border: [false, false, false, false],
                    fontSize: 8,
                    alignment: 'right'
                },
                numericValue: {
                    alignment: 'right'
                }
            };
            this.docDefinition = {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [56, 28, 56, 70],
                style: { font: 'arial' },
                content: [
                    this.getImageContent()
                ],
                styles: this.styles,
                footer: function (currentPage, pageCount, pageSize) {
                    var footerPDF = userCompany && userCompany.footerPDF;
                    var footerDisclaimerItems = [];
                    if (footerPDF) {
                        var $elem = $("<div>" + footerPDF + "<div>");
                        $("p", $elem).each(function () {
                            footerDisclaimerItems.push({
                                text: $(this).text(),
                                style: 'footerText'
                            });
                        });
                    }
                    var footer = [
                        {
                            "fontSize": 1,
                            margin: [56, 0, 56, 5],
                            layout: {
                                hLineColor: function (i, node) {
                                    return 'lightgray';
                                }
                            },
                            "table": {
                                "widths": ["*"],
                                "headerRows": 1,
                                "body": [
                                    [
                                        { "border": [false, false, false, true], "text": " ", "alignment": "left" },
                                    ],
                                ]
                            }
                        },
                    ];
                    footer = footer.concat(footerDisclaimerItems);
                    footer.push({
                        margin: [56, 0, 56, 0],
                        style: { fontSize: 5 },
                        table: {
                            widths: ['*', '*'],
                            body: [
                                [
                                    { "border": [false, false, false, false], 'text': moment().tz('Australia/Sydney').format('D MMM YYYY h:mm:ss A [AEST]'), "style": { 'alignment': 'left' } },
                                    { "border": [false, false, false, false], 'text': 'Page ' + currentPage + ' of ' + pageCount, "style": { 'alignment': 'right' } }
                                ]
                            ]
                        }
                    });
                    return footer;
                }
            };
        }
        PdfBuilder.prototype.getImageContent = function () {
            return {
                image: this.base64logo,
                style: this.styles.logo,
                width: 141,
                height: 43
            };
        };
        PdfBuilder.prototype.setFilename = function (filename) {
            this.filename = filename;
            return this;
        };
        PdfBuilder.prototype.setTitle = function (titleText) {
            this.titleText = titleText;
            return this;
        };
        PdfBuilder.prototype.setSubTitle = function (subTitleText) {
            this.subTitleText = subTitleText;
            return this;
        };
        PdfBuilder.prototype.addHeaderTableRow = function (nameLeft, valueLeft, nameRight, valueRight) {
            this.headerTable.addRow(nameLeft, valueLeft, nameRight, valueRight);
            return this;
        };
        PdfBuilder.prototype.addHeading = function (headingText) {
            this.headings.push(headingText);
            return this;
        };
        PdfBuilder.prototype.addFooter = function (footerText) {
            this.footer.push(footerText);
            return this;
        };
        PdfBuilder.prototype.addTable = function (titleText, dataRows, fieldNames, headings, formatHints, lastRowIsTotal) {
            var table = new PdfTable(this.userCompany);
            if (dataRows == null) {
                dataRows = [];
            }
            if (!dataRows || dataRows.length === 0) {
                return this;
            }
            this.tables.push(table
                .setTitle(titleText)
                .setContent(dataRows, fieldNames, headings, formatHints, lastRowIsTotal));
            return this;
        };
        PdfBuilder.prototype.addTableAligned = function (titleText, dataRows, fieldNames, headings, formatHints, lastRowIsTotal) {
            var table = new PdfTable(this.userCompany);
            if (dataRows == null) {
                dataRows = [];
            }
            if (!dataRows || dataRows.length === 0) {
                return this;
            }
            this.tables.push(table
                .setTitle(titleText)
                .setContentAligned(dataRows, fieldNames, headings, formatHints, lastRowIsTotal));
            return this;
        };
        PdfBuilder.prototype.addNormalText = function (titleText) {
            var table = new PdfTable(this.userCompany);
            this.tables.push(table.setNormalText(titleText));
            return this;
        };
        // Optionally pass in a pre-built document definition, which is just an array
        // of content items, as supported by PdfMake.
        PdfBuilder.prototype.build = function (injectedContent) {
            this.pushTitle();
            this.pushSubTitle();
            this.pushHeaderTable();
            this.pushAllHeadings();
            if (injectedContent && injectedContent.length > 0) {
                this.injectContent(injectedContent);
            }
            else {
                this.pushAllTables();
            }
            //this.pushFooter();
            //console.log(JSON.stringify(this.docDefinition.content));
            return pdfMake.createPdf(this.docDefinition).download(this.filename + '.pdf');
        };
        // Optionally pass in a pre-built document definition, which is just an array
        // of content items, as supported by PdfMake.
        PdfBuilder.prototype.buildContent = function (injectedContent) {
            this.pushTitle();
            this.pushSubTitle();
            this.pushHeaderTable();
            this.pushAllHeadings();
            if (injectedContent && injectedContent.length > 0) {
                this.injectContent(injectedContent);
            }
            else {
                this.pushAllTables();
            }
            //this.pushFooter();
            return this.docDefinition;
        };
        PdfBuilder.prototype.pushTitle = function () {
            if (this.titleText !== undefined) {
                this.docDefinition.content.push({ text: this.titleText, style: 'header' });
            }
        };
        PdfBuilder.prototype.pushSubTitle = function () {
            if (this.subTitleText !== undefined) {
                this.docDefinition.content.push({ text: this.subTitleText, style: 'subHeader' });
            }
        };
        PdfBuilder.prototype.pushHeaderTable = function () {
            if (this.headerTable !== undefined) {
                this.docDefinition.content.push(this.headerTable.content);
            }
        };
        PdfBuilder.prototype.pushAllHeadings = function () {
            var i;
            for (i = 0; i < this.headings.length; i++) {
                this.docDefinition.content.push({ text: this.headings[i], style: 'headerText' });
            }
        };
        PdfBuilder.prototype.getFooter = function () {
            var footerContent = [];
            var i;
            if (this.footer.length > 0) {
                footerContent.push({ text: ' ', fontSize: 8 });
                // add footer line
                footerContent.push({
                    "fontSize": 8,
                    layout: {
                        hLineColor: function (i, node) {
                            return 'lightgray';
                        }
                    },
                    "table": {
                        "widths": ["*"],
                        "headerRows": 1,
                        "body": [
                            [
                                { "border": [false, false, false, true], "text": " ", "alignment": "left" },
                            ],
                        ]
                    }
                });
                footerContent.push({ text: ' ', fontSize: 5 });
            }
            for (i = 0; i < this.footer.length; i++) {
                footerContent.push({ text: this.footer[i], style: 'footerText' });
            }
            return footerContent;
        };
        PdfBuilder.prototype.pushFooter = function () {
            var i;
            if (this.footer.length > 0) {
                this.docDefinition.content.footer.push({ text: ' ', fontSize: 8 });
                // add footer line
                this.docDefinition.content.footer.push({
                    "fontSize": 8,
                    layout: {
                        hLineColor: function (i, node) {
                            return 'lightgray';
                        }
                    },
                    "table": {
                        "widths": ["*"],
                        "headerRows": 1,
                        "body": [
                            [
                                { "border": [false, false, false, true], "text": " ", "alignment": "left" },
                            ],
                        ]
                    }
                });
                this.docDefinition.content.footer.push({ text: ' ', fontSize: 5 });
            }
            for (i = 0; i < this.footer.length; i++) {
                this.docDefinition.content.footer.push({ text: this.footer[i], style: 'footerText' });
            }
        };
        PdfBuilder.prototype.injectContent = function (injectedContent) {
            this.docDefinition.content = this.docDefinition.content.concat(injectedContent);
        };
        PdfBuilder.prototype.pushAllTables = function () {
            for (var _i = 0, _a = this.tables; _i < _a.length; _i++) {
                var table = _a[_i];
                if (table.hasTitle()) {
                    this.docDefinition.content.push(table.getTitle());
                }
                if (table.hasBody()) {
                    this.docDefinition.content.push(table.getBody());
                }
            }
        };
        PdfBuilder.prototype.generateDefaultFilename = function () {
            // Generate a pseudorandom 16-character string using [0-9a-z].
            var randomString = (Math.random().toString(36) + '00000000000000000').slice(2, 18);
            var timeStamp = new Date();
            return randomString + '-' + timeStamp.toISOString();
        };
        return PdfBuilder;
    }());
    Patersons.PdfBuilder = PdfBuilder;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PDFBuilderService = (function () {
        function PDFBuilderService($q, userCompanyService) {
            this.q = $q;
            this.userCompanyService = userCompanyService;
        }
        PDFBuilderService.prototype.toDataUrl = function (url, callback) {
            try {
                var xhr = new XMLHttpRequest();
                xhr.onload = function () {
                    var reader = new FileReader();
                    reader.onloadend = function () {
                        callback(reader.result);
                    };
                    reader.readAsDataURL(xhr.response);
                };
                xhr.open('GET', url);
                xhr.responseType = 'blob';
                xhr.send();
            }
            catch (error) {
                callback(null);
            }
        };
        PDFBuilderService.prototype.newPdfBuilderInstance = function () {
            var _this = this;
            var deferred = this.q.defer();
            this.userCompanyService.getUserCompany().then(function (company) {
                if (!_this.base64logo) {
                    _this.toDataUrl(company.companyPdfImage, function (image) {
                        if (image) {
                            _this.base64logo = image;
                        }
                        else {
                            console.error("Could not get logo");
                        }
                        var pdfBuilder = new Patersons.PdfBuilder(_this.base64logo, company);
                        deferred.resolve(pdfBuilder);
                    });
                }
                else {
                    var pdfBuilder = new Patersons.PdfBuilder(_this.base64logo, company);
                    deferred.resolve(pdfBuilder);
                }
            });
            return deferred.promise;
        };
        ;
        PDFBuilderService.$inject = ['$q', 'userCompanyService'];
        return PDFBuilderService;
    }());
    Patersons.PDFBuilderService = PDFBuilderService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var CsvBuilder = (function () {
        function CsvBuilder() {
            this.filename = this.generateDefaultFilename();
            this.headers = new Array();
            this.data = new Array();
        }
        CsvBuilder.prototype.setFilename = function (filename) {
            if (filename !== null && filename !== undefined) {
                this.filename = filename;
            }
            return this;
        };
        CsvBuilder.prototype.setTopLine = function (topLine) {
            this.topLine = topLine;
            return this;
        };
        CsvBuilder.prototype.setHeaders = function (headers) {
            this.headers = headers;
            return this;
        };
        CsvBuilder.prototype.setData = function (data) {
            this.data = data;
            return this;
        };
        CsvBuilder.prototype.build = function () {
            var blob = this.createCsvFile(this.headers, this.data);
            this.makeCsv(blob);
        };
        CsvBuilder.prototype.makeCsv = function (csvBlob) {
            this.filename += '.csv';
            this.saveFile(this.filename, csvBlob);
        };
        CsvBuilder.prototype.saveFile = function (name, data) {
            if (data !== null && navigator.msSaveBlob)
                return navigator.msSaveBlob(data, name);
            var a = $("<a style='display: none;'/>");
            var url = window.URL.createObjectURL(data);
            a.attr("href", url);
            a.attr("download", name);
            $("body").append(a);
            a[0].click();
            window.URL.revokeObjectURL(url);
            a.remove();
        };
        CsvBuilder.prototype.createCsvFile = function (headers, data) {
            var EOL = '\r\n';
            var csvContent = "";
            if (this.topLine != null) {
                csvContent = '"' + this.topLine + '"' + EOL;
            }
            csvContent = csvContent + headers.
                map(function (header) { return '"' + header + '"'; }).
                join(',') + EOL;
            for (var _i = 0, data_1 = data; _i < data_1.length; _i++) {
                var row = data_1[_i];
                var rowItems = [];
                for (var _a = 0, row_1 = row; _a < row_1.length; _a++) {
                    var field = row_1[_a];
                    var val = field;
                    if (typeof val === 'string') {
                        val = val.replace(/"/g, '""');
                    }
                    if (typeof val === 'number') {
                        rowItems.push(val);
                    }
                    else {
                        rowItems.push('"' + val + '"');
                    }
                }
                csvContent += rowItems.join(',') + EOL;
            }
            return new Blob([csvContent], { type: 'text/csv;charset=utf-8' });
        };
        CsvBuilder.prototype.generateDefaultFilename = function () {
            // Generate a pseudorandom 16-character string using [0-9a-z].
            var randomString = (Math.random().toString(36) + '00000000000000000').slice(2, 18);
            var timeStamp = new Date();
            return randomString + '-' + timeStamp.toISOString();
        };
        return CsvBuilder;
    }());
    Patersons.CsvBuilder = CsvBuilder;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var TokenService = (function () {
        function TokenService() {
            var model = document.getElementById("model").textContent.trim();
            var dictionary = JSON.parse(model);
            this.oauthSettings = dictionary['oauthSettings'];
            this.tokenManager = new OidcTokenManager(this.oauthSettings);
        }
        return TokenService;
    }());
    Patersons.TokenService = TokenService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var BearerInjector = (function () {
        function BearerInjector($q, tokenService) {
            var _this = this;
            this.request = function (config) {
                if (config.url.indexOf(_this.baseUrl, 0) == 0 || config.url.indexOf("assets/templates") == 0) {
                    var token = _this.tokenService.tokenManager.access_token;
                    if (token) {
                        console.log('Adding authorization header for request: ' + config.url);
                        config.headers['Authorization'] = 'Bearer ' + token;
                    }
                }
                return config;
            };
            this.responseError = function (response) {
                var x = response;
                console.log(response);
                if (response.status === 401 && response.config.url.indexOf("https://api-global.morningstar.com") === -1) {
                    //Store current URL to redirect back to it after login.
                    window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                    _this.tokenService.tokenManager.redirectForToken();
                }
                if (response.status === 403) {
                }
                return _this.q.reject(response);
            };
            this.q = $q;
            this.tokenService = tokenService;
            var model = document.getElementById("model").textContent.trim();
            var dictionary = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
        }
        BearerInjector.$inject = ['$q', 'tokenService'];
        return BearerInjector;
    }());
    Patersons.BearerInjector = BearerInjector;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SelectionService = (function () {
        function SelectionService($log) {
            this.log = $log;
        }
        SelectionService.prototype.getSelectedAccount = function (accounts) {
            var _this = this;
            if (accounts && accounts.length > 0) {
                var account = accounts.filter(function (x) { return x.accountId == _this.selectedAccountId; })[0];
                if (account == null) {
                    return accounts[0];
                }
                return account;
            }
            return null;
        };
        SelectionService.$inject = ['$log'];
        return SelectionService;
    }());
    Patersons.SelectionService = SelectionService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var BaseService = (function () {
        function BaseService($http, $log, $state, $q, tokenService) {
            this.http = $http;
            this.log = $log;
            this.tokenService = tokenService;
            this.state = $state;
            this.q = $q;
            var model = document.getElementById("model").textContent.trim();
            var dictionary = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
        }
        BaseService.prototype.get = function (url) {
            var _this = this;
            var absoluteUrl = this.baseUrl + url;
            this.log.info("GET - " + absoluteUrl);
            var cancel = this.q.defer();
            var config = {
                timeout: cancel.promise,
                cancel: cancel,
                headers: {}
            };
            return this.http.get(absoluteUrl, config)
                .then(function (response) {
                return _this.mapResponseData(response);
            }, function (reason) {
                return _this.errorHandler(reason, "Error calling GET on " + absoluteUrl);
            });
        };
        BaseService.prototype.post = function (url, data) {
            var _this = this;
            var absoluteUrl = this.baseUrl + url;
            this.log.info("POST - " + absoluteUrl);
            this.log.info(data);
            return this.http.post(absoluteUrl, data)
                .then(function (response) {
                return _this.mapResponseData(response);
            }, function (reason) {
                return _this.errorHandler(reason, "Error calling POST on " + absoluteUrl);
            });
        };
        BaseService.prototype.patch = function (url, data) {
            var _this = this;
            var absoluteUrl = this.baseUrl + url;
            this.log.info("PATCH - " + absoluteUrl);
            this.log.info(data);
            return this.http.patch(absoluteUrl, data)
                .then(function (response) {
                return _this.mapResponseData(response);
            }, function (reason) {
                return _this.errorHandler(reason, "Error calling PATCH on " + absoluteUrl);
            });
        };
        BaseService.prototype.put = function (url, data) {
            var _this = this;
            var absoluteUrl = this.baseUrl + url;
            this.log.info("PUT - " + absoluteUrl);
            this.log.info(data);
            return this.http.put(absoluteUrl, data)
                .then(function (response) {
                return _this.mapResponseData(response);
            }, function (reason) {
                return _this.errorHandler(reason, "Error calling PUT on " + absoluteUrl);
            });
        };
        BaseService.prototype.delete = function (url) {
            var _this = this;
            var absoluteUrl = this.baseUrl + url;
            this.log.info("DELETE - " + absoluteUrl);
            return this.http.delete(absoluteUrl)
                .then(function (response) {
                return _this.mapResponseData(response);
            }, function (reason) {
                return _this.errorHandler(reason, "Error calling DELETE on " + absoluteUrl);
            });
        };
        BaseService.prototype.errorHandler = function (reason, msg) {
            msg = msg || "Unexpected Error";
            if (reason.data && reason.data.exceptionMessage) {
                this.log.error(reason.data);
            }
            if (reason.status === 401) {
                //Unauthorized
                //Store current URL to redirect back to it after login.
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
            }
            if (reason.status === 403) {
                // forbidden
                if (reason.data != 'Please verify code send via SMS') {
                    this.state.go('forbidden');
                }
            }
            /*if (reason.status === 404) {
                // forbidden
                this.state.go('otherwise');
            }*/
            /*if (reason.status === 500) {
                // internal server error
                this.state.go('error');
            }*/
            throw reason;
        };
        BaseService.prototype.mapResponseData = function (response) {
            console.log(response.config.url);
            if (response.data !== null &&
                response.data !== undefined &&
                response.data.value !== null &&
                response.data.value !== undefined) {
                return response.data.value;
            }
            else if (response.data !== undefined &&
                response.data !== null) {
                return response.data;
            }
            else {
                return response;
            }
        };
        BaseService.$inject = ['$http', '$log', '$state', '$q', 'tokenService'];
        return BaseService;
    }());
    Patersons.BaseService = BaseService;
})(Patersons || (Patersons = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var IdentityService = (function (_super) {
        __extends(IdentityService, _super);
        function IdentityService() {
            _super.apply(this, arguments);
        }
        IdentityService.prototype.triggerForgottenPan = function (forgottenPanDetails) {
            return this.post("/identity/api/account/ForgottenPan", forgottenPanDetails);
        };
        ;
        IdentityService.prototype.triggerForgottenPassword = function (forgottenPasswordDetails) {
            return this.post("/identity/api/account/ForgottenPassword", forgottenPasswordDetails);
        };
        ;
        IdentityService.prototype.changePassword = function (changePasswordDetails) {
            return this.post("/identity/api/account/ChangePassword", changePasswordDetails);
        };
        ;
        IdentityService.prototype.changeEmail = function (changeEmailDetails) {
            return this.post("/identity/api/account/ChangeEmail", changeEmailDetails);
        };
        ;
        IdentityService.prototype.changeMobileNumber = function (phoneDetails) {
            return this.post("/identity/api/account/ChangeMobileNumber", phoneDetails);
        };
        ;
        IdentityService.prototype.confirmMobileNumberChange = function (phoneDetails) {
            return this.post("/identity/api/account/ConfirmSms", phoneDetails);
        };
        ;
        IdentityService.prototype.setPassword = function (setPasswordDetails) {
            return this.post("/identity/api/account/SetPassword", setPasswordDetails);
        };
        ;
        IdentityService.prototype.request2FAToken = function () {
            return this.post("/identity/api/account/Request2FAToken", null);
        };
        ;
        IdentityService.prototype.getSkipMobileRegistration = function () {
            return this.get("/identity/api/account/GetSkipMobileRegistration");
        };
        ;
        IdentityService.prototype.getIsPhoneNumberVerifyed = function () {
            return this.get("/identity/api/account/IsPhoneNumberVerifyed");
        };
        ;
        IdentityService.prototype.getPhoneNumber = function () {
            return this.get("/identity/api/account/GetPhoneNumber");
        };
        ;
        IdentityService.prototype.getUserAddressDetails = function () {
            return this.get("/identity/api/account/GetUserAddressDetails");
        };
        IdentityService.prototype.saveSkipMobileRegistration = function (skipMobileDetails) {
            return this.post("/identity/api/account/SaveSkipMobileRegistration", skipMobileDetails);
        };
        ;
        return IdentityService;
    }(Patersons.BaseService));
    Patersons.IdentityService = IdentityService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var AnalysisService = (function (_super) {
        __extends(AnalysisService, _super);
        function AnalysisService() {
            _super.apply(this, arguments);
        }
        AnalysisService.prototype.getWatchlists = function () {
            return this.get("/dataService/odata/watchlists");
        };
        ;
        AnalysisService.prototype.getAWatchlist = function (watchlistId) {
            return this.get("/dataService/odata/watchlists(" + watchlistId + ")");
        };
        ;
        AnalysisService.prototype.patchWatchlist = function (watchlist) {
            return this.patch("/dataService/odata/watchlists(" + watchlist.id + ')', watchlist);
        };
        ;
        AnalysisService.prototype.postWatchlist = function (newWatchlist) {
            return this.post("/dataService/odata/watchlists", newWatchlist);
        };
        ;
        AnalysisService.prototype.deleteWatchlist = function (watchlistId) {
            return this.delete("/dataService/odata/watchlists(" + watchlistId + ")");
        };
        ;
        return AnalysisService;
    }(Patersons.BaseService));
    Patersons.AnalysisService = AnalysisService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SessionTimeoutModalCtrl = (function () {
        function SessionTimeoutModalCtrl($scope, $uibModalInstance, currentState) {
            this.scope = $scope;
            this.scope.currentState = currentState;
            this.modalInstance = $uibModalInstance;
            this.scope.events = this;
        }
        SessionTimeoutModalCtrl.prototype.close = function (data) {
            this.modalInstance.close(data);
        };
        ;
        SessionTimeoutModalCtrl.prototype.dismiss = function (data) {
            this.modalInstance.dismiss(data);
        };
        ;
        SessionTimeoutModalCtrl.$inject = ['$scope', '$uibModalInstance', 'currentState'];
        return SessionTimeoutModalCtrl;
    }());
    Patersons.SessionTimeoutModalCtrl = SessionTimeoutModalCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SessionService = (function () {
        function SessionService(tokenService, $rootScope, $uibModal, $uibModalStack, $analytics) {
            var _this = this;
            this.sessionTimeoutHandler = null;
            this.sessionPreTimeoutHandler = null;
            this.sessionTimeoutKey = '$psl.sessionTimeout';
            this.tokenService = tokenService;
            this.modalInstance = $uibModal;
            this.modalStack = $uibModalStack;
            this.$analytics = $analytics;
            $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                var session = _this.checkSession();
                // if (!session) {
                //     event.preventDefault();
                //     return;
                // }
            });
        }
        SessionService.prototype.setSessionExpiringModal = function () {
            var _this = this;
            this.modalStack.dismissAll();
            this.openModal = this.modalInstance.open({
                templateUrl: 'assets/templates/common/sessionTimeoutModal.html',
                size: 'sm',
                controller: Patersons.SessionTimeoutModalCtrl,
                keyboard: false,
                backdrop: 'static',
                openedClass: 'timeout-modal',
                resolve: {
                    currentState: function () { return 'expiring'; }
                }
            }).result.then(function (result) {
                if (result == 'yes') {
                    _this.checkSession();
                }
            });
        };
        SessionService.prototype.setSessionExpiredModal = function () {
            var _this = this;
            this.modalStack.dismissAll();
            this.openModal = this.modalInstance.open({
                templateUrl: 'assets/templates/common/sessionTimeoutModal.html',
                size: 'sm',
                controller: Patersons.SessionTimeoutModalCtrl,
                keyboard: false,
                backdrop: 'static',
                openedClass: 'timeout-modal',
                resolve: {
                    currentState: function () { return 'expired'; }
                }
            }).result.then(function (result) {
                if (result == 'ok') {
                    _this.handleSessionTimedout();
                }
            });
        };
        SessionService.prototype.checkSession = function () {
            var _this = this;
            console.log('checking timeout');
            var sessionTimeoutExists = localStorage.getItem(this.sessionTimeoutKey);
            var now = new Date();
            var timeout = new Date(+sessionTimeoutExists);
            var isLoggedIn = this.isLoggedIn();
            var timeoutInMinutes = 20;
            clearTimeout(this.sessionTimeoutHandler);
            clearTimeout(this.sessionPreTimeoutHandler);
            if (isLoggedIn) {
                if ((now > timeout) && sessionTimeoutExists) {
                    console.log('timedout');
                    //need to log user out here
                    this.setSessionExpiredModal();
                    return false;
                }
                else {
                    var timeout_1 = now.getTime() + (timeoutInMinutes * 60 * 1000); // add x minutes
                    console.log('extending session');
                    localStorage.setItem(this.sessionTimeoutKey, timeout_1.toString());
                    this.sessionPreTimeoutHandler = setTimeout(function () {
                        console.log("Timeout is coming up");
                        _this.setSessionExpiringModal();
                    }, (timeout_1 - (1 * 60 * 1000)) - now.getTime()); // 1 minute before
                    this.sessionTimeoutHandler = setTimeout(function () {
                        console.log("Timeout is past");
                        _this.setSessionExpiredModal();
                    }, (timeout_1) - now.getTime()); // timeout has passed
                    return true;
                }
            }
            else {
                localStorage.removeItem(this.sessionTimeoutKey);
                return true;
            }
        };
        SessionService.prototype.handleSessionTimedout = function () {
            window.stop();
            localStorage.removeItem(this.sessionTimeoutKey);
            this.$analytics.eventTrack('Logout Session Timed Out', {
                category: 'Logout'
            });
            window.location = "/identity/connect/endsession";
            // this.tokenService.tokenManager.redirectForLogout();
            return false;
        };
        SessionService.prototype.login = function () {
            window.localStorage.setItem('$psl.redirect_uri', window.location.href);
            this.tokenService.tokenManager.redirectForToken();
        };
        SessionService.prototype.logout = function () {
            this.$analytics.eventTrack('Logout Success', {
                category: 'Logout'
            });
            this.tokenService.tokenManager.removeToken();
            window.location = "/identity/connect/endsession";
            // this.tokenService.tokenManager.redirectForLogout();
        };
        SessionService.prototype.isLoggedIn = function () {
            return this.tokenService.tokenManager && !this.tokenService.tokenManager.expired;
        };
        SessionService.prototype.getCurrentUserProfile = function () {
            if (this.isLoggedIn()) {
                return this.tokenService.tokenManager.profile;
            }
            else {
                this.login();
            }
        };
        SessionService.$inject = ['tokenService', '$rootScope', '$uibModal', '$uibModalStack', '$analytics'];
        return SessionService;
    }());
    Patersons.SessionService = SessionService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SizeDetectorService = (function () {
        function SizeDetectorService() {
            this.initSizeDetector();
        }
        SizeDetectorService.prototype.initSizeDetector = function () {
            var _this = this;
            console.log("initializing size detector");
            $(document).ready(function ($) {
                _this.$html = $('html');
                $(window).resize(function () {
                    _this.checkWidth();
                });
                //Fire it when the page first loads:
                _this.checkWidth();
            });
        };
        SizeDetectorService.prototype.checkWidth = function () {
            var windowWidth = document.body.clientWidth;
            this.$html.removeClass('table-xSmall table-small table-medium table-large');
            if (windowWidth < 569) {
                return this.$html.addClass('table-small');
            }
            else if (windowWidth >= 569 && windowWidth < 1024) {
                return this.$html.addClass('table-medium');
            }
            else if (windowWidth > 1024) {
                return this.$html.addClass('table-large');
            }
        };
        ;
        return SizeDetectorService;
    }());
    Patersons.SizeDetectorService = SizeDetectorService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var MorningStarService = (function () {
        function MorningStarService() {
            this.getRecentResearch = function (filterBy1Year) {
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        url: "https://content.morningstar.com.au/equityxml/customResearchReportXml?client=canaccordgenuity&format=json&v=2&rowsreturn=everything",
                        type: "GET",
                    }).then(function (res) {
                        if (res && res.customArcResearchList) {
                            if (filterBy1Year) {
                                var oneYearAgo = new Date();
                                oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1);
                                var filteredItems = res.customArcResearchList.filter(function (item) {
                                    var date = new Date(item.dateWritten);
                                    return date >= oneYearAgo;
                                });
                                resolve(filteredItems);
                            }
                            else {
                                resolve(res.customArcResearchList);
                            }
                        }
                        else {
                            resolve(null);
                        }
                    }).fail(function (res) {
                        resolve(res);
                    });
                });
            };
            this.getASXAnnouncementsDocument = function (path) {
                var query = {
                    path: path
                };
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        url: "/financeService/Morningstar/GetASXAnnouncementDocument",
                        data: query,
                        type: "GET",
                    }).then(function (res) {
                        resolve(res);
                    }).fail(function (res) {
                        resolve(res);
                    });
                });
            };
            this.getASXAnnouncements = function (asxcode, dateRange, page) {
                var query = {};
                if (asxcode) {
                    query.asxcode = asxcode;
                }
                if (dateRange) {
                    query.dateRange = dateRange;
                }
                if (page) {
                    query.page = page;
                }
                return new Promise(function (resolve, reject) {
                    $.ajax({
                        url: "/financeService/Morningstar/GetASXAnnouncements",
                        data: query,
                        type: "GET",
                    }).then(function (res) {
                        resolve(res);
                    }).fail(function (res) {
                        resolve(res);
                    });
                });
            };
        }
        MorningStarService.prototype.mapAgilityExchangeCodeToMIC = function (exchangeCode) {
            switch (exchangeCode) {
                case "HKE":
                case "HKG":
                    exchangeCode = "EX$$$$XHKG";
                    break;
                case "SGX":
                case "SES":
                    exchangeCode = "EX$$$$XSES";
                    break;
                case "NAS":
                    exchangeCode = "EX$$$$XNAS";
                    break;
                case "NYS":
                    exchangeCode = "EX$$$$XNYS";
                    break;
                case "AME":
                case "ASE":
                    exchangeCode = "EX$$$$XASE";
                    break;
                case "LSE":
                case "LON":
                    exchangeCode = "EX$$$$XLON";
                    break;
                case "ETR":
                case "FRA":
                    exchangeCode = "EX$$$$XFRA";
                    break;
                case "PAR":
                    exchangeCode = "EX$$$$XPAR";
                    break;
                case "ARC":
                case "ARCX":
                    exchangeCode = "EX$$$$ARCX";
                    break;
                case "AMS":
                    exchangeCode = "EX$$$$XAMS";
                    break;
                case "MAD":
                case "MCE":
                    exchangeCode = "EX$$$$XMCE";
                    break;
                case "MTA":
                case "MIL":
                    exchangeCode = "EX$$$$XMIL";
                    break;
                case "AXW":
                case "ASX":
                    exchangeCode = "EX$$$$XASX";
                    break;
                default:
                    exchangeCode = "UNL";
                    break;
            }
            return exchangeCode;
        };
        MorningStarService.prototype.getMorningStarDataForSecurityCode = function (exchangeCode, securityCode) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (!exchangeCode || !securityCode) {
                    resolve(null);
                    return;
                }
                // replace : with . for the M* API
                var symbol = securityCode.replace(/:/g, ".");
                // need to append 0 to HKG/KHE security codes
                if (exchangeCode == "HKE" || exchangeCode == "HKG") {
                    symbol = "0" + symbol;
                }
                $.ajax({
                    url: "https://lt.morningstar.com/api/rest.svc/4ostbpo1me/security/screener?page=1&pageSize=1&sortOrder=name=asc&outputType=json&version=1&languageId=en-AU&currencyId=AUD&universeIds=UNIVE$$ALL&securityDataPoints=holdingTypeId%7CSecId%7CAPIR%7CName%7CExchangeCode%7CSymbol%7CFundShareClassId&filters=ExchangeID:EQ:" + _this.mapAgilityExchangeCodeToMIC(exchangeCode) + "|Symbol:EQ:" + symbol,
                    type: "GET",
                }).then(function (res) {
                    if (res.total > 0) {
                        resolve(res.rows[0]);
                    }
                    else {
                        resolve(null);
                    }
                }).fail(function (res) {
                    resolve(res);
                });
            });
        };
        MorningStarService.prototype.getMorningStarDataForSecurityId = function (securityId) {
            return new Promise(function (resolve, reject) {
                $.ajax({
                    url: "https://lt.morningstar.com/api/rest.svc/4ostbpo1me/security/screener?page=1&pageSize=1&sortOrder=name=asc&outputType=json&version=1&languageId=en-AU&currencyId=AUD&universeIds=UNIVE$$ALL&securityDataPoints=holdingTypeId%7CSecId%7CAPIR%7CName%7CExchangeCode%7CSymbol%7CFundShareClassId&filters=SecId:EQ:" + securityId,
                    type: "GET",
                }).then(function (res) {
                    if (res.total > 0) {
                        resolve(res.rows[0]);
                    }
                    else {
                        resolve(null);
                    }
                }).fail(function (res) {
                    resolve(res);
                });
            });
        };
        return MorningStarService;
    }());
    Patersons.MorningStarService = MorningStarService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var NavigationService = (function () {
        function NavigationService() {
            this.sections = ['dashboard', 'portfolio', 'analysis', 'research'];
        }
        NavigationService.prototype.activateSection = function (section) {
            this.deactivateAll();
            var sectionDiv = angular.element(document.querySelector('#' + section + '-section'));
            sectionDiv.addClass('active-section');
        };
        NavigationService.prototype.deactivateSection = function (section) {
            var sectionDiv = angular.element(document.querySelector('#' + section + '-section'));
            sectionDiv.removeClass('active-section');
        };
        NavigationService.prototype.deactivateAll = function () {
            for (var _i = 0, _a = this.sections; _i < _a.length; _i++) {
                var section = _a[_i];
                var sectionDiv = angular.element(document.querySelector('#' + section + '-section'));
                sectionDiv.removeClass('active-section');
            }
        };
        return NavigationService;
    }());
    Patersons.NavigationService = NavigationService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ClientConfigService = (function (_super) {
        __extends(ClientConfigService, _super);
        function ClientConfigService() {
            _super.apply(this, arguments);
        }
        ClientConfigService.prototype.getAdviser = function () {
            return this.get("/dataService/api/adviser");
        };
        ;
        ClientConfigService.prototype.getChangeRequestCount = function () {
            return this.get("/dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApprovalCount");
        };
        return ClientConfigService;
    }(Patersons.BaseService));
    Patersons.ClientConfigService = ClientConfigService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    (function (ResearchPublicationType) {
        ResearchPublicationType[ResearchPublicationType["AustralianInvestor"] = "AustralianInvestor"] = "AustralianInvestor";
        ResearchPublicationType[ResearchPublicationType["MorningMarket"] = "MorningMarket"] = "MorningMarket";
        ResearchPublicationType[ResearchPublicationType["WeeklyMarketWrap"] = "WeeklyMarketWrap"] = "WeeklyMarketWrap";
    })(Patersons.ResearchPublicationType || (Patersons.ResearchPublicationType = {}));
    var ResearchPublicationType = Patersons.ResearchPublicationType;
    var MyDetailsService = (function (_super) {
        __extends(MyDetailsService, _super);
        function MyDetailsService() {
            _super.apply(this, arguments);
        }
        MyDetailsService.prototype.getAccoladeOptions = function () {
            return this.get("/dataService/odata/accoladeoptions/Holdings.GetByUserId");
        };
        ;
        MyDetailsService.prototype.updateAccoladeOptions = function (accoladeOptions) {
            return this.put("/dataService/odata/accoladeoptions(" + accoladeOptions.id + ")", accoladeOptions);
        };
        ;
        MyDetailsService.prototype.getResearchSubscriptions = function () {
            return this.get("/dataService/api/ResearchSubscriptions");
        };
        ;
        MyDetailsService.prototype.getResearchSubscription = function (publication) {
            return this.get("/dataService/api/ResearchSubscriptions/" + publication);
        };
        ;
        MyDetailsService.prototype.updateResearchSubscriptions = function (data) {
            return this.patch("/dataService/api/ResearchSubscriptions", data.reduce(function (acc, curr) {
                if (curr.enabled) {
                    acc[curr.id] = curr.isSubscribed;
                }
                return acc;
            }, {}));
        };
        ;
        return MyDetailsService;
    }(Patersons.BaseService));
    Patersons.MyDetailsService = MyDetailsService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioService = (function (_super) {
        __extends(PortfolioService, _super);
        function PortfolioService($http, $log, $state, $q, tokenService) {
            _super.call(this, $http, $log, $state, $q, tokenService);
            this.portfolios = {};
            this.portfolioOrder = [];
        }
        PortfolioService.prototype.getPortfolioOrder = function () {
            var _this = this;
            this.portfolioOrder = [];
            return this.get("/dataService/api/Portfolios/GetPortfolioOrder").then(function (results) {
                _this.portfolioOrder = results;
            }, function (reason) {
                console.log('No order data loaded ');
                _this.log.error(reason);
            });
        };
        PortfolioService.prototype.getPortfolios = function (accounts) {
            var _this = this;
            this.portfolios = {};
            if (!Array.isArray(accounts)) {
                accounts = [accounts];
            }
            var allPromises = new Array();
            var _loop_1 = function() {
                var accountCode = accounts[i];
                foundPortolio = this_1.portfolios[accountCode];
                if (foundPortolio === undefined) {
                    this_1.log.debug("Load portfolio with accountCode: " + accountCode);
                    allPromises.push(this_1.get("/dataService/api/Portfolios/" + accountCode)
                        .then(function (results) {
                        _this.log.info(results);
                        results.summaryError = false;
                        _this.portfolios[accountCode] = results;
                        _this.log.info(_this.portfolios[accountCode]);
                    }, function (reason) {
                        // error handling: can't get account details
                        console.log('No account data loaded ' + accountCode);
                        var accountPlaceholder = new Patersons.Account();
                        accountPlaceholder.accountId = accountCode;
                        accountPlaceholder.accountName = 'Currently Unavailable';
                        accountPlaceholder.summaryError = true;
                        _this.portfolios[accountCode] = accountPlaceholder;
                        _this.log.info(_this.portfolios[accountCode]);
                        _this.log.error(reason);
                    }));
                }
            };
            var this_1 = this;
            var foundPortolio;
            for (var i = 0; i < accounts.length; i++) {
                _loop_1();
            }
            return Promise.all(allPromises);
        };
        PortfolioService.prototype.getCombinedPortfolioData = function () {
            var _this = this;
            if (!this.tokenService.tokenManager.profile) {
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
                // this.state.go('dashboard')
                throw "Get Profile first";
            }
            var acccounts = [];
            if (this.tokenService.tokenManager.profile["account"]) {
                if (this.tokenService.tokenManager.profile["account"] instanceof Array) {
                    acccounts = this.tokenService.tokenManager.profile["account"];
                }
                else {
                    acccounts = [this.tokenService.tokenManager.profile["account"]];
                }
            }
            var agacccounts = [];
            if (this.tokenService.tokenManager.profile["agaccount"]) {
                if (this.tokenService.tokenManager.profile["agaccount"] instanceof Array) {
                    agacccounts = this.tokenService.tokenManager.profile["agaccount"];
                }
                else {
                    agacccounts = [this.tokenService.tokenManager.profile["agaccount"]];
                }
            }
            acccounts = acccounts.concat(agacccounts);
            return new Promise(function (resolve, reject) {
                _this.getPortfolios(acccounts)
                    .then(function (result) {
                    return _this.getPortfolioOrder();
                })
                    .then(function (result) {
                    _this.log.info('All portfolios loaded' + _this.portfolios);
                    var accounts = new Array();
                    for (var key in _this.portfolios) {
                        _this.log.info(key);
                        var account = _this.portfolios[key];
                        account.isAuthorisedAgentAccount = (agacccounts.indexOf(account.accountId) > -1);
                        accounts.push(account);
                    }
                    // order the accounts
                    var accountsOrdered = new Array();
                    _this.portfolioOrder.forEach(function (portfolioOrder) {
                        var account = accounts.filter(function (account) {
                            return account.accountId === portfolioOrder.accountId;
                        });
                        if (account && account[0]) {
                            accountsOrdered.push(account[0]);
                        }
                    });
                    // add the rest of the accounts as before
                    accounts.sort(function (a, b) {
                        return a.accountId > b.accountId ? 1 : ((b.accountId > a.accountId) ? -1 : 0);
                    }).forEach(function (account) {
                        if (accountsOrdered.indexOf(account) === -1) {
                            accountsOrdered.push(account);
                        }
                    });
                    resolve(accountsOrdered);
                });
            });
        };
        ;
        PortfolioService.prototype.getPortfolioData = function () {
            var _this = this;
            if (!this.tokenService.tokenManager.profile) {
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
            }
            var acccounts = [];
            if (this.tokenService.tokenManager.profile["account"] instanceof Array) {
                acccounts = this.tokenService.tokenManager.profile["account"];
            }
            else {
                acccounts = [this.tokenService.tokenManager.profile["account"]];
            }
            return this.getPortfolios(acccounts)
                .then(function (result) {
                _this.log.info('All portfolios loaded' + _this.portfolios);
                var accounts = new Array();
                for (var key in _this.portfolios) {
                    _this.log.info(key);
                    var account = _this.portfolios[key];
                    account.isAuthorisedAgentAccount = false;
                    accounts.push(account);
                }
                return accounts.sort(function (a, b) {
                    return a.accountId > b.accountId ? 1 : ((b.accountId > a.accountId) ? -1 : 0);
                });
            });
        };
        ;
        // get dashboard -> account -> header values
        PortfolioService.prototype.getTopSectors = function (accountCode) {
            return this.get("/dataService/api/shares/" + accountCode + "/topSectors");
        };
        PortfolioService.prototype.getTopAssetClass = function (accountCode) {
            return this.get("/dataService/api/shares/" + accountCode + "/topAssetClass");
        };
        PortfolioService.prototype.getAccoladeTopSectors = function (accountCode) {
            return this.get("/dataService/api/shares/" + accountCode + "/AccoladeTopSectors");
        };
        PortfolioService.prototype.getAccoladeTopAssetClass = function (accountCode) {
            return this.get("/dataService/api/shares/" + accountCode + "/AccoladeTopAssetClass");
        };
        PortfolioService.prototype.getAccoladeHoldings = function (accountCode) {
            return this.get("/dataService/api/shares/" + accountCode + "/AccoladeHoldings");
        };
        PortfolioService.prototype.updateTaxFileNumber = function (accountCode, taxFileNumber, taxFileNumberType) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetTaxFileNumber', '{"Number": "' + taxFileNumber + '", "TaxFileNumberType": "' + taxFileNumberType + '"}');
        };
        PortfolioService.prototype.updateBankDetails = function (accountCode, bankDetails) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetBankAccount', bankDetails);
        };
        ;
        PortfolioService.prototype.updateAllBankDetails = function (accountCode, bankDetails) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetAllBankAccounts', bankDetails);
        };
        ;
        PortfolioService.prototype.updatePostalAddressDetails = function (accountCode, addressDetail) {
            return this.post("/dataService/api/Portfolios/" + accountCode + "/SetPostalAddress", addressDetail);
        };
        ;
        PortfolioService.prototype.updateResidentialAddressDetails = function (accountCode, addressDetail) {
            return this.post("/dataService/api/Portfolios/" + accountCode + "/SetResidentialAddress", addressDetail);
        };
        ;
        PortfolioService.prototype.updateRegistrationAddressDetails = function (accountCode, addressDetail) {
            return this.post("/dataService/api/Portfolios/" + accountCode + "/SetRegistrationAddress", addressDetail);
        };
        ;
        /*updateAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
            return this.post("/dataService/api/Portfolios/" + accountCode + "/SetAddress", addressDetail);
        };
    
        updateSensitiveAddressDetails(accountCode: string, addressDetail: Address): ng.IHttpPromise<any> {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetSensitiveAddress', addressDetail);
        };*/
        PortfolioService.prototype.updateEmailAddress = function (accountCode, emailAddress) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetEmailAddress', emailAddress);
        };
        ;
        PortfolioService.prototype.updateSensitiveEmailAddress = function (accountCode, emailAddress) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetSensitiveEmailAddress', emailAddress);
        };
        ;
        PortfolioService.prototype.updatePhoneNumbers = function (accountCode, account) {
            return this.post('/dataService/api/Portfolios/' + accountCode + '/SetPhoneNumber', account);
        };
        ;
        PortfolioService.prototype.getInternationalShares = function (accountId) {
            return this.get("/dataService/api/Shares/" + accountId + '/International');
        };
        ;
        PortfolioService.prototype.getInternationalSharesForHoldings = function (account) {
            if (account.accountType && account.accountType.toUpperCase() === 'STANDARD') {
                return this.get("/dataService/api/Shares/" + account.accountId + '/InternationalStandard');
            }
            else {
                return this.get("/dataService/api/Shares/" + account.accountId + '/InternationalAccolade');
            }
        };
        ;
        PortfolioService.prototype.getShares = function (accountId) {
            return this.get("/dataService/api/Shares/" + accountId);
        };
        ;
        PortfolioService.prototype.getCombinedShares = function (accountId) {
            return this.get("/dataService/api/Shares/" + accountId + "/All");
        };
        ;
        PortfolioService.prototype.getCashAccounts = function (accountId) {
            return this.get("/dataService/api/CashAccounts/" + accountId);
        };
        ;
        PortfolioService.prototype.getHighInterestCashAccounts = function (accountId) {
            return this.get("/dataService/api/CashAccounts/" + accountId + "/HighInterest");
        };
        ;
        PortfolioService.prototype.getTermDeposits = function (accountId) {
            return this.get("/dataService/api/TermDeposits/" + accountId);
        };
        ;
        PortfolioService.prototype.getPortfolioValue = function (account) {
            if (account.accountType && account.accountType.toUpperCase() === 'STANDARD') {
                return this.get("/dataService/api/StandardPortfolioValue/" + account.accountId);
            }
            else {
                return this.get("/dataService/api/AccoladePortfolioValue/" + account.accountId);
            }
        };
        ;
        PortfolioService.prototype.getBackdatedPortfolioData = function (accountCode, asAt) {
            return this.get("/dataService/api/BackdatedHolding/" + accountCode + "/" + moment(asAt).format("YYYY-MM-DD"));
        };
        ;
        PortfolioService.prototype.getContractNotes = function (accountCode, dateFrom, dateTo) {
            return this.get("/dataService/api/ContractNotes/" + accountCode + "/" + moment(dateFrom).format("YYYY-MM-DD") + "/" + moment(dateTo).format("YYYY-MM-DD"));
        };
        ;
        PortfolioService.prototype.getMarketOrders = function (accountCode) {
            return this.get("/dataService/api/MarketOrders/" + accountCode);
        };
        ;
        PortfolioService.prototype.getOrderDepthData = function (securityCode) {
            return this.get("/financeService/OrderDepth/" + securityCode);
        };
        ;
        PortfolioService.prototype.placeOrderRequest = function (details) {
            return this.post("/dataService/odata/OrderRequests", details);
        };
        ;
        PortfolioService.prototype.getOrderRequests = function () {
            return this.get("/dataService/odata/OrderRequests/");
        };
        ;
        PortfolioService.prototype.createCancelOrder = function (order) {
            return this.post("/dataService/odata/OrderRequests", order);
        };
        ;
        PortfolioService.$inject = ['$http', '$log', '$state', '$q', 'tokenService'];
        return PortfolioService;
    }(Patersons.BaseService));
    Patersons.PortfolioService = PortfolioService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ReportService = (function (_super) {
        __extends(ReportService, _super);
        function ReportService() {
            _super.apply(this, arguments);
        }
        ReportService.prototype.getFile = function (url) {
            var _this = this;
            this.log.info("reportService getting binary pdf data for" + url);
            return this.http.get(url, { responseType: 'arraybuffer' })
                .then(function (data) {
                var file = new Blob([data], { type: 'application/pdf' });
                var fileURL = URL.createObjectURL(file);
                window.open(fileURL);
            }, function (reason) { return _this.errorHandler(reason, "Error retrieving binary pdf data"); });
        };
        ;
        ReportService.prototype.getAllAccoladeNotifications = function () {
            this.log.info("reportService getting investor docs notifications");
            return this.get('/dataService/api/InvestorDocs/GetAllNotifications');
        };
        ReportService.prototype.acknowledgeAccoladeNotifications = function () {
            this.log.info("reportService acknolegding investor docs notifications");
            return this.get('/dataService/api/InvestorDocs/AcknowledgeAllNotifications');
        };
        ReportService.prototype.getReport = function (reportType, accountCode, dateFrom, dateTo) {
            return this.get("/dataService/api/Reporting?reportType=" + reportType + "&accountCode=" + accountCode + "&dateFrom=" + dateFrom.toISOString() + "&dateTo=" + dateTo.toISOString());
        };
        ;
        ReportService.prototype.checkFreezeWindow = function () {
            return this.get("/dataService/api/Reporting/CheckFreezeWindow");
        };
        ;
        return ReportService;
    }(Patersons.BaseService));
    Patersons.ReportService = ReportService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ReportDownloadService = (function () {
        function ReportDownloadService($q, $filter, pdfBuilderService, userCompanyService) {
            var _this = this;
            this.q = $q;
            this.filter = $filter;
            this.pdfBuilderService = pdfBuilderService;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.userCompany = company;
            });
            this.pdfBuilderService.newPdfBuilderInstance().then(function (pdfBuilder) {
                _this.pdfBuilder = pdfBuilder;
            });
        }
        ReportDownloadService.prototype.downloadPdfFile = function (report, account) {
            var _this = this;
            this.report = report;
            this.account = account;
            var fileName = this.getFileName();
            this.getPdfTemplateDefinition().then(function (def) {
                var reportDefinition = _this.getReportDefinition(def);
                //console.log(JSON.stringify(reportDefinition));
                pdfMake.createPdf(reportDefinition).download(fileName + '.pdf');
            });
        };
        ;
        ReportDownloadService.prototype.downloadCsvFile = function (report, account) {
            this.report = report;
            this.account = account;
            var fileName = this.getFileName();
            this.makeCsv(fileName + '.csv');
        };
        ;
        ReportDownloadService.prototype.makeCsv = function (filename) {
            var blob = this.createCsvFile();
            if (window.navigator.msSaveOrOpenBlob) {
                navigator.msSaveBlob(blob, filename);
            }
            else {
                var downloadLink = document.createElement('a');
                downloadLink.href = window.URL.createObjectURL(blob);
                downloadLink.target = '_blank';
                downloadLink.setAttribute('download', filename);
                document.body.appendChild(downloadLink);
                downloadLink.click();
                downloadLink.remove();
            }
        };
        //pdf and csv download
        ReportDownloadService.prototype.getReportDefinition = function (doc) {
            switch (this.report.reportType) {
                case Patersons.ReportType.CapitalTransactions:
                    return this.getCapitalTransactionStatement(doc);
                case Patersons.ReportType.QuarterlyReports:
                    return this.getQuarterlyReportsReport(doc);
                case Patersons.ReportType.Cash:
                    return this.getCashReport(doc);
                case Patersons.ReportType.Income:
                    return this.getIncomeReport(doc);
                case Patersons.ReportType.CapitalGains:
                    return this.getCapitalGainsReport(doc);
                case Patersons.ReportType.UnrealisedCapitalGains:
                    return this.getUnrealisedCapitalGainsReport(doc);
                case Patersons.ReportType.Performance:
                    return this.getPerformanceReport(doc);
                case Patersons.ReportType.TaxReports:
                    return this.getTaxReportsReport(doc);
                case Patersons.ReportType.Valuation:
                    return this.getValuationStatement(doc);
                case Patersons.ReportType.StandardLedger:
                    return this.getStandardLedger(doc);
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
        };
        ReportDownloadService.prototype.getColumnDefinitions = function (reportType) {
            switch (reportType) {
                case Patersons.ReportType.CapitalTransactions:
                    return {
                        columnNames: ['tradeDate', 'settlementDate', 'quantity', 'code', 'description', 'unitPrice', 'grossAmount', 'brokerage', 'gst', 'netAmount'],
                        /*displayNames: [
                          { text: 'Trade Date', alignment: 'left'},
                          { text: 'Settlement Date',  alignment: 'left'},
                          { text: 'Quantity',  alignment: 'right'},
                          { text: 'Code',  alignment: 'left'},
                          { text: 'Description',  alignment: 'left'},
                          { text: 'Unit Price',  alignment: 'right'},
                          { text: 'Gross Amount',  alignment: 'right'},
                          { text: 'Brokerage',  alignment: 'right'},
                          { text: 'GST',  alignment: 'right'},
                          { text: 'Net Amount', alignment: 'right'},
                        ],*/
                        displayNames: [
                            'Trade Date',
                            'Settlement Date',
                            'Quantity',
                            'Code',
                            'Description',
                            'Unit Price',
                            'Gross Amount',
                            'Brokerage',
                            'GST',
                            'Net Amount'
                        ],
                        csvColumnNames: ['tradeDate', 'settlementDate', 'quantity', 'code', 'description', 'unitPrice', 'grossAmount', 'brokerage', 'gst', 'netAmount', 'tradeCategory'],
                        csvDisplayNames: ['Trade Date', 'Settlement Date', 'Quantity', 'Code', 'Description', 'Unit Price', 'Gross Amount', 'Brokerage', 'GST', 'Net Amount', 'Category'],
                        columnWidths: ['auto', 'auto', 'auto', 'auto', '*', 'auto', 'auto', 'auto', 'auto', 'auto']
                    };
                case Patersons.ReportType.QuarterlyReports:
                    return {
                        columnNames: ["name"],
                        /*displayNames: [
                          {text: "Title", alignment: 'left'}
                        ],*/
                        displayNames: [
                            "Title"
                        ],
                        csvColumnNames: ["name"],
                        csvDisplayNames: ["Report Name"],
                        columnWidths: ['*']
                    };
                case Patersons.ReportType.Cash:
                    return {
                        columnNames: ["date", "description", "debit", "credit", "balance"],
                        /*displayNames: [
                          { text: "Date", alignment: 'left'},
                          { text: "Description", alignment: 'left'},
                          { text: "Debit",  alignment: 'right'},
                          { text: "Credit",  alignment: 'right'},
                          { text: "Balance", alignment: 'right'}
                        ],*/
                        displayNames: [
                            "Date",
                            "Description",
                            "Debit",
                            "Credit",
                            "Balance"
                        ],
                        csvColumnNames: ["date", "description", "debit", "credit", "balance", "cashSecurityGroupName"],
                        csvDisplayNames: ["Date", "Description", "Debit", "Credit", "Balance", "Cash Security Group"],
                        columnWidths: ['auto', '*', 90, 90, 90]
                    };
                case Patersons.ReportType.Income:
                    return {
                        columnNames: ['payDate', 'exDate', 'code', 'description', 'amount', 'frankingCredits', 'withholdingTax', 'gst'],
                        /*displayNames: [
                          { text:"Pay-Date", alignment: 'left'},
                          { text:"Ex-Date", alignment: 'left'},
                          { text:"Code", alignment: 'left'},
                          { text:"Description", alignment: 'left'},
                          { text:"Amount Received / Paid",alignment: 'right'},
                          { text:"Franking Credits", alignment: 'right'},
                          { text:"Withholding Tax", alignment: 'right'},
                          { text:"GST", alignment: 'right'}
                        ],*/
                        displayNames: [
                            "Pay-Date",
                            "Ex-Date",
                            "Code",
                            "Description",
                            "Amount Received / Paid",
                            "Franking Credits",
                            "Withholding Tax",
                            "GST"
                        ],
                        csvColumnNames: ['payDate', 'exDate', 'code', 'description', 'amount', 'frankingCredits', 'withholdingTax', 'gst', 'transType', 'subTransType'],
                        csvDisplayNames: ["Pay-Date", "Ex-Date", "Code", "Description", "Amount Received / Paid", "Franking Credits", "Withholding Tax", "GST", "Type", "SubType"],
                        //columnWidths: [50, 50, 40, "*", 90, 90, 90, 90]
                        columnWidths: [50, 50, '*', 200, 50, 50, 50, 50]
                    };
                case Patersons.ReportType.CapitalGains:
                    return {
                        columnNames: ['purchaseDate', 'saleDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'salePrice', 'capitalProceeds'],
                        /*displayNames: [
                          { text:'Purchase Date', alignment: 'left'},
                          { text:'Sale Date', alignment: 'left'},
                          { text:'Quantity', alignment: 'right'},
                          { text:'Capital Proceeds', alignment: 'right'},
                          { text:'Total Cost', alignment: 'right'},
                          { text:'Reduced Cost Base', alignment: 'right'},
                          { text:'Indexed Cost Base', alignment: 'right'},
                          { text:'Discount Cost Base', alignment: 'right'},
                          { text:'Capital Loss', alignment: 'right'},
                          { text:'Indexed Gain', alignment: 'right'},
                          { text:'Gross Discount Gain', alignment: 'right'},
                          { text:'Other Gain', alignment: 'right'},
                        ],*/
                        displayNames: [
                            'Purchase Date',
                            'Sale Date',
                            'Quantity',
                            'Cost Price',
                            'Total Cost',
                            'Reduced Cost Base',
                            'Indexed Cost Base',
                            'Discount Cost Base',
                            'Capital Loss',
                            'Indexed Gain',
                            'Gross Discount Gain',
                            'Other Gain',
                            'Sale Price',
                            'Capital Proceeds',
                        ],
                        csvColumnNames: ['purchaseDate', 'saleDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'securityDescription', 'assetClass', 'salePrice', 'capitalProceeds'],
                        csvDisplayNames: ['Purchase Date', 'Sale Date', 'Quantity', 'Cost Price', 'Total Cost', 'Reduced Cost Base', 'Indexed Cost Base', 'Discount Cost Base', 'Capital Loss', 'Indexed Gain', 'Gross Discount Gain', 'Other Gain', 'Security Description', 'Asset Class', 'Sale Price', 'Capital Proceeds'],
                        columnWidths: ["*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*", "*"]
                    };
                case Patersons.ReportType.UnrealisedCapitalGains:
                    return {
                        columnNames: ['purchaseDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'marketPrice', 'marketValue'],
                        /*displayNames: [
                          { text:'Purchase Date', alignment: 'left'},
                          { text:'Quantity', alignment: 'right'},
                          { text:'Market Value', alignment: 'right'},
                          { text:'Total Cost', alignment: 'right'},
                          { text:'Reduced Cost Base', alignment: 'right'},
                          { text:'Indexed Cost Base', alignment: 'right'},
                          { text:'Discounted Cost Base', alignment: 'right'},
                          { text:'Capital Loss', alignment: 'right'},
                          { text:'Indexed Gain', alignment: 'right'},
                          { text:'Gross Discount Gain', alignment: 'right'},
                          { text:'Other Gain', alignment: 'right'},
                        ],*/
                        displayNames: [
                            'Purchase Date',
                            'Quantity',
                            'Cost Price',
                            'Total Cost',
                            'Reduced Cost Base',
                            'Indexed Cost Base',
                            'Discounted Cost Base',
                            'Capital Loss',
                            'Indexed Gain',
                            'Gross Discount Gain',
                            'Other Gain',
                            'Market Price',
                            'Market Value',
                        ],
                        csvColumnNames: ['purchaseDate', 'quantity', 'costPrice', 'totalCost', 'reducedCostBase', 'indexedCostBase', 'discountedCostBase', 'capitalLoss', 'indexedGain', 'grossDiscountGain', 'otherGain', 'securityDescription', 'assetClass', 'marketPrice', 'marketValue'],
                        csvDisplayNames: ['Purchase Date', 'Quantity', 'Cost Price', 'Total Cost', 'Reduced Cost Base', 'Indexed Cost Base', 'Discounted Cost Base', 'Capital Loss', 'Indexed Gain', 'Gross Discount Gain', 'Other Gain', 'Security Description', 'Asset Class', 'Market Price', 'Market Value'],
                        columnWidths: ['*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*', '*']
                    };
                case Patersons.ReportType.Performance:
                    return {
                        columnNames: ['openMarketValue', 'netContributionsWithdrawals', 'netAssetMovement', 'income', 'expenses', 'managementFees', 'closedMarketValue', 'irr'],
                        /*displayNames: [
                          { text:'Open Market Value', alignment: 'right'},
                          { text:'Net Contributions / Withdrawals', alignment: 'right'},
                          { text:'Net Asset Movement', alignment: 'right'},
                          { text:'Income', alignment: 'right'},
                          { text:'Expenses', alignment: 'right'},
                          { text:'Management Fees', alignment: 'right'},
                          { text:'Closed Market Value', alignment: 'right'},
                          { text:'IRR', alignment: 'right'}
                        ],*/
                        displayNames: [
                            'Open Market Value',
                            'Net Contributions / Withdrawals',
                            'Net Asset Movement',
                            'Income',
                            'Expenses',
                            'Management Fees',
                            'Closed Market Value',
                            'IRR'
                        ],
                        csvColumnNames: ['openMarketValue', 'netContributionsWithdrawals', 'netAssetMovement', 'income', 'expenses', 'managementFees', 'closedMarketValue', 'irr'],
                        csvDisplayNames: ['Open Market Value', 'Net Contributions / Withdrawals', 'Net Asset Movement', 'Income', 'Expenses', 'Management Fees', 'Closed Market Value', 'IRR'],
                        columnWidths: ['*', 300]
                    };
                case Patersons.ReportType.TaxReports:
                    return {
                        columnNames: ["name"],
                        /*displayNames: [
                          { text:"Title", alignment: 'left'}
                        ],*/
                        displayNames: [
                            "Title"
                        ],
                        csvColumnNames: ["name"],
                        csvDisplayNames: ["Report Name"],
                        columnWidths: ['*']
                    };
                case Patersons.ReportType.Valuation:
                    //remove Gross Yield, Estimated Income and Estimated Franking Credits for CG accounts
                    if (this.userCompany.enableFeature) {
                        var result = {
                            columnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue", "profitOrLoss", "pctAssets", "estAnnualIncome", "estFrankingCredits", "estGrossYield"],
                            displayNames: [
                                "Code",
                                "Security Name",
                                "Quantity",
                                "Cost Price",
                                "Reduced Cost Base",
                                "Market Price",
                                "Market Value",
                                "Profit (Loss)",
                                "Pct. Assets",
                                "Historic Income",
                                "Historic Fr. Credits",
                                "Historic Gross Yield"
                            ],
                            columnNamesInternational: [
                                "code",
                                "currency",
                                "securityName",
                                "quantity",
                                "nativeCostPrice",
                                "nativeTotalCost",
                                "nativeMarketPrice",
                                "nativeMarketValue",
                                "nativeProfitLoss",
                                "totalCost",
                                "marketValue",
                                "profitOrLoss",
                                "pctAssets",
                                "estAnnualIncome"
                            ],
                            displayNamesInternational: [
                                "Code",
                                "Currency",
                                "Name",
                                "Quantity",
                                "Native Cost Price",
                                "Native Total Cost",
                                "Native Market Price",
                                "Native Market Value",
                                "Native Profit (Loss)",
                                "AUD Total Cost",
                                "AUD Market Value",
                                "AUD Profit (Loss)",
                                "Pct. Assets",
                                "Historic Income"
                            ],
                            csvColumnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue", "profitOrLoss", "pctAssets", "estAnnualIncome", "estFrankingCredits", "estGrossYield"],
                            csvDisplayNames: ["Code", "Security Name", "Quantity", "Cost Price", "Reduced Cost Base", "Market Price", "Market Value", "Profit (Loss)", "Pct. Assets", "Historic Income", "Historic Fr. Credits", "Historic Gross Yield"],
                            columnWidths: ["auto", "*", 50, 40, 60, 50, 60, 50, 40, 60, 50, 40],
                            columnWidthsInternational: ["auto", "auto", "*", 40, 40, 50, 50, 50, 40, 50, 50, 40, 40, 40],
                            csvGroupBy: "category",
                            totalColumnNames: ["totalCost", "marketValue", "estAnnualIncome", "estFrankingCredits", "estAnnualGrossIncome", "estGrossYield"],
                            totalDisplayNames: ["Total Cost", "Total Market Value", "Est.Annual Income", "Est.Annual Franking Credit", "Est.Annual Gross Income", "Est.Annual Gross Yield"],
                            totalColumnWidths: ["*", "*", "*", "*", "*", "*"],
                            csvTotalColumnNames: ["", "", "", "", "", "totalCost", "marketValue", "profitOrLoss", "estAnnualIncome", "estFrankingCredits", "estAnnualGrossIncome", "estGrossYield"],
                            csvTotalDisplayNames: ["", "", "", "", "", "Total Cost", "Total Market Value", "Profit (Loss)", "Historic Income", "Historic Franking Credits", "Historic Gross Income", "Historic Gross Yield"],
                        };
                        return result;
                    }
                    else {
                        var result = {
                            columnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue", "profitOrLoss", "pctAssets"],
                            displayNames: [
                                "Code",
                                "Security Name",
                                "Quantity",
                                "Cost Price",
                                "Reduced Cost Base",
                                "Market Price",
                                "Market Value",
                                "Profit (Loss)",
                                "Pct. Assets",
                            ],
                            displayNamesInternational: [
                                "Code",
                                "Currency",
                                "Name",
                                "Quantity",
                                "Native Cost Price",
                                "Native Total Cost",
                                "Native Market Price",
                                "Native Market Value",
                                "Native Profit (Loss)",
                                "AUD Total Cost",
                                "AUD Market Value",
                                "AUD Profit (Loss)",
                                "Pct. Assets",
                            ],
                            columnNamesInternational: [
                                "code",
                                "currency",
                                "securityName",
                                "quantity",
                                "nativeCostPrice",
                                "nativeTotalCost",
                                "nativeMarketPrice",
                                "nativeMarketValue",
                                "nativeProfitLoss",
                                "totalCost",
                                "marketValue",
                                "profitOrLoss",
                                "pctAssets"
                            ],
                            csvColumnNames: ["code", "securityName", "quantity", "costPrice", "totalCost", "price", "marketValue", "profitOrLoss", "pctAssets"],
                            csvDisplayNames: ["Code", "Security Name", "Quantity", "Cost Price", "Reduced Cost Base", "Market Price", "Market Value", "Profit (Loss)", "Pct. Assets"],
                            columnWidths: ["auto", "*", 50, 40, 60, 50, 60, 50, 40],
                            columnWidthsInternational: ["auto", "auto", "*", 40, 40, 50, 50, 50, 40, 50, 50, 40, 40],
                            csvGroupby: "category",
                            totalColumnNames: ["totalCost", "marketValue"],
                            totalDisplayNames: ["Total Cost", "Total Market Value"],
                            totalColumnWidths: ["*", "*",],
                            csvTotalColumnNames: ["", "", "", "", "", "totalCost", "marketValue", "profitOrLoss", "estAnnualIncome"],
                            scvTotalDisplayNames: ["", "", "", "", "", "Total Cost", "Total Market Value", "Profit (Loss)", "Historic Income"],
                        };
                        return result;
                    }
                case Patersons.ReportType.StandardLedger:
                    return {
                        columnNames: ["ledgerDate", "description", "amount", "balance", "currency", "reference"],
                        /*displayNames: [
                          { text:"Date", alignment: 'left'},
                          { text:"Description", alignment: 'left'},
                          { text:"Amount", alignment: 'right'},
                          { text:"Balance", alignment: 'right'},
                          { text:"Currency", alignment: 'right'},
                          { text:"Reference", alignment: 'right'}
                        ],*/
                        displayNames: [
                            "Date",
                            "Description",
                            "Amount",
                            "Balance",
                            "Currency",
                            "Reference"
                        ],
                        csvColumnNames: ["ledgerDate", "description", "amount", "balance", "currency", "reference"],
                        csvDisplayNames: ["Date", "Description", "Amount", "Balance", "Currency", "Reference"],
                        columnWidths: ["auto", "*", "auto", "auto", "auto", "auto"]
                    };
                default:
                    console.error('Unrecognised report type encountered: ' + reportType);
                    return null;
            }
        };
        ReportDownloadService.prototype.getCapitalTransactionStatement = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var statement = this.report;
            var transactions, footer, colspan = 1;
            if (statement && statement.tradeCategories && statement.tradeCategories.length > 0) {
                var categories = statement.tradeCategories;
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    doc.content.push(this.headerRow(category.name));
                    transactions = category.transactions;
                    footer = category.subtotal;
                    footer.tradeDate = null;
                    footer.settlementDate = null;
                    footer.quantity = 'n/a';
                    footer.unitPrice = 'n/a';
                    doc.content.push(this.table(transactions, headerCols, displayHeaderCols, widths, null, colspan, footer));
                }
            }
            return doc;
        };
        ReportDownloadService.prototype.getCapitalGainsReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var report = this.report;
            var footer, colspan = 1;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses;
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i];
                    doc.content.push(this.headerRow(assetClass.name));
                    // AE: Capital Gains Report header row fix
                    doc.content.push(this.table(null, headerCols, displayHeaderCols, widths, null, colspan, null));
                    var assets = assetClass.assets;
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j];
                        doc.content.push(this.subHeaderRow(asset.name));
                        footer = asset.subtotal;
                        footer.purchaseDate = null;
                        footer.saleDate = null;
                        doc.content.push(this.table(asset.capitalGains, headerCols, null, widths, null, colspan, footer));
                    }
                    footer = assetClass.subtotal;
                    footer.purchaseDate = null;
                    footer.saleDate = null;
                    footer.quantity = null;
                    doc.content.push(this.subTotalTable(null, headerCols, null, widths, 'Sub Total', colspan, footer));
                }
                footer = report.total;
                footer.purchaseDate = null;
                footer.saleDate = null;
                footer.quantity = null;
                doc.content.push(this.totalTable(null, headerCols, null, widths, 'Total', colspan, footer));
            }
            return doc;
        };
        ReportDownloadService.prototype.getUnrealisedCapitalGainsReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var report = this.report;
            var footer, colspan = 1;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses;
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i];
                    doc.content.push(this.headerRow(assetClass.name));
                    // AE: Unreleased Capital Gains headers row fix
                    doc.content.push(this.table(null, headerCols, displayHeaderCols, widths, null, colspan, null));
                    var assets = assetClass.assets;
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j];
                        doc.content.push(this.subHeaderRow(asset.name));
                        footer = asset.subtotal;
                        footer.purchaseDate = null;
                        doc.content.push(this.table(asset.capitalGains, headerCols, null, widths, null, colspan, footer));
                    }
                    footer = assetClass.subtotal;
                    footer.purchaseDate = null;
                    footer.quantity = 'n/a';
                    footer.marketValue = 'n/a';
                    footer.indexedCostBase = 'n/a';
                    footer.discountedCostBase = 'n/a';
                    footer.indexedGain = 'n/a';
                    doc.content.push(this.subTotalTable(null, headerCols, null, widths, 'Sub Total', colspan, footer));
                }
                footer = report.total;
                footer.purchaseDate = null;
                footer.quantity = 'n/a';
                footer.marketValue = 'n/a';
                footer.indexedCostBase = 'n/a';
                footer.discountedCostBase = 'n/a';
                footer.indexedGain = 'n/a';
                doc.content.push(this.totalTable(null, headerCols, null, widths, 'Total', colspan, footer));
            }
            return doc;
        };
        ReportDownloadService.prototype.getPerformanceReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var report = this.report;
            if (!report) {
                return null;
            }
            var columnNames = columnDefinitions.columnNames;
            var displayNames = columnDefinitions.displayNames;
            var performanceTable = {
                table: {
                    widths: columnDefinitions.columnWidths,
                    headerRows: 0,
                    body: []
                },
                layout: this.getPerformanceLayout() //this.layoutThinLightBorder()
            };
            doc.content.push(this.headerRow("Performance"));
            for (var i = 0; i < columnNames.length; i++) {
                var displayName = displayNames[i];
                var item = columnNames[i];
                var value = this.currencyFormatted(report[item]);
                if (i == 0 || i > columnNames.length - 3) {
                    performanceTable.table.body.push([
                        { text: displayName, border: [false, false, false, true], style: this.pdfBuilder.styles.tableCellBold },
                        { text: value, alignment: 'right', border: [false, false, false, true], style: this.pdfBuilder.styles.tableCellBold }
                    ]);
                }
                else {
                    performanceTable.table.body.push([
                        { text: displayName, border: [false, false, false, true], style: this.pdfBuilder.styles.tableCell },
                        { text: value, alignment: 'right', border: [false, false, false, true], style: this.pdfBuilder.styles.tableCell }
                    ]);
                }
            }
            doc.content.push(performanceTable);
            return doc;
        };
        ReportDownloadService.prototype.capitalizeFirstLetter = function (string) {
            return string.charAt(0).toUpperCase() + string.slice(1);
        };
        // Holdings report
        ReportDownloadService.prototype.handleLongString = function (category) {
            category.items.forEach(function (x, index) {
                var words = x.securityName.split(" ");
                var code = x.code.split(/[_\s]+/);
                // split the words into subwords
                for (var i = 0; i < words.length; i++) {
                    if (words[i].length > 5) {
                        words[i] = words[i].substring(0, 5) + " " + words[i].substring(5);
                    }
                }
                for (var i = 0; i < code.length; i++) {
                    if (code[i].length > 3) {
                        code[i] = code[i].substring(0, 3) + " " + code[i].substring(3);
                    }
                }
                var newCode = code.join(" ");
                category.items[index].code = newCode;
                var newSentence = words.join(" ");
                category.items[index].securityName = newSentence;
            });
        };
        ReportDownloadService.prototype.getValuationStatement = function (doc) {
            var _this = this;
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var headerColsInternational = columnDefinitions.columnNamesInternational;
            var displayHeaderCols = columnDefinitions.displayNames;
            var displayHeaderColsInternational = columnDefinitions.displayNamesInternational;
            var widths = columnDefinitions.columnWidths;
            var widthsInternational = columnDefinitions.columnWidthsInternational;
            var valuationStatement = this.report;
            var tableBody = [];
            // Non-LOA securities
            if (valuationStatement.nonLoaSecurities) {
                var categories = valuationStatement.nonLoaSecurities;
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    this.handleLongString(category);
                    tableBody = [];
                    if (category.categoryName.includes("International")) {
                        tableBody.push(this.getHoldingsHeaderRow(displayHeaderColsInternational));
                        tableBody.push(this.formatSubheadingRow(category.categoryName, headerColsInternational.length));
                        var lineItems = this.formatDataForPdf(category.items);
                        var footer = this.formatDataForPdf(category.subtotal);
                        tableBody = tableBody.concat(this.buildTableBody(lineItems, headerColsInternational, null, null, 0, footer));
                        doc.content.push(this.tableWithHeader(tableBody, headerColsInternational, widthsInternational));
                    }
                    else {
                        tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                        tableBody.push(this.formatSubheadingRow(category.categoryName, headerCols.length));
                        var lineItems = this.formatDataForPdf(category.items);
                        var footer = this.formatDataForPdf(category.subtotal);
                        tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                        doc.content.push(this.tableWithHeader(tableBody, headerCols, widths));
                    }
                }
            }
            // Non-LOA unsettled dividends
            if (valuationStatement.nonLoaUnsettledDividends) {
                var dividends = valuationStatement.nonLoaUnsettledDividends;
                if (dividends.items && dividends.items.length > 0) {
                    tableBody = [];
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow("Unsettled Dividends", headerCols.length));
                    var lineItems = this.formatDataForPdf(dividends.items);
                    var footer = this.formatDataForPdf(dividends.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(this.tableWithHeader(tableBody, headerCols, widths));
                }
            }
            // LOA securities
            if (valuationStatement.loaSecurities) {
                var categories = valuationStatement.loaSecurities;
                for (var i = 0; i < categories.length; i++) {
                    tableBody = [];
                    var category = categories[i];
                    this.handleLongString(category);
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow(category.categoryName, headerCols.length));
                    var lineItems = this.formatDataForPdf(category.items);
                    var footer = this.formatDataForPdf(category.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(this.tableWithHeader(tableBody, headerCols, widths));
                }
            }
            // LOA unsettled dividends
            if (valuationStatement.loaUnsettledDividends) {
                var dividends = valuationStatement.loaUnsettledDividends;
                if (dividends.items && dividends.items.length > 0) {
                    tableBody = [];
                    tableBody.push(this.getHoldingsHeaderRow(displayHeaderCols));
                    tableBody.push(this.formatSubheadingRow("Unsettled Dividends", headerCols.length));
                    var lineItems = this.formatDataForPdf(dividends.items);
                    var footer = this.formatDataForPdf(dividends.subtotal);
                    tableBody = tableBody.concat(this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                    doc.content.push(this.tableWithHeader(tableBody, headerCols, widths));
                }
            }
            if (valuationStatement.managedAccounts) {
                Object.keys(valuationStatement.managedAccounts).forEach(function (key) {
                    if (valuationStatement.managedAccounts[key].items.length) {
                        var categories = valuationStatement.managedAccounts[key].items;
                        tableBody = [];
                        tableBody.push(_this.getHoldingsHeaderRow(displayHeaderCols));
                        tableBody.push(_this.formatSubheadingRow(_this.capitalizeFirstLetter(key), headerCols.length));
                        for (var i = 0; i < categories.length; i++) {
                            var category = categories[i];
                            _this.handleLongString(category);
                            tableBody.push(_this.formatNestedSubheadingRow(category.categoryName, headerCols.length));
                            var lineItems = _this.formatDataForPdf(category.items);
                            var footer = _this.formatDataForPdf(category.subtotal);
                            tableBody = tableBody.concat(_this.buildTableBody(lineItems, headerCols, null, null, 0, footer));
                        }
                        doc.content.push(_this.tableWithHeader(tableBody, headerCols, widths, displayHeaderCols));
                    }
                });
            }
            // doc.content.push(<any>this.tableWithHeader(tableBody, headerCols, widths, displayHeaderCols));
            // Grand totals
            if (valuationStatement.grandTotal) {
                var total = [];
                total.push(valuationStatement.grandTotal);
                doc.content.push(this.headerRow("Grand Totals"));
                doc.content.push(this.table(total, columnDefinitions.totalColumnNames, columnDefinitions.totalDisplayNames, columnDefinitions.totalColumnWidths, null, 0, null));
            }
            return doc;
        };
        ReportDownloadService.prototype.getQuarterlyReportsReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var quarterlyReport = this.report;
            var colspan = 1;
            if (quarterlyReport && quarterlyReport.investorDocs && quarterlyReport.investorDocs.length > 0) {
                doc.content.push(this.table(quarterlyReport.investorDocs, headerCols, displayHeaderCols, widths, null, colspan, null));
            }
            return doc;
        };
        ReportDownloadService.prototype.getTaxReportsReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var taxReport = this.report;
            var colspan = 1;
            if (taxReport && taxReport.investorDocs && taxReport.investorDocs.length > 0) {
                doc.content.push(this.table(taxReport.investorDocs, headerCols, displayHeaderCols, widths, null, colspan, null));
            }
            return doc;
        };
        ReportDownloadService.prototype.getCashReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var cashReport = this.report;
            var transactions, footer, colspan = 1;
            if (cashReport && cashReport.transactionGroups && cashReport.transactionGroups.length > 0) {
                var groups = cashReport.transactionGroups;
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    doc.content.push(this.headerRow(group.name));
                    transactions = group.transactions;
                    footer = group.closingBalance;
                    doc.content.push(this.table(transactions, headerCols, displayHeaderCols, widths, null, colspan, footer));
                }
            }
            return doc;
        };
        ReportDownloadService.prototype.getIncomeReport = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var incomeReport = this.report;
            var categories;
            var subCategories;
            var footer;
            var colspan = 4;
            if (incomeReport && incomeReport.transactionTypeCategories && incomeReport.transactionTypeCategories.length > 0) {
                var categories = incomeReport.transactionTypeCategories;
                for (var cat = 0; cat < categories.length; cat++) {
                    var category = categories[cat];
                    doc.content.push(this.headerRow(category.name));
                    doc.content.push(this.tableWithHeader(null, columnDefinitions, widths, displayHeaderCols));
                    for (var subCat = 0; subCat < category.subCategories.length; subCat++) {
                        var subCategory = category.subCategories[subCat];
                        if (subCategory.name != category.name) {
                            doc.content.push(this.subHeaderRow(subCategory.name));
                        }
                        var lineItems = subCategory.lineItems;
                        doc.content.push(this.table(lineItems, headerCols, null, widths, null, null, null));
                    }
                    footer = category.subtotal;
                    footer.payDate = null;
                    footer.exDate = null;
                    footer.code = null;
                    footer.description = null;
                    doc.content.push(this.table(null, headerCols, null, widths, "TOTAL " + category.name.toUpperCase(), colspan, footer));
                }
                if (incomeReport && incomeReport.grandTotal) {
                    footer = incomeReport.grandTotal;
                    footer.payDate = null;
                    footer.exDate = null;
                    footer.code = null;
                    footer.description = null;
                    doc.content.push(this.table(null, headerCols, null, widths, "INCOME LESS EXPENSES:", colspan, footer));
                }
            }
            return doc;
        };
        ReportDownloadService.prototype.getStandardLedger = function (doc) {
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var colspan = 1;
            var standardLedgerReport = this.report;
            if (standardLedgerReport &&
                standardLedgerReport.ledgerEntries &&
                standardLedgerReport.ledgerEntries.length > 0) {
                var entries = standardLedgerReport.ledgerEntries;
                doc.content.push(this.headerRow("Ledger"));
                doc.content.push(this.ledgerTable(entries, headerCols, displayHeaderCols, widths, null, colspan, null));
            }
            return doc;
        };
        ReportDownloadService.prototype.formatDataForPdf = function (data) {
            var _this = this;
            if (!data)
                return null;
            var pdfData = angular.copy(data);
            if (pdfData instanceof Array) {
                pdfData.map(function (item) {
                    _this.formatDataRow(item);
                });
            }
            else {
                this.formatDataRow(pdfData);
            }
            return pdfData;
        };
        ReportDownloadService.prototype.formatDataRow = function (item) {
            if (item == null || item === undefined)
                return null;
            switch (this.report.reportType) {
                case Patersons.ReportType.CapitalTransactions:
                    item.tradeDate = this.dateFormatted(item.tradeDate);
                    item.settlementDate = this.dateFormatted(item.settlementDate);
                    item.quantity = this.currencyFormatted(item.quantity);
                    item.unitPrice = this.currencyFormatted(item.unitPrice);
                    item.grossAmount = this.currencyFormatted(item.grossAmount);
                    item.brokerage = this.currencyFormatted(item.brokerage);
                    item.gst = this.currencyFormatted(item.gst);
                    item.netAmount = this.currencyFormatted(item.netAmount);
                    break;
                case Patersons.ReportType.QuarterlyReports:
                    break;
                case Patersons.ReportType.Cash:
                    item.date = this.dateFormatted(item.date);
                    item.debit = this.currencyFormatted(this.absoluteValue(item.debit));
                    item.credit = this.currencyFormatted(item.credit);
                    item.balance = this.currencyFormatted(item.balance);
                    break;
                case Patersons.ReportType.Income:
                    item.payDate = this.dateFormatted(item.payDate);
                    item.exDate = this.dateFormatted(item.exDate);
                    item.amount = this.currencyFormatted(item.amount);
                    item.frankingCredits = this.currencyFormatted(item.frankingCredits);
                    item.withholdingTax = this.currencyFormatted(item.withholdingTax);
                    item.gst = this.currencyFormatted(item.gst);
                    break;
                case Patersons.ReportType.CapitalGains:
                    item.purchaseDate = this.dateFormatted(item.purchaseDate);
                    item.saleDate = this.dateFormatted(item.saleDate);
                    item.quantity = this.integerFormatted(item.quantity);
                    item.costPrice = this.currencyFormatted(item.costPrice);
                    item.totalCost = this.currencyFormatted(item.totalCost);
                    item.reducedCostBase = this.currencyFormatted(item.reducedCostBase);
                    item.indexedCostBase = this.currencyFormatted(item.indexedCostBase);
                    item.discountedCostBase = this.currencyFormatted(item.discountedCostBase);
                    item.capitalLoss = this.currencyFormatted(item.capitalLoss);
                    item.indexedGain = this.currencyFormatted(item.indexedGain);
                    item.grossDiscountGain = this.currencyFormatted(item.grossDiscountGain);
                    item.salePrice = this.currencyFormatted(item.salePrice);
                    item.otherGain = this.currencyFormatted(item.otherGain);
                    item.capitalProceeds = this.currencyFormatted(item.capitalProceeds);
                    break;
                case Patersons.ReportType.UnrealisedCapitalGains:
                    item.purchaseDate = this.dateFormatted(item.purchaseDate);
                    item.quantity = this.integerFormatted(item.quantity);
                    item.costPrice = this.currencyFormatted(item.costPrice);
                    item.totalCost = this.currencyFormatted(item.totalCost);
                    item.reducedCostBase = this.currencyFormatted(item.reducedCostBase);
                    item.indexedCostBase = this.currencyFormatted(item.indexedCostBase);
                    item.discountedCostBase = this.currencyFormatted(item.discountedCostBase);
                    item.capitalLoss = this.currencyFormatted(item.capitalLoss);
                    item.indexedGain = this.currencyFormatted(item.indexedGain);
                    item.grossDiscountGain = this.currencyFormatted(item.grossDiscountGain);
                    item.otherGain = this.currencyFormatted(item.otherGain);
                    item.marketPrice = this.currencyFormatted(item.marketPrice);
                    item.marketValue = this.currencyFormatted(item.marketValue);
                    break;
                case Patersons.ReportType.Performance:
                    break;
                case Patersons.ReportType.TaxReports:
                    break;
                case Patersons.ReportType.Valuation:
                    if (item.hasOwnProperty("unsettledIncome")) {
                        item.code = item.securityCode;
                        item.marketValue = this.currencyFormatted(item.unsettledIncome);
                    }
                    else {
                        item.quantity = this.currencyFormatted(item.quantity);
                        item.costPrice = this.formatAsCurrency4DecPts(item.costPrice);
                        item.totalCost = this.currencyFormatted(item.totalCost);
                        item.price = this.formatAsCurrency4DecPts(item.price);
                        item.marketValue = this.currencyFormatted(item.marketValue);
                        item.profitOrLoss = this.currencyFormatted(item.profitOrLoss);
                        item.pctAssets = this.percentFormatted(item.pctAssets);
                        item.estAnnualIncome = this.currencyFormatted(item.estAnnualIncome);
                        item.estAnnualGrossIncome = this.currencyFormatted(item.estAnnualGrossIncome);
                        item.estFrankingCredits = this.currencyFormatted(item.estFrankingCredits);
                        item.estGrossYield = this.percentFormatted(item.estGrossYield);
                        item.nativeCostPrice = this.currencyFormatted(item.nativeCostPrice);
                        item.nativeTotalCost = this.currencyFormatted(item.nativeTotalCost);
                        item.nativeMarketPrice = this.currencyFormatted(item.nativeMarketPrice);
                        item.nativeMarketValue = this.currencyFormatted(item.nativeMarketValue);
                        item.nativeProfitLoss = this.currencyFormatted(item.nativeProfitLoss);
                    }
                    break;
                case Patersons.ReportType.StandardLedger:
                    item.ledgerDate = this.dateFormatted(item.ledgerDate);
                    item.amount = this.currencyFormatted(item.amount);
                    item.balance = this.currencyFormatted(item.balance);
                    item.isCancelled = IdMgr.YesNo()(item.isCancelled);
                    item.isOpen = IdMgr.YesNo()(item.isOpen);
                    break;
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
            return item;
        };
        ReportDownloadService.prototype.dateFormatted = function (date) {
            return date ? moment(date).format("DD-MM-YYYY") : null;
        };
        ReportDownloadService.prototype.getPdfTemplateDefinition = function () {
            var deferred = this.q.defer();
            var timestamp = moment.tz(this.report.creationDateUtc, 'Australia/Sydney').format("h:mm a [AEST on] D MMM YYYY");
            var reportTitle = this.report.title;
            //let adviserName = this.account.adviserName ? this.account.adviserName : "";
            //let dateHeading: any[] = this.buildDateHeading(this.report.asAtDate, this.report.dateFrom, this.report.dateTo);
            var docDefinition = {
                pageSize: 'A4',
                pageOrientation: 'landscape',
                pageMargins: [56, 28, 56, 60],
                content: [
                    this.pdfBuilder.getImageContent(),
                    {
                        text: reportTitle,
                        style: this.pdfBuilder.styles.header,
                        margin: [0, 0, 0, 0]
                    },
                    {
                        text: this.filter("accountName")(this.account.designation ? this.account.accountName + ' ' + this.account.designation : this.account.accountName),
                        style: this.pdfBuilder.styles.subHeader,
                        margin: [0, 5, 0, 10]
                    },
                    this.buildHeadingTable(this.report.asAtDate, this.report.dateFrom, this.report.dateTo),
                ],
                footer: this.pdfBuilder.docDefinition.footer,
                styles: {
                    header: {
                        fontSize: 16,
                        bold: false,
                        margin: [5, 5, 0, 10]
                    },
                    headerText: {
                        margin: [5, 5, 5, 5]
                    },
                    lastHeaderText: {
                        margin: [5, 5, 5, 15]
                    },
                    tableHeader: {
                        fontSize: 8,
                        bold: true,
                        alignment: 'center',
                        fillColor: '#dadada',
                        margin: [5, 5, 0, 10]
                    },
                    filledHeader: {
                        bold: true,
                        fontSize: 8,
                        color: 'white',
                        fillColor: this.pdfBuilder.userCompany.colorSecondary,
                        margin: [10, 2, 2, 2],
                    },
                    filledHoldingsHeader: {
                        bold: true,
                        fontSize: 8,
                        color: 'white',
                        fillColor: '#dadada',
                        margin: [10, 2, 2, 2],
                    },
                    secondaryHeader: {
                        bold: true,
                        fontSize: 8,
                        color: 'black',
                        alignment: 'left'
                    },
                    footerRow: {
                        bold: true,
                        fontSize: 8,
                        margin: [0, 2, 2, 2]
                    },
                    footerText: {
                        fontSize: 5,
                        bold: false,
                        alignment: 'center'
                    }
                }
            };
            deferred.resolve(docDefinition);
            return deferred.promise;
        };
        ReportDownloadService.prototype.appendSpannedCells = function (row, span) {
            // For a colspanning cell, we must still define the empty cells.
            for (var i = 1; i < span; i++) {
                row.push({ border: [false, false, false, false] });
            }
            return row;
        };
        ReportDownloadService.prototype.formatNestedSubheadingRow = function (label, colspan) {
            var row = [];
            row.push({
                border: [false, false, false, false],
                text: label,
                colSpan: colspan,
                style: this.pdfBuilder.styles.filledSubHeader,
                margin: [0, 5, 5, 5],
                alignment: 'left' });
            this.appendSpannedCells(row, colspan);
            return row;
        };
        ReportDownloadService.prototype.formatSubheadingRow = function (label, colspan) {
            var row = [];
            row.push({
                border: [false, false, false, false],
                text: label,
                colSpan: colspan,
                style: this.pdfBuilder.styles.filledHeader,
                margin: [0, 5, 5, 5],
                alignment: 'left' });
            this.appendSpannedCells(row, colspan);
            return row;
        };
        ReportDownloadService.prototype.headerRow = function (label) {
            return {
                table: {
                    widths: ['*'],
                    body: [
                        [
                            {
                                border: [false, false, false, false],
                                text: label,
                                style: this.pdfBuilder.styles.filledHeader,
                                margin: [5, 2, 2, 2]
                            }
                        ]
                    ]
                },
                layout: 'noBorders'
            };
        };
        ReportDownloadService.prototype.subHeaderRow = function (label) {
            return {
                table: {
                    widths: ['*'],
                    body: [[{ text: label, style: 'secondaryHeader', margin: [5, 2, 2, 2] }]]
                },
                layout: 'noBorders'
            };
        };
        // if footerLabel - Sub Total
        ReportDownloadService.prototype.table = function (transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: (headers) ? this.getTablelayout(false, false, true, false) : this.getTablelayout(false, false, false, false) //(headers) ? this.layoutThinLightBorderHeader() : this.layoutThinLightBorder()
            };
        };
        // if footerLabel - Sub Total
        ReportDownloadService.prototype.ledgerTable = function (transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(false, false, false, false, true)
            };
        };
        // if footerLabel - Sub Total
        ReportDownloadService.prototype.subTotalTable = function (transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildSubTotalTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(true, false, false, false)
            };
        };
        // if footerLabel - Sub Total
        ReportDownloadService.prototype.totalTable = function (transactions, columns, headers, widths, footerLabel, footerLabelColspan, footerData) {
            var data = this.formatDataForPdf(transactions);
            var footer = this.formatDataForPdf(footerData);
            return {
                fontSize: 8,
                table: {
                    widths: widths,
                    headerRows: 0,
                    body: this.buildSubTotalTableBody(data, columns, headers, footerLabel, footerLabelColspan, footer)
                },
                layout: this.getTablelayout(false, true, false, false)
            };
        };
        ReportDownloadService.prototype.tableWithHeader = function (bodyRows, columns, columnWidths, headers) {
            var isHoldings = false;
            var tableBody = [];
            if (bodyRows) {
                isHoldings = true;
                for (var i = 0; i < bodyRows.length; i++) {
                    tableBody.push(bodyRows[i]);
                }
            }
            else {
                if (headers) {
                    tableBody.push(this.getHeaderRow(headers));
                }
            }
            return {
                fontSize: 8,
                table: {
                    widths: columnWidths,
                    headerRows: 1,
                    body: tableBody
                },
                margin: isHoldings ? [0, 0, 0, 10] : [],
                layout: (isHoldings) ?
                    this.getTablelayout(false, false, false, true) :
                    this.getTablelayout(false, false, true, false)
            };
        };
        ReportDownloadService.prototype.buildHeadingTable = function (asAtDate, dateFrom, dateTo) {
            var headingTable = {
                style: { fontSize: 8 },
                margin: [-4, 8, 0, 5],
                table: {
                    widths: ['auto', '*', 'auto', 'auto'],
                    body: []
                }
            };
            headingTable.table.body.push([
                { border: [false, false, false, false], text: 'Adviser: ', style: { bold: true, alignment: 'left' } },
                { border: [false, false, false, false], text: this.account.adviserName ? this.account.adviserName : "", style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
            ]);
            headingTable.table.body.push([
                { border: [false, false, false, false], text: 'Account No: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: this.account.accountId, style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
            ]);
            if (!asAtDate) {
                headingTable.table.body.push([
                    { border: [false, false, false, false], text: 'From Date: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                    { border: [false, false, false, false], text: moment(dateFrom).format("YYYY-MM-DD"), style: { bold: false, alignment: 'left', fontSize: 8 } },
                    { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                    { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
                ]);
                headingTable.table.body.push([
                    { border: [false, false, false, false], text: 'To Date: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                    { border: [false, false, false, false], text: moment(dateTo).format("YYYY-MM-DD"), style: { bold: false, alignment: 'left', fontSize: 8 } },
                    { border: [false, false, false, false], text: '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                    { border: [false, false, false, false], text: '', style: { bold: false, alignment: 'right', fontSize: 8 } }
                ]);
            }
            headingTable.table.body.push([
                { border: [false, false, false, false], text: 'Report Generated At: ', style: { bold: true, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: moment.tz(new Date(), 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), style: { bold: false, alignment: 'left', fontSize: 8 } },
                { border: [false, false, false, false], text: (asAtDate) ? 'As at:' : '', style: { bold: true, alignment: 'right', fontSize: 8 } },
                { border: [false, false, false, false], text: (asAtDate) ? moment(asAtDate).tz('Sydney/Australia').format("D MMM YYYY hh:mm:ss A [AEST]") : '', style: { bold: false, alignment: 'right', fontSize: 8.5 } }
            ]);
            return headingTable;
        };
        // footerLabel - Sub Total
        ReportDownloadService.prototype.buildTableBody = function (data, columns, headers, footerLabel, footerLabelColspan, footerData) {
            var _this = this;
            var body = [];
            if (headers) {
                body.push(this.getHeaderRow(headers));
            }
            if (data) {
                data.forEach(function (row) {
                    var dataRow = _this.getRow(row, columns);
                    body.push(dataRow);
                });
            }
            if (footerData) {
                body.push(this.getFooterRow(footerLabel, columns, footerLabelColspan, footerData));
            }
            return body;
        };
        // footerLabel - Sub Total
        ReportDownloadService.prototype.buildSubTotalTableBody = function (data, columns, headers, footerLabel, footerLabelColspan, footerData) {
            var _this = this;
            var body = [];
            if (headers) {
                body.push(this.getHeaderRow(headers));
            }
            if (data) {
                data.forEach(function (row) {
                    var dataRow = _this.getSubTotalRow(row, columns);
                    body.push(dataRow);
                });
            }
            if (footerData) {
                body.push(this.getSubTotalFooterRow(footerLabel, columns, footerLabelColspan, footerData));
            }
            return body;
        };
        ReportDownloadService.prototype.isNumericHeader = function (header) {
            var numericHeaders = [
                'Quantity',
                'Price',
                'Cost',
                'Value',
                'Assets',
                'Income',
                'Credit',
                'Debit',
                'Balance',
                'Yield',
                'Amount',
                'Brokerage',
                'GST',
                'Tax',
                'Capital',
                'Gain',
                'Loss'
            ];
            return numericHeaders.some(function (v) { return header.indexOf(v) >= 0; });
        };
        ReportDownloadService.prototype.getHeaderRow = function (headers) {
            var formattedHeaders = [];
            if (headers) {
                for (var h = 0; h < headers.length; h++) {
                    formattedHeaders.push({
                        border: [false, false, false, true],
                        text: headers[h],
                        style: this.pdfBuilder.styles.tableHeader,
                        alignment: this.isNumericHeader(headers[h]) ? 'right' : 'left'
                    });
                }
            }
            return formattedHeaders;
        };
        ReportDownloadService.prototype.getHoldingsHeaderRow = function (headers) {
            var formattedHeaders = [];
            if (headers) {
                for (var h = 0; h < headers.length; h++) {
                    formattedHeaders.push({
                        border: [false, true, false, true],
                        text: headers[h],
                        style: this.pdfBuilder.styles.filledHoldingsHeader,
                        alignment: this.isNumericHeader(headers[h]) ? 'right' : 'left'
                    });
                }
            }
            return formattedHeaders;
        };
        ReportDownloadService.prototype.getRow = function (data, columns) {
            var _this = this;
            var result = [];
            columns.forEach(function (column) {
                if (column && data[column]) {
                    var style = JSON.parse(JSON.stringify(_this.pdfBuilder.styles.tableCell));
                    if (column === "profitOrLoss" || column === "nativeProfitLoss") {
                        var value = parseFloat(data[column]);
                        if (!isNaN(value)) {
                            if (value != 0) {
                                if (value > 0) {
                                    style.fillColor = '#dff0d8';
                                }
                                else {
                                    style.fillColor = '#f2dede';
                                }
                            }
                        }
                    }
                    result.push({
                        border: [false, false, false, true],
                        text: data[column].toString(),
                        style: style,
                        alignment: !isNaN(data[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left'
                    });
                }
                else {
                    result.push({ border: [false, false, false, true], text: '' });
                }
            });
            return result;
        };
        ReportDownloadService.prototype.getSubTotalRow = function (data, columns) {
            var _this = this;
            var result = [];
            columns.forEach(function (column) {
                if (column && data[column]) {
                    result.push({
                        border: [false, true, false, false],
                        text: data[column].toString(),
                        style: _this.pdfBuilder.styles.tableCell,
                        alignment: !isNaN(data[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left'
                    });
                }
                else {
                    result.push({ border: [false, true, false, false], text: '' });
                }
            });
            return result;
        };
        ReportDownloadService.prototype.getFooterRow = function (footerLabel, columns, footerColspan, footerData) {
            var workingColumns = angular.copy(columns);
            var result = [];
            if (footerLabel) {
                result = [{
                        text: footerLabel,
                        colSpan: footerColspan,
                        style: { bold: true },
                        alignment: 'left',
                        border: [false, false, false, false]
                    }];
                delete workingColumns[0]; //this is to keep the same col count same as the rest of the table rows
            }
            if (!workingColumns || workingColumns.length <= 0) {
                return result;
            }
            workingColumns.forEach(function (column) {
                if (column && footerData[column]) {
                    result.push({
                        text: footerData[column].toString(),
                        style: { bold: true },
                        alignment: !isNaN(footerData[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left',
                        margin: [0, 0, 0, 0],
                        border: [false, true, false, false]
                    });
                }
                else {
                    result.push({ text: '', style: { bold: true }, border: [false, false, false, false] });
                }
            });
            return result;
        };
        ReportDownloadService.prototype.getSubTotalFooterRow = function (footerLabel, columns, footerColspan, footerData) {
            var workingColumns = angular.copy(columns);
            var result = [];
            if (footerLabel) {
                result = [{
                        text: footerLabel,
                        colSpan: footerColspan,
                        style: 'footerRow',
                        alignment: 'left',
                        border: [false, true, false, false]
                    }];
                delete workingColumns[0]; //this is to keep the same col count same as the rest of the table rows
            }
            if (!workingColumns || workingColumns.length <= 0) {
                return result;
            }
            workingColumns.forEach(function (column) {
                if (column && footerData[column]) {
                    result.push({
                        text: footerData[column].toString(),
                        style: 'footerRow',
                        alignment: !isNaN(footerData[column].replace(/,/g, '').replace(/%/g, '')) ? 'right' : 'left',
                        margin: [0, 0, 0, 0],
                        border: [false, true, false, false]
                    });
                }
                else {
                    result.push({ text: '', style: 'footerRow', border: [false, true, false, false] });
                }
            });
            return result;
        };
        ReportDownloadService.prototype.integerFormatted = function (amount) {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            var i = parseInt(amount);
            return this.addCommas(i.toString());
        };
        ReportDownloadService.prototype.formatAsCurrency4DecPts = function (amount) {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            return amount.toFixed(4).replace(/\d(?=(\d{3})+\.)/g, '$&,');
        };
        ReportDownloadService.prototype.currencyFormatted = function (amount) {
            if (amount === 'n/a' || amount === '' || amount === null || amount === undefined) {
                return '';
            }
            var i = parseFloat(amount);
            if (isNaN(i)) {
                i = 0.00;
            }
            var minus = '';
            if (i < 0) {
                minus = '-';
            }
            i = Math.abs(i);
            i = parseInt(((i + .005) * 100).toString());
            i = i / 100;
            var s = i.toString();
            if (s.indexOf('.') < 0) {
                s += '.00';
            }
            if (s.indexOf('.') === (s.length - 2)) {
                s += '0';
            }
            s = minus + s;
            return this.addCommas(s);
        };
        ReportDownloadService.prototype.addCommas = function (nStr) {
            nStr = nStr + '';
            var x = nStr.split('.');
            var x1 = x[0];
            var x2 = x.length > 1 ? '.' + x[1] : '';
            var rgx = /(\d+)(\d{3})/;
            while (rgx.test(x1)) {
                x1 = x1.replace(rgx, '$1' + ',' + '$2');
            }
            return x1 + x2;
        };
        ReportDownloadService.prototype.absoluteValue = function (amount) {
            if (amount === null || amount === undefined) {
                return null;
            }
            return Math.abs(amount);
        };
        ReportDownloadService.prototype.percentFormatted = function (amount) {
            var numberString = this.currencyFormatted(amount);
            return numberString + "%";
        };
        ReportDownloadService.prototype.getFileName = function () {
            if (this.account == null) {
                return "";
            }
            if (this.report == null) {
                return "";
            }
            var accountId = this.account.accountId;
            var startDate = moment(this.report.dateFrom).format("YYYY-MM-DD");
            var endDate = moment(this.report.dateTo).format("YYYY-MM-DD");
            return accountId + "-" + this.report.reportType + "-" + startDate + "_" + endDate;
        };
        ReportDownloadService.prototype.createCsvFile = function () {
            var nowDate = moment(new Date());
            var topLine = ReportDownloadService.getCsvTopLine(this.account, this.report.creationDateUtc, this.report.dateFrom, this.report.dateTo, this.report.asAtDate);
            var columnDefinition = this.getColumnDefinitions(this.report.reportType);
            var header = this.getCsvColumnHeadings();
            var columnNames = this.getCsvColumnNames();
            var data = this.getCsvData();
            var groupBy = columnDefinition.csvGroupBy;
            var csvContent = [];
            var processCsvRows = function (rows) {
                if (!rows) {
                    return;
                }
                for (var i = 0; i < rows.length; i++) {
                    var row = rows[i];
                    var rowItems = [];
                    for (var columnIndex = 0; columnIndex < columnNames.length; columnIndex++) {
                        var val = row[columnNames[columnIndex]];
                        rowItems.push(val);
                    }
                    csvContent.push(rowItems);
                }
            };
            if (groupBy) {
                csvContent.push([topLine]);
                csvContent.push([]);
                // Group data by category
                var groupedData = data.reduce(function (acc, row) {
                    var category = row[groupBy];
                    if (!acc[category]) {
                        acc[category] = [];
                    }
                    acc[category].push(row);
                    return acc;
                }, {});
                // Loop through each category and its rows
                for (var category in groupedData) {
                    csvContent.push([category]);
                    csvContent.push(header); // Add column headings for each category
                    var rows = groupedData[category];
                    // Loop through each row in the current category
                    processCsvRows(rows);
                }
            }
            else {
                csvContent.push([topLine]);
                csvContent.push(header);
                processCsvRows(data);
            }
            var managedAccounts = this.report.managedAccounts;
            if (managedAccounts) {
                Object.keys(managedAccounts).forEach(function (key) {
                    if (managedAccounts[key].items && managedAccounts[key].items.length) {
                        csvContent.push(["CG Managed Accounts"]);
                        for (var i = 0; i < managedAccounts[key].items.length; i++) {
                            if (managedAccounts[key].items[i] && managedAccounts[key].items[i].items && managedAccounts[key].items[i].items.length > 0) {
                                var asset = managedAccounts[key].items[i];
                                csvContent.push([asset.categoryName, "", "", "", asset.subtotal.totalCost, "", asset.subtotal.marketValue, asset.subtotal.profitOrLoss, asset.subtotal.pctAssets, "", "", ""]);
                                csvContent.push(header);
                                processCsvRows(asset.items);
                            }
                        }
                    }
                });
            }
            var csvTotalColumnNames = columnDefinition.csvTotalColumnNames;
            var csvTotalDisplayNames = columnDefinition.csvTotalDisplayNames;
            if (columnDefinition.csvTotalColumnNames) {
                var totals = this.report.grandTotal;
                //Grand totals
                csvContent.push(csvTotalDisplayNames);
                var rowItems = [];
                for (var columnIndex = 0; columnIndex < csvTotalColumnNames.length; columnIndex++) {
                    var val = totals[csvTotalColumnNames[columnIndex]];
                    rowItems.push(val || "");
                }
                csvContent.push(rowItems);
            }
            var EOL = '\r\n';
            var csvContentString = "";
            for (var _i = 0, csvContent_1 = csvContent; _i < csvContent_1.length; _i++) {
                var row = csvContent_1[_i];
                var rowItems_1 = [];
                for (var _a = 0, row_1 = row; _a < row_1.length; _a++) {
                    var field = row_1[_a];
                    var val_1 = field;
                    if (val_1 === undefined || val_1 === null) {
                        val_1 = "";
                    }
                    if (typeof val_1 === 'string') {
                        val_1 = val_1.replace(/"/g, '""');
                    }
                    if (typeof val_1 === 'number') {
                        rowItems_1.push(val_1);
                    }
                    else {
                        rowItems_1.push('"' + val_1 + '"');
                    }
                }
                csvContentString += rowItems_1.join(',') + EOL;
            }
            return new Blob([csvContentString], { type: 'text/csv;charset=utf-8' });
        };
        ReportDownloadService.prototype.getColumnNames = function () {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.columnNames : null;
        };
        ReportDownloadService.prototype.getCsvColumnHeadings = function () {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.csvDisplayNames : null;
        };
        ReportDownloadService.prototype.getCsvColumnNames = function () {
            var definitions = this.getColumnDefinitions(this.report.reportType);
            return definitions ? definitions.csvColumnNames : null;
        };
        ReportDownloadService.getCsvTopLine = function (account, creationDateUtc, dateFrom, dateTo, asAtDate) {
            var adviser = account.adviserName ? account.adviserName :
                account.adviserCode ? account.adviserCode : "<unknown>";
            var timestamp = moment.tz(creationDateUtc, 'Australia/Sydney').format("h:mm a [AEST on] D MMM YYYY");
            var dateString;
            if (asAtDate === undefined) {
                var fromDateStr = moment(dateFrom).format("[From:] D MMM YYYY");
                var toDateStr = moment(dateTo).format("[To:] D MMM YYYY");
                dateString = fromDateStr + ' ' + toDateStr;
            }
            else {
                var asAtDateStr = moment(asAtDate).format("[As at:] D MMM YYYY");
                dateString = asAtDateStr;
            }
            return 'Adviser: ' + adviser +
                ', Account: ' + account.accountId +
                ', ' + dateString +
                ', Report generated at: ' + timestamp;
        };
        ReportDownloadService.prototype.getCsvData = function () {
            switch (this.report.reportType) {
                case Patersons.ReportType.CapitalTransactions:
                    return this.getCapitalTransactionStatementCsv();
                case Patersons.ReportType.QuarterlyReports:
                    return this.getQuarterlyReportsCsv();
                case Patersons.ReportType.Cash:
                    return this.getCashCsv();
                case Patersons.ReportType.Income:
                    return this.getIncomeCsv();
                case Patersons.ReportType.CapitalGains:
                    return this.getCapitalGainsCsv();
                case Patersons.ReportType.UnrealisedCapitalGains:
                    return this.getUnrealisedCapitalGainsCsv();
                case Patersons.ReportType.Performance:
                    return this.getPerformanceCsv();
                case Patersons.ReportType.TaxReports:
                    return this.getTaxReportsCsv();
                case Patersons.ReportType.Valuation:
                    return this.getValuationStatementCsv();
                case Patersons.ReportType.StandardLedger:
                    return this.getStandardLedgerCsv();
                default:
                    console.error('Unrecognised report type encountered: ' + this.report.reportType);
                    return null;
            }
        };
        ReportDownloadService.prototype.getCapitalTransactionStatementCsv = function () {
            var _this = this;
            var result = [], csvData;
            var statement = this.report;
            var transactions;
            if (statement && statement.tradeCategories && statement.tradeCategories.length > 0) {
                var categories = statement.tradeCategories;
                for (var i = 0; i < categories.length; i++) {
                    var category = categories[i];
                    transactions = category.transactions;
                    csvData = angular.copy(transactions);
                    csvData.map(function (txn) {
                        delete txn.isSell;
                        delete txn.sign;
                        return _this.formatDataRow(txn);
                    });
                    result = result.concat(csvData);
                }
            }
            return result;
        };
        ReportDownloadService.prototype.getCapitalGainsCsv = function () {
            var _this = this;
            var result = [], csvData;
            var report = this.report;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses;
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i];
                    var assets = assetClass.assets;
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j];
                        var capitalGains = asset.capitalGains;
                        csvData = angular.copy(capitalGains);
                        csvData.map(function (txn) {
                            return _this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }
            return result;
        };
        ReportDownloadService.prototype.getUnrealisedCapitalGainsCsv = function () {
            var _this = this;
            var result = [], csvData;
            var report = this.report;
            if (report && report.assetClasses.length > 0) {
                var assetClasses = report.assetClasses;
                for (var i = 0; i < assetClasses.length; i++) {
                    var assetClass = assetClasses[i];
                    var assets = assetClass.assets;
                    for (var j = 0; j < assets.length; j++) {
                        var asset = assets[j];
                        var capitalGains = asset.capitalGains;
                        csvData = angular.copy(capitalGains);
                        csvData.map(function (txn) {
                            return _this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }
            return result;
        };
        ReportDownloadService.prototype.getPerformanceCsv = function () {
            var report = this.report;
            return [report];
        };
        ReportDownloadService.prototype.getQuarterlyReportsCsv = function () {
            var _this = this;
            var result = [], csvData;
            var quarterlyReportsListReport = this.report;
            if (quarterlyReportsListReport && quarterlyReportsListReport.investorDocs && quarterlyReportsListReport.investorDocs.length > 0) {
                var entries = quarterlyReportsListReport.investorDocs;
                csvData = angular.copy(entries);
                csvData.map(function (txn) {
                    return _this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }
            return result;
        };
        ReportDownloadService.prototype.getTaxReportsCsv = function () {
            var _this = this;
            var result = [], csvData;
            var taxReportsListReport = this.report;
            if (taxReportsListReport && taxReportsListReport.investorDocs && taxReportsListReport.investorDocs.length > 0) {
                var entries = taxReportsListReport.investorDocs;
                csvData = angular.copy(entries);
                csvData.map(function (txn) {
                    return _this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }
            return result;
        };
        ReportDownloadService.prototype.getCashCsv = function () {
            var _this = this;
            var result = [], csvData;
            var cashReport = this.report;
            if (cashReport && cashReport.transactionGroups && cashReport.transactionGroups.length > 0) {
                var groups = cashReport.transactionGroups;
                for (var i = 0; i < groups.length; i++) {
                    var group = groups[i];
                    var transactions = group.transactions;
                    csvData = angular.copy(transactions);
                    csvData.map(function (txn) {
                        delete txn.aac;
                        delete txn.accountName;
                        delete txn.netValue;
                        delete txn.openingBalance;
                        return _this.formatDataRow(txn);
                    });
                    result = result.concat(csvData);
                }
            }
            return result;
        };
        ReportDownloadService.prototype.getIncomeCsv = function () {
            var _this = this;
            var result = [], csvData, transactions;
            var columnDefinitions = this.getColumnDefinitions(this.report.reportType);
            var headerCols = columnDefinitions.columnNames;
            var displayHeaderCols = columnDefinitions.displayNames;
            var widths = columnDefinitions.columnWidths;
            var incomeReport = this.report;
            var transactionTypeCategories = incomeReport.transactionTypeCategories;
            if (transactionTypeCategories && transactionTypeCategories.length > 0) {
                for (var cat = 0; cat < transactionTypeCategories.length; cat++) {
                    var subcategories = transactionTypeCategories[cat].subCategories;
                    for (var subCat = 0; subCat < subcategories.length; subCat++) {
                        var lineItems = subcategories[subCat].lineItems;
                        csvData = angular.copy(lineItems);
                        csvData.map(function (txn) {
                            return _this.formatDataRow(txn);
                        });
                        result = result.concat(csvData);
                    }
                }
            }
            return result;
        };
        ReportDownloadService.prototype.getStandardLedgerCsv = function () {
            var _this = this;
            var result = [], csvData, transactions;
            var standardLedgerReport = this.report;
            if (standardLedgerReport && standardLedgerReport.ledgerEntries && standardLedgerReport.ledgerEntries.length > 0) {
                var entries = standardLedgerReport.ledgerEntries;
                csvData = angular.copy(entries);
                csvData.map(function (txn) {
                    return _this.formatDataRow(txn);
                });
                result = result.concat(csvData);
            }
            return result;
        };
        ReportDownloadService.prototype.getValuationStatementCsv = function () {
            var _this = this;
            var result = [];
            var csvData;
            var statement = this.report;
            if (statement.nonLoaSecurities && statement.nonLoaSecurities.length > 0) {
                var categories = statement.nonLoaSecurities;
                categories.forEach(function (cat) {
                    csvData = angular.copy(cat.items);
                    csvData = csvData.map(function (itm) {
                        return {
                            category: itm.categoryName,
                            code: itm.code,
                            securityName: itm.securityName,
                            quantity: itm.quantity,
                            costPrice: _this.safeFixedDecimals(itm.costPrice, 4),
                            totalCost: _this.safeFixedDecimals(itm.totalCost, 2),
                            price: _this.safeFixedDecimals(itm.price, 4),
                            marketValue: _this.safeFixedDecimals(itm.marketValue, 2),
                            profitOrLoss: _this.safeFixedDecimals(itm.profitOrLoss, 2),
                            pctAssets: _this.safeFixedDecimals(itm.pctAssets, 2),
                            estAnnualIncome: _this.safeFixedDecimals(itm.estAnnualIncome, 2),
                            estFrankingCredits: _this.safeFixedDecimals(itm.estFrankingCredits, 2),
                            estGrossYield: _this.safeFixedDecimals(itm.estGrossYield, 2)
                        };
                    });
                    result = result.concat(csvData);
                });
            }
            if (statement.nonLoaUnsettledDividends && statement.nonLoaUnsettledDividends.items && statement.nonLoaUnsettledDividends.items.length > 0) {
                var dividends = statement.nonLoaUnsettledDividends;
                csvData = angular.copy(dividends.items);
                csvData = csvData.map(function (itm) {
                    return {
                        category: "Unsettled Dividends",
                        code: itm.securityCode,
                        securityName: itm.securityName,
                        quantity: null,
                        costPrice: null,
                        totalCost: null,
                        price: null,
                        marketValue: _this.safeFixedDecimals(itm.unsettledIncome, 2),
                        profitOrLoss: null,
                        pctAssets: null,
                        estAnnualIncome: null,
                        estFrankingCredits: null,
                        estGrossYield: null
                    };
                });
                result = result.concat(csvData);
            }
            if (statement.loaSecurities && statement.loaSecurities.length > 0) {
                var categories = statement.loaSecurities;
                categories.forEach(function (cat) {
                    csvData = angular.copy(cat.items);
                    csvData = csvData.map(function (itm) {
                        return {
                            category: itm.categoryName,
                            code: itm.code,
                            securityName: itm.securityName,
                            quantity: itm.quantity,
                            costPrice: _this.safeFixedDecimals(itm.costPrice, 4),
                            totalCost: _this.safeFixedDecimals(itm.totalCost, 2),
                            price: _this.safeFixedDecimals(itm.price, 4),
                            marketValue: _this.safeFixedDecimals(itm.marketValue, 2),
                            profitOrLoss: _this.safeFixedDecimals(itm.profitOrLoss, 2),
                            pctAssets: _this.safeFixedDecimals(itm.pctAssets, 2),
                            estAnnualIncome: _this.safeFixedDecimals(itm.estAnnualIncome, 2),
                            estFrankingCredits: _this.safeFixedDecimals(itm.estFrankingCredits, 2),
                            estGrossYield: _this.safeFixedDecimals(itm.estGrossYield, 2)
                        };
                    });
                    result = result.concat(csvData);
                });
            }
            if (statement.loaUnsettledDividends && statement.loaUnsettledDividends.items && statement.loaUnsettledDividends.items.length > 0) {
                var dividends = statement.loaUnsettledDividends;
                csvData = angular.copy(dividends.items);
                csvData = csvData.map(function (itm) {
                    return {
                        category: "Unsettled Dividends",
                        code: itm.securityCode,
                        securityName: itm.securityName,
                        quantity: null,
                        costPrice: null,
                        totalCost: null,
                        price: null,
                        marketValue: _this.safeFixedDecimals(itm.unsettledIncome, 2),
                        profitOrLoss: null,
                        pctAssets: null,
                        estAnnualIncome: null,
                        estFrankingCredits: null,
                        estGrossYield: null
                    };
                });
                result = result.concat(csvData);
            }
            return result;
        };
        ReportDownloadService.prototype.safeFixedDecimals = function (value, decimals) {
            if (value === null || value === undefined) {
                return undefined;
            }
            return parseFloat(value.toFixed(decimals));
        };
        ReportDownloadService.prototype.getPerformanceLayout = function () {
            var _this = this;
            return {
                hLineWidth: function (i, node) { return 1; },
                vLineWidth: function (i, node) { return 1; },
                hLineColor: function (i, node) {
                    if (i === 1 || i === node.table.body.length - 1) {
                        return _this.userCompany.colorSecondary;
                    }
                    else {
                        return 'lightgray';
                    }
                },
                vLineColor: function (i, node) { return 'lightgray'; }
            };
        };
        ReportDownloadService.prototype.getTablelayout = function (subtotal, total, headers, holdings, noFooter) {
            var _this = this;
            if (noFooter === void 0) { noFooter = null; }
            if (holdings) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    vLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 0) {
                            return 'black';
                        }
                        if (i === 2 || i === node.table.body.length - 1) {
                            return _this.userCompany.colorSecondary;
                        }
                        else {
                            return 'lightgray';
                        }
                        //return 'lightgray';
                    },
                    vLineColor: function (i, node) { return 'lightgray'; }
                };
            }
            if (subtotal) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    vLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 0) {
                            return _this.userCompany.colorSecondary;
                        }
                    },
                    vLineColor: function (i, node) { return 'lightgray'; }
                };
            }
            if (total) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    vLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 0) {
                            return _this.userCompany.colorSecondary;
                        }
                    },
                    vLineColor: function (i, node) { return 'lightgray'; }
                };
            }
            if (headers) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    vLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 1 || i === node.table.body.length - 1) {
                            return _this.userCompany.colorSecondary;
                        }
                        else {
                            return 'lightgray';
                        }
                    },
                    vLineColor: function (i, node) { return 'lightgray'; }
                };
            }
            if (noFooter) {
                return {
                    hLineWidth: function (i, node) { return 1; },
                    vLineWidth: function (i, node) { return 1; },
                    hLineColor: function (i, node) {
                        if (i === 1) {
                            return _this.userCompany.colorSecondary;
                        }
                        else {
                            return 'lightgray';
                        }
                    },
                    vLineColor: function (i, node) { return 'lightgray'; }
                };
            }
            return {
                hLineWidth: function (i, node) { return 1; },
                vLineWidth: function (i, node) { return 1; },
                //hLineColor: function(i, node) { return 'lightgray';},
                hLineColor: function (i, node) {
                    if (i === node.table.body.length) {
                        return _this.userCompany.colorSecondary;
                    }
                    else {
                        return 'lightgray';
                    }
                },
                vLineColor: function (i, node) { return 'lightgray'; }
            };
        };
        ReportDownloadService.prototype.layoutThinLightBorderHeader = function () {
            var _this = this;
            return {
                hLineWidth: function (i, node) { return 1; },
                vLineWidth: function (i, node) { return 1; },
                hLineColor: function (i, node) {
                    if (i === 1 || i === node.table.body.length - 1) {
                        return _this.userCompany.colorSecondary;
                    }
                    else {
                        return 'lightgray';
                    }
                },
                vLineColor: function (i, node) { return 'lightgray'; },
            };
        };
        ReportDownloadService.prototype.layoutThinLightBorderHeaderHoldings = function () {
            var _this = this;
            return {
                hLineWidth: function (i, node) { return 1; },
                vLineWidth: function (i, node) { return 1; },
                hLineColor: function (i, node) {
                    if (i === 2 || i === node.table.body.length - 1) {
                        return _this.userCompany.colorSecondary;
                    }
                    else {
                        return 'lightgray';
                    }
                },
                vLineColor: function (i, node) { return 'lightgray'; },
            };
        };
        ReportDownloadService.prototype.layoutThinLightBorder = function () {
            var _this = this;
            return {
                hLineWidth: function (i, node) { return 1; },
                vLineWidth: function (i, node) { return 1; },
                //hLineColor: function(i, node) { return 'lightgray';},
                hLineColor: function (i, node) {
                    if (i === node.table.body.length) {
                        return _this.userCompany.colorSecondary;
                    }
                    else {
                        return 'lightgray';
                    }
                },
                vLineColor: function (i, node) { return 'lightgray'; },
            };
        };
        ReportDownloadService.$inject = ['$q', '$filter', 'pdfBuilderService', 'userCompanyService'];
        return ReportDownloadService;
    }());
    Patersons.ReportDownloadService = ReportDownloadService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var BulkDownloadService = (function () {
        function BulkDownloadService($q, $window, $http) {
            this.downloadItems = function (items, zipFilename) {
                var zip = new JSZip();
                var http = this.http;
                var window = this.window;
                var fileDownloads = [];
                angular.forEach(items, function (item) {
                    fileDownloads.push(http.get(item.uri, { responseType: 'arraybuffer' })
                        .then(function (result) {
                        var filename = item.name;
                        // If the item has a pretty filename then use it as the filename
                        if (item.prettyFileName && item.prettyFileName !== '') {
                            filename = item.prettyFileName;
                        }
                        console.info('Zipping ' + filename);
                        zip.file(filename, result.data, { binary: true });
                    })
                        .catch(function (response) {
                        console.error('Error downloading file from ' + item.uri, response.status, response.data);
                    }));
                });
                var deferred = this.q.defer();
                return this.q.all(fileDownloads)
                    .then(function () {
                    console.info('Generating zip file');
                    zip.generateAsync({ type: "blob" })
                        .then(function (blob) {
                        window.saveAs(blob, zipFilename);
                        deferred.resolve();
                        return deferred.promise;
                    })
                        .catch(function (response) {
                        console.error('Error saving zip file', response.status, response.data);
                        deferred.reject(response);
                        return deferred.promise;
                    });
                });
            };
            this.q = $q;
            this.http = $http;
            this.window = $window;
        }
        BulkDownloadService.$inject = ['$q', '$window', '$http'];
        return BulkDownloadService;
    }());
    Patersons.BulkDownloadService = BulkDownloadService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var HelpService = (function (_super) {
        __extends(HelpService, _super);
        function HelpService() {
            _super.apply(this, arguments);
        }
        HelpService.prototype.getFAQs = function () {
            return this.get("/dataService/api/Faqs");
        };
        ;
        return HelpService;
    }(Patersons.BaseService));
    Patersons.HelpService = HelpService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var NewsService = (function (_super) {
        __extends(NewsService, _super);
        function NewsService() {
            _super.apply(this, arguments);
        }
        NewsService.prototype.getNews = function () {
            return this.get("/dataService/api/News");
        };
        ;
        return NewsService;
    }(Patersons.BaseService));
    Patersons.NewsService = NewsService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var UserCompanyService = (function (_super) {
        __extends(UserCompanyService, _super);
        function UserCompanyService() {
            _super.apply(this, arguments);
            this.userCompany = null;
        }
        UserCompanyService.prototype.waitForGettingData = function () {
            var _this = this;
            var deferred = this.q.defer();
            var check = function () {
                setTimeout(function () {
                    if (!_this.isGettingData) {
                        deferred.resolve(true);
                    }
                    else {
                        check();
                    }
                }, 300);
            };
            check();
            return deferred.promise;
        };
        UserCompanyService.prototype.setFavicon = function () {
            if (this.userCompany && this.userCompany.faviconImage && !this.isFaviconSet) {
                $("#favicon").attr("href", this.userCompany.faviconImage);
                $("#favicon-shortcut").attr("href", this.userCompany.faviconImage);
                this.isFaviconSet = true;
            }
        };
        UserCompanyService.prototype.setTheme = function () {
            if (this.userCompany.colorPrimary && this.userCompany.colorPrimaryDarker && this.userCompany.colorTertiary && this.userCompany.colorSecondary && !this.isThemeSet) {
                document.documentElement.style.setProperty('--color-primary', this.userCompany.colorPrimary);
                document.documentElement.style.setProperty('--color-primary-darker', this.userCompany.colorPrimaryDarker);
                document.documentElement.style.setProperty('--color-tertiary', this.userCompany.colorTertiary);
                document.documentElement.style.setProperty('--color-secondary', this.userCompany.colorSecondary);
                cssVars({
                    variables: {
                        '--color-primary': this.userCompany.colorPrimary,
                        '--color-primary-darker': this.userCompany.colorPrimaryDarker,
                        '--color-tertiary': this.userCompany.colorTertiary,
                        '--color-secondary': this.userCompany.colorSecondary,
                    }
                });
                this.isThemeSet = true;
            }
        };
        UserCompanyService.prototype.getUserCompany = function () {
            var _this = this;
            //provide a fallback company so that the portal does not fail if the API is down
            var fallbackCompany = {
                companyName: "Canaccord Genuity",
                companyPdfImage: "/assets/content/CG WM Digital Black-01.svg",
                companyPdfImage: "/assets/content/CG WM Digital Black-01.svg",
                contactEmail: "CGAU-CGA@cgf.com",
                contactPhone: "1300 582 256",
                enableWholesaleClientsResearch: false,
            };
            var deferred = this.q.defer(); // Type the deferred to get better 'intellisense' support
            if (this.isGettingData) {
                this.waitForGettingData().then(function () {
                    deferred.resolve(_this.userCompany);
                });
            }
            else {
                if (this.userCompany === null) {
                    this.isGettingData = true;
                    var promise = this.get("/dataService/api/userCompany");
                    promise.then(function (data) {
                        _this.userCompany = data;
                        _this.isGettingData = false;
                        _this.setFavicon();
                        _this.setTheme();
                        deferred.resolve(_this.userCompany);
                    }, function (err) {
                        _this.isGettingData = false;
                        _this.setFavicon();
                        _this.setTheme();
                        deferred.resolve(fallbackCompany);
                    });
                }
                else {
                    this.isGettingData = false;
                    this.setFavicon();
                    deferred.resolve(this.userCompany);
                }
            }
            return deferred.promise;
        };
        ;
        return UserCompanyService;
    }(Patersons.BaseService));
    Patersons.UserCompanyService = UserCompanyService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var RecaptchaVerifyService = (function (_super) {
        __extends(RecaptchaVerifyService, _super);
        function RecaptchaVerifyService() {
            _super.apply(this, arguments);
        }
        // Confirm the response token received from Google Recaptcha is valid
        // This is posted to a server side controller so as not to expose the Recaptcha secret
        RecaptchaVerifyService.prototype.siteVerify = function (response) {
            var rv = new Patersons.RecaptchaVerify();
            rv.remoteip = '';
            rv.response = response;
            var absoluteUrl = this.baseUrl + "/dataService/api/recaptcha";
            return this.post("/dataService/api/recaptcha", rv);
        };
        ;
        return RecaptchaVerifyService;
    }(Patersons.BaseService));
    Patersons.RecaptchaVerifyService = RecaptchaVerifyService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ConfigurationService = (function (_super) {
        __extends(ConfigurationService, _super);
        function ConfigurationService() {
            _super.apply(this, arguments);
        }
        ConfigurationService.prototype.getValueByKey = function (key) {
            return this.get("/dataService/odata/appconfigurations('" + key + "')");
        };
        return ConfigurationService;
    }(Patersons.BaseService));
    Patersons.ConfigurationService = ConfigurationService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var BannerService = (function (_super) {
        __extends(BannerService, _super);
        function BannerService() {
            _super.apply(this, arguments);
        }
        BannerService.prototype.getCurrent = function () {
            return this.get("/dataService/odata/banners?$filter=publishDate lt " + new Date().toJSON() + "&$orderby=publishDate desc&$top=1");
        };
        return BannerService;
    }(Patersons.BaseService));
    Patersons.BannerService = BannerService;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ChangeRequest = (function () {
        function ChangeRequest() {
            this.isApproved = false;
            this.isRejected = false;
        }
        return ChangeRequest;
    }());
    Patersons.ChangeRequest = ChangeRequest;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ChangeRequestService = (function (_super) {
        __extends(ChangeRequestService, _super);
        function ChangeRequestService() {
            _super.apply(this, arguments);
        }
        ChangeRequestService.prototype.getChangeRequests = function () {
            return this.get("/dataService/odata/changeRequests");
        };
        ChangeRequestService.prototype.getChangeRequestsForApproval = function () {
            return this.get("/dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApproval");
        };
        ChangeRequestService.prototype.approveChangeRequest = function (changeRequestId, verificationCode) {
            return this.post('/dataService/odata/changeRequests(' + changeRequestId + ')/ChangeRequestService.ApproveChangeRequest', { smsToken: verificationCode });
        };
        ;
        ChangeRequestService.prototype.rejectChangeRequest = function (changeRequestId) {
            return this.post('/dataService/odata/changeRequests(' + changeRequestId + ')/ChangeRequestService.RejectChangeRequest', null);
        };
        ;
        ChangeRequestService.prototype.areAllAccountApproversRegistered = function (accountCode) {
            return this.get("/dataService/api/portfolios/" + accountCode + "/AreAllAccountApproversRegistered");
        };
        ;
        ChangeRequestService.prototype.getAccountApproversCount = function (accountCode) {
            return this.get("/dataService/api/portfolios/" + accountCode + "/GetAccountApproversCount");
        };
        ;
        return ChangeRequestService;
    }(Patersons.BaseService));
    Patersons.ChangeRequestService = ChangeRequestService;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var Feed = (function () {
        function Feed() {
        }
        return Feed;
    }());
    Patersons.Feed = Feed;
    var ResearchFeedService = (function (_super) {
        __extends(ResearchFeedService, _super);
        function ResearchFeedService() {
            _super.apply(this, arguments);
        }
        ResearchFeedService.prototype.getAllPrivateWealthResearch = function () {
            return this.get("/dataService/api/ResearchArticles/AllPrivateWealthResearch");
        };
        ResearchFeedService.prototype.getAllStrategyAndEconomics = function () {
            return this.get("/dataService/api/ResearchArticles/AllStrategyAndEconomics");
        };
        ResearchFeedService.prototype.getFeaturedStrategyAndEconomics = function () {
            return this.get("/dataService/api/ResearchArticles/FeaturedStrategyAndEconomics");
        };
        ResearchFeedService.prototype.getTop3StrategyAndEconomics = function () {
            return this.get("/dataService/api/ResearchArticles/Top3StrategyAndEconomics");
        };
        ResearchFeedService.prototype.getTop3PrivateWealthResearch = function () {
            return this.get("/dataService/api/ResearchArticles/Top3PrivateWealthResearch");
        };
        ResearchFeedService.prototype.getLatestMorningMarket = function () {
            return this.get("/dataService/api/ResearchArticles/LatestMorningMarket");
        };
        ResearchFeedService.prototype.getAllQuantitativeAnalysis = function () {
            return this.get("/dataService/api/ResearchArticles/AllQuantitativeAnalysis");
        };
        ResearchFeedService.prototype.getFeaturedQuantitativeAnalysis = function () {
            return this.get("/dataService/api/ResearchArticles/FeaturedQuantitativeAnalysis");
        };
        ResearchFeedService.prototype.getFeaturedPrivateWealthResearch = function () {
            return this.get("/dataService/api/ResearchArticles/FeaturedPrivateWealthResearch");
        };
        ResearchFeedService.prototype.getTop3QuantitativeAnalysis = function () {
            return this.get("/dataService/api/ResearchArticles/Top3QuantitativeAnalysis");
        };
        ResearchFeedService.prototype.getArticle = function (articleId) {
            return this.get("/dataService/api/ResearchArticles/GetArticle?articleId=" + articleId);
        };
        ResearchFeedService.prototype.getLatestFeedItemForCategory = function (feedItems, category) {
            console.log(feedItems);
            if (feedItems === null || feedItems === undefined) {
                return null;
            }
            var filteredItems = feedItems.filter(function (item) { return item.publication.toLowerCase() === category.toLowerCase(); });
            return this.orderFeedItemsByPublishedDateDescending(filteredItems)[0];
        };
        ResearchFeedService.prototype.getLatestFeedItemExcludingCategories = function (feedItems, categories, index) {
            if (feedItems === null || feedItems === undefined) {
                return null;
            }
            var filteredItems = feedItems.filter(function (item) { return !item.categories.some(function (c) { return categories.indexOf(c) != -1; }); });
            if (filteredItems.length <= index) {
                return null;
            }
            return this.orderFeedItemsByPublishedDateDescending(filteredItems)[index];
        };
        ResearchFeedService.prototype.orderFeedItemsByPublishedDateDescending = function (feedItems) {
            if (feedItems === null || feedItems === undefined) {
                return null;
            }
            return feedItems.sort(function (a, b) {
                return moment(b.publishedDate).toDate().getTime() - moment(a.publishedDate).toDate().getTime();
            });
        };
        return ResearchFeedService;
    }(Patersons.BaseService));
    Patersons.ResearchFeedService = ResearchFeedService;
})(Patersons || (Patersons = {}));

var myServiceModule = angular.module("app.services", []);
myServiceModule.value("version", "1.0.0");
myServiceModule.service('selectionService', Patersons.SelectionService);
myServiceModule.service('tokenService', Patersons.TokenService);
myServiceModule.service('sessionService', Patersons.SessionService);
myServiceModule.service('bearerInjector', Patersons.BearerInjector);
myServiceModule.service('identityService', Patersons.IdentityService);
myServiceModule.service('analysisService', Patersons.AnalysisService);
myServiceModule.service('clientConfigService', Patersons.ClientConfigService);
myServiceModule.service('portfolioService', Patersons.PortfolioService);
myServiceModule.service('myDetailsService', Patersons.MyDetailsService);
myServiceModule.service('recaptchaVerifyService', Patersons.RecaptchaVerifyService);
myServiceModule.service('configurationService', Patersons.ConfigurationService);
myServiceModule.service('bannerService', Patersons.BannerService);
myServiceModule.service('reportService', Patersons.ReportService);
myServiceModule.service('reportDownloadService', Patersons.ReportDownloadService);
myServiceModule.service('navigationService', Patersons.NavigationService);
myServiceModule.service('bulkDownloadService', Patersons.BulkDownloadService);
myServiceModule.service('helpService', Patersons.HelpService);
myServiceModule.service('newsService', Patersons.NewsService);
myServiceModule.service('userCompanyService', Patersons.UserCompanyService);
myServiceModule.service('changeRequestService', Patersons.ChangeRequestService);
myServiceModule.service('morningStarService', Patersons.MorningStarService);
myServiceModule.service('researchFeedService', Patersons.ResearchFeedService);
myServiceModule.service('pdfBuilderService', Patersons.PDFBuilderService);

'use strict';
var Patersons;
(function (Patersons) {
    var MorningStarXrayPortfolio = (function () {
        function MorningStarXrayPortfolio() {
            this.apiOptions = '{type: 3}';
            this.holdingAllocation = new Array();
            this.benchmark = new MorningStarXrayIdentifier('EUCA000620', 'MSID', 0); // the morningstar MSID they gave us...it will probably change
        }
        return MorningStarXrayPortfolio;
    }());
    Patersons.MorningStarXrayPortfolio = MorningStarXrayPortfolio;
    var MorningStarXrayIdentifier = (function () {
        function MorningStarXrayIdentifier($identifier, $type, $amount) {
            this.Identifier = $identifier;
            this.IdentifierType = $type;
            this.Amount = $amount;
        }
        return MorningStarXrayIdentifier;
    }());
    Patersons.MorningStarXrayIdentifier = MorningStarXrayIdentifier;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var Investor = (function () {
        function Investor() {
        }
        return Investor;
    }());
    Patersons.Investor = Investor;
    var AccoladeOptions = (function () {
        function AccoladeOptions() {
        }
        return AccoladeOptions;
    }());
    Patersons.AccoladeOptions = AccoladeOptions;
    var ResearchSubscription = (function () {
        function ResearchSubscription() {
        }
        return ResearchSubscription;
    }());
    Patersons.ResearchSubscription = ResearchSubscription;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var OrderRequest = (function () {
        function OrderRequest() {
        }
        return OrderRequest;
    }());
    Patersons.OrderRequest = OrderRequest;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var User = (function () {
        function User() {
        }
        return User;
    }());
    Patersons.User = User;
    var Profile = (function () {
        function Profile() {
        }
        return Profile;
    }());
    Patersons.Profile = Profile;
    var ProfileAddress = (function () {
        function ProfileAddress() {
        }
        Object.defineProperty(ProfileAddress.prototype, "address", {
            get: function () {
                return [this.addressLine1, this.addressLine2, this.addressLine3, this.addressLine4, this.postcode, this.country].filter(Boolean).join("\n");
            },
            enumerable: true,
            configurable: true
        });
        return ProfileAddress;
    }());
    Patersons.ProfileAddress = ProfileAddress;
    var PhoneDetails = (function () {
        function PhoneDetails() {
        }
        return PhoneDetails;
    }());
    Patersons.PhoneDetails = PhoneDetails;
    var ForgottenPanDetails = (function () {
        function ForgottenPanDetails() {
        }
        return ForgottenPanDetails;
    }());
    Patersons.ForgottenPanDetails = ForgottenPanDetails;
    var ForgottenPasswordDetails = (function () {
        function ForgottenPasswordDetails() {
        }
        return ForgottenPasswordDetails;
    }());
    Patersons.ForgottenPasswordDetails = ForgottenPasswordDetails;
    var CreateAccount = (function () {
        function CreateAccount() {
        }
        return CreateAccount;
    }());
    Patersons.CreateAccount = CreateAccount;
    var TaxFileNumber = (function () {
        function TaxFileNumber() {
        }
        return TaxFileNumber;
    }());
    Patersons.TaxFileNumber = TaxFileNumber;
    var PasswordResetDetails = (function () {
        function PasswordResetDetails() {
        }
        return PasswordResetDetails;
    }());
    Patersons.PasswordResetDetails = PasswordResetDetails;
    var SetPasswordDetails = (function () {
        function SetPasswordDetails() {
        }
        return SetPasswordDetails;
    }());
    Patersons.SetPasswordDetails = SetPasswordDetails;
    var ChangePasswordDetails = (function () {
        function ChangePasswordDetails() {
        }
        return ChangePasswordDetails;
    }());
    Patersons.ChangePasswordDetails = ChangePasswordDetails;
    var ChangeEmailDetails = (function () {
        function ChangeEmailDetails() {
        }
        return ChangeEmailDetails;
    }());
    Patersons.ChangeEmailDetails = ChangeEmailDetails;
    var SkipMobileDetails = (function () {
        function SkipMobileDetails() {
            this.skipMobileRegistration = true;
        }
        return SkipMobileDetails;
    }());
    Patersons.SkipMobileDetails = SkipMobileDetails;
    var PhoneConfirmationDetails = (function () {
        function PhoneConfirmationDetails() {
        }
        return PhoneConfirmationDetails;
    }());
    Patersons.PhoneConfirmationDetails = PhoneConfirmationDetails;
    var EmailConfirmation = (function () {
        function EmailConfirmation() {
        }
        return EmailConfirmation;
    }());
    Patersons.EmailConfirmation = EmailConfirmation;
    var ClientAdviser = (function () {
        function ClientAdviser(firstname, surname, telephone, email, description, headshotLarge, headshotSmall) {
            this.Firstname = firstname;
            this.Surname = surname;
            this.Telephone = telephone;
            this.Email = email;
            this.Description = description;
            this.HeadshotLarge = headshotLarge;
            this.HeadshotSmall = headshotSmall;
        }
        return ClientAdviser;
    }());
    Patersons.ClientAdviser = ClientAdviser;
    var RecaptchaVerify = (function () {
        function RecaptchaVerify() {
        }
        return RecaptchaVerify;
    }());
    Patersons.RecaptchaVerify = RecaptchaVerify;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var UserPreferences = (function () {
        function UserPreferences() {
            this.pan = '';
            this.skipMobileRegistration = false;
        }
        UserPreferences.load = function (pan) {
            var prefsString = localStorage.getItem(UserPreferences.preferenceKeyName(pan));
            var prefs = JSON.parse(prefsString) || new UserPreferences();
            prefs.pan = pan;
            return prefs;
        };
        UserPreferences.prototype.save = function () {
            var prefsString = JSON.stringify(this, this.jsonReplacer);
            localStorage.setItem(UserPreferences.preferenceKeyName(this.pan), prefsString);
        };
        UserPreferences.preferenceKeyName = function (pan) {
            return "Patersons.Preferences." + pan;
        };
        UserPreferences.prototype.jsonReplacer = function (key, value) {
            if (key == 'pan') {
                return undefined;
            }
            else {
                return value;
            }
        };
        return UserPreferences;
    }());
    Patersons.UserPreferences = UserPreferences;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var WatchlistItem = (function () {
        function WatchlistItem(watchlistId, isin) {
            this.isin = isin;
            this.watchlistId = watchlistId;
        }
        return WatchlistItem;
    }());
    Patersons.WatchlistItem = WatchlistItem;
    var Watchlist = (function () {
        function Watchlist(watchlistId, name, description) {
            this.id = watchlistId;
            this.name = name;
            this.description = description;
            this.watchlistItems = new Array();
        }
        return Watchlist;
    }());
    Patersons.Watchlist = Watchlist;
    var Security = (function () {
        function Security() {
        }
        return Security;
    }());
    Patersons.Security = Security;
    (function (SelectListType) {
        SelectListType[SelectListType["portfolio"] = 1] = "portfolio";
        SelectListType[SelectListType["model"] = 2] = "model";
        SelectListType[SelectListType["watchlist"] = 3] = "watchlist";
    })(Patersons.SelectListType || (Patersons.SelectListType = {}));
    var SelectListType = Patersons.SelectListType;
    var WatchlistSelectListDescriptor = (function () {
        function WatchlistSelectListDescriptor() {
        }
        return WatchlistSelectListDescriptor;
    }());
    Patersons.WatchlistSelectListDescriptor = WatchlistSelectListDescriptor;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var Account = (function () {
        function Account() {
            this.headerLoaded = false;
            this.summaryLoaded = false;
            this.summaryError = false;
            this.headerError = false;
            this.isAuthorisedAgentAccount = false;
        }
        return Account;
    }());
    Patersons.Account = Account;
    var AccountAddresses = (function () {
        function AccountAddresses() {
        }
        return AccountAddresses;
    }());
    Patersons.AccountAddresses = AccountAddresses;
    var BankingDetails = (function () {
        function BankingDetails() {
        }
        return BankingDetails;
    }());
    Patersons.BankingDetails = BankingDetails;
    // NOTE: In the UI templates, these are referred to as 'Contract Notes'.
    var ConfirmationNote = (function () {
        function ConfirmationNote() {
        }
        return ConfirmationNote;
    }());
    Patersons.ConfirmationNote = ConfirmationNote;
    var Holding = (function () {
        function Holding(marketValue, totalCost, assetCategory, isin, securityName) {
            this.marketValue = marketValue;
            this.totalCost = totalCost;
            this.assetCategory = assetCategory;
            this.isin = isin;
            this.securityName = securityName;
        }
        return Holding;
    }());
    Patersons.Holding = Holding;
    var Sector = (function () {
        function Sector() {
        }
        return Sector;
    }());
    Patersons.Sector = Sector;
    var BankAccountDetail = (function () {
        function BankAccountDetail() {
        }
        return BankAccountDetail;
    }());
    Patersons.BankAccountDetail = BankAccountDetail;
    var CashDeposit = (function () {
        function CashDeposit() {
        }
        return CashDeposit;
    }());
    Patersons.CashDeposit = CashDeposit;
    var TermDeposit = (function () {
        function TermDeposit() {
        }
        TermDeposit.prototype.hasData = function () {
            return ((typeof this.accountCode != 'undefined' && this.accountCode) ||
                (typeof this.balance != 'undefined' && this.balance) ||
                (typeof this.rate != 'undefined' && this.rate) ||
                (typeof this.maturityDate != 'undefined' && this.maturityDate) ||
                (typeof this.provider != 'undefined' && this.provider));
        };
        return TermDeposit;
    }());
    Patersons.TermDeposit = TermDeposit;
    var Quote = (function () {
        function Quote() {
        }
        return Quote;
    }());
    Patersons.Quote = Quote;
    var Address = (function () {
        function Address() {
        }
        return Address;
    }());
    Patersons.Address = Address;
    var EmailAddress = (function () {
        function EmailAddress(id, emailAddressType, email) {
            this.id = id;
            this.email = email;
            this.emailAddressType = emailAddressType;
        }
        return EmailAddress;
    }());
    Patersons.EmailAddress = EmailAddress;
    var Portfolio = (function () {
        function Portfolio() {
            this.Holdings = new Array();
        }
        return Portfolio;
    }());
    Patersons.Portfolio = Portfolio;
    var SelectedAccountTotal = (function () {
        function SelectedAccountTotal() {
            this.cashBalanceTotal = 0;
            this.equityTotalCostTotal = 0;
            this.equityMarketValueTotal = 0;
            this.equityProfitLossTotal = 0;
            this.equityEstimatedIncomeTotal = 0;
        }
        return SelectedAccountTotal;
    }());
    Patersons.SelectedAccountTotal = SelectedAccountTotal;
    var Banner = (function () {
        function Banner() {
        }
        return Banner;
    }());
    Patersons.Banner = Banner;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var CallbackCtrl = (function () {
        function CallbackCtrl($scope, $location, $window, $state, $http, tokenService, applicationInsightsService, identityService, $analytics) {
            var _this = this;
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.http = $http;
            this.tokenService = tokenService;
            this.identityService = identityService;
            this.state = $state;
            this.$analytics = $analytics;
            var url = this.location.url();
            var querystring = url.substring(url.lastIndexOf('#'), url.length);
            this.scope.events = this;
            console.log(querystring);
            var promise = this.tokenService.tokenManager.processTokenCallbackAsync(querystring);
            promise.then(function (value) {
                // The following sets the unique id for app insights to the sub
                var uuidKey = "$$appInsights__uuid";
                var uuid = applicationInsightsService._localStorage.get(uuidKey);
                if (uuid != tokenService.tokenManager.profile.sub) {
                    var uuid = applicationInsightsService._localStorage.set(uuidKey, tokenService.tokenManager.profile.sub);
                }
                $scope.events.navigateOnSuccess();
            }, function (reason) {
                alert('An error has occurred: ' + (reason && reason.message || "Unknown error"));
                _this.tokenService.tokenManager.removeToken();
                //this.tokenService.tokenManager.redirectForLogout();
                window.location = "/identity/connect/endsession";
            });
        }
        CallbackCtrl.prototype.navigateOnSuccess = function () {
            var _this = this;
            var redirect_to = '/dashboard';
            var redirect_uri = window.localStorage.getItem('$psl.redirect_uri');
            if (redirect_uri) {
                window.localStorage.removeItem('$psl.redirect_uri');
                if (redirect_uri.indexOf("confirmPassword") === -1) {
                    redirect_to = redirect_uri;
                }
            }
            if (this.tokenService.tokenManager.profile) {
                var profile = this.tokenService.tokenManager.profile;
                //let prefs: UserPreferences = UserPreferences.load(profile.preferred_username);
                this.$analytics.setUsername(profile.preferred_username);
                var trackLoginSuccess = function (callback) {
                    if (window['google_tag_manager']) {
                        var dataLayer = window["dataLayer"] || [];
                        dataLayer.push({
                            'event': 'interaction',
                            'target': 'Login',
                            'action': 'Login Success',
                            'userId': profile.preferred_username,
                            'eventCallback': function () {
                                callback();
                            },
                            'eventTimeout': 1500
                        });
                    }
                    else {
                        callback();
                    }
                };
                trackLoginSuccess(function () {
                    _this.identityService.getSkipMobileRegistration().
                        then(function (skipMobile) {
                        if (skipMobile === true) {
                            console.log(skipMobile);
                            _this.window.location.href = redirect_to;
                            return false;
                        }
                        else {
                            // check if phone number is verifyed
                            _this.identityService.getIsPhoneNumberVerifyed().
                                then(function (phone_number_verified) {
                                // if phone is veryfied
                                if (phone_number_verified === true) {
                                    console.log(profile);
                                    // go to dashboard
                                    _this.window.location.href = redirect_to;
                                    return false;
                                }
                                else {
                                    // else
                                    _this.identityService.saveSkipMobileRegistration(new Patersons.SkipMobileDetails()).
                                        then(function () {
                                        _this.window.location.href = '/registerMobile';
                                    }).
                                        catch(function () {
                                        _this.window.location.href = '/registerMobile';
                                    });
                                }
                            });
                        }
                    }).
                        catch(function (response) {
                        _this.window.location.href = redirect_to;
                        return false;
                    });
                });
            }
            else {
                this.window.location.href = redirect_to;
                return false;
            }
        };
        CallbackCtrl.$inject = ['$scope', '$location', '$window', '$state', '$http', 'tokenService', 'applicationInsightsService', 'identityService', '$analytics'];
        return CallbackCtrl;
    }());
    Patersons.CallbackCtrl = CallbackCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var NavbarCtrl = (function () {
        function NavbarCtrl($scope, $rootScope, $location, $window, $stateParams, $http, sessionService, clientConfigService, userCompanyService) {
            var _this = this;
            this.scope = $scope;
            this.rootScope = $rootScope;
            this.location = $location;
            this.window = $window;
            this.stateParams = $stateParams;
            this.http = $http;
            this.sessionService = sessionService;
            this.clientConfigService = clientConfigService;
            this.userCompanyService = userCompanyService;
            this.scope.editMode = false;
            this.scope.events = this;
            this.scope.isLoggedIn = this.sessionService.isLoggedIn();
            this.scope.isNavCollapsed = true;
            this.scope.adviserList = [];
            console.log('adviserList');
            console.log(this.scope.adviserList);
            if (this.scope.isLoggedIn) {
                //console.log('loadAdviserData');
                this.scope.profile = this.sessionService.getCurrentUserProfile();
                this.loadAdviserData();
                this.loadPendingChangeRequestCount();
                this.load();
            }
            else {
                this.scope.adviserList = [];
            }
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
                _this.scope.themeRGB = _this.hexToRgb(company.colorSecondary);
            });
            this.rootScope.$on('changeRequestActioned', function (event, data) {
                $scope.changeRequestCount -= 1;
            });
            console.log('Navbar load');
        }
        NavbarCtrl.prototype.hexToRgb = function (hex) {
            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            return result ? {
                r: parseInt(result[1], 16),
                g: parseInt(result[2], 16),
                b: parseInt(result[3], 16)
            } : null;
        };
        NavbarCtrl.prototype.load = function () {
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-autocomplete-top', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader').then(function () {
                    console.log('Done loading autocomplete.');
                    morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                        if (newVal.secId) {
                            window['openAutocompleteResult'](newVal); //declared in autocomplete config
                            morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader').setParameter('search', '');
                        }
                    });
                });
                initComponent('component-autocomplete-top-2', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader2').then(function () {
                    console.log('Done loading autocomplete.');
                    morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader2').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                        if (newVal.secId) {
                            window['openAutocompleteResult'](newVal); //declared in autocomplete config
                            morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader2').setParameter('search', '');
                        }
                    });
                });
                initComponent('component-autocomplete-top-3', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteHeader3').then(function () {
                    console.log('Done loading autocomplete.');
                    morningstar.asterix.instanceRegistry.find('ecAutocompleteHeader3').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                        if (newVal.secId) {
                            window['openAutocompleteResult'](newVal); //declared in autocomplete config
                            morningstar.asterix.instanceRegistry.get('ecAutocompleteHeader3').setParameter('search', '');
                        }
                    });
                });
            });
        };
        NavbarCtrl.prototype.login = function () {
            this.sessionService.login();
        };
        NavbarCtrl.prototype.logout = function () {
            this.sessionService.logout();
        };
        NavbarCtrl.prototype.loadAdviserData = function () {
            var _this = this;
            console.log('loadAdviserData');
            var promise = this.clientConfigService.getAdviser();
            promise.then(function (result) {
                //this.scope.$apply(() => {
                console.log('Loaded advisers');
                console.log(result);
                _this.scope.adviserList = result;
                //});
            }, function (reason) {
                _this.clientConfigService.errorHandler = reason.data;
            });
        };
        NavbarCtrl.prototype.loadPendingChangeRequestCount = function () {
            var _this = this;
            console.log('loadPendingChangeRequestCount');
            var promise = this.clientConfigService.getChangeRequestCount();
            promise.then(function (result) {
                //this.scope.$apply(() => {
                console.log('Loaded change requests');
                console.log(result);
                _this.scope.changeRequestCount = result;
                //});
            }, function (reason) {
                _this.clientConfigService.errorHandler = reason.data;
            });
        };
        NavbarCtrl.$inject = ['$scope', '$rootScope', '$location', '$window', '$stateParams', '$http', 'sessionService', 'clientConfigService', 'userCompanyService'];
        return NavbarCtrl;
    }());
    Patersons.NavbarCtrl = NavbarCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var FooterCtrl = (function () {
        function FooterCtrl($scope, sessionService, userCompanyService, reportService) {
            var _this = this;
            this.scope = $scope;
            this.userCompanyService = userCompanyService;
            this.sessionService = sessionService;
            this.reportService = reportService;
            this.scope.events = this;
            this.scope.isLoggedIn = this.sessionService.isLoggedIn();
            if (this.scope.isLoggedIn) {
                this.scope.profile = this.sessionService.getCurrentUserProfile();
                this.checkFreezeWindow();
                this.userCompanyService.getUserCompany().then(function (company) {
                    _this.scope.userCompany = company;
                });
            }
        }
        FooterCtrl.prototype.checkFreezeWindow = function () {
            var _this = this;
            this.reportService.checkFreezeWindow().then(function (freezeWindow) {
                _this.scope.freezeWindow = freezeWindow;
            });
        };
        FooterCtrl.prototype.login = function () {
            this.sessionService.login();
        };
        FooterCtrl.prototype.logout = function () {
            this.sessionService.logout();
        };
        FooterCtrl.$inject = ['$scope', 'sessionService', 'userCompanyService', 'reportService'];
        return FooterCtrl;
    }());
    Patersons.FooterCtrl = FooterCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var LandingCtrl = (function () {
        function LandingCtrl($scope, $location, $window, $state, $stateParams, $http, tokenService) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.stateParams = $stateParams;
            this.http = $http;
            this.tokenService = tokenService;
            this.scope.editMode = false;
            this.scope.events = this;
            if (this.tokenService.tokenManager) {
                if (this.tokenService.tokenManager.expired) {
                    this.tokenService.tokenManager.redirectForToken();
                }
                else {
                    $state.go("dashboard");
                }
            }
            else {
                $state.go("dashboard");
            }
        }
        LandingCtrl.$inject = ['$scope', '$location', '$window', '$state', '$stateParams', '$http', 'tokenService'];
        return LandingCtrl;
    }());
    Patersons.LandingCtrl = LandingCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var AbstractController = (function () {
        function AbstractController($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope) {
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.rootScope = $rootScope;
            this.log = $log;
            var model = document.getElementById("model").textContent.trim();
            var dictionary = JSON.parse(model);
            this.baseUrl = dictionary['hostPath'];
            var userId = dictionary['userId'];
        }
        AbstractController.prototype.redirect = function (url) {
            this.location.url(url);
            this.window.location.href = url;
            this.window.location.reload();
        };
        AbstractController.prototype.errorHandler = function (msg, Url) {
            msg = msg || "Unexpected Error";
            var self = this;
            return function (response) {
                if (response.data.exceptionMessage) {
                    this.log.error(response.data.exceptionMessage);
                }
                this.rootScope.$emit('error', { error: msg, url: Url });
                throw (response.data.errors || response.data.message || msg);
            };
        };
        AbstractController.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope'];
        return AbstractController;
    }());
    Patersons.AbstractController = AbstractController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var IdentityBaseCtrl = (function (_super) {
        __extends(IdentityBaseCtrl, _super);
        function IdentityBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
        }
        IdentityBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return IdentityBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.IdentityBaseCtrl = IdentityBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ForgottenPanCtrl = (function (_super) {
        __extends(ForgottenPanCtrl, _super);
        function ForgottenPanCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, tokenService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.scope.isBusy = false;
            this.scope.events = this;
            this.scope.isTriggered = false;
        }
        ForgottenPanCtrl.prototype.save = function () {
            var _this = this;
            this.scope.isTriggered = false;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.forgottenPanForm.$invalid) {
                return;
            }
            else {
                var dto = new Patersons.ForgottenPanDetails();
                dto.email = this.scope.email;
                dto.dob = moment.utc(this.scope.dob, "DD/MM/YYYY").toISOString();
                this.scope.isBusy = true;
                this.identityService.triggerForgottenPan(dto)
                    .then(function (result) {
                    _this.scope.isTriggered = true;
                    _this.returnToLoginScreenIn(30);
                })
                    .finally(function () {
                    _this.scope.isBusy = false;
                });
            }
        };
        ForgottenPanCtrl.prototype.returnToLoginScreenIn = function (nSeconds) {
            var _this = this;
            return new Promise(function () { return setTimeout(function () { return _this.tokenService.tokenManager.redirectForToken(); }, nSeconds * 1000); });
        };
        ForgottenPanCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'tokenService', 'navigationService'];
        return ForgottenPanCtrl;
    }(Patersons.IdentityBaseCtrl));
    Patersons.ForgottenPanCtrl = ForgottenPanCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ForgottenPasswordCtrl = (function () {
        function ForgottenPasswordCtrl($scope, $log, $location, $window, $state, $stateParams, $http, identityService, tokenService, userCompanyService) {
            var _this = this;
            this.setResponse = function (response) {
                this.response = response;
            };
            this.setWidgetId = function (widgetId) {
                console.info('Created widget ID: %s', widgetId);
                this.scope.widgetId = widgetId;
            };
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.log = $log;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.userCompanyService = userCompanyService;
            this.scope.isBusy = false;
            this.scope.isSmsRequired = false;
            this.scope.events = this;
            this.scope.isTriggered = false;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        ForgottenPasswordCtrl.prototype.save = function () {
            var _this = this;
            this.scope.isTriggered = false;
            this.scope.$broadcast('show-errors-check-validity');
            //if (this.response) {
            //    this.verifyResponse(this.response).then((result) => {
            // Once the token has been verified we can then complete the rest of the process
            //if (result && result.data && result.data.success == "true") {
            if (this.scope.forgottenPasswordForm.$invalid) {
                return;
            }
            else {
                this.scope.isBusy = true;
                this.identityService.triggerForgottenPassword(this.scope.forgottenPasswordDetails)
                    .then(function (result) {
                    _this.state.go('confirmPassword');
                }, function (reason) {
                    _this.log.warn(reason);
                    if (reason.status == '403') {
                        _this.scope.isSmsRequired = true;
                    }
                    if (reason.status == '400') {
                        _this.scope.validationMessage = reason.data.Message;
                    }
                }).
                    finally(function () {
                    _this.scope.isBusy = false;
                });
            }
            //  }
            //    });
            //}
        };
        ForgottenPasswordCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', 'identityService', 'tokenService', 'userCompanyService'];
        return ForgottenPasswordCtrl;
    }());
    Patersons.ForgottenPasswordCtrl = ForgottenPasswordCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var TwoFactorAuthenticationCtrl = (function () {
        function TwoFactorAuthenticationCtrl($scope, $uibModalInstance, identityService) {
            this.scope = $scope;
            this.scope.events = this;
            this.modalInstance = $uibModalInstance;
            this.identityService = identityService;
            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.scope.informationMessage = null;
            this.scope.errorMessage = null;
            this.scope.isSendingCode = false;
            this.scope.isBusy = false;
            this.sendVerificationCode();
        }
        TwoFactorAuthenticationCtrl.prototype.sendVerificationCode = function () {
            var _this = this;
            this.scope.isSendingCode = true;
            this.scope.isSubmitted = false;
            this.scope.informationMessage = "Sending verification code...";
            this.scope.errorMessage = null;
            this.identityService.request2FAToken()
                .then(function (result) {
                _this.scope.isError = false;
                _this.scope.informationMessage = "A code has been sent via SMS to the mobile number registered on this profile. Please enter this code below to verify your identity.";
            }, function (reason) {
                _this.scope.isError = true;
                _this.scope.informationMessage = null;
                _this.scope.errorMessage = "Failed to send verification code. Please request a new code.";
            })
                .finally(function () {
                _this.scope.isSendingCode = false;
            });
        };
        TwoFactorAuthenticationCtrl.prototype.submit = function () {
            this.scope.isSubmitted = true;
            this.modalInstance.close();
        };
        TwoFactorAuthenticationCtrl.prototype.cancel = function () {
            this.scope.isSubmitted = false;
            this.modalInstance.dismiss();
        };
        TwoFactorAuthenticationCtrl.prototype.handleErrorResponse = function (reason) {
            if (reason.status === 403) {
                this.showForbiddenMessage();
            }
            else {
                this.modalInstance.close(false);
            }
        };
        TwoFactorAuthenticationCtrl.prototype.showForbiddenMessage = function () {
            this.scope.isError = true;
            this.scope.informationMessage = null;
            this.scope.errorMessage = "The code you have entered is incorrect. Please try again, or click “Resend Code”. ";
        };
        TwoFactorAuthenticationCtrl.$inject = ['$scope', '$uibModalInstance', 'identityService'];
        return TwoFactorAuthenticationCtrl;
    }());
    Patersons.TwoFactorAuthenticationCtrl = TwoFactorAuthenticationCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var BankDetailsChangeRequestCtrl = (function (_super) {
        __extends(BankDetailsChangeRequestCtrl, _super);
        function BankDetailsChangeRequestCtrl($scope, $uibModalInstance, identityService, portfolioService, account, bankAccountDetail, saveAll) {
            _super.call(this, $scope, $uibModalInstance, identityService);
            this.portfolioService = portfolioService;
            this.accountId = account.accountId;
            this.bankAccountDetail = bankAccountDetail;
            this.saveAll = saveAll;
            this.scope.nameOfPdf = "Banking and Electronic Consent";
            this.scope.linkToPdf = "https://www.canaccordgenuity.com/494d20/globalassets/wealth-management-australia/documents/forms/banking-and-electronic-consent-form-pershing.pdf";
        }
        BankDetailsChangeRequestCtrl.prototype.submit = function () {
            var _this = this;
            this.scope.isSubmitted = true;
            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.bankAccountDetail.smsToken = this.scope.verificationCode;
            if (this.saveAll) {
                this.portfolioService.updateAllBankDetails(this.accountId, this.bankAccountDetail)
                    .then(function (result) {
                    _this.modalInstance.close(true);
                }, function (reason) {
                    _this.handleErrorResponse(reason);
                })
                    .finally(function () {
                    _this.scope.isBusy = false;
                });
            }
            else {
                this.portfolioService.updateBankDetails(this.accountId, this.bankAccountDetail)
                    .then(function (result) {
                    _this.modalInstance.close(true);
                }, function (reason) {
                    _this.handleErrorResponse(reason);
                })
                    .finally(function () {
                    _this.scope.isBusy = false;
                });
            }
        };
        BankDetailsChangeRequestCtrl.$inject = ['$scope', '$uibModalInstance', 'identityService', 'portfolioService', 'account', 'bankAccountDetail', 'saveAll'];
        return BankDetailsChangeRequestCtrl;
    }(Patersons.TwoFactorAuthenticationCtrl));
    Patersons.BankDetailsChangeRequestCtrl = BankDetailsChangeRequestCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var SensitiveEmailAddressChangeRequestCtrl = (function (_super) {
        __extends(SensitiveEmailAddressChangeRequestCtrl, _super);
        function SensitiveEmailAddressChangeRequestCtrl($scope, $uibModalInstance, identityService, portfolioService, account, emailAddresses) {
            _super.call(this, $scope, $uibModalInstance, identityService);
            this.portfolioService = portfolioService;
            this.accountId = account.accountId;
            this.emailAddresses = emailAddresses;
            this.scope.nameOfPdf = "Change of Account Details";
            this.scope.linkToPdf = "https://www.canaccordgenuity.com/4a460f/globalassets/wealth-management-australia/documents/forms/change-of-address-details-form";
        }
        SensitiveEmailAddressChangeRequestCtrl.prototype.submit = function () {
            this.scope.isSubmitted = true;
            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }
            this.updateEmailAddress(0);
        };
        SensitiveEmailAddressChangeRequestCtrl.prototype.updateEmailAddress = function (index) {
            var _this = this;
            if (index >= this.emailAddresses.length) {
                this.modalInstance.close(true);
                return;
            }
            this.scope.isBusy = true;
            this.emailAddresses[index].smsToken = this.scope.verificationCode;
            this.portfolioService.updateSensitiveEmailAddress(this.accountId, this.emailAddresses[index])
                .then(function (result) {
                _this.updateEmailAddress(index + 1);
            }, function (reason) {
                _this.handleErrorResponse(reason);
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        SensitiveEmailAddressChangeRequestCtrl.$inject = ['$scope', '$uibModalInstance', 'identityService', 'portfolioService', 'account', 'emailAddresses'];
        return SensitiveEmailAddressChangeRequestCtrl;
    }(Patersons.TwoFactorAuthenticationCtrl));
    Patersons.SensitiveEmailAddressChangeRequestCtrl = SensitiveEmailAddressChangeRequestCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var SensitiveAddressChangeRequestCtrl = (function (_super) {
        __extends(SensitiveAddressChangeRequestCtrl, _super);
        function SensitiveAddressChangeRequestCtrl($scope, $uibModalInstance, identityService, portfolioService, account, address) {
            _super.call(this, $scope, $uibModalInstance, identityService);
            this.portfolioService = portfolioService;
            this.accountId = account.accountId;
            this.address = address;
            this.scope.nameOfPdf = "Change of Account Details";
            this.scope.linkToPdf = "https://www.canaccordgenuity.com/4a460f/globalassets/wealth-management-australia/documents/forms/change-of-address-details-form";
        }
        SensitiveAddressChangeRequestCtrl.prototype.submit = function () {
            var _this = this;
            this.scope.isSubmitted = true;
            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.address.smsToken = this.scope.verificationCode;
            this.portfolioService.updateRegistrationAddressDetails(this.accountId, this.address)
                .then(function (result) {
                _this.modalInstance.close(true);
            }, function (reason) {
                _this.handleErrorResponse(reason);
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        SensitiveAddressChangeRequestCtrl.$inject = ['$scope', '$uibModalInstance', 'identityService', 'portfolioService', 'account', 'address'];
        return SensitiveAddressChangeRequestCtrl;
    }(Patersons.TwoFactorAuthenticationCtrl));
    Patersons.SensitiveAddressChangeRequestCtrl = SensitiveAddressChangeRequestCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ApproveChangeRequestCtrl = (function (_super) {
        __extends(ApproveChangeRequestCtrl, _super);
        function ApproveChangeRequestCtrl($scope, $uibModalInstance, identityService, changeRequestService, changeRequestId) {
            _super.call(this, $scope, $uibModalInstance, identityService);
            this.changeRequestService = changeRequestService;
            this.changeRequestId = changeRequestId;
        }
        ApproveChangeRequestCtrl.prototype.submit = function () {
            var _this = this;
            this.scope.isSubmitted = true;
            if (this.scope.twoFactorAuthForm.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.changeRequestService.approveChangeRequest(this.changeRequestId, this.scope.verificationCode)
                .then(function (result) {
                _this.modalInstance.close(true);
            }, function (reason) {
                _this.handleErrorResponse(reason);
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        ApproveChangeRequestCtrl.$inject = ['$scope', '$uibModalInstance', 'identityService', 'changeRequestService', 'changeRequestId'];
        return ApproveChangeRequestCtrl;
    }(Patersons.TwoFactorAuthenticationCtrl));
    Patersons.ApproveChangeRequestCtrl = ApproveChangeRequestCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var AnalysisBaseCtrl = (function (_super) {
        __extends(AnalysisBaseCtrl, _super);
        function AnalysisBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.activateSection('analysis');
        }
        AnalysisBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return AnalysisBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.AnalysisBaseCtrl = AnalysisBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var WatchlistsCtrl = (function (_super) {
        __extends(WatchlistsCtrl, _super);
        function WatchlistsCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, analysisService, selectionService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.onDeleteWatchlist = function (value) {
                if (confirm('Are you sure you want to delete watchlist?')) {
                    this.scope.deleteWatchlist(value);
                }
            };
            this.scope = $scope;
            this.scope.events = this;
            this.analysisService = analysisService;
            this.selectionService = selectionService;
            this.scope.isError = false;
            this.scope.hasData = false;
            if (this.state.params['add']) {
                this.selectionService.selectedWatchlistSecIds = this.state.params['add'];
                $location.url($location.path());
            }
            else if (this.selectionService.selectedWatchlistSecIds) {
                this.scope.secIds = this.selectionService.selectedWatchlistSecIds;
                this.selectionService.selectedWatchlistSecIds = null;
            }
            this.scope.isBusy = false;
            this.scope.isEdit = false;
            this.scope.watchlists = new Array();
            this.getWatchlists();
        }
        WatchlistsCtrl.prototype.listWatchlists = function () {
            return this.scope.watchlists.map(function (w) { return w.name.toLowerCase(); }).join("|");
        };
        WatchlistsCtrl.prototype.deleteWatchlist = function (watchlistId) {
            var _this = this;
            if (confirm("Are you sure you wish to delete this watchlist?")) {
                var promise = this.analysisService.deleteWatchlist(watchlistId);
                promise.then(function (result) {
                    _this.getWatchlists();
                    _this.scope.isError = false;
                    _this.scope.hasData = true;
                }, function (reason) {
                    //this.analysisService.errorHandler = reason.data;
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                });
            }
        };
        WatchlistsCtrl.prototype.getWatchlists = function () {
            var _this = this;
            this.scope.isLoading = true;
            var promise = this.analysisService.getWatchlists();
            promise.then(function (result) {
                _this.scope.isLoading = false;
                _this.scope.watchlists = result;
                _this.scope.isError = false;
                _this.scope.hasData = true;
            }, function (reason) {
                //this.analysisService.errorHandler = reason.data;
                _this.scope.isError = true;
                _this.scope.hasData = false;
            });
        };
        WatchlistsCtrl.prototype.prepareNewWatchlist = function () {
            this.scope.isEdit = true;
            this.scope.newWatchlist = new Patersons.Watchlist();
        };
        WatchlistsCtrl.prototype.addWatchlist = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.watchlistForm.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.scope.isLoading = true;
            this.analysisService.postWatchlist(this.scope.newWatchlist).then(function (result) {
                _this.scope.isLoading = false;
                _this.scope.isEdit = false;
                _this.getWatchlists();
                _this.scope.isError = false;
                _this.scope.hasData = true;
            }, function (reason) {
                //this.analysisService.errorHandler = reason.data;
                _this.scope.isError = true;
                _this.scope.hasData = false;
            }).finally(function () {
                _this.scope.isBusy = false;
            });
        };
        WatchlistsCtrl.prototype.cancelAddWatchlist = function () {
            this.scope.isEdit = false;
            this.scope.watchlistForm.$setPristine();
            this.scope.watchlistForm.$setUntouched();
        };
        WatchlistsCtrl.prototype.loadWatchlist = function (watchlistId) {
            var _this = this;
            var newSecIds = [];
            if (this.scope.secIds !== undefined || this.scope.secIds != null) {
                var newItems = this.scope.secIds.split(',');
                for (var i = 0; i < newItems.length; i++) {
                    newSecIds.push(newItems[i]);
                }
                var promise = this.analysisService.getAWatchlist(watchlistId);
                promise.then(function (watchlist) {
                    for (var i = 0; i < newSecIds.length; i++) {
                        watchlist.watchlistItems.push(newItems[i]);
                    }
                    var unique = watchlist.watchlistItems.filter(function (elem, index, self) {
                        return index == self.indexOf(elem);
                    });
                    watchlist.watchlistItems = unique;
                    _this.analysisService.patchWatchlist(watchlist).then(function () {
                        _this.state.go("watchlistView", {
                            "watchlistId": watchlistId
                        });
                    });
                });
            }
            else {
                this.state.go("watchlistView", {
                    "watchlistId": watchlistId
                });
            }
        };
        WatchlistsCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'analysisService', 'selectionService', 'navigationService'];
        return WatchlistsCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.WatchlistsCtrl = WatchlistsCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var WatchlistItemCtrl = (function (_super) {
        __extends(WatchlistItemCtrl, _super);
        function WatchlistItemCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, analysisService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.analysisService = analysisService;
            this.scope.watchlistId = $stateParams['watchlistId'];
            this.load();
        }
        WatchlistItemCtrl.prototype.showAllWatchlists = function () {
            this.state.go("watchlist", {}, { reload: true });
        };
        WatchlistItemCtrl.prototype.load = function () {
            var _this = this;
            var tickers = [];
            if (this.state.params['watchlistId']) {
                this.analysisService.getAWatchlist(this.state.params['watchlistId'])
                    .then(function (watchlist) {
                    _this.scope.relatedWatchlist = watchlist;
                    _this.scope.name = watchlist.name;
                    var unique = watchlist.watchlistItems.filter(function (elem, index, self) {
                        return index == self.indexOf(elem);
                    });
                    watchlist.watchlistItems = unique;
                    tickers = watchlist.watchlistItems;
                    _this.initializeMorningstar(tickers);
                }).catch(function (err) {
                    _this.state.go('watchlist');
                    alert('Watchlist not found.');
                });
            }
            else if (this.state.params['secIds']) {
                tickers = this.state.params['secIds'].split("|");
                this.initializeMorningstar(tickers);
            }
            else {
                this.state.go("watchlist");
            }
        };
        WatchlistItemCtrl.prototype.updateWatchlistFromTickers = function (tickers) {
            this.scope.relatedWatchlist.watchlistItems = tickers.map(function (item) {
                return item;
            });
            var unique = this.scope.relatedWatchlist.watchlistItems.filter(function (elem, index, self) {
                return index == self.indexOf(elem);
            });
            this.scope.relatedWatchlist.watchlistItems = unique;
            return this.analysisService.patchWatchlist(this.scope.relatedWatchlist);
        };
        WatchlistItemCtrl.prototype.openAsHeatmap = function () {
            if (this.scope.watchlistId) {
                window.open(this.state.href("heatmap", { watchlistId: this.scope.watchlistId }), "_parent");
            }
        };
        WatchlistItemCtrl.prototype.initializeMorningstar = function (tickers) {
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-watchlist', 'ecWatchList-container', 'ec-watch-list', 'ecWatchList').then(function () {
                    var watchlistInstance = morningstar.asterix.instanceRegistry.get('ecWatchList');
                    //set default watchlist items
                    watchlistInstance.setParameter('tickers', tickers);
                    initComponent('component-autocomp-watchlist', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteWatchlist').then(function () {
                        //connect watchlist to autocomplete search
                        morningstar.asterix.instanceRegistry.find('ecAutocompleteWatchlist').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                            var tickersTemp = morningstar.asterix.instanceRegistry.get('ecWatchList').getParameter('tickers');
                            //make sure there is no duplicate
                            if (newVal.secId && !tickersTemp.includes(newVal.secId)) {
                                tickersTemp.push(newVal.secId);
                                morningstar.asterix.instanceRegistry.get('ecWatchList').setParameter('tickers', tickersTemp);
                                self.updateWatchlistFromTickers(morningstar.asterix.instanceRegistry.get('ecWatchList').getParameter('tickers'));
                                morningstar.asterix.instanceRegistry.get('ecAutocompleteWatchlist').setParameter('search', '');
                            }
                        });
                        morningstar.asterix.instanceRegistry.get('ecWatchList.actionBar.actionRemove').on('click', function (event) {
                            event.preventDefault();
                            var watchlist = morningstar.asterix.instanceRegistry.find('ecWatchList');
                            var toBeRemove = watchlist.getParameter('selectedItemKeys');
                            var tempList = watchlist.getParameter('tickers').slice().filter(function (el) { return toBeRemove.indexOf(el) < 0; });
                            watchlist.setParameter('tickers', tempList);
                            self.updateWatchlistFromTickers(tempList).then(function () {
                                if (tempList.length == 0) {
                                    self.state.reload();
                                }
                            });
                        });
                    });
                });
            });
        };
        WatchlistItemCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'analysisService', 'navigationService'];
        return WatchlistItemCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.WatchlistItemCtrl = WatchlistItemCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var MarketHeatmapCtrl = (function (_super) {
        __extends(MarketHeatmapCtrl, _super);
        function MarketHeatmapCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService, analysisService, morningStarService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.rootScope = $rootScope;
            this.analysisService = analysisService;
            this.morningStarService = morningStarService;
            this.load();
        }
        MarketHeatmapCtrl.prototype.transformWatchlistToMorningStarWatchlist = function (watchlists) {
            var _this = this;
            // due to a request to only show stock tickers that are not of type Fund (holdingtypeId = 2),
            // we need to query the M* API to determine if a particular ticker is infact a fund or not
            // and use that information to show/hide the tickers from the heatmap component.
            return new Promise(function (resolveAll) {
                var mWatchlists = [];
                Promise.all(watchlists.map(function (watchlist) {
                    return new Promise(function (resolveEach) {
                        var mWatchlist = {
                            name: watchlist.name,
                            data: [],
                            id: "m" + watchlist.id
                        };
                        Promise.all(watchlist.watchlistItems.map(function (ticker) {
                            return new Promise(function (resolveTicker) {
                                _this.morningStarService.getMorningStarDataForSecurityId(ticker).then(function (res) {
                                    if (res) {
                                        var holdingTypeId = res.holdingTypeId;
                                        if (holdingTypeId != 2) {
                                            mWatchlist.data.push({ ticker: ticker });
                                        }
                                    }
                                    resolveTicker();
                                });
                            });
                        })).then(function () {
                            mWatchlists.push(mWatchlist);
                            resolveEach();
                        });
                    });
                })).then(function () {
                    resolveAll(mWatchlists);
                });
            });
            // This is kept incase we dont need to check each ticker
            // return watchlists.map(function (watchlist) {
            //     return {
            //         name: watchlist.name,
            //         data: watchlist.watchlistItems.map(function (isin) {
            //             return {
            //                 ticker: isin
            //             }
            //         }),
            //         id: "m" + watchlist.id
            //     }
            // })
        };
        MarketHeatmapCtrl.prototype.load = function () {
            var self = this;
            this.analysisService.getWatchlists().then(function (watchlists) {
                rootMorningstarPromise().then(function (promiseChain) {
                    console.log('initializing component');
                    self.transformWatchlistToMorningStarWatchlist(watchlists).then(function (mWatchlists) {
                        loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.watchList = mWatchlists;
                        if (self.state.params['watchlistId']) {
                            try {
                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.active = "m" + self.state.params['watchlistId'];
                                //need to nullify the 'index' value as it takes precedent over the tickerList in the config
                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.index = null;
                                var tickers_1 = [];
                                mWatchlists.filter(function (item) {
                                    return item.id == "m" + self.state.params['watchlistId'];
                                })[0].data.forEach(function (ticker) {
                                    tickers_1.push(ticker.ticker);
                                });
                                loaderConfig.configuration.overrides.components.marketsHeatmap.settings.tickerList = tickers_1;
                            }
                            catch (error) {
                                self.state.go('heatmap', {}, { inherit: false, reload: true });
                                alert('Could not load heatmap from watchlist');
                                return;
                            }
                        }
                        else {
                            // need to reset to default values due to manilupating the configuration at runtime above.
                            // possibly look into a more elegant way to handle this
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.selectionlist.active = 4;
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.index = "146.10.XJO";
                            loaderConfig.configuration.overrides.components.marketsHeatmap.settings.tickerList = null;
                        }
                        initComponent("component-heatmap", "heatmap-container", "markets-components-heatmap", "marketsHeatmap");
                    });
                });
            });
        };
        MarketHeatmapCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService', 'analysisService', 'morningStarService'];
        return MarketHeatmapCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.MarketHeatmapCtrl = MarketHeatmapCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var MarketChartCtrl = (function (_super) {
        __extends(MarketChartCtrl, _super);
        function MarketChartCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.load();
        }
        MarketChartCtrl.prototype.load = function () {
            this.log.info('market chartCtrl loading...');
            var tickers = [];
            var compareTickers = [];
            var mainTicker = '';
            if (this.state.params['secIds'] != undefined && this.state.params['secIds'] != null) {
                tickers = this.state.params['secIds'].split('|');
                if (tickers.length > 1) {
                    compareTickers = tickers.slice(1);
                }
                this.scope.isCompare = true;
                mainTicker = tickers[0];
            }
            rootMorningstarPromise().then(function (morningstarPromise) {
                console.log('initializing component');
                if (mainTicker) {
                    loaderConfig.configuration.overrides.components.advanceChart_compare.settings.mainTicker = mainTicker;
                    loaderConfig.configuration.overrides.components.advanceChart_compare.settings.compareTickers = compareTickers;
                    initComponent('component-container', 'chart-container', 'markets-components-svgchart', 'advanceChart_compare').then(function () {
                        console.log("done loading advance chart");
                    });
                }
                else {
                    initComponent('component-container', 'chart-container', 'markets-components-svgchart', 'advanceChart').then(function () {
                        console.log("done loading advance chart");
                    });
                }
            });
        };
        MarketChartCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return MarketChartCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.MarketChartCtrl = MarketChartCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var StockCompareCtrl = (function (_super) {
        __extends(StockCompareCtrl, _super);
        function StockCompareCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.state = $state;
            this.load();
        }
        StockCompareCtrl.prototype.load = function () {
            var isinData = this.state.params['secIds']
                ? this.state.params['secIds']
                : "";
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log("initializing component");
                initComponent("component-investcomp", "ecinvestment-container", "ec-investment-compare", "ecStockCompare").then(function () {
                    morningstar.asterix.instanceRegistry
                        .get("ecStockCompare")
                        .setParameter("securityIds", isinData); // pipe separated list of IDs
                });
            });
        };
        StockCompareCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return StockCompareCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.StockCompareCtrl = StockCompareCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var FundCompareCtrl = (function (_super) {
        __extends(FundCompareCtrl, _super);
        function FundCompareCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.state = $state;
            this.load();
        }
        FundCompareCtrl.prototype.load = function () {
            var isinData = this.state.params['secIds']
                ? this.state.params['secIds']
                : "";
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log("initializing component");
                initComponent("component-investcomp", "ecinvestment-container", "ec-investment-compare", "ecFundCompare").then(function () {
                    morningstar.asterix.instanceRegistry
                        .get("ecFundCompare")
                        .setParameter("securityIds", isinData); // pipe separated list of IDs
                });
            });
        };
        FundCompareCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return FundCompareCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.FundCompareCtrl = FundCompareCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ETFCompareCtrl = (function (_super) {
        __extends(ETFCompareCtrl, _super);
        function ETFCompareCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.state = $state;
            this.load();
        }
        ETFCompareCtrl.prototype.load = function () {
            var isinData = this.state.params['secIds']
                ? this.state.params['secIds']
                : "";
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log("initializing component");
                initComponent("component-investcomp", "ecinvestment-container", "ec-investment-compare", "ecETFCompare").then(function () {
                    morningstar.asterix.instanceRegistry
                        .get("ecETFCompare")
                        .setParameter("securityIds", isinData); // pipe separated list of IDs
                });
            });
        };
        ETFCompareCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return ETFCompareCtrl;
    }(Patersons.AnalysisBaseCtrl));
    Patersons.ETFCompareCtrl = ETFCompareCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var analysisModule = angular.module("app.analysisModule", []);
analysisModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.analysisModule config...');
        var wholesaleClientChecker = ['sessionService', '$q', '$state', 'userCompanyService', function (sessionService, $q, $state, userCompanyService) {
                var deferred = $q.defer();
                userCompanyService.getUserCompany().then(function (company) {
                    if (sessionService.getCurrentUserProfile().wholesaleclient === 'True' && !company.enableWholesaleClientsResearch) {
                        $state.go('dashboard');
                        deferred.reject();
                    }
                    else {
                        deferred.resolve();
                    }
                });
                return deferred.promise;
            }];
        $stateProvider
            .state("watchlist", {
            url: "/watchlists?add",
            templateUrl: "assets/templates/Analysis/watchlists.html",
            controller: 'watchlistsCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Watchlists" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state("watchlistView", {
            url: "/watchlists/view?watchlistId?secIds",
            templateUrl: "assets/templates/Analysis/watchlistItem.html",
            controller: 'watchlistItemCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Watchlists" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state("heatmap", {
            url: "/heatmap?watchlistId",
            templateUrl: "assets/templates/Analysis/marketHeatmap.html",
            controller: 'marketHeatmapCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Market Heatmap" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state("charts", {
            url: "/charts?secIds",
            templateUrl: "assets/templates/Analysis/marketCharts.html",
            controller: 'marketChartCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Charting Tools" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state("stockCompare", {
            url: "/stockCompare?secIds",
            templateUrl: "assets/templates/Analysis/stockCompare.html",
            controller: 'stockCompareCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Equities Comparison" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        });
        // .state("fundCompare",
        //   {
        //     url: "/fundCompare?secIds",
        //     templateUrl: "assets/templates/Analysis/fundCompare.html",
        //     controller: 'fundCompareCtrl',
        //     resolve: {
        //       wholesaleClientCheck: wholesaleClientChecker,
        //       impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
        //         var deferred = $q.defer();
        //         if (sessionService.getCurrentUserProfile().impersonator === 'True') {
        //           $state.go('dashboard');
        //           deferred.reject();
        //         } else {
        //           deferred.resolve();
        //         }
        //         return deferred.promise;
        //       }]
        //     }
        //   })
        // .state("etfCompare",
        //   {
        //     url: "/etfCompare?secIds",
        //     templateUrl: "assets/templates/Analysis/etfCompare.html",
        //     controller: 'etfCompareCtrl',
        //     resolve: {
        //       wholesaleClientCheck: wholesaleClientChecker,
        //       impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
        //         var deferred = $q.defer();
        //         if (sessionService.getCurrentUserProfile().impersonator === 'True') {
        //           $state.go('dashboard');
        //           deferred.reject();
        //         } else {
        //           deferred.resolve();
        //         }
        //         return deferred.promise;
        //       }]
        //     }
        //   })
    }]);
analysisModule.controller('analysisBaseCtrl', Patersons.AnalysisBaseCtrl);
analysisModule.controller('watchlistsCtrl', Patersons.WatchlistsCtrl);
analysisModule.controller('watchlistItemCtrl', Patersons.WatchlistItemCtrl);
analysisModule.controller('marketHeatmapCtrl', Patersons.MarketHeatmapCtrl);
analysisModule.controller('marketChartCtrl', Patersons.MarketChartCtrl);
analysisModule.controller('stockCompareCtrl', Patersons.StockCompareCtrl);
analysisModule.controller('fundCompareCtrl', Patersons.FundCompareCtrl);
analysisModule.controller('etfCompareCtrl', Patersons.ETFCompareCtrl);

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ClientAdviserViewCtrl = (function (_super) {
        __extends(ClientAdviserViewCtrl, _super);
        function ClientAdviserViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, tokenService, clientConfigService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.tokenService = tokenService;
            this.clientConfigService = clientConfigService;
            if (this.tokenService.tokenManager && !this.tokenService.tokenManager.expired) {
                this.getAdviserData();
                this.scope.ShowFullImage = function (url) {
                    $('.imagepreview').attr('src', url);
                    $('#imagemodal').modal('show');
                };
            }
        }
        ClientAdviserViewCtrl.prototype.getAdviserData = function () {
            var _this = this;
            this.scope.isLoading = true;
            var promise = this.clientConfigService.getAdviser();
            promise.then(function (result) {
                _this.scope.isLoading = false;
                _this.scope.adviserList = result;
                if (_this.scope.adviserList.length > 1) {
                    _this.scope.adviserLabel = "Meet your Advisers";
                }
                else if (_this.scope.adviserList.length == 1) {
                    _this.scope.adviserLabel = "Meet your Adviser";
                }
                else if (_this.scope.adviserLabel.length == 0) {
                    _this.scope.adviserLabel = "";
                }
                if (_this.tokenService.tokenManager) {
                    _this.scope.isLoggedIn = !_this.tokenService.tokenManager.expired;
                }
            }, function (reason) {
                _this.scope.isLoading = false;
                _this.clientConfigService.errorHandler = reason.data;
            });
            return null;
        };
        ClientAdviserViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'tokenService', 'clientConfigService'];
        return ClientAdviserViewCtrl;
    }(Patersons.AbstractController));
    Patersons.ClientAdviserViewCtrl = ClientAdviserViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var FAQ = (function () {
        function FAQ() {
        }
        return FAQ;
    }());
    Patersons.FAQ = FAQ;
    var HelpViewCtrl = (function (_super) {
        __extends(HelpViewCtrl, _super);
        function HelpViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, helpService, navigationService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.helpService = helpService;
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
            this.load();
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        HelpViewCtrl.prototype.load = function () {
            var _this = this;
            this.helpService.getFAQs()
                .then(function (result) {
                if (result) {
                    _this.scope.faqList = result.faqs;
                }
                _this.scope.hasData = _this.scope.faqList != null && _this.scope.faqList.length > 0;
                _this.log.info("Loaded Help List");
            }, function (error) {
                _this.scope.hasData = false;
            });
        };
        HelpViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'helpService', 'navigationService', 'userCompanyService'];
        return HelpViewCtrl;
    }(Patersons.AbstractController));
    Patersons.HelpViewCtrl = HelpViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var MyDetailsBaseCtrl = (function (_super) {
        __extends(MyDetailsBaseCtrl, _super);
        function MyDetailsBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
        }
        MyDetailsBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return MyDetailsBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.MyDetailsBaseCtrl = MyDetailsBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var AccoladeOptionsViewCtrl = (function (_super) {
        __extends(AccoladeOptionsViewCtrl, _super);
        function AccoladeOptionsViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, myDetailsService, portfolioService, navigationService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.myDetailsService = myDetailsService;
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.scope.isLoading = false;
            this.scope.isBusy = false;
            this.getAccoladeOptions();
            this.scope.isError = false;
            this.scope.hasData = false;
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        AccoladeOptionsViewCtrl.prototype.onSave = function () {
            var _this = this;
            this.scope.isBusy = true;
            var promise = this.myDetailsService.updateAccoladeOptions(this.scope.accoladeOptions);
            promise.then(function (result) {
                console.info('myDetailsService.updateAccoladeOptions');
                console.info(result);
                _this.scope.isSubmitted = true;
                _this.scope.isError = false;
                _this.scope.hasData = true;
                _this.updateAccoladeOptions(result);
            }, function (reason) {
                _this.scope.isError = true;
                _this.scope.hasData = false;
                _this.scope.isSubmitted = false;
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        AccoladeOptionsViewCtrl.prototype.onCancel = function () {
            // reload ourselves if cancelled to get the original settings
            this.redirect("/accoladeOptions");
        };
        AccoladeOptionsViewCtrl.prototype.getAccoladeOptions = function () {
            var _this = this;
            this.scope.isLoading = true;
            var accoladeCheckPromise = this.portfolioService.getCombinedPortfolioData();
            accoladeCheckPromise.then(function (accounts) {
                if (accounts.every(function (account) { return account.accountType == "Standard"; })) {
                    _this.scope.hasAccoladeAccounts = false;
                    _this.scope.isLoading = false;
                }
                else {
                    _this.scope.hasAccoladeAccounts = true;
                    var optionsPromise = _this.myDetailsService.getAccoladeOptions();
                    optionsPromise.then(function (result) {
                        _this.log.info("Accolade Opts: result = " + JSON.stringify(result));
                        _this.updateAccoladeOptions(result);
                    }, function (reason) {
                        _this.scope.isError = true;
                        _this.scope.isSubmitted = false;
                        _this.myDetailsService.errorHandler = reason.data;
                    })
                        .finally(function () {
                        _this.scope.isLoading = false;
                    });
                }
                _this.scope.isError = false;
                _this.scope.hasData = true;
            }, function (reason) {
                _this.scope.isError = true;
                _this.scope.hasData = false;
            });
            return null;
        };
        AccoladeOptionsViewCtrl.prototype.updateAccoladeOptions = function (options) {
            console.info('updateAccoladeOptions');
            console.info(options);
            this.scope.accoladeOptions = options;
            this.scope.enableAnnualAccoladeReports = !this.scope.accoladeOptions.hasElectronicTaxReports;
            this.scope.enableQuarterlyAccoladeReports = !this.scope.accoladeOptions.hasElectronicQuarterlyReports;
        };
        AccoladeOptionsViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'myDetailsService', 'portfolioService', 'navigationService', 'userCompanyService'];
        return AccoladeOptionsViewCtrl;
    }(Patersons.MyDetailsBaseCtrl));
    Patersons.AccoladeOptionsViewCtrl = AccoladeOptionsViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ResearchSubscriptionsViewCtrl = (function (_super) {
        __extends(ResearchSubscriptionsViewCtrl, _super);
        function ResearchSubscriptionsViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, myDetailsService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.myDetailsService = myDetailsService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.hasChanged = false;
            this.scope.isSubmitted = false;
            this.scope.isError = false;
            this.scope.isLoading = false;
            this.getResearchSubscriptions();
        }
        ResearchSubscriptionsViewCtrl.prototype.setChanged = function () {
            this.scope.hasChanged = true;
        };
        ResearchSubscriptionsViewCtrl.prototype.onSave = function () {
            var _this = this;
            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.scope.isSaving = true;
            this.myDetailsService.updateResearchSubscriptions(this.scope.subscribedPublications)
                .then(function (result) {
                _this.scope.isSubmitted = result.status == 200;
            }, function (reason) {
                _this.scope.isError = true;
                _this.myDetailsService.errorHandler = reason.data;
            }).finally(function () {
                _this.scope.isSaving = false;
                _this.scope.hasChanged = false;
            });
        };
        ResearchSubscriptionsViewCtrl.prototype.getResearchSubscriptions = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.myDetailsService.getResearchSubscriptions()
                .then(function (result) {
                var data = result;
                _this.scope.subscribedPublications = data;
                _this.scope.isLoading = false;
            }, function (reason) {
                _this.scope.isError = true;
                _this.scope.isLoading = false;
            });
        };
        ResearchSubscriptionsViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'myDetailsService', 'navigationService'];
        return ResearchSubscriptionsViewCtrl;
    }(Patersons.MyDetailsBaseCtrl));
    Patersons.ResearchSubscriptionsViewCtrl = ResearchSubscriptionsViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var AccountBaseCtrl = (function (_super) {
        __extends(AccountBaseCtrl, _super);
        function AccountBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
        }
        AccountBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return AccountBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.AccountBaseCtrl = AccountBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var BankDetailsViewCtrl = (function (_super) {
        __extends(BankDetailsViewCtrl, _super);
        function BankDetailsViewCtrl($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, portfolioService, tokenService, changeRequestService, navigationService, identityService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.tokenService = tokenService;
            this.changeRequestService = changeRequestService;
            this.identityService = identityService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            this.scope.submissionFailed = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
            this.scope.phoneNumberIsVerified = false;
            this.scope.allApproversRegistered = false;
            this.scope.hasApprovers = false;
            this.scope.hasAcceptedTandCs = false;
            this.scope.hasApplyAllChecked = false;
            this.scope.disableCreditUpdate = false;
            var accountId = $stateParams.accountId;
            this.modal = $uibModal;
            this.document = $document;
            this.scope.scrollDuration = 700;
            this.scope.isSensitive = true;
            this.load();
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        BankDetailsViewCtrl.prototype.setSelectedAccount = function (accountId) {
            this.scope.hasApplyAllChecked = false;
            this.scope.hasAcceptedTandCs = false;
            this.scope.disableCreditUpdate = false;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            if (this.scope.selectedAccount) {
                this.scope.disableCreditUpdate = this.isCashManagementAccount(this.scope.selectedAccount.bankingDetails.creditBankAccount) &&
                    (!this.scope.selectedAccount.isChessManaged || this.scope.selectedAccount.bankingDetails.creditBankAccount.depositDividends);
            }
            this.scope.isSubmitted = false;
            this.scope.submissionFailed = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
            this.checkAllApproversRegistered();
            this.checkHasApprovers();
        };
        ;
        BankDetailsViewCtrl.prototype.isCashManagementAccount = function (bankAccountDetail) {
            return bankAccountDetail.serviceType === 'MM';
        };
        BankDetailsViewCtrl.prototype.deselectDepositDividends = function () {
            if (this.scope.selectedAccount.isChessManaged) {
                this.scope.selectedAccount.bankingDetails.creditBankAccount.depositDividends = false;
            }
        };
        BankDetailsViewCtrl.prototype.checkAllApproversRegistered = function () {
            var _this = this;
            if (!this.scope.selectedAccount) {
                return;
            }
            this.changeRequestService.areAllAccountApproversRegistered(this.scope.selectedAccount.accountId)
                .then(function (result) {
                _this.scope.allApproversRegistered = result;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        BankDetailsViewCtrl.prototype.checkHasApprovers = function () {
            var _this = this;
            if (!this.scope.selectedAccount) {
                return;
            }
            this.changeRequestService.getAccountApproversCount(this.scope.selectedAccount.accountId)
                .then(function (result) {
                _this.scope.hasApprovers = result > 0;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        BankDetailsViewCtrl.prototype.load = function () {
            var _this = this;
            this.identityService.getIsPhoneNumberVerifyed().
                then(function (phone_number_verified) {
                _this.scope.phoneNumberIsVerified = phone_number_verified;
                var promise = _this.portfolioService.getCombinedPortfolioData();
                promise.then(function (result) {
                    _this.scope.accounts = result;
                    if (_this.scope.accounts != undefined && _this.scope.accounts.length > 0) {
                        _this.setSelectedAccount(_this.scope.accounts[0].accountId);
                    }
                });
            });
            /*if (this.tokenService.tokenManager.profile.phone_number_verified === 'true') {
                this.scope.phoneNumberIsVerified = true;
            }
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then((result: Array<Account>) => {
                this.scope.accounts = result;
                if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
                    this.setSelectedAccount(this.scope.accounts[0].accountId);
                }
            });*/
        };
        BankDetailsViewCtrl.prototype.canSubmitChangeRequest = function () {
            if (!this.scope.phoneNumberIsVerified) {
                this.scope.submissionFailedVerifyPhoneNumber = true;
            }
            if (!this.scope.allApproversRegistered) {
                this.scope.submissionFailedNotAllApproversRegistered = true;
            }
            if (this.scope.submissionFailedVerifyPhoneNumber || this.scope.submissionFailedNotAllApproversRegistered) {
                return false;
            }
            return true;
        };
        ;
        BankDetailsViewCtrl.prototype.saveDirectDebitForm = function () {
            this.scope.selectedAccount.bankingDetails.debitBankAccount.cardType = "Debit Card";
            return this.saveForm(this.scope.directDebitForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.debitBankAccount, false);
        };
        BankDetailsViewCtrl.prototype.updatehasAcceptedTandCs = function () {
            if (!this.scope.hasApplyAllChecked) {
                this.scope.hasAcceptedTandCs = false;
            }
        };
        ;
        BankDetailsViewCtrl.prototype.saveDirectCreditForm = function () {
            if (this.scope.hasApplyAllChecked && this.scope.hasAcceptedTandCs) {
                return this.saveForm(this.scope.directCreditForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.creditBankAccount, true);
            }
            this.scope.selectedAccount.bankingDetails.creditBankAccount.cardType = "Credit Card";
            return this.saveForm(this.scope.directCreditForm, this.scope.selectedAccount, this.scope.selectedAccount.bankingDetails.creditBankAccount, false);
        };
        BankDetailsViewCtrl.prototype.saveForm = function (form, account, bankAccountDetail, saveAll) {
            var _this = this;
            this.scope.submissionFailed = false;
            this.scope.isSensitive = true;
            if (form.$invalid || account == undefined) {
                return;
            }
            if (!this.canSubmitChangeRequest()) {
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                return;
            }
            var modalPopup = this.modal.open({
                templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                controller: Patersons.BankDetailsChangeRequestCtrl,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                    account: account,
                    bankAccountDetail: bankAccountDetail,
                    saveAll: saveAll
                }
            });
            modalPopup.result
                .then(function (result) {
                if (result === true) {
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    _this.scope.isSubmitted = true;
                }
                else {
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    _this.scope.submissionFailed = true;
                }
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        BankDetailsViewCtrl.$inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'portfolioService', 'tokenService', 'changeRequestService', 'navigationService', 'identityService', 'userCompanyService'];
        return BankDetailsViewCtrl;
    }(Patersons.AccountBaseCtrl));
    Patersons.BankDetailsViewCtrl = BankDetailsViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var AccountEmail = "AccountEmail";
    var ContractNoteEmail = "ContractNoteEmail";
    var ContactInfoViewCtrl = (function (_super) {
        __extends(ContactInfoViewCtrl, _super);
        function ContactInfoViewCtrl($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, myDetailsService, portfolioService, tokenService, changeRequestService, navigationService, identityService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.myDetailsService = myDetailsService;
            this.portfolioService = portfolioService;
            this.tokenService = tokenService;
            this.identityService = identityService;
            this.changeRequestService = changeRequestService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
            this.scope.phoneNumberIsVerified = false;
            this.scope.allApproversRegistered = false;
            this.scope.hasApprovers = false;
            var accountId = $stateParams.accountId;
            this.modal = $uibModal;
            this.scope.emailTags = [];
            this.scope.contractEmailTags = [];
            this.document = $document;
            this.scope.scrollDuration = 700;
            this.load();
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        ContactInfoViewCtrl.prototype.setSelectedAccount = function (accountId) {
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            if (this.setSelectedAccount == null) {
                return;
            }
            if (this.scope.selectedAccount.email) {
                this.scope.emailTags = this.scope.selectedAccount.email.split(";").join(",").split(",").map(function (e) { return { text: e.toLowerCase() }; });
            }
            else {
                this.scope.emailTags = [];
            }
            if (this.scope.selectedAccount.emailContractNotes) {
                this.scope.contractEmailTags = this.scope.selectedAccount.emailContractNotes.split(";").join(",").split(",").map(function (e) { return { text: e.toLowerCase() }; });
            }
            else {
                this.scope.contractEmailTags = [];
            }
            this.scope.sensitiveEmailAddressesDirty = false;
            this.scope.isSubmitted = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
            this.checkAllApproversRegistered();
            this.checkHasApprovers();
        };
        ;
        ContactInfoViewCtrl.prototype.checkAllApproversRegistered = function () {
            var _this = this;
            if (!this.scope.selectedAccount) {
                return;
            }
            this.changeRequestService.areAllAccountApproversRegistered(this.scope.selectedAccount.accountId)
                .then(function (result) {
                _this.scope.allApproversRegistered = result;
            });
        };
        ContactInfoViewCtrl.prototype.checkHasApprovers = function () {
            var _this = this;
            if (!this.scope.selectedAccount) {
                return;
            }
            this.changeRequestService.getAccountApproversCount(this.scope.selectedAccount.accountId)
                .then(function (result) {
                _this.scope.hasApprovers = result > 0;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                _this.scope.isLoading = false;
            });
        };
        ContactInfoViewCtrl.prototype.load = function () {
            var _this = this;
            this.identityService.getIsPhoneNumberVerifyed().
                then(function (phone_number_verified) {
                _this.scope.phoneNumberIsVerified = phone_number_verified;
                var promise = _this.portfolioService.getCombinedPortfolioData();
                promise.then(function (result) {
                    _this.scope.accounts = result;
                    if (_this.scope.accounts != undefined && _this.scope.accounts.length > 0) {
                        _this.setSelectedAccount(_this.scope.accounts[0].accountId);
                    }
                }, function (reason) {
                    _this.scope.errorHandler = reason.data;
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    _this.scope.isLoading = false;
                });
            });
            /*if (this.tokenService.tokenManager.profile.phone_number_verified === 'true') {
              this.scope.phoneNumberIsVerified = true;
            }
      
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then((result: Array<Account>) => {
              this.scope.accounts = result;
              if (this.scope.accounts != undefined && this.scope.accounts.length > 0) {
      
                this.setSelectedAccount(this.scope.accounts[0].accountId);
              }
            }, (reason) => {
                this.scope.errorHandler = reason.data;
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                this.scope.isLoading = false;
              });*/
        };
        ContactInfoViewCtrl.prototype.canSubmitChangeRequest = function () {
            this.hideAllNotifications();
            if (!this.scope.phoneNumberIsVerified) {
                this.scope.submissionFailedVerifyPhoneNumber = true;
            }
            if (!this.scope.allApproversRegistered) {
                this.scope.submissionFailedNotAllApproversRegistered = true;
            }
            if (this.scope.submissionFailedVerifyPhoneNumber || this.scope.submissionFailedNotAllApproversRegistered) {
                return false;
            }
            return true;
        };
        ContactInfoViewCtrl.prototype.setAllAddressFields = function (address) {
            if (!this.scope.selectedAccount.isAuthorisedAgentAccount) {
                this.scope.selectedAccount.accountAddresses.postalAddress = Object.assign({}, address, { type: "Postal" });
                this.scope.selectedAccount.accountAddresses.residentialOrBusinessAddress = Object.assign({}, address, { type: "ResidentialOrBusiness" });
            }
            if (!(this.scope.selectedAccount.isAuthorisedAgentAccount || this.scope.selectedAccount.accountType == 'Accolade')) {
                this.scope.selectedAccount.accountAddresses.registrationAddress = Object.assign({}, address, { type: "Registration" });
            }
        };
        ContactInfoViewCtrl.prototype.applyToAll = function (addressForm, invalid) {
            var _this = this;
            if (!invalid) {
                if (confirm("This will apply your residential address to all sections of this form and submit your changes to us for processing")) {
                    this.setAllAddressFields(addressForm);
                    return Promise.resolve()
                        .then(function () {
                        return _this.saveRegistrationAddress();
                    })
                        .then(function () {
                        return _this.savePostalAddress();
                    })
                        .then(function () {
                        return _this.saveResidentialAddress();
                    });
                }
            }
        };
        ContactInfoViewCtrl.prototype.savePostalAddress = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this.scope.selectedAccount.isAuthorisedAgentAccount) {
                    return resolve();
                }
                _this.scope.$broadcast('show-errors-check-validity');
                _this.scope.isSensitive = false;
                if (_this.scope.postalAddressForm.$invalid) {
                    return resolve();
                }
                var promises = [];
                promises.push(_this.portfolioService.updatePostalAddressDetails(_this.scope.selectedAccount.accountId, _this.scope.selectedAccount.accountAddresses.postalAddress));
                _this.executePromises(promises).then(function () {
                    return resolve();
                }, function (reason) {
                    return reject();
                });
            });
        };
        ContactInfoViewCtrl.prototype.saveResidentialAddress = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this.scope.selectedAccount.isAuthorisedAgentAccount) {
                    return resolve();
                }
                _this.scope.$broadcast('show-errors-check-validity');
                _this.scope.isSensitive = false;
                if (_this.scope.residentialAddressForm.$invalid) {
                    return resolve();
                }
                var promises = [];
                promises.push(_this.portfolioService.updateResidentialAddressDetails(_this.scope.selectedAccount.accountId, _this.scope.selectedAccount.accountAddresses.residentialOrBusinessAddress));
                _this.executePromises(promises).then(function () {
                    return resolve();
                }, function (reason) {
                    return reject();
                });
            });
        };
        ContactInfoViewCtrl.prototype.saveRegistrationAddress = function () {
            var _this = this;
            return new Promise(function (resolve, reject) {
                if (_this.scope.selectedAccount.isAuthorisedAgentAccount || _this.scope.selectedAccount.accountType == 'Accolade') {
                    return resolve();
                }
                _this.scope.$broadcast('show-errors-check-validity');
                _this.scope.isSensitive = true;
                if (_this.scope.registrationAddressForm.$invalid) {
                    return resolve();
                }
                if (!_this.canSubmitChangeRequest()) {
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    return reject();
                }
                var modalPopup = _this.modal.open({
                    templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                    controller: Patersons.SensitiveAddressChangeRequestCtrl,
                    keyboard: false,
                    backdrop: 'static',
                    resolve: {
                        account: _this.scope.selectedAccount,
                        address: _this.scope.selectedAccount.accountAddresses.registrationAddress
                    }
                });
                modalPopup.result
                    .then(function (result) {
                    if (result === true) {
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                        _this.scope.isSubmitted = true;
                        return resolve();
                    }
                    else {
                        _this.scope.errorHandler.Message = 'Error saving registration address details';
                        return reject();
                    }
                }, function (reason) {
                    _this.scope.errorHandler = reason.data;
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    _this.scope.isLoading = false;
                    return reject();
                });
            });
        };
        // non sensitive
        ContactInfoViewCtrl.prototype.saveAccountEmailAddressForm = function () {
            this.scope.$broadcast('show-errors-check-validity');
            this.scope.isSensitive = true;
            if (this.scope.accountEmailAddressForm.$invalid) {
                return;
            }
            /*if (!this.canSubmitChangeRequest()) {
              var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
              this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
              return;
            }*/
            /*var sensitiveEmailAddresses: Array<EmailAddress> = [
              new EmailAddress(0, ContractNoteEmail, this.scope.contractEmailTags.map((tag) => { return tag.text }).join(','))
            ];*/
            var nonSensitiveEmailAddresses = [
                new Patersons.EmailAddress(1, AccountEmail, this.scope.emailTags.map(function (tag) { return tag.text; }).join(','))
            ];
            // if the list of contract notes email addresses has changed or one of the email addresses has been deleted
            /*if (sensitiveEmailAddresses.length > 0 && this.scope.sensitiveEmailAddressesDirty) {
              var modalPopup = this.modal.open({
                templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                controller: SensitiveEmailAddressChangeRequestCtrl,
                keyboard: false,
                backdrop: 'static',
                resolve: {
                  account: this.scope.selectedAccount,
                  emailAddresses: function() { return sensitiveEmailAddresses }
                }
              });
      
              modalPopup.result
                .then((result) => {
                  if (result === true) {
                    var promises = [];
      
                    for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                      promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
                    }
      
                    this.executePromises(promises);
      
                    this.scope.isSubmitted = true;
                    this.scope.sensitiveEmailAddressesDirty = false;
                  }
                  else {
                    this.scope.errorHandler.Message = 'Error saving email address details';
                  }
                });
            }
            else {*/
            var promises = [];
            for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
            }
            this.executePromises(promises);
            this.scope.isSubmitted = true;
            //}
        };
        // sensitive
        ContactInfoViewCtrl.prototype.saveContractEmailAddressForm = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            this.scope.isSensitive = true;
            if (this.scope.contractEmailAddressForm.$invalid) {
                return;
            }
            if (!this.canSubmitChangeRequest()) {
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                this.document.scrollToElement(scrollPlaceholder, 0, this.scope.scrollDuration);
                return;
            }
            var sensitiveEmailAddresses = [
                new Patersons.EmailAddress(0, ContractNoteEmail, this.scope.contractEmailTags.map(function (tag) { return tag.text; }).join(','))
            ];
            /*var nonSensitiveEmailAddresses: Array<EmailAddress> = [
              new EmailAddress(1, AccountEmail, this.scope.emailTags.map((tag) => { return tag.text }).join(','))
            ];*/
            // if the list of contract notes email addresses has changed or one of the email addresses has been deleted
            if (sensitiveEmailAddresses.length > 0 && this.scope.sensitiveEmailAddressesDirty) {
                var modalPopup = this.modal.open({
                    templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                    controller: Patersons.SensitiveEmailAddressChangeRequestCtrl,
                    keyboard: false,
                    backdrop: 'static',
                    resolve: {
                        account: this.scope.selectedAccount,
                        emailAddresses: function () { return sensitiveEmailAddresses; }
                    }
                });
                modalPopup.result
                    .then(function (result) {
                    if (result === true) {
                        /*var promises = [];
          
                        for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                          promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
                        }
          
                        this.executePromises(promises);
                        */
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                        _this.scope.isSubmitted = true;
                        _this.scope.sensitiveEmailAddressesDirty = false;
                    }
                    else {
                        _this.scope.errorHandler.Message = 'Error saving email address details';
                    }
                }, function (reason) {
                    _this.scope.errorHandler = reason.data;
                    var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                    _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                    _this.scope.isLoading = false;
                });
            }
            /*else {
              var promises = [];
              for (var i = 0; i < nonSensitiveEmailAddresses.length; i++) {
                promises.push(this.portfolioService.updateEmailAddress(this.scope.selectedAccount.accountId, nonSensitiveEmailAddresses[i]));
              }
              this.executePromises(promises);
              this.scope.isSubmitted = true;
            }*/
        };
        ContactInfoViewCtrl.prototype.savePhoneNumberForm = function () {
            this.scope.$broadcast('show-errors-check-validity');
            this.scope.isSensitive = false;
            if (this.scope.phoneNumberForm.$invalid) {
                return;
            }
            this.scope.isLoading = true;
            var promises = [];
            promises.push(this.portfolioService.updatePhoneNumbers(this.scope.selectedAccount.accountId, this.scope.selectedAccount));
            return this.executePromises(promises);
        };
        ContactInfoViewCtrl.prototype.hideAllNotifications = function () {
            this.scope.isSubmitted = false;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.submissionFailedNotAllApproversRegistered = false;
        };
        ContactInfoViewCtrl.prototype.executePromises = function (promises) {
            var _this = this;
            var numDone = 0;
            var checkAllDone = function () {
                if (numDone === promises.length) {
                    return true;
                }
            };
            return new Promise(function (resolve, reject) {
                _this.hideAllNotifications();
                for (var i = 0; i < promises.length; i++) {
                    promises[i].then(function (result) {
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                        _this.scope.isSubmitted = true;
                        _this.scope.isLoading = false;
                        numDone++;
                        if (checkAllDone()) {
                            resolve();
                        }
                        return;
                    }, function (reason) {
                        _this.scope.errorHandler = reason.data;
                        var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                        _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                        _this.scope.isLoading = false;
                        numDone++;
                        if (checkAllDone()) {
                            resolve();
                        }
                    });
                }
            });
        };
        ContactInfoViewCtrl.$inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'myDetailsService', 'portfolioService', 'tokenService', 'changeRequestService', 'navigationService', 'identityService', 'userCompanyService'];
        return ContactInfoViewCtrl;
    }(Patersons.AccountBaseCtrl));
    Patersons.ContactInfoViewCtrl = ContactInfoViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var TaxFileNumberViewCtrl = (function (_super) {
        __extends(TaxFileNumberViewCtrl, _super);
        function TaxFileNumberViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $document, portfolioService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.taxFileNumber = '';
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.isSubmitted = false;
            this.scope.isBusy = false;
            this.scope.events = this;
            this.document = $document;
            this.scope.scrollDuration = 700;
            this.load();
        }
        TaxFileNumberViewCtrl.prototype.setSelectedAccount = function (accountId) {
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
        };
        ;
        TaxFileNumberViewCtrl.prototype.load = function () {
            var _this = this;
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then(function (result) {
                _this.scope.accounts = result;
                if (_this.scope.accounts != undefined && _this.scope.accounts.length > 0) {
                    _this.scope.selectedAccount = _this.scope.accounts[0];
                }
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        TaxFileNumberViewCtrl.prototype.saveTaxFileNumber = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.taxFileNumberForm.$invalid) {
                return;
            }
            if (this.scope.selectedAccount === undefined) {
                return;
            }
            this.scope.isBusy = true;
            var promise = this.portfolioService.updateTaxFileNumber(this.scope.selectedAccount.accountId, this.scope.taxFileNumber, this.scope.taxFileNumberType);
            promise.then(function (result) {
                var scrollPlaceholder = angular.element(document.getElementById('scrollPlaceholder'));
                _this.document.scrollToElement(scrollPlaceholder, 0, _this.scope.scrollDuration);
                _this.scope.isSubmitted = true;
                return;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        TaxFileNumberViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$document', 'portfolioService', 'navigationService'];
        return TaxFileNumberViewCtrl;
    }(Patersons.AccountBaseCtrl));
    Patersons.TaxFileNumberViewCtrl = TaxFileNumberViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var accountDetailsModule = angular.module("app.accountDetailsModule", []);
accountDetailsModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.myDetailsModule config...');
        $stateProvider
            .state("contactInfo", {
            url: "/contactInfo",
            templateUrl: "assets/templates/accountDetails/contactInfo.html",
            controller: 'contactInfoViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Account Contact Information" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("bankDetails", {
            url: "/bankDetails",
            templateUrl: "assets/templates/accountDetails/bankDetails.html",
            controller: 'bankDetailsViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Account Banking Details" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("taxFileNumber", {
            url: "/taxFileNumber",
            templateUrl: "assets/templates/accountDetails/taxFileNumber.html",
            controller: 'taxFileNumberViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Account Tax File Number" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        });
    }]);
accountDetailsModule.controller('accountBaseCtrl', Patersons.AccountBaseCtrl);
accountDetailsModule.controller('contactInfoViewCtrl', Patersons.ContactInfoViewCtrl);
accountDetailsModule.controller('bankDetailsViewCtrl', Patersons.BankDetailsViewCtrl);
accountDetailsModule.controller('taxFileNumberViewCtrl', Patersons.TaxFileNumberViewCtrl);

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ResearchBaseCtrl = (function (_super) {
        __extends(ResearchBaseCtrl, _super);
        function ResearchBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.activateSection('research');
        }
        ResearchBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return ResearchBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.ResearchBaseCtrl = ResearchBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var StrategyCtrl = (function (_super) {
        __extends(StrategyCtrl, _super);
        function StrategyCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.researchFeedService = researchFeedService;
            this.scope.events = this;
            this.load();
        }
        StrategyCtrl.prototype.load = function () {
            var _this = this;
            this.researchFeedService.getFeaturedStrategyAndEconomics()
                .then(function (result) {
                var feedItems = result;
                _this.scope.morningMarket = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Morning Market');
                //this.scope.weeklyMarketWrap = this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Weekly Market Wrap');
                _this.scope.modelPortfolioUpdate = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Model Portfolio Update');
                _this.scope.australianInvestor = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Australian Investor');
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getTop3StrategyAndEconomics()
                .then(function (result) {
                var feedItems = result;
                if (feedItems === null || feedItems === undefined) {
                    return;
                }
                _this.scope.otherFeatured1 = feedItems.length >= 1 ? feedItems[0] : null;
                _this.scope.otherFeatured2 = feedItems.length >= 2 ? feedItems[1] : null;
                _this.scope.otherFeatured3 = feedItems.length >= 3 ? feedItems[2] : null;
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getAllStrategyAndEconomics()
                .then(function (result) {
                _this.scope.feedList = result;
            }, function (error) {
                console.log('Data is not availabe');
            });
        };
        StrategyCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return StrategyCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.StrategyCtrl = StrategyCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PrivateWealthCtrl = (function (_super) {
        __extends(PrivateWealthCtrl, _super);
        function PrivateWealthCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.researchFeedService = researchFeedService;
            this.scope.events = this;
            this.load();
        }
        PrivateWealthCtrl.prototype.load = function () {
            var _this = this;
            this.researchFeedService.getFeaturedPrivateWealthResearch()
                .then(function (result) {
                var feedItems = result;
                _this.scope.modelPortfolioUpdate = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Model Portfolio Update');
                _this.scope.modelPortfolio = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Model Portfolio');
                _this.scope.sectorStrategy = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Sector Strategy');
                _this.scope.australianInvestor = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Australian Investor');
                _this.scope.momentumMonitor = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Momentum Monitor');
                _this.scope.qualityInvesting = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Investment Strategy');
                _this.scope.highYieldStocks = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'High Yield Stocks');
                _this.scope.fixedInterestSecurities = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Fixed Interest Securities');
                _this.scope.marketStrategy = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Market Strategy');
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getTop3PrivateWealthResearch()
                .then(function (result) {
                var feedItems = result;
                if (feedItems === null || feedItems === undefined) {
                    return;
                }
                _this.scope.otherFeatured1 = feedItems.length >= 1 ? feedItems[0] : null;
                _this.scope.otherFeatured2 = feedItems.length >= 2 ? feedItems[1] : null;
                _this.scope.otherFeatured3 = feedItems.length >= 3 ? feedItems[2] : null;
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getAllPrivateWealthResearch()
                .then(function (result) {
                _this.scope.feedList = result;
            }, function (error) {
                console.log('Data is not availabe');
            });
        };
        PrivateWealthCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return PrivateWealthCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.PrivateWealthCtrl = PrivateWealthCtrl;
})(Patersons || (Patersons = {}));

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
'use strict';
var Patersons;
(function (Patersons) {
    var ArticleCtrl = (function (_super) {
        __extends(ArticleCtrl, _super);
        function ArticleCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $sce, researchFeedService, navigationService, $analytics, article) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.researchFeedService = researchFeedService;
            this.sce = $sce;
            this.$analytics = $analytics;
            this.scope.events = this;
            this.scope.isError = false;
            this.load(article);
        }
        ArticleCtrl.prototype.load = function (article) {
            this.scope.section = this.stateParams['section'];
            console.log(this.scope.section);
            if (article) {
                console.log(article);
                this.scope.article = article;
                this.$analytics.eventTrack('article view', {
                    category: 'Research Article',
                    label: article.title + " - " + window.location.href
                });
                this.scope.isError = false;
            }
            else {
                this.scope.isError = true;
            }
        };
        ArticleCtrl.prototype.toTrustedHTML = function (html) {
            return this.sce.trustAsHtml(html);
        };
        ArticleCtrl.prototype.sanitizeHTMLforView = function (html) {
            var clean = DOMPurify.sanitize(html, { FORBID_TAGS: ['style', 'class'], ADD_ATTR: ['allow', 'allowfullscreen', 'frameborder', 'scrolling'], ADD_TAGS: ['iframe'] });
            return clean;
        };
        ArticleCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$sce', 'researchFeedService', 'navigationService', '$analytics', 'article'];
        return ArticleCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.ArticleCtrl = ArticleCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var QuantitativeAnalysisCtrl = (function (_super) {
        __extends(QuantitativeAnalysisCtrl, _super);
        function QuantitativeAnalysisCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.researchFeedService = researchFeedService;
            this.scope.events = this;
            this.load();
        }
        QuantitativeAnalysisCtrl.prototype.getArticleUrl = function (feedItem) {
            return this.location.absUrl() + '&articleId=' + feedItem.id;
        };
        QuantitativeAnalysisCtrl.prototype.load = function () {
            var _this = this;
            this.researchFeedService.getFeaturedQuantitativeAnalysis()
                .then(function (result) {
                console.log(result);
                var feedItems = result;
                _this.scope.momentumMonitor = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Momentum Monitor');
                _this.scope.qualityInvesting = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'Quality Investing');
                _this.scope.highYieldStocks = _this.researchFeedService.getLatestFeedItemForCategory(feedItems, 'High Yield Stocks');
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getTop3QuantitativeAnalysis()
                .then(function (result) {
                console.log(result);
                var feedItems = result;
                if (feedItems === null || feedItems === undefined) {
                    return;
                }
                _this.scope.otherFeatured1 = feedItems.length >= 1 ? feedItems[0] : null;
                _this.scope.otherFeatured2 = feedItems.length >= 2 ? feedItems[1] : null;
                _this.scope.otherFeatured3 = feedItems.length >= 3 ? feedItems[2] : null;
            }, function (error) {
                console.log('Data is not availabe');
            });
            this.researchFeedService.getAllQuantitativeAnalysis()
                .then(function (result) {
                _this.scope.feedList = result;
            }, function (error) {
                console.log('Data is not availabe');
            });
        };
        QuantitativeAnalysisCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return QuantitativeAnalysisCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.QuantitativeAnalysisCtrl = QuantitativeAnalysisCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var CompanyResearchCtrl = (function (_super) {
        __extends(CompanyResearchCtrl, _super);
        function CompanyResearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
        }
        CompanyResearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return CompanyResearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.CompanyResearchCtrl = CompanyResearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var EquitiesResearchCtrl = (function (_super) {
        __extends(EquitiesResearchCtrl, _super);
        function EquitiesResearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.load();
        }
        EquitiesResearchCtrl.prototype.load = function () {
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-stockScreener', 'ecScreener-container', 'ec-screener', 'ecScreener_stock').then(function () {
                    console.log("Loaded screener");
                });
            });
        };
        EquitiesResearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return EquitiesResearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.EquitiesResearchCtrl = EquitiesResearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var RecentResearchCtrl = (function (_super) {
        __extends(RecentResearchCtrl, _super);
        function RecentResearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService, morningStarService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.scope.reverse = true;
            this.morningStarService = morningStarService;
            this.scope.hasData = false;
            this.scope.predicate = "dateWritten";
            this.scope.selectedCode = "";
            this.scope.selectedDate = new Date();
            this.scope.selectedAnalysts = "";
            this.scope.selectedRecommendation = "";
            this.scope.currentPage = 1;
            this.scope.itemsPerPage = 15;
            this.load();
        }
        RecentResearchCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.morningStarService.getRecentResearch(true).then(function (data) {
                _this.scope.$apply(function () {
                    _this.scope.hasData = true;
                    _this.scope.isLoading = false;
                    _this.scope.items = data;
                    _this.scope.filteredItems = data;
                });
            });
        };
        RecentResearchCtrl.prototype.filterArray = function (array, filters) {
            var filterKeys = Object.keys(filters);
            return array.filter(function (item) {
                // validates all filter criteria
                return filterKeys.every(function (key) {
                    // ignores non-function predicates
                    if (typeof filters[key] !== 'function')
                        return true;
                    return filters[key](item[key]);
                });
            });
        };
        RecentResearchCtrl.prototype.filterItems = function () {
            var _this = this;
            var filters = {};
            if (this.scope.selectedCode) {
                filters.asxcode = function (selectedCode) { return selectedCode === _this.scope.selectedCode; };
            }
            if (this.scope.selectedAnalysts) {
                filters.author = function (author) { return author === _this.scope.selectedAnalysts; };
            }
            if (this.scope.selectedRecommendation) {
                filters.licenseeRecommendation = function (licenseeRecommendation) { return licenseeRecommendation === _this.scope.selectedRecommendation; };
            }
            if (this.scope.selectedDate) {
                filters.dateWritten = function (dateWritten) { return new Date(dateWritten) <= _this.scope.selectedDate; };
            }
            this.scope.filteredItems = this.filterArray(this.scope.items, filters);
        };
        RecentResearchCtrl.prototype.onFilterChange = function (property, value) {
            this.scope[property] = value;
            this.filterItems();
        };
        RecentResearchCtrl.prototype.order = function (predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        };
        RecentResearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService', 'morningStarService'];
        return RecentResearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.RecentResearchCtrl = RecentResearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ASXAnnouncementsCtrl = (function (_super) {
        __extends(ASXAnnouncementsCtrl, _super);
        function ASXAnnouncementsCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService, morningStarService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.onFilterChange = function (key, value) {
                _this.scope[key] = value;
                var selectedCode = _this.scope.selectedCode;
                if (!selectedCode || selectedCode.length <= 5) {
                    _this.load(selectedCode, _this.scope.selectedDate, _this.scope.currentPage);
                }
            };
            this.scope = $scope;
            this.scope.events = this;
            this.morningStarService = morningStarService;
            this.scope.hasData = false;
            this.scope.totalItems = 0;
            this.scope.selectedCode = "";
            this.scope.dateOptions = [
                {
                    key: "day1",
                    value: "Today"
                }, {
                    key: "day2",
                    value: "Previous Day"
                }, {
                    key: "week1",
                    value: "Past week"
                }, {
                    key: "month1",
                    value: "Past Month"
                }, {
                    key: "month3",
                    value: "Past 3 Months"
                }, {
                    key: "month6",
                    value: "Past 6 Months"
                }, {
                    key: "year1",
                    value: "Past Year"
                }
            ];
            this.scope.selectedDate = "day1";
            this.scope.itemsPerPage = 15;
            this.load(this.scope.selectedCode, this.scope.selectedDate, this.scope.currentPage);
        }
        ASXAnnouncementsCtrl.prototype.load = function (selectedCode, selectedDate, page) {
            var _this = this;
            this.scope.isLoading = true;
            this.morningStarService.getASXAnnouncements(selectedCode, selectedDate, page).then(function (data) {
                _this.scope.$apply(function () {
                    _this.scope.hasData = true;
                    _this.scope.isLoading = false;
                    if (data.document) {
                        _this.scope.items = [].concat(data.document);
                        if (_this.scope.selectedDate === 'day2') {
                        }
                    }
                    else {
                        _this.scope.items = [];
                    }
                    _this.scope.totalItems = +data.resultstotal;
                });
            });
        };
        ASXAnnouncementsCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService', 'morningStarService'];
        return ASXAnnouncementsCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.ASXAnnouncementsCtrl = ASXAnnouncementsCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ETFResearchCtrl = (function (_super) {
        __extends(ETFResearchCtrl, _super);
        function ETFResearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.load();
        }
        ETFResearchCtrl.prototype.load = function () {
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-etfScreener', 'ecScreener-container', 'ec-screener', 'ecScreener_etf').then(function () {
                    console.log("Loaded screener");
                });
            });
        };
        ETFResearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return ETFResearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.ETFResearchCtrl = ETFResearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var FundResearchCtrl = (function (_super) {
        __extends(FundResearchCtrl, _super);
        function FundResearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.load();
        }
        FundResearchCtrl.prototype.load = function () {
            var self = this;
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-fundScreener', 'ecScreener-container', 'ec-screener', 'ecScreener_fund').then(function () {
                    console.log("Loaded screener");
                });
            });
        };
        FundResearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return FundResearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.FundResearchCtrl = FundResearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var QuickSearchCtrl = (function (_super) {
        __extends(QuickSearchCtrl, _super);
        function QuickSearchCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, researchFeedService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.load();
        }
        QuickSearchCtrl.prototype.load = function () {
            rootMorningstarPromise().then(function (promiseChain) {
                console.log('initializing component');
                initComponent('component-autocomplete-search', 'ecAutocomplete-container', 'ec-autocomplete', 'ecAutocompleteSearch').then(function () {
                    console.log('Done loading autocomplete search.');
                    morningstar.asterix.instanceRegistry.find('ecAutocompleteSearch').on('parameterChanged:latestSelectedSecurity', function (newVal) {
                        window['openAutocompleteResult'](newVal); //declared in autocomplete config
                        morningstar.asterix.instanceRegistry.get('ecAutocompleteSearch').setParameter('search', '');
                    });
                });
            });
        };
        QuickSearchCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'researchFeedService', 'navigationService'];
        return QuickSearchCtrl;
    }(Patersons.ResearchBaseCtrl));
    Patersons.QuickSearchCtrl = QuickSearchCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var researchModule = angular.module("app.researchModule", []);
researchModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.researchModule config...');
        var wholesaleClientChecker = ['sessionService', '$q', '$state', 'userCompanyService', function (sessionService, $q, $state, userCompanyService) {
                var deferred = $q.defer();
                userCompanyService.getUserCompany().then(function (company) {
                    if (sessionService.getCurrentUserProfile().wholesaleclient === 'True' && !company.enableWholesaleClientsResearch) {
                        $state.go('dashboard');
                        deferred.reject();
                    }
                    else {
                        deferred.resolve();
                    }
                });
                return deferred.promise;
            }];
        $stateProvider
            .state("privateWealth", {
            url: "/privateWealthResearch?articleId",
            templateUrl: "assets/templates/Research/privateWealth.html",
            controller: "privateWealthCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Private Wealth Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('article', {
            url: '/article/:section/:articleId',
            templateUrl: 'assets/templates/research/article.html',
            controller: "articleCtrl",
            resolve: {
                //resolve the title a bit differently - get the article first 
                article: ['$rootScope', '$stateParams', '$q', 'researchFeedService', function ($rootScope, $stateParams, $q, researchFeedService) {
                        var deferred = $q.defer();
                        researchFeedService.getArticle($stateParams['articleId'])
                            .then(function (article) {
                            if (article.id) {
                                $rootScope.meta = { title: article.title };
                                deferred.resolve(article);
                            }
                            else {
                                $rootScope.meta = { title: "Article Not Available" };
                                deferred.resolve();
                            }
                        }, function (reason) {
                            $rootScope.meta = { title: "Article Not Available" };
                            deferred.resolve();
                        });
                        return deferred.promise;
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('companyResearch', {
            url: '/companyResearch',
            templateUrl: 'assets/templates/research/companyResearch.html',
            controller: 'companyResearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Company Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('equitiesResearch', {
            url: '/equitiesResearch',
            templateUrl: 'assets/templates/research/equitiesResearch.html',
            controller: 'equitiesResearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Equities Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('fundResearch', {
            url: '/fundResearch',
            templateUrl: 'assets/templates/research/fundResearch.html',
            controller: 'fundResearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Fund Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('etfResearch', {
            url: '/etfResearch',
            templateUrl: 'assets/templates/research/etfResearch.html',
            controller: 'etfResearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "ETF Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('recentResearch', {
            url: '/recentResearch',
            templateUrl: 'assets/templates/research/recentResearch.html',
            controller: 'recentResearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Recent Equities Research" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('asxAnnouncements', {
            url: '/asxAnnouncements',
            templateUrl: 'assets/templates/research/asxAnnouncements.html',
            controller: 'asxAnnouncementsCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "ASX Announcements" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        })
            .state('search', {
            url: '/search',
            templateUrl: 'assets/templates/research/quickSearch.html',
            controller: 'quickSearchCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Quick Search" };
                    }],
                wholesaleClientCheck: wholesaleClientChecker
            }
        });
    }]);
researchModule.controller('researchBaseCtrl', Patersons.ResearchBaseCtrl);
researchModule.controller('strategyCtrl', Patersons.StrategyCtrl);
researchModule.controller('privateWealthCtrl', Patersons.PrivateWealthCtrl);
researchModule.controller('quantitativeAnalysisCtrl', Patersons.QuantitativeAnalysisCtrl);
researchModule.controller('companyResearchCtrl', Patersons.CompanyResearchCtrl);
researchModule.controller('equitiesResearchCtrl', Patersons.EquitiesResearchCtrl);
researchModule.controller('fundResearchCtrl', Patersons.FundResearchCtrl);
researchModule.controller('etfResearchCtrl', Patersons.ETFResearchCtrl);
researchModule.controller('quickSearchCtrl', Patersons.QuickSearchCtrl);
researchModule.controller('recentResearchCtrl', Patersons.RecentResearchCtrl);
researchModule.controller('asxAnnouncementsCtrl', Patersons.ASXAnnouncementsCtrl);
researchModule.controller('articleCtrl', Patersons.ArticleCtrl);

'use strict';
var myDetailsModule = angular.module("app.myDetailsModule", []);
myDetailsModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.myDetailsModule config...');
        $stateProvider
            .state("accoladeOptions", {
            url: "/accoladeOptions",
            templateUrl: "assets/templates/myProfile/accoladeOptions.html",
            controller: 'accoladeOptionsViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Accolade Mailing Options" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("researchSubscriptions", {
            url: "/researchSubscriptions",
            templateUrl: "assets/templates/myProfile/researchSubscriptions.html",
            controller: 'researchSubscriptionsViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Manage Research Subscriptions" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state('profile', {
            url: '/profile',
            templateUrl: 'assets/templates/myProfile/profile.html',
            controller: "profileCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Profile" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        });
    }]);
myDetailsModule.controller('myDetailsBaseCtrl', Patersons.MyDetailsBaseCtrl);
myDetailsModule.controller('accoladeOptionsViewCtrl', Patersons.AccoladeOptionsViewCtrl);
myDetailsModule.controller('researchSubscriptionsViewCtrl', Patersons.ResearchSubscriptionsViewCtrl);

'use strict';
var Patersons;
(function (Patersons) {
    var ChangeRequestSubmittedComponent = (function () {
        function ChangeRequestSubmittedComponent() {
            this.templateUrl = 'assets/templates/common/components/changeRequestSubmitted.component.html';
            this.bindings = {
                hasApprovers: '<',
                isSensitive: '<'
            };
        }
        return ChangeRequestSubmittedComponent;
    }());
    Patersons.ChangeRequestSubmittedComponent = ChangeRequestSubmittedComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PhoneNotRegisteredComponent = (function () {
        function PhoneNotRegisteredComponent() {
            this.templateUrl = 'assets/templates/common/components/phoneNotRegistered.component.html';
        }
        return PhoneNotRegisteredComponent;
    }());
    Patersons.PhoneNotRegisteredComponent = PhoneNotRegisteredComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ApproversNotRegisteredComponent = (function () {
        function ApproversNotRegisteredComponent() {
            this.templateUrl = 'assets/templates/common/components/approversNotRegistered.component.html';
            this.controller = ApproversNotRegisteredController;
        }
        return ApproversNotRegisteredComponent;
    }());
    Patersons.ApproversNotRegisteredComponent = ApproversNotRegisteredComponent;
    var ApproversNotRegisteredController = (function () {
        function ApproversNotRegisteredController($location, userCompanyService) {
            var _this = this;
            this.location = $location;
            userCompanyService.getUserCompany().then(function (company) {
                _this.userCompany = company;
            });
        }
        ApproversNotRegisteredController.$inject = ['$location', 'userCompanyService'];
        return ApproversNotRegisteredController;
    }());
    Patersons.ApproversNotRegisteredController = ApproversNotRegisteredController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SectionHeaderComponent = (function () {
        function SectionHeaderComponent() {
            this.templateUrl = 'assets/templates/common/components/sectionHeader.component.html';
            this.bindings = {
                title: '@'
            };
        }
        return SectionHeaderComponent;
    }());
    Patersons.SectionHeaderComponent = SectionHeaderComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SpinnerComponent = (function () {
        function SpinnerComponent() {
            this.templateUrl = 'assets/templates/common/components/spinner.component.html';
        }
        return SpinnerComponent;
    }());
    Patersons.SpinnerComponent = SpinnerComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var AccountSelectComponent = (function () {
        function AccountSelectComponent() {
            this.templateUrl = 'assets/templates/common/components/accountSelect.component.html';
            this.controller = AccountSelectController;
            this.bindings = {
                accounts: '=',
                selectedAccount: '<',
                isDisabled: '<',
                rememberSelection: '<',
                showSelectAccount: '<',
                labelText: '@',
                onAccountChange: '&'
            };
        }
        return AccountSelectComponent;
    }());
    Patersons.AccountSelectComponent = AccountSelectComponent;
    var AccountSelectController = (function () {
        function AccountSelectController(selectionService) {
            this.selectionService = selectionService;
            if (this.rememberSelection === undefined) {
                this.useSelectionService = true;
            }
            else {
                this.useSelectionService = this.rememberSelection;
            }
        }
        Object.defineProperty(AccountSelectController.prototype, "accounts", {
            get: function () {
                return this._accounts;
            },
            set: function (value) {
                this._accounts = value;
                if (!this.useSelectionService) {
                    return;
                }
                if (this.selectionService && this.selectionService.selectedAccountId) {
                    var account = this.selectionService.getSelectedAccount(this._accounts);
                    if (account != null) {
                        this._selectedAccount = account;
                        this.onAccountChange({ accountId: this._selectedAccount.accountId });
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(AccountSelectController.prototype, "selectedAccount", {
            get: function () {
                return this._selectedAccount;
            },
            set: function (value) {
                this._selectedAccount = value;
                if (!this.useSelectionService) {
                    return;
                }
                if (this.selectionService) {
                    if (value) {
                        this.selectionService.selectedAccountId = value.accountId;
                    }
                }
            },
            enumerable: true,
            configurable: true
        });
        AccountSelectController.$inject = ['selectionService'];
        return AccountSelectController;
    }());
    Patersons.AccountSelectController = AccountSelectController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ActionButtonComponent = (function () {
        function ActionButtonComponent() {
            this.templateUrl = 'assets/templates/common/components/actionButton.component.html';
            this.bindings = {
                isDisabled: '<',
                isBusy: '<',
                text: '@',
                onClick: '&'
            };
        }
        return ActionButtonComponent;
    }());
    Patersons.ActionButtonComponent = ActionButtonComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PasswordValidationComponent = (function () {
        function PasswordValidationComponent() {
            this.templateUrl = 'assets/templates/common/components/passwordValidation.component.html';
            this.bindings = {
                password: '<',
                onValidation: '<'
            };
            this.controller = PasswordValidationCtrl;
        }
        return PasswordValidationComponent;
    }());
    Patersons.PasswordValidationComponent = PasswordValidationComponent;
    var PasswordValidationCtrl = (function () {
        function PasswordValidationCtrl() {
            this.$ctrl = this;
            this.resetValidation();
        }
        PasswordValidationCtrl.prototype.resetValidation = function () {
            this.validUppercase = false;
            this.validLowercase = false;
            this.validNumber = false;
            this.validSpecial = false;
            this.valid = false;
        };
        PasswordValidationCtrl.prototype.validate = function () {
            this.resetValidation();
            if (this.password) {
                if (this.password.match(/[A-Z]/g)) {
                    this.validUppercase = true;
                }
                if (this.password.match(/[a-z]/g)) {
                    this.validLowercase = true;
                }
                if (this.password.match(/[0-9]/g)) {
                    this.validNumber = true;
                }
                if (this.password.match(/[#$^+=!*()@%&]/g)) {
                    this.validSpecial = true;
                }
                if (this.validUppercase &&
                    this.validLowercase &&
                    this.validNumber &&
                    this.validSpecial) {
                    this.valid = true;
                }
                if (this.onValidation) {
                    this.onValidation(this.valid);
                }
            }
        };
        PasswordValidationCtrl.prototype.$onChanges = function (changesObj) {
            this.validate();
        };
        return PasswordValidationCtrl;
    }());
    Patersons.PasswordValidationCtrl = PasswordValidationCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var DateSelectComponent = (function () {
        function DateSelectComponent() {
            this.templateUrl = 'assets/templates/common/components/dateSelect.component.html';
            this.controller = DateSelectController;
            this.bindings = {
                isDisabled: '<',
                defaultDate: '<',
                date: '<',
                labelText: '@',
                onDateChange: '&'
            };
        }
        return DateSelectComponent;
    }());
    Patersons.DateSelectComponent = DateSelectComponent;
    var DateSelectController = (function () {
        function DateSelectController() {
            this.isOpened = false;
            this.format = "dd/MM/yyyy";
            this.isOpened = false;
            this.format = "dd/MM/yyyy";
            if (this.defaultDate) {
                this.selectedDate = this.defaultDate;
            }
            else {
                if (this.date) {
                    this.selectedDate = this.date;
                }
                else {
                    console.log(this.selectedDate);
                    this.selectedDate = new Date();
                }
            }
        }
        DateSelectController.prototype.$onChanges = function (changesObj) {
            if (changesObj.date && changesObj.date.currentValue) {
                this.selectedDate = changesObj.date.currentValue;
            }
        };
        DateSelectController.prototype.onDateSelect = function (e, data) {
            this.isOpened = false;
            this.onDateChange(data);
        };
        DateSelectController.prototype.openCalendar = function () {
            this.isOpened = true;
        };
        return DateSelectController;
    }());
    Patersons.DateSelectController = DateSelectController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var MorningstarErrorComponent = (function () {
        function MorningstarErrorComponent() {
            this.templateUrl = 'assets/templates/common/components/morningstarError.component.html';
        }
        return MorningstarErrorComponent;
    }());
    Patersons.MorningstarErrorComponent = MorningstarErrorComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ChangePhoneComponent = (function () {
        function ChangePhoneComponent() {
            this.templateUrl = 'assets/templates/common/components/changePhone.component.html';
            this.controller = ChangePhoneCtrl;
            this.bindings = {
                showCancelButton: '<',
            };
        }
        return ChangePhoneComponent;
    }());
    Patersons.ChangePhoneComponent = ChangePhoneComponent;
    var ChangePhoneCtrl = (function () {
        function ChangePhoneCtrl($scope, $location, $window, $state, $stateParams, identityService, tokenService, navigationService, userCompanyService, sessionService) {
            var _this = this;
            this.scope = $scope;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.navigationService = navigationService;
            this.location = $location;
            this.sessionService = sessionService;
            this.scope.profile = this.sessionService.getCurrentUserProfile();
            this.scope.events = this;
            this.scope.showCancelButton = this.showCancelButton;
            var userId = $stateParams.userId;
            this.scope.isCodeSubmitted = false;
            this.scope.phoneDetails = {
                mobilePhoneNumber: ""
            };
            this.navigationService.deactivateAll();
            this.updateUiFromProfile();
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        ChangePhoneCtrl.prototype.updateUiFromProfile = function () {
            //let profile = this.tokenService.tokenManager.profile;
            var _this = this;
            //if (profile) {
            //this.scope.showInfo = (profile.phone_number_verified != "true");
            //this.scope.currentNumber = profile.phone_number;
            // get phone number from backend
            var promise = this.identityService.getPhoneNumber();
            promise.then(function (result) {
                _this.scope.showInfo = (result["phoneNumberVerified"] != true);
                _this.scope.currentNumber = result["phoneNumber"];
                _this.scope.phoneDetails = {
                    mobilePhoneNumber: _this.scope.currentNumber
                };
                console.log(_this.scope.currentNumber);
                console.info('this.scope.showInfo ' + _this.scope.showInfo);
                console.info('this.scope.currentNumber ' + _this.scope.currentNumber);
            }).catch(function (reason) {
                _this.scope.showInfo = true;
                console.error(reason);
            });
            //} else {
            //  this.scope.showInfo = true;
            //}
        };
        ChangePhoneCtrl.prototype.changeNumber = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.changePhoneForm.$invalid) {
                return;
            }
            this.identityService.changeMobileNumber(this.scope.phoneDetails)
                .then(function (result) {
                _this.scope.isCodeSubmitted = true;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        ChangePhoneCtrl.prototype.confirmCode = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.verifyPhoneForm.$invalid) {
                return;
            }
            this.scope.phoneConfirmationDetails.mobilePhoneNumber = this.scope.phoneDetails.mobilePhoneNumber;
            this.identityService.confirmMobileNumberChange(this.scope.phoneConfirmationDetails)
                .then(function (result) {
                _this.scope.showInfo = false;
                _this.scope.currentNumber = _this.scope.phoneConfirmationDetails.mobilePhoneNumber;
                setTimeout(function () {
                    location.href = '/dashboard';
                }, 2000);
                // need to avoid that redirect
                //this.tokenService.tokenManager.redirectForToken();
            }, function (reason) {
                _this.updateUiFromProfile();
                _this.scope.errorHandler = reason.data;
            });
        };
        ChangePhoneCtrl.prototype.cancelRegistration = function () {
            location.href = '/dashboard';
        };
        ChangePhoneCtrl.$inject = ['$scope', '$location', '$window', '$state', '$stateParams', 'identityService', 'tokenService', 'navigationService', 'userCompanyService', 'sessionService'];
        return ChangePhoneCtrl;
    }());
    Patersons.ChangePhoneCtrl = ChangePhoneCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var FeaturedItemComponent = (function () {
        function FeaturedItemComponent() {
            this.templateUrl = 'assets/templates/research/components/featuredItem.component.html';
            this.bindings = {
                feedItem: '<',
                showImage: '<',
                defaultImage: '@',
                title: '@'
            };
        }
        return FeaturedItemComponent;
    }());
    Patersons.FeaturedItemComponent = FeaturedItemComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var feedListComponent = (function () {
        function feedListComponent() {
            this.templateUrl = 'assets/templates/research/components/feedList.component.html';
            this.controller = FeedListController;
            this.bindings = {
                feedItems: '<',
                title: '@'
            };
        }
        return feedListComponent;
    }());
    Patersons.feedListComponent = feedListComponent;
    var FeedListController = (function () {
        function FeedListController() {
            this.predicate = 'publishedDate';
            this.reverse = true;
        }
        FeedListController.prototype.order = function (predicate) {
            this.reverse = (this.predicate === predicate) ? !this.reverse : false;
            this.predicate = predicate;
        };
        return FeedListController;
    }());
    Patersons.FeedListController = FeedListController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var InvestorDocsComponent = (function () {
        function InvestorDocsComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/investorDocs.component.html';
            this.controller = InvestorDocsController;
            this.bindings = {
                report: '<',
                isDownloading: '<',
                onDownloadFiles: '&'
            };
        }
        return InvestorDocsComponent;
    }());
    Patersons.InvestorDocsComponent = InvestorDocsComponent;
    var InvestorDocsController = (function () {
        function InvestorDocsController() {
            this.extractDateFromString = function (string) {
                var months = ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"];
                // Match = 12 January 2019
                var regexpFullDate = new RegExp("\\d{1,2} (" + months.join("|") + ") \\d{4}", "gi");
                var matchFullDate = string.match(regexpFullDate);
                // Match 2019'20
                var regexpYear = new RegExp("\\d{4}'\\d{2}");
                var matchYear = string.match(regexpYear);
                // Match September 2019
                var regexpPartialDate = new RegExp("(" + months.join("|") + ") \\d{4}", "gi");
                var matchPartialDate = string.match(regexpPartialDate);
                var date = null;
                if (matchFullDate && matchFullDate[0]) {
                    date = new Date(matchFullDate[0]);
                }
                else if (matchYear && matchYear[0]) {
                    var yearSplit = matchYear[0].split("'");
                    var year = parseInt(yearSplit[0]) + 1;
                    date = new Date(year.toString());
                }
                else if (matchPartialDate && matchPartialDate[0]) {
                    var dateSplit = matchPartialDate[0].split(" ");
                    date = new Date(dateSplit[1], months.indexOf(dateSplit[0].toLowerCase()), 1);
                }
                return date;
            };
            this.selectAll = function (check) {
                this.report.investorDocs.forEach(function (item, index) {
                    item.isSelected = check;
                });
            };
            this.order = function (predicate) {
                this.reverse = (this.predicate === predicate) ? !this.reverse : false;
                this.predicate = predicate;
            };
            this.downloadDocs = function () {
                var selectedItems = [];
                this.report.investorDocs.forEach(function (item, index) {
                    if (item.isSelected) {
                        selectedItems.push(item);
                    }
                });
                this.onDownloadFiles({ investorDocs: selectedItems });
            };
            this.predicate = "date";
            this.reverse = true;
            var self = this;
            this.report.investorDocs = this.report.investorDocs.map(function (a) {
                a.date = self.extractDateFromString(a.name);
                return a;
            });
        }
        return InvestorDocsController;
    }());
    Patersons.InvestorDocsController = InvestorDocsController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ReportTypeSelectComponent = (function () {
        function ReportTypeSelectComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/reportTypeSelect.component.html';
            this.controller = ReportTypeSelectController;
            this.bindings = {
                isDisabled: '<',
                onReportTypeChange: '&'
            };
        }
        return ReportTypeSelectComponent;
    }());
    Patersons.ReportTypeSelectComponent = ReportTypeSelectComponent;
    var ReportTypeSelectController = (function () {
        function ReportTypeSelectController($scope, $location, $state, $stateParams, userCompanyService) {
            var _this = this;
            this.$ctrl = this;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.menuOpen = false;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
        }
        ReportTypeSelectController.$inject = ['$scope', '$location', '$state', '$stateParams', 'userCompanyService'];
        return ReportTypeSelectController;
    }());
    Patersons.ReportTypeSelectController = ReportTypeSelectController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var HoldingsDisclaimerComponent = (function () {
        function HoldingsDisclaimerComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/holdingsDisclaimer.component.html';
            this.controller = ['userCompanyService', function (userCompanyService) {
                    var _this = this;
                    userCompanyService.getUserCompany().then(function (company) {
                        _this.userCompany = company;
                    });
                }];
        }
        return HoldingsDisclaimerComponent;
    }());
    Patersons.HoldingsDisclaimerComponent = HoldingsDisclaimerComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var ReportDisclaimerComponent = (function () {
        function ReportDisclaimerComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/reportDisclaimer.component.html';
            this.controller = ['userCompanyService', function (userCompanyService) {
                    var _this = this;
                    userCompanyService.getUserCompany().then(function (company) {
                        _this.userCompany = company;
                    });
                }];
        }
        return ReportDisclaimerComponent;
    }());
    Patersons.ReportDisclaimerComponent = ReportDisclaimerComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var AccountDateRangeFilterComponent = (function () {
        function AccountDateRangeFilterComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/accountDateRangeFilter.component.html';
            this.controller = AccountDateRangeFilterController;
            this.bindings = {
                defaultFromDate: '<',
                defaultToDate: '<',
                accounts: '=',
                isBusy: '<',
                onApplyFilter: '&'
            };
        }
        return AccountDateRangeFilterComponent;
    }());
    Patersons.AccountDateRangeFilterComponent = AccountDateRangeFilterComponent;
    var AccountDateRangeFilterController = (function () {
        function AccountDateRangeFilterController() {
            if (this.defaultFromDate) {
                this.setFromDate(this.defaultFromDate);
            }
            else {
                this.setFromDate(new Date());
            }
            if (this.defaultToDate) {
                this.setToDate(this.defaultToDate);
            }
            else {
                this.setToDate(new Date());
            }
        }
        AccountDateRangeFilterController.prototype.setSelectedAccount = function (accountId) {
            this.selectedAccount = this.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            console.info('selected account id: ' + this.selectedAccount.accountId);
            if (this.selectedAccount && this.fromDate && this.toDate) {
                this.onApplyFilter({ accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate });
            }
        };
        AccountDateRangeFilterController.prototype.setFromDate = function (fromDate) {
            this.fromDate = fromDate;
            console.info('from date: ' + this.fromDate);
            if (this.selectedAccount && this.fromDate && this.toDate) {
                this.onApplyFilter({ accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate });
            }
        };
        AccountDateRangeFilterController.prototype.setToDate = function (toDate) {
            this.toDate = toDate;
            console.info('to date: ' + this.toDate);
            if (this.selectedAccount && this.fromDate && this.toDate) {
                this.onApplyFilter({ accountId: this.selectedAccount.accountId, fromDate: this.fromDate, toDate: this.toDate });
            }
        };
        AccountDateRangeFilterController.prototype.$onChanges = function (changesObj) {
            console.log("Account Date Range Obj: ");
            console.log(changesObj);
            if (this.accounts && this.accounts[0] && !this.selectedAccount) {
                this.setSelectedAccount(this.accounts[0].accountId);
            }
        };
        return AccountDateRangeFilterController;
    }());
    Patersons.AccountDateRangeFilterController = AccountDateRangeFilterController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PortfolioSummaryComponent = (function () {
        function PortfolioSummaryComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/portfolioSummary.component.html';
            this.controller = PortfolioSummaryController;
            this.bindings = {
                account: '<',
                isDownloadReady: '<',
                summaryText: '@',
                onDownloadPdfClicked: '&',
                onDownloadCsvClicked: '&',
                hidePdfOption: '<',
                hideCsvOption: '<'
            };
        }
        return PortfolioSummaryComponent;
    }());
    Patersons.PortfolioSummaryComponent = PortfolioSummaryComponent;
    var PortfolioSummaryController = (function () {
        function PortfolioSummaryController() {
        }
        return PortfolioSummaryController;
    }());
    Patersons.PortfolioSummaryController = PortfolioSummaryController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    // This enum must be kept consistent with the C# enum defined in Patersons.Investors.InvestorApi.Model.
    // HACK: The quirk of casting "Value" to <any> before assigning it to the enum Value is necessary
    // because, when we deserialise the ReportType information from the Web API we get back a string, which
    // the transpiled Javascript happily assigns to the target property since it stores no type information.
    (function (ReportType) {
        ReportType[ReportType["CapitalTransactions"] = "CapitalTransactions"] = "CapitalTransactions";
        ReportType[ReportType["QuarterlyReports"] = "QuarterlyReports"] = "QuarterlyReports";
        ReportType[ReportType["Cash"] = "Cash"] = "Cash";
        ReportType[ReportType["Income"] = "Income"] = "Income";
        ReportType[ReportType["CapitalGains"] = "CapitalGains"] = "CapitalGains";
        ReportType[ReportType["UnrealisedCapitalGains"] = "UnrealisedCapitalGains"] = "UnrealisedCapitalGains";
        ReportType[ReportType["Performance"] = "Performance"] = "Performance";
        ReportType[ReportType["TaxReports"] = "TaxReports"] = "TaxReports";
        ReportType[ReportType["Valuation"] = "Valuation"] = "Valuation";
        ReportType[ReportType["StandardLedger"] = "StandardLedger"] = "StandardLedger";
        ReportType[ReportType["MarketValue"] = "MarketValue"] = "MarketValue";
    })(Patersons.ReportType || (Patersons.ReportType = {}));
    var ReportType = Patersons.ReportType;
    var AbstractReport = (function () {
        function AbstractReport() {
        }
        return AbstractReport;
    }());
    Patersons.AbstractReport = AbstractReport;
    var AbstractReportController = (function () {
        function AbstractReportController() {
            this.shortPaddedDateFormat = 'dd MMM yyyy';
            this.mediumDateFormat = 'd MMMM yyyy';
            this.fullDateTimeFormat = 'd MMMM yyyy h:mm:ssa';
        }
        AbstractReportController.prototype.mapAgilityExchangeCodeToMIC = function (exchangeCode) {
            switch (exchangeCode) {
                case "HKE":
                case "HKG":
                    exchangeCode = "EX$$$$XHKG";
                    break;
                case "SGX":
                case "SES":
                    exchangeCode = "EX$$$$XSES";
                    break;
                case "NAS":
                    exchangeCode = "EX$$$$XNAS";
                    break;
                case "NYS":
                    exchangeCode = "EX$$$$XNYS";
                    break;
                case "AME":
                case "ASE":
                    exchangeCode = "EX$$$$XASE";
                    break;
                case "LSE":
                case "LON":
                    exchangeCode = "EX$$$$XLON";
                    break;
                case "ETR":
                case "FRA":
                    exchangeCode = "EX$$$$XFRA";
                    break;
                case "PAR":
                    exchangeCode = "EX$$$$XPAR";
                    break;
                case "ARC":
                case "ARCX":
                    exchangeCode = "EX$$$$ARCX";
                    break;
                case "AMS":
                    exchangeCode = "EX$$$$XAMS";
                    break;
                case "MAD":
                case "MCE":
                    exchangeCode = "EX$$$$XMCE";
                    break;
                case "MTA":
                case "MIL":
                    exchangeCode = "EX$$$$XMIL";
                    break;
                case "AXW":
                case "ASX":
                    exchangeCode = "EX$$$$XASX";
                    break;
                default:
                    exchangeCode = "UNL";
                    break;
            }
            return exchangeCode;
        };
        return AbstractReportController;
    }());
    Patersons.AbstractReportController = AbstractReportController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var IncomeReport = (function (_super) {
        __extends(IncomeReport, _super);
        function IncomeReport() {
            _super.apply(this, arguments);
        }
        return IncomeReport;
    }(Patersons.AbstractReport));
    Patersons.IncomeReport = IncomeReport;
    var TransactionTypeCategory = (function () {
        function TransactionTypeCategory() {
        }
        return TransactionTypeCategory;
    }());
    Patersons.TransactionTypeCategory = TransactionTypeCategory;
    var TransactionTypeSubCategory = (function () {
        function TransactionTypeSubCategory() {
        }
        return TransactionTypeSubCategory;
    }());
    Patersons.TransactionTypeSubCategory = TransactionTypeSubCategory;
    var IncomeReportLineItem = (function () {
        function IncomeReportLineItem() {
        }
        return IncomeReportLineItem;
    }());
    Patersons.IncomeReportLineItem = IncomeReportLineItem;
    var IncomeReportComponent = (function () {
        function IncomeReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/incomeReport.component.html';
            this.controller = IncomeReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return IncomeReportComponent;
    }());
    Patersons.IncomeReportComponent = IncomeReportComponent;
    var IncomeReportController = (function (_super) {
        __extends(IncomeReportController, _super);
        function IncomeReportController() {
            _super.apply(this, arguments);
        }
        return IncomeReportController;
    }(Patersons.AbstractReportController));
    Patersons.IncomeReportController = IncomeReportController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var CashReport = (function (_super) {
        __extends(CashReport, _super);
        function CashReport() {
            _super.apply(this, arguments);
        }
        return CashReport;
    }(Patersons.AbstractReport));
    Patersons.CashReport = CashReport;
    var CashReportTransactionGroup = (function () {
        function CashReportTransactionGroup() {
        }
        return CashReportTransactionGroup;
    }());
    Patersons.CashReportTransactionGroup = CashReportTransactionGroup;
    var CashReportLineItem = (function () {
        function CashReportLineItem() {
        }
        return CashReportLineItem;
    }());
    Patersons.CashReportLineItem = CashReportLineItem;
    var CashReportComponent = (function () {
        function CashReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/cashReport.component.html';
            this.controller = CashReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return CashReportComponent;
    }());
    Patersons.CashReportComponent = CashReportComponent;
    var CashReportController = (function (_super) {
        __extends(CashReportController, _super);
        function CashReportController() {
            _super.apply(this, arguments);
        }
        return CashReportController;
    }(Patersons.AbstractReportController));
    Patersons.CashReportController = CashReportController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var CapitalTransactionStatement = (function (_super) {
        __extends(CapitalTransactionStatement, _super);
        function CapitalTransactionStatement() {
            _super.apply(this, arguments);
        }
        return CapitalTransactionStatement;
    }(Patersons.AbstractReport));
    Patersons.CapitalTransactionStatement = CapitalTransactionStatement;
    var TradeCategory = (function () {
        function TradeCategory() {
        }
        return TradeCategory;
    }());
    Patersons.TradeCategory = TradeCategory;
    var CapitalTransaction = (function () {
        function CapitalTransaction() {
        }
        return CapitalTransaction;
    }());
    Patersons.CapitalTransaction = CapitalTransaction;
    var CapitalTransactionStatementComponent = (function () {
        function CapitalTransactionStatementComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/capitalTransactionStatement.component.html';
            this.controller = CapitalTransactionStatementController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return CapitalTransactionStatementComponent;
    }());
    Patersons.CapitalTransactionStatementComponent = CapitalTransactionStatementComponent;
    var CapitalTransactionStatementController = (function (_super) {
        __extends(CapitalTransactionStatementController, _super);
        function CapitalTransactionStatementController() {
            _super.apply(this, arguments);
        }
        return CapitalTransactionStatementController;
    }(Patersons.AbstractReportController));
    Patersons.CapitalTransactionStatementController = CapitalTransactionStatementController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var StandardLedgerReport = (function (_super) {
        __extends(StandardLedgerReport, _super);
        function StandardLedgerReport() {
            _super.apply(this, arguments);
        }
        return StandardLedgerReport;
    }(Patersons.AbstractReport));
    Patersons.StandardLedgerReport = StandardLedgerReport;
    var LedgerEntry = (function () {
        function LedgerEntry() {
        }
        return LedgerEntry;
    }());
    Patersons.LedgerEntry = LedgerEntry;
    var StandardLedgerReportComponent = (function () {
        function StandardLedgerReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/standardLedgerReport.component.html';
            this.controller = StandardLedgerReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return StandardLedgerReportComponent;
    }());
    Patersons.StandardLedgerReportComponent = StandardLedgerReportComponent;
    var StandardLedgerReportController = (function (_super) {
        __extends(StandardLedgerReportController, _super);
        function StandardLedgerReportController() {
            _super.apply(this, arguments);
        }
        return StandardLedgerReportController;
    }(Patersons.AbstractReportController));
    Patersons.StandardLedgerReportController = StandardLedgerReportController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var QuarterlyReportsListReport = (function (_super) {
        __extends(QuarterlyReportsListReport, _super);
        function QuarterlyReportsListReport() {
            _super.apply(this, arguments);
        }
        return QuarterlyReportsListReport;
    }(Patersons.AbstractReport));
    Patersons.QuarterlyReportsListReport = QuarterlyReportsListReport;
    var QuarterlyReportsListEntry = (function () {
        function QuarterlyReportsListEntry() {
        }
        return QuarterlyReportsListEntry;
    }());
    Patersons.QuarterlyReportsListEntry = QuarterlyReportsListEntry;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var TaxReportsListReport = (function (_super) {
        __extends(TaxReportsListReport, _super);
        function TaxReportsListReport() {
            _super.apply(this, arguments);
        }
        return TaxReportsListReport;
    }(Patersons.AbstractReport));
    Patersons.TaxReportsListReport = TaxReportsListReport;
    var TaxReportsListEntry = (function () {
        function TaxReportsListEntry() {
        }
        return TaxReportsListEntry;
    }());
    Patersons.TaxReportsListEntry = TaxReportsListEntry;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PerformanceReport = (function (_super) {
        __extends(PerformanceReport, _super);
        function PerformanceReport() {
            _super.apply(this, arguments);
        }
        return PerformanceReport;
    }(Patersons.AbstractReport));
    Patersons.PerformanceReport = PerformanceReport;
    var PerformanceReportComponent = (function () {
        function PerformanceReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/performanceReport.component.html';
            this.controller = PerformanceReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return PerformanceReportComponent;
    }());
    Patersons.PerformanceReportComponent = PerformanceReportComponent;
    var PerformanceReportController = (function (_super) {
        __extends(PerformanceReportController, _super);
        function PerformanceReportController() {
            _super.apply(this, arguments);
        }
        return PerformanceReportController;
    }(Patersons.AbstractReportController));
    Patersons.PerformanceReportController = PerformanceReportController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PortfolioGraphComponent = (function () {
        function PortfolioGraphComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/portfolioGraph.component.html';
            this.controller = PortfolioGraphController;
            this.bindings = {
                account: '<',
            };
        }
        return PortfolioGraphComponent;
    }());
    Patersons.PortfolioGraphComponent = PortfolioGraphComponent;
    var PortfolioGraphController = (function () {
        function PortfolioGraphController($scope, portfolioService) {
            this.sectorOptions = {
                showLabel: false,
                donut: true,
                donutWidth: 45
            };
            this.assetClassOptions = {
                showLabel: false,
                donut: true,
                donutWidth: 45
            };
            this.portfolioService = portfolioService;
            this.activeToggle = "sector";
            this.getTopSectors();
        }
        PortfolioGraphController.prototype.toggleActive = function (toggle) {
            this.activeToggle = toggle;
            this.getTopSectors();
        };
        PortfolioGraphController.prototype.extractSeriesData = function (results) {
            if (results.length == 0) {
                var emptyData = [100];
                var emptyLabels = new Array();
                emptyLabels.push({ name: "Unknown", value: 100 });
                emptyLabels.push({ name: "--", value: 0 });
                emptyLabels.push({ name: "--", value: 0 });
                emptyLabels.push({ name: "--", value: 0 });
                emptyLabels.push({ name: "--", value: 0 });
                return {
                    data: emptyData,
                    labels: emptyLabels
                };
            }
            else {
                var total = 0;
                for (var i = 0; i < results.length; i++) {
                    total = total + results[i].count;
                }
                var seriesData = new Array();
                var labelData = [];
                for (var i = 0; i < results.length; i++) {
                    var percentage = (results[i].count / total) * 100;
                    var roundedPercentage = Math.round(percentage * 100000) / 100000;
                    seriesData.push(roundedPercentage);
                    var label = {};
                    label.name = results[i].sectorName;
                    label.value = roundedPercentage.toFixed(2);
                    labelData.push(label);
                }
                console.log;
                return {
                    data: seriesData,
                    labels: labelData
                };
            }
        };
        PortfolioGraphController.prototype.getSectorDataPromise = function () {
            if (this.account.accountType === 'Standard') {
                switch (this.activeToggle) {
                    case "assetClass":
                        return this.portfolioService.getTopAssetClass(this.account.accountId);
                    case "sector":
                        return this.portfolioService.getTopSectors(this.account.accountId);
                }
            }
            else {
                switch (this.activeToggle) {
                    case "assetClass":
                        return this.portfolioService.getAccoladeTopAssetClass(this.account.accountId);
                    case "sector":
                        return this.portfolioService.getAccoladeTopSectors(this.account.accountId);
                }
            }
        };
        PortfolioGraphController.prototype.getTopSectors = function () {
            var _this = this;
            if (this.activeToggle === "assetClass" && this.assetClassData !== undefined ||
                this.activeToggle === "sector" && this.sectorData !== undefined) {
                return;
            }
            this.summaryLoaded = false;
            this.summaryError = false;
            var promise = this.getSectorDataPromise();
            promise.then(function (results) {
                var data = _this.extractSeriesData(results);
                switch (_this.activeToggle) {
                    case "assetClass":
                        _this.assetClassData = {
                            series: data.data
                        };
                        _this.assetClassLabels = data.labels;
                        _this.assetClassError = false;
                        break;
                    case "sector":
                        _this.sectorData = {
                            series: data.data
                        };
                        _this.sectorLabels = data.labels;
                        _this.sectorsError = false;
                        break;
                }
                _this.summaryError = false;
                _this.summaryLoaded = true;
            }, function (reason) {
                _this.sectorsError = true;
                _this.summaryError = true;
                _this.summaryLoaded = true;
            });
        };
        PortfolioGraphController.$inject = ['$scope', 'portfolioService'];
        return PortfolioGraphController;
    }());
    Patersons.PortfolioGraphController = PortfolioGraphController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var RealisedCapitalGainsReport = (function (_super) {
        __extends(RealisedCapitalGainsReport, _super);
        function RealisedCapitalGainsReport() {
            _super.apply(this, arguments);
        }
        return RealisedCapitalGainsReport;
    }(Patersons.AbstractReport));
    Patersons.RealisedCapitalGainsReport = RealisedCapitalGainsReport;
    var RealisedCapitalGainsAssetClass = (function () {
        function RealisedCapitalGainsAssetClass() {
        }
        return RealisedCapitalGainsAssetClass;
    }());
    Patersons.RealisedCapitalGainsAssetClass = RealisedCapitalGainsAssetClass;
    var RealisedCapitalGainsAsset = (function () {
        function RealisedCapitalGainsAsset() {
        }
        return RealisedCapitalGainsAsset;
    }());
    Patersons.RealisedCapitalGainsAsset = RealisedCapitalGainsAsset;
    var RealisedCapitalGain = (function () {
        function RealisedCapitalGain() {
        }
        return RealisedCapitalGain;
    }());
    Patersons.RealisedCapitalGain = RealisedCapitalGain;
    var RealisedCapitalGainsReportComponent = (function () {
        function RealisedCapitalGainsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/realisedCapitalGainsReport.component.html';
            this.controller = RealisedCapitalGainsReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return RealisedCapitalGainsReportComponent;
    }());
    Patersons.RealisedCapitalGainsReportComponent = RealisedCapitalGainsReportComponent;
    var RealisedCapitalGainsReportController = (function (_super) {
        __extends(RealisedCapitalGainsReportController, _super);
        function RealisedCapitalGainsReportController() {
            _super.apply(this, arguments);
        }
        return RealisedCapitalGainsReportController;
    }(Patersons.AbstractReportController));
    Patersons.RealisedCapitalGainsReportController = RealisedCapitalGainsReportController;
})(Patersons || (Patersons = {}));

"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var MarketValue = (function () {
        function MarketValue() {
        }
        return MarketValue;
    }());
    Patersons.MarketValue = MarketValue;
    var MarketValueReport = (function (_super) {
        __extends(MarketValueReport, _super);
        function MarketValueReport() {
            _super.apply(this, arguments);
        }
        return MarketValueReport;
    }(Patersons.AbstractReport));
    Patersons.MarketValueReport = MarketValueReport;
    var MarketValueReportComponent = (function () {
        function MarketValueReportComponent() {
            this.templateUrl = "assets/templates/portfolioSummary/components/marketValueReport.component.html";
            this.controller = MarketValueReportController;
            this.bindings = {
                account: "<",
                displayTitle: "@",
                asAt: "<"
            };
        }
        return MarketValueReportComponent;
    }());
    Patersons.MarketValueReportComponent = MarketValueReportComponent;
    var MarketValueReportController = (function (_super) {
        __extends(MarketValueReportController, _super);
        function MarketValueReportController($scope, $rootScope, userCompanyService, reportService) {
            var _this = this;
            _super.call(this);
            this.getMarketValueReport = function () {
                var _this = this;
                this.scope.isMarketValueError = false;
                this.scope.hasMarketValueData = false;
                if (this.account == undefined) {
                    return;
                }
                this.scope.isMarketValueLoading = true;
                this.reportService
                    .getReport(Patersons.ReportType.MarketValue, this.account.accountId, this.scope.fromDate, this.scope.toDate)
                    .then(function (result) {
                    _this.scope.marketValueReport = result;
                    _this.buildChartData();
                    _this.scope.hasMarketValueData = true;
                    _this.scope.isMarketValueError = false;
                    _this.scope.loadedOnce = true;
                }, function (error) {
                    // error handling
                    _this.scope.marketValueReport = null;
                    _this.scope.isMarketValueError = true;
                    _this.scope.hasMarketValueData = false;
                })
                    .finally(function () {
                    _this.scope.isMarketValueLoading = false;
                });
            };
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.scope.events = this;
            this.userCompanyService = userCompanyService;
            this.reportService = reportService;
            this.scope.fromDate = moment(this.asAt).add(-1, "Y").toDate();
            this.scope.toDate = moment(this.asAt).toDate();
            this.scope.selectedPeriod = "1Y";
            this.scope.periodFilter = [
                {
                    id: "ALL",
                    text: "All",
                    fromDate: moment(this.asAt).add(-100, "Y").toDate(),
                    toDate: moment(this.asAt).toDate(),
                    unit: undefined
                },
                {
                    id: "5Y",
                    text: "5Y",
                    fromDate: moment(this.asAt).add(-5, "Y").toDate(),
                    toDate: moment(this.asAt).toDate(),
                    unit: "year"
                },
                {
                    id: "1Y",
                    text: "1Y",
                    fromDate: moment(this.asAt).add(-1, "Y").toDate(),
                    toDate: moment(this.asAt).toDate(),
                    unit: "month"
                },
                {
                    id: "6M",
                    text: "6M",
                    fromDate: moment(this.asAt).add(-6, "M").toDate(),
                    toDate: moment(this.asAt).toDate(),
                    unit: "month"
                },
                {
                    id: "1M",
                    text: "1M",
                    fromDate: moment(this.asAt).add(-1, "M").toDate(),
                    toDate: moment(this.asAt).toDate(),
                    unit: "day"
                },
            ];
            this.scope.chartOptions = {
                maintainAspectRatio: false,
                tooltips: {
                    mode: "index",
                    intersect: false,
                    backgroundColor: '#FFF',
                    titleFontSize: 16,
                    titleFontColor: '#000',
                    bodyFontColor: '#000',
                    xPadding: 10,
                    yPadding: 10,
                    caretSize: 0,
                    caretPadding: 10,
                    titleSpacing: 4,
                    cornerRadius: 0,
                    bodyFontSize: 14,
                    displayColors: false,
                    callbacks: {
                        label: function (tooltipItem, data) {
                            return tooltipItem.yLabel.toLocaleString("en-AU", {
                                style: "currency",
                                currency: "AUD",
                            });
                        },
                    },
                },
                elements: {
                    point: {
                        radius: 0,
                    },
                    line: {
                        tension: 0,
                        fill: false,
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                maxTicksLimit: 6,
                                callback: function (value, index, values) {
                                    return value.toLocaleString("en-AU", {
                                        style: "currency",
                                        currency: "AUD",
                                    });
                                },
                            },
                        },
                    ],
                    xAxes: [
                        {
                            type: "time",
                            time: {
                                unit: "month",
                                minUnit: "day",
                                tooltipFormat: "DD MMMM YYYY",
                                displayFormats: {
                                    quarter: "MMM YYYY",
                                },
                            },
                        },
                    ],
                },
            };
            this.scope.datasetOverride = [
                {
                    type: "LineWithLine",
                },
            ];
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
                if (company.enableFeature) {
                    _this.load();
                }
            });
        }
        MarketValueReportController.prototype.load = function () {
            this.getMarketValueReport();
        };
        MarketValueReportController.prototype.setFromDate = function (selectedDate) {
            this.scope.fromDate = selectedDate;
            this.scope.selectedPeriod = null;
            this.getMarketValueReport();
        };
        MarketValueReportController.prototype.setToDate = function (selectedDate) {
            this.scope.toDate = selectedDate;
            this.scope.selectedPeriod = null;
            this.getMarketValueReport();
        };
        MarketValueReportController.prototype.setSelectedPeriod = function (selectedPeriod) {
            this.scope.toDate = selectedPeriod.toDate;
            this.scope.fromDate = selectedPeriod.fromDate;
            this.scope.selectedPeriod = selectedPeriod.id;
            this.scope.chartOptions.scales.xAxes[0].time.unit = selectedPeriod.unit;
            this.getMarketValueReport();
        };
        MarketValueReportController.prototype.buildChartData = function () {
            this.scope.chartSeries = ["Market Value for " + this.account.accountId];
            var seriesData = this.scope.marketValueReport.marketValuation.map(function (element) {
                return {
                    x: moment(element.date).toDate(),
                    y: element.value,
                };
            });
            if (this.scope.selectedPeriod === "ALL") {
                if (seriesData.length > 365) {
                    this.scope.chartOptions.scales.xAxes[0].time.unit = "year";
                }
                else {
                    this.scope.chartOptions.scales.xAxes[0].time.unit = "month";
                }
            }
            this.scope.chartData = [seriesData];
        };
        MarketValueReportController.$inject = [
            "$scope",
            "$rootScope",
            "userCompanyService",
            "reportService",
        ];
        return MarketValueReportController;
    }(Patersons.AbstractReportController));
    Patersons.MarketValueReportController = MarketValueReportController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var UnrealisedCapitalGainsReport = (function (_super) {
        __extends(UnrealisedCapitalGainsReport, _super);
        function UnrealisedCapitalGainsReport() {
            _super.apply(this, arguments);
        }
        return UnrealisedCapitalGainsReport;
    }(Patersons.AbstractReport));
    Patersons.UnrealisedCapitalGainsReport = UnrealisedCapitalGainsReport;
    var UnrealisedCapitalGainsAssetClass = (function () {
        function UnrealisedCapitalGainsAssetClass() {
        }
        return UnrealisedCapitalGainsAssetClass;
    }());
    Patersons.UnrealisedCapitalGainsAssetClass = UnrealisedCapitalGainsAssetClass;
    var UnrealisedCapitalGainsAsset = (function () {
        function UnrealisedCapitalGainsAsset() {
        }
        return UnrealisedCapitalGainsAsset;
    }());
    Patersons.UnrealisedCapitalGainsAsset = UnrealisedCapitalGainsAsset;
    var UnrealisedCapitalGain = (function () {
        function UnrealisedCapitalGain() {
        }
        return UnrealisedCapitalGain;
    }());
    Patersons.UnrealisedCapitalGain = UnrealisedCapitalGain;
    var UnrealisedCapitalGainsReportComponent = (function () {
        function UnrealisedCapitalGainsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/unrealisedCapitalGainsReport.component.html';
            this.controller = UnrealisedCapitalGainsReportController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return UnrealisedCapitalGainsReportComponent;
    }());
    Patersons.UnrealisedCapitalGainsReportComponent = UnrealisedCapitalGainsReportComponent;
    var UnrealisedCapitalGainsReportController = (function (_super) {
        __extends(UnrealisedCapitalGainsReportController, _super);
        function UnrealisedCapitalGainsReportController() {
            _super.apply(this, arguments);
        }
        return UnrealisedCapitalGainsReportController;
    }(Patersons.AbstractReportController));
    Patersons.UnrealisedCapitalGainsReportController = UnrealisedCapitalGainsReportController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var TermDepositsHoldingsReport = (function () {
        function TermDepositsHoldingsReport() {
        }
        return TermDepositsHoldingsReport;
    }());
    Patersons.TermDepositsHoldingsReport = TermDepositsHoldingsReport;
    var TermDepositsHoldingsReportComponent = (function () {
        function TermDepositsHoldingsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/termDepositsReport.component.html';
            this.bindings = {
                report: '<',
                predicate: '<',
                sortOrder: '<',
                searchText: '<',
                onOrderChanged: '&'
            };
        }
        return TermDepositsHoldingsReportComponent;
    }());
    Patersons.TermDepositsHoldingsReportComponent = TermDepositsHoldingsReportComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var CashHoldingsReport = (function () {
        function CashHoldingsReport() {
        }
        return CashHoldingsReport;
    }());
    Patersons.CashHoldingsReport = CashHoldingsReport;
    var CashHolding = (function () {
        function CashHolding() {
        }
        CashHolding.prototype.hasData = function () {
            return ((typeof this.instituteCode != 'undefined' && this.instituteCode) ||
                (typeof this.accountName != 'undefined' && this.accountName) ||
                (typeof this.type != 'undefined' && this.type) ||
                (typeof this.balance != 'undefined' && this.balance));
        };
        return CashHolding;
    }());
    Patersons.CashHolding = CashHolding;
    var CashHoldingsReportComponent = (function () {
        function CashHoldingsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/cashHoldingsReport.component.html';
            this.bindings = {
                title: '@',
                report: '<',
                predicate: '<',
                sortOrder: '<',
                searchText: '<',
                onOrderChanged: '&'
            };
        }
        return CashHoldingsReportComponent;
    }());
    Patersons.CashHoldingsReportComponent = CashHoldingsReportComponent;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var CashHighInterestHoldingsReportComponent = (function () {
        function CashHighInterestHoldingsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/cashHighInterestHoldingsReport.component.html';
            this.bindings = {
                title: '@',
                report: '<',
                predicate: '<',
                sortOrder: '<',
                searchText: '<',
                onOrderChanged: '&'
            };
        }
        return CashHighInterestHoldingsReportComponent;
    }());
    Patersons.CashHighInterestHoldingsReportComponent = CashHighInterestHoldingsReportComponent;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var EquityHoldingsReport = (function () {
        function EquityHoldingsReport() {
        }
        return EquityHoldingsReport;
    }());
    Patersons.EquityHoldingsReport = EquityHoldingsReport;
    var EquityHolding = (function () {
        function EquityHolding() {
        }
        EquityHolding.prototype.hasData = function () {
            return ((typeof this.securityCode != 'undefined' && this.securityCode) ||
                (typeof this.companyName != 'undefined' && this.companyName) ||
                (typeof this.quantity != 'undefined' && this.quantity) ||
                (typeof this.averageCost != 'undefined' && this.averageCost) ||
                (typeof this.lastPrice != 'undefined' && this.lastPrice) ||
                (typeof this.averageCost != 'undefined' && this.averageCost) ||
                (typeof this.totalCost != 'undefined' && this.totalCost) ||
                (typeof this.marketValue != 'undefined' && this.marketValue) ||
                (typeof this.profitOrLoss != 'undefined' && this.profitOrLoss) ||
                (typeof this.dividendPerShare != 'undefined' && this.dividendPerShare) ||
                (typeof this.frankedAmount != 'undefined' && this.frankedAmount) ||
                (typeof this.income != 'undefined' && this.income) ||
                (typeof this.yield != 'undefined' && this.yield) ||
                (typeof this.priceToEarnings != 'undefined' && this.priceToEarnings));
        };
        return EquityHolding;
    }());
    Patersons.EquityHolding = EquityHolding;
    var EquityHoldingsReportComponent = (function () {
        function EquityHoldingsReportComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/equityHoldingsReport.component.html';
            this.controller = EquityHoldingsReportComponentController;
            this.bindings = {
                title: '@',
                report: '<',
                isInternational: '<',
                predicate: '<',
                sortOrder: '<',
                searchText: '<',
                onOrderChanged: '&'
            };
        }
        return EquityHoldingsReportComponent;
    }());
    Patersons.EquityHoldingsReportComponent = EquityHoldingsReportComponent;
    var EquityHoldingsReportComponentController = (function (_super) {
        __extends(EquityHoldingsReportComponentController, _super);
        function EquityHoldingsReportComponentController($scope, $rootScope, morningStarService, userCompanyService) {
            var _this = this;
            _super.call(this);
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.scope.events = this;
            this.morningStarService = morningStarService;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
                if (company.enableFeature) {
                    _this.load();
                }
            });
        }
        EquityHoldingsReportComponentController.prototype.load = function () {
            var _this = this;
            var codes = [];
            this.report.holdings.forEach(function (report) {
                _this.morningStarService.getMorningStarDataForSecurityCode(report.exchange, report.securityCode).then(function (res) {
                    if (res) {
                        var elem = $('td:first-child:not(:has(a))').filter(function () {
                            return $(this).text().trim() === report.securityCode;
                        }).first();
                        var openURL = '';
                        var secId = res.FundShareClassId;
                        openURL = mapHoldingTypeIdToReportURL(res.holdingTypeId);
                        if (openURL) {
                            openURL += '#/' + secId;
                            elem.html('<a target="_blank" href="' + openURL + '">' + report.securityCode + '</a>');
                            elem.next().html('<a target="_blank" href="' + openURL + '">' + elem.next().text() + '</a>');
                        }
                    }
                });
            });
        };
        EquityHoldingsReportComponentController.$inject = ['$scope', '$rootScope', 'morningStarService', 'userCompanyService'];
        return EquityHoldingsReportComponentController;
    }(Patersons.AbstractReportController));
    Patersons.EquityHoldingsReportComponentController = EquityHoldingsReportComponentController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var TotalMarketValueComponent = (function () {
        function TotalMarketValueComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/totalMarketValue.component.html';
            this.bindings = {
                marketValue: '@'
            };
        }
        return TotalMarketValueComponent;
    }());
    Patersons.TotalMarketValueComponent = TotalMarketValueComponent;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ValuationStatement = (function (_super) {
        __extends(ValuationStatement, _super);
        function ValuationStatement() {
            _super.apply(this, arguments);
        }
        return ValuationStatement;
    }(Patersons.AbstractReport));
    Patersons.ValuationStatement = ValuationStatement;
    var AssetCategory = (function () {
        function AssetCategory() {
        }
        return AssetCategory;
    }());
    Patersons.AssetCategory = AssetCategory;
    var ValuationStatementAsset = (function () {
        function ValuationStatementAsset() {
        }
        return ValuationStatementAsset;
    }());
    Patersons.ValuationStatementAsset = ValuationStatementAsset;
    var UnsettledDividends = (function () {
        function UnsettledDividends() {
        }
        return UnsettledDividends;
    }());
    Patersons.UnsettledDividends = UnsettledDividends;
    var UnsettledDividend = (function () {
        function UnsettledDividend() {
        }
        return UnsettledDividend;
    }());
    Patersons.UnsettledDividend = UnsettledDividend;
    var ValuationStatementComponent = (function () {
        function ValuationStatementComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/valuationStatement.component.html';
            this.controller = ValuationStatementController;
            this.bindings = {
                report: '<',
                title: '@'
            };
        }
        return ValuationStatementComponent;
    }());
    Patersons.ValuationStatementComponent = ValuationStatementComponent;
    var sortFunds = function (a, b) { return a.code && a.code.localeCompare(b.code, undefined, { numeric: true }); };
    var extractManagedFunds = function (items) {
        var managedFunds = items.filter(function (element) {
            return element.exchangeCode === "FND";
        }).sort(sortFunds);
        var unlisted = items.filter(function (element) {
            return element.exchangeCode === "UNL";
        }).sort(sortFunds);
        var everythingElse = items.filter(function (element) {
            return ["FND", "UNL"].indexOf(element.exchangeCode) === -1;
        }).sort(sortFunds);
        return everythingElse.concat(managedFunds, unlisted);
    };
    var ValuationStatementController = (function (_super) {
        __extends(ValuationStatementController, _super);
        function ValuationStatementController($scope, $rootScope, morningStarService, userCompanyService) {
            var _this = this;
            _super.call(this);
            this.toggleManagedAccount = function (key, managedAccountIndex) {
                _this.report.managedAccounts[key].items[managedAccountIndex].expanded = !_this.report.managedAccounts[key].items[managedAccountIndex].expanded;
            };
            this.scope = $scope;
            this.$rootScope = $rootScope;
            this.scope.events = this;
            this.morningStarService = morningStarService;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
                if (company.enableFeature) {
                    _this.load();
                }
            });
        }
        ValuationStatementController.prototype.load = function () {
            var _this = this;
            var codes = [];
            this.report.nonLoaSecurities.forEach(function (category) {
                category.items.forEach(function (item) {
                    codes.push({
                        code: item.code,
                        exchangeCode: item.exchangeCode
                    });
                });
                category.items = extractManagedFunds(category.items);
            });
            Object.keys(this.report.managedAccounts).forEach(function (key) {
                var sortedItem = _this.report.managedAccounts[key].items.sort(function (a, b) { return a.categoryName.localeCompare(b.categoryName); });
                var first = "CG Large Cap Australian Equity Portfolio";
                sortedItem.forEach(function (item, i) {
                    if (item.categoryName === first) {
                        sortedItem.splice(i, 1);
                        sortedItem.unshift(item);
                    }
                });
                _this.report.managedAccounts[key].items = sortedItem;
                _this.report.managedAccounts[key].items.forEach(function (category) {
                    category.items.forEach(function (item) {
                        codes.push({
                            code: item.code,
                            exchangeCode: item.exchangeCode
                        });
                    });
                    category.items = extractManagedFunds(category.items);
                });
            });
            this.report.loaSecurities.forEach(function (category) {
                category.items.forEach(function (item) {
                    codes.push({
                        code: item.code,
                        exchangeCode: item.exchangeCode
                    });
                });
                category.items = extractManagedFunds(category.items);
            });
            this.report.nonLoaUnsettledDividends.items.forEach(function (unsettledDividend) {
                codes.push({
                    code: unsettledDividend.code,
                    exchangeCode: unsettledDividend.exchangeCode
                });
                _this.report.nonLoaUnsettledDividends.items = extractManagedFunds(_this.report.nonLoaUnsettledDividends.items);
            });
            this.report.loaUnsettledDividends.items.forEach(function (unsettledDividend) {
                codes.push({
                    code: unsettledDividend.code,
                    exchangeCode: unsettledDividend.exchangeCode
                });
                _this.report.loaUnsettledDividends.items = extractManagedFunds(_this.report.loaUnsettledDividends.items);
            });
            codes = codes.filter(function (value, index, self) { return self.indexOf(value) === index; });
            codes.forEach(function (code) {
                _this.morningStarService.getMorningStarDataForSecurityCode(code.exchangeCode, code.code).then(function (res) {
                    if (res) {
                        var elem = $('td:first-child:not(:has(a))').filter(function () {
                            return $(this).text().trim() === code.code;
                        }).first();
                        var openURL = '';
                        var secId = res.FundShareClassId;
                        openURL = mapHoldingTypeIdToReportURL(res.holdingTypeId);
                        if (openURL) {
                            openURL += '#/' + secId;
                            elem.html('<a target="_blank" href="' + openURL + '">' + code.code + '</a>');
                            elem.siblings('.has-data-link').each(function () {
                                var child = $(this);
                                child.html('<a target="_blank" href="' + openURL + '">' + child.text() + '</a>');
                            });
                        }
                    }
                });
            });
        };
        ValuationStatementController.$inject = ['$scope', '$rootScope', 'morningStarService', 'userCompanyService'];
        return ValuationStatementController;
    }(Patersons.AbstractReportController));
    Patersons.ValuationStatementController = ValuationStatementController;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var PortfolioNavigationComponent = (function () {
        function PortfolioNavigationComponent() {
            this.templateUrl = 'assets/templates/portfolioSummary/components/portfolioNavigation.component.html';
            this.controller = PortfolioNavigationController;
            this.bindings = {
                key: '@'
            };
        }
        return PortfolioNavigationComponent;
    }());
    Patersons.PortfolioNavigationComponent = PortfolioNavigationComponent;
    var PortfolioNavigationController = (function () {
        function PortfolioNavigationController($scope, $location, $state, $stateParams, userCompanyService) {
            var _this = this;
            this.$ctrl = this;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.menuOpen = false;
            this.userCompanyService = userCompanyService;
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
                _this.initOptions();
            });
        }
        PortfolioNavigationController.prototype.initOptions = function () {
            var items = [];
            items.push({
                key: "holdings",
                title: "Holdings",
            });
            if (this.scope.userCompany.isDefault) {
                items.push({
                    key: "portfolioSnapshot",
                    title: "Snapshot",
                });
                items.push({
                    key: "portfolioHeatmap",
                    title: "Heatmap",
                });
                items.push({
                    key: "marketOrders",
                    title: "Orders",
                });
            }
            items.push({
                key: "ledger",
                title: "Ledger",
            });
            items.push({
                key: "confirmationNotes",
                title: "Contract Notes",
            });
            items.push({
                key: "report",
                title: "Accolade Portfolio Service",
            });
            this.scope.items = items;
        };
        PortfolioNavigationController.prototype.toggleMenu = function () {
            this.scope.menuOpen = !this.scope.menuOpen;
        };
        PortfolioNavigationController.$inject = ['$scope', '$location', '$state', '$stateParams', 'userCompanyService'];
        return PortfolioNavigationController;
    }());
    Patersons.PortfolioNavigationController = PortfolioNavigationController;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioBaseCtrl = (function (_super) {
        __extends(PortfolioBaseCtrl, _super);
        function PortfolioBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
            this.navigationService.activateSection('portfolio');
            if ($location.$$path.indexOf('marketDepth') !== -1)
                this.navigationService.activateSection('analysis');
            if ($location.$$path.indexOf('stockReport') !== -1)
                this.navigationService.activateSection('research');
        }
        PortfolioBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return PortfolioBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.PortfolioBaseCtrl = PortfolioBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PlaceOrderRequestViewCtrl = (function (_super) {
        __extends(PlaceOrderRequestViewCtrl, _super);
        function PlaceOrderRequestViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, placeOrderRequestService, portfolioService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            var accountId = $stateParams.accountId;
            this.clearOrderRequestForm();
        }
        PlaceOrderRequestViewCtrl.prototype.placeOrderRequest = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.orderRequestForm.$invalid) {
                return;
            }
            var promise = this.portfolioService.placeOrderRequest(this.scope.order);
            promise.then(function (result) {
                _this.scope.isSubmitted = true;
                return;
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            });
        };
        PlaceOrderRequestViewCtrl.prototype.viewOrderRequests = function () {
            this.location.path('/viewOrderRequests');
        };
        PlaceOrderRequestViewCtrl.prototype.clearOrderRequestForm = function () {
            this.scope.order = new Patersons.OrderRequest();
        };
        PlaceOrderRequestViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];
        return PlaceOrderRequestViewCtrl;
    }(Patersons.AbstractController));
    Patersons.PlaceOrderRequestViewCtrl = PlaceOrderRequestViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ViewOrderRequestsViewCtrl = (function (_super) {
        __extends(ViewOrderRequestsViewCtrl, _super);
        function ViewOrderRequestsViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.order = function (predicate) {
                this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
                this.scope.predicate = predicate;
            };
            this.cancelOrder = function (orderToCancel) {
                this.createCancelOrder(orderToCancel);
            };
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.scope.parentController = this;
            this.scope.events = this;
            this.scope.isError = false;
            this.scope.isSubmitted = false;
            this.getOrderRequests();
        }
        ViewOrderRequestsViewCtrl.prototype.getOrderRequests = function () {
            var _this = this;
            var promise = this.portfolioService.getOrderRequests();
            promise.then(function (result) {
                _this.scope.investorOrders = result.data.value;
            }, function (reason) {
                _this.portfolioService.errorHandler = reason.data;
            });
        };
        ViewOrderRequestsViewCtrl.prototype.createCancelOrder = function (order) {
            var _this = this;
            var cancelOrder = new Patersons.OrderRequest();
            cancelOrder.orderAction = "Cancel";
            cancelOrder.portfolioId = order.portfolioId;
            cancelOrder.price = order.price;
            cancelOrder.securityCode = order.securityCode;
            cancelOrder.volume = order.volume;
            cancelOrder.requestDateTime = new Date();
            cancelOrder.buyAtMarketRate = true;
            cancelOrder.orderNumber = order.id;
            var promise = this.portfolioService.createCancelOrder(cancelOrder);
            promise.then(function (result) {
                _this.scope.isSubmitted = result.status == 200;
                _this.scope.isError = false;
                _this.getOrderRequests();
            }, function (reason) {
                _this.scope.isError = true;
                _this.scope.isSubmitted = false;
            });
        };
        ViewOrderRequestsViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];
        return ViewOrderRequestsViewCtrl;
    }(Patersons.AbstractController));
    Patersons.ViewOrderRequestsViewCtrl = ViewOrderRequestsViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioDashboardCtrl = (function (_super) {
        __extends(PortfolioDashboardCtrl, _super);
        function PortfolioDashboardCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, bannerService, selectionService, navigationService, reportService, newsService, researchFeedService, sessionService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.portfolioService = portfolioService;
            this.selectionService = selectionService;
            this.navigationService = navigationService;
            this.reportService = reportService;
            this.researchFeedService = researchFeedService;
            this.scope.isLoading = false;
            this.bannerService = bannerService;
            this.newsService = newsService;
            this.filter = $filter;
            this.sessionService = sessionService;
            this.scope.events = this;
            this.scope.headerError = false;
            this.scope.hasNotifications = false;
            this.scope.isLoggedIn = this.sessionService.isLoggedIn();
            // this.getBanner();
            this.getNews();
            // this.getLatestMorningMarket();
            this.getPortfolioData();
            this.getAccoladeNotifications();
            this.navigationService.deactivateAll();
            this.navigationService.activateSection('dashboard');
            if (this.scope.isLoggedIn) {
                //console.log('loadAdviserData');
                this.scope.profile = this.sessionService.getCurrentUserProfile();
                userCompanyService.getUserCompany().then(function (company) {
                    _this.scope.userCompany = company;
                });
            }
        }
        PortfolioDashboardCtrl.prototype.getAccoladeNotifications = function () {
            var _this = this;
            var promise = this.reportService.getAllAccoladeNotifications();
            promise.then(function (result) {
                console.log(result);
                if (result.length == 1) {
                    _this.scope.notificationText = "A new " + result[0].type + " is available. ";
                    _this.scope.hasNotifications = true;
                    _this.scope.notificationLink = result[0].link;
                    _this.scope.notificationStateLink = null;
                }
                else if (result.length > 0) {
                    var firstReportType_1 = result[0].type;
                    var allSame = result.every(function (item) {
                        return item.type == firstReportType_1;
                    });
                    if (allSame) {
                        _this.scope.notificationText = result.length + " new " + firstReportType_1 + "s are available.";
                    }
                    else {
                        _this.scope.notificationText = result.length + " new Accolade Reports are available.";
                    }
                    switch (firstReportType_1) {
                        case "Accolade Tax Report":
                            _this.scope.notificationStateLink = "report.tax";
                            break;
                        case "Accolade Quarterly Report":
                            _this.scope.notificationStateLink = "report.quarterly";
                            break;
                        case "Accolade Invoice":
                            _this.scope.notificationStateLink = "report.invoices";
                            break;
                        default:
                            _this.scope.notificationStateLink = "report";
                            break;
                    }
                    _this.scope.hasNotifications = true;
                    _this.scope.notificationLink = null;
                }
            }, function (error) {
                console.log("processAccoladeNotifications error");
                console.log(error);
            });
        };
        //https://gist.github.com/bronthulke/cac00b8857c886108069
        PortfolioDashboardCtrl.prototype.getFinancialYear = function (yearsBack) {
            var financialYearStart, financialYearEnd;
            if (moment().quarter() > 2) {
                financialYearStart = moment().month('July').startOf('month'); // this year's July
                financialYearEnd = moment().add(1, 'years').month('June').endOf('month'); // next year's June
            }
            else {
                financialYearStart = moment().subtract(1, "years").month('July').startOf('month'); // last year's July
                financialYearEnd = moment().month('June').endOf('month'); // this year's June
            }
            ;
            if (yearsBack != undefined) {
                financialYearStart = financialYearStart.subtract(yearsBack, "years");
                financialYearEnd = financialYearEnd.subtract(yearsBack, "years");
            }
            return { "start": financialYearStart.startOf('day'), "end": financialYearEnd.startOf('day') };
        };
        PortfolioDashboardCtrl.prototype.acknowledgeNotification = function () {
            var _this = this;
            var promise = this.reportService.acknowledgeAccoladeNotifications();
            promise.then(function (result) {
                if (_this.scope.notificationLink) {
                    _this.window.location.href = _this.scope.notificationLink;
                }
                else {
                    if (_this.scope.notificationStateLink) {
                        _this.state.go(_this.scope.notificationStateLink);
                    }
                }
            }, function (error) {
                alert("Error acknowledging notifications. Please try again");
                console.log("acknowledgeNotification error");
                console.log(error);
            });
        };
        PortfolioDashboardCtrl.prototype.getNews = function () {
            var _this = this;
            this.scope.isNewsLoading = true;
            var newsCampaignParams = {
                utm_source: 'client_portal',
                utm_medium: 'dashboard_news'
            };
            var max_news = 4;
            var promise = this.newsService.getNews();
            promise.then(function (result) {
                if (result) {
                    var newsConfig = result['news'];
                    newsConfig = newsConfig.slice(0, max_news);
                    newsConfig = newsConfig.map(function (element, index) {
                        if (element.link && element.link.indexOf('http://') !== 0 && element.link.indexOf('https://') !== 0) {
                            element.link = 'http://' + element.link;
                        }
                        var utmQuery = '';
                        Object.keys(newsCampaignParams).forEach(function (key, index, all) {
                            utmQuery = utmQuery + key + "=" + newsCampaignParams[key] + (index !== all.length - 1 ? "&" : '');
                        });
                        utmQuery = utmQuery + "&utm_campaign=" + element.title;
                        if (element.link.indexOf('?') === -1) {
                            element.link = element.link + "?" + utmQuery;
                        }
                        else {
                            var lastChar = element.link.substr(element.link.length - 1);
                            if (lastChar == "&") {
                                element.link = element.link + utmQuery;
                            }
                            {
                                element.link = element.link + "&" + utmQuery;
                            }
                        }
                        return element;
                    });
                    _this.scope.newsConfig = newsConfig;
                    setTimeout(function () {
                        $('.clampThis').each(function (index, element) {
                            $clamp(element, { clamp: 4, useNativeClamp: true });
                        });
                    }, 500);
                }
            }, function (error) {
            })
                .finally(function () {
                _this.scope.isNewsLoading = false;
            });
        };
        PortfolioDashboardCtrl.prototype.getLatestMorningMarket = function () {
            var _this = this;
            this.scope.isMorningMarketLoading = true;
            var promise = this.researchFeedService.getLatestMorningMarket();
            promise.then(function (result) {
                if (result) {
                    _this.scope.latestMorningMarket = result;
                }
            }, function (error) {
                _this.scope.latestMorningMarket = null;
            })
                .finally(function () {
                _this.scope.isMorningMarketLoading = false;
            });
        };
        PortfolioDashboardCtrl.prototype.getBanner = function () {
            var _this = this;
            this.scope.isBannerLoading = true;
            var promise = this.bannerService.getCurrent();
            promise.then(function (result) {
                if (result && result[0]) {
                    var bannerConfig = result[0];
                    var buttonUrl = bannerConfig.buttonUrl.toLowerCase();
                    if (buttonUrl.indexOf('http://') !== 0 && buttonUrl.indexOf('https://') !== 0) {
                        bannerConfig.buttonUrl = 'http://' + bannerConfig.buttonUrl;
                    }
                    _this.scope.bannerConfig = bannerConfig;
                }
                else {
                    _this.scope.bannerConfig = new Patersons.Banner();
                    _this.scope.bannerConfig.isHidden = true;
                }
            }, function (error) {
                _this.scope.bannerConfig = new Patersons.Banner();
                _this.scope.bannerConfig.isHidden = true;
            })
                .finally(function () {
                _this.scope.isBannerLoading = false;
            });
        };
        PortfolioDashboardCtrl.prototype.goToEOFYStatement = function (accountId) {
            var previousFY = this.getFinancialYear(1);
            this.state.go("holdings", {
                accountId: accountId,
                autoDownloadPDF: true,
                asAt: previousFY.end.toDate()
            });
        };
        PortfolioDashboardCtrl.prototype.getPortfolioData = function () {
            var _this = this;
            this.scope.isLoading = true;
            console.log(this.scope.isLoading);
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then(function (result) {
                _this.scope.investorPortfolios = result;
                for (var i = 0; i < _this.scope.investorPortfolios.length; i++) {
                    _this.getPortfolioValue(_this.scope.investorPortfolios[i]); // error handling: --
                }
                _this.scope.isLoading = false;
                console.log(_this.scope.isLoading);
            }, function (reason) {
                _this.scope.isLoading = false;
                _this.portfolioService.errorHandler = reason.data;
            });
        };
        PortfolioDashboardCtrl.prototype.getPortfolioValue = function (account) {
            var promise = this.portfolioService.getPortfolioValue(account);
            promise.then(function (result) {
                if (result) {
                    account.totalMovementToday = result.currentMovementValue;
                    account.totalMovementPercentage = result.currentMovementPercent;
                    account.totalHoldingsValue = result.currentValue;
                    account.headerLoaded = true;
                }
            }, function (error) {
                account.totalMovementToday = undefined;
                account.totalMovementPercentage = undefined;
                account.totalHoldingsValue = undefined;
                //this.scope.headerError = true;
                account.headerLoaded = true;
            });
        };
        PortfolioDashboardCtrl.prototype.goToPorfolioOverview = function (accountId) {
            this.selectionService.selectedAccountId = accountId;
            this.state.go("viewPortfolio");
        };
        PortfolioDashboardCtrl.prototype.goToHoldings = function (accountId) {
            this.selectionService.selectedAccountId = accountId;
            this.state.go("holdings");
        };
        PortfolioDashboardCtrl.prototype.getAccount = function (accountId) {
            var accounts = this.scope.investorPortfolios.filter(function (x) { return x.accountId == accountId; });
            if (accounts) {
                return accounts[0];
            }
            return null;
        };
        PortfolioDashboardCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'bannerService', 'selectionService', 'navigationService', 'reportService', 'newsService', 'researchFeedService', 'sessionService', 'userCompanyService'];
        return PortfolioDashboardCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.PortfolioDashboardCtrl = PortfolioDashboardCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioSnapshotCtrl = (function (_super) {
        __extends(PortfolioSnapshotCtrl, _super);
        function PortfolioSnapshotCtrl($scope, $q, $log, $location, $window, $state, $stateParams, $http, $rootScope, reportService, reportDownloadService, portfolioService, navigationService, morningStarService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.getPortfolioSnapshot = function () {
                // if(this.scope.isLoading){
                //     return;
                // }
                this.scope.isError = false;
                this.scope.hasData = false;
                this.scope.isLoading = true;
                this.loadPortfolioSnapshot();
            };
            this.scope = $scope;
            this.q = $q;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.scope.accounts = new Array();
            this.morningStarService = morningStarService;
            this.scope.cachedAccounts = [];
            this.load();
        }
        PortfolioSnapshotCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    if (result[0]) {
                        console.log(_this.scope.selectedAccount);
                        _this.setSelectedAccount(result[0].accountId);
                        setTimeout(function () {
                            _this.getPortfolioSnapshot();
                        }, 500);
                    }
                });
            })
                .catch(function (reason) {
                _this.scope.$apply(function () {
                    _this.scope.isLoading = false;
                });
            });
        };
        PortfolioSnapshotCtrl.prototype.setSelectedAccount = function (accountId) {
            console.info('Selected Account Id: ' + accountId);
            this.scope.hasData = false;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
        };
        PortfolioSnapshotCtrl.prototype.extractCodesFromReport = function (report) {
            var codes = [];
            if (report) {
                report.forEach(function (item) {
                    codes.push({
                        securityCode: item.securityCode,
                        exchangeCode: item.exchange
                    });
                });
            }
            return codes;
        };
        PortfolioSnapshotCtrl.prototype.loadPortfolioSnapshot = function () {
            var _this = this;
            if (this.scope.selectedAccount.accountType == "Standard") {
                var codes_1 = [];
                var cashAccountsPromise = this.portfolioService.getCashAccounts(this.scope.selectedAccount.accountId);
                cashAccountsPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var highInterestCashPromise = this.portfolioService.getHighInterestCashAccounts(this.scope.selectedAccount.accountId);
                highInterestCashPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var termDepositPromise = this.portfolioService.getTermDeposits(this.scope.selectedAccount.accountId);
                termDepositPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var internationalSharesPromise = this.portfolioService.getInternationalSharesForHoldings(this.scope.selectedAccount);
                internationalSharesPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var sharesPromise = this.portfolioService.getShares(this.scope.selectedAccount.accountId);
                sharesPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var allPromises = this.q.all([
                    cashAccountsPromise,
                    highInterestCashPromise,
                    termDepositPromise,
                    internationalSharesPromise,
                    sharesPromise]);
                allPromises.then(function () {
                    _this.loadMorningStarSnapshot(_this.scope.selectedAccount.accountId, codes_1);
                });
            }
            else {
                this.reportService.getReport(Patersons.ReportType.Valuation, this.scope.selectedAccount.accountId, new Date(), new Date())
                    .then(function (report) {
                    var codes = [];
                    report.nonLoaSecurities.forEach(function (category) {
                        category.items.forEach(function (item) {
                            codes.push({
                                securityCode: item.code,
                                exchangeCode: item.exchangeCode
                            });
                        });
                    });
                    report.loaSecurities.forEach(function (category) {
                        category.items.forEach(function (item) {
                            codes.push({
                                securityCode: item.code,
                                exchangeCode: item.exchangeCode
                            });
                        });
                    });
                    report.nonLoaUnsettledDividends.items.forEach(function (unsettledDividend) {
                        codes.push({
                            securityCode: unsettledDividend.code,
                            exchangeCode: unsettledDividend.exchangeCode
                        });
                    });
                    report.loaUnsettledDividends.items.forEach(function (unsettledDividend) {
                        codes.push({
                            securityCode: unsettledDividend.code,
                            exchangeCode: unsettledDividend.exchangeCode
                        });
                    });
                    _this.loadMorningStarSnapshot(_this.scope.selectedAccount.accountId, codes);
                }, function (error) {
                    // error handling
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                });
            }
        };
        PortfolioSnapshotCtrl.prototype.loadMorningStarSnapshot = function (accountId, data) {
            var _this = this;
            var tickers = [];
            //need to filter out funds (holdingTypeId = 2)
            Promise.all(data.map(function (code) {
                return new Promise(function (resolveTicker) {
                    _this.morningStarService.getMorningStarDataForSecurityCode(code.exchangeCode, code.securityCode).then(function (res) {
                        if (res) {
                            if (res.holdingTypeId != 2) {
                                tickers.push(res.FundShareClassId);
                            }
                        }
                        resolveTicker();
                    });
                });
            })).then(function () {
                //load data here
                rootMorningstarPromise().then(function (promiseChain) {
                    initComponent('component-portfolio-snapshot-container', 'ecWatchList-container', 'ec-watch-list', 'ecWatchList').then(function () {
                        var watchlistInstance = morningstar.asterix.instanceRegistry.get('ecWatchList');
                        watchlistInstance.setParameter('showActionBar', false);
                        watchlistInstance.setParameter('tickers', tickers);
                        _this.scope.$apply(function () {
                            _this.scope.isLoading = false;
                        });
                    });
                });
                //the watchlist component takes a few seconds to load the data.
                //if there is an event to hook into this will be much better however at present there are no events to hook into that the component exposes. 
                setTimeout(function () {
                }, 4000);
            });
        };
        PortfolioSnapshotCtrl.$inject = ['$scope', '$q', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'reportService', 'reportDownloadService', 'portfolioService', 'navigationService', 'morningStarService'];
        return PortfolioSnapshotCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.PortfolioSnapshotCtrl = PortfolioSnapshotCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioHeatmapCtrl = (function (_super) {
        __extends(PortfolioHeatmapCtrl, _super);
        function PortfolioHeatmapCtrl($scope, $q, $log, $location, $window, $state, $stateParams, $http, $rootScope, reportService, reportDownloadService, portfolioService, navigationService, morningStarService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.getPortfolioHeatmap = function () {
                // if(this.scope.isLoading){
                //     return;
                // }
                this.scope.isError = false;
                this.scope.hasData = false;
                this.loadPortfolioHeatmap();
            };
            this.scope = $scope;
            this.q = $q;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.scope.accounts = new Array();
            this.morningStarService = morningStarService;
            this.scope.cachedAccounts = [];
            this.load();
        }
        PortfolioHeatmapCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    _this.scope.isLoading = false;
                    if (result[0]) {
                        _this.setSelectedAccount(result[0].accountId);
                        setTimeout(function () {
                            _this.getPortfolioHeatmap();
                        }, 500);
                    }
                });
            })
                .catch(function (reason) {
                _this.scope.$apply(function () {
                    _this.scope.isLoading = false;
                });
            });
        };
        PortfolioHeatmapCtrl.prototype.extractCodesFromReport = function (report) {
            var codes = [];
            if (report) {
                report.forEach(function (item) {
                    codes.push({
                        securityCode: item.securityCode,
                        exchangeCode: item.exchange
                    });
                });
            }
            return codes;
        };
        PortfolioHeatmapCtrl.prototype.setSelectedAccount = function (accountId) {
            console.info('Selected Account Id: ' + accountId);
            this.scope.hasData = false;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
        };
        PortfolioHeatmapCtrl.prototype.loadPortfolioHeatmap = function () {
            var _this = this;
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.scope.isLoading = true;
                var codes_1 = [];
                var cashAccountsPromise = this.portfolioService.getCashAccounts(this.scope.selectedAccount.accountId);
                cashAccountsPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var highInterestCashPromise = this.portfolioService.getHighInterestCashAccounts(this.scope.selectedAccount.accountId);
                highInterestCashPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var termDepositPromise = this.portfolioService.getTermDeposits(this.scope.selectedAccount.accountId);
                termDepositPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var internationalSharesPromise = this.portfolioService.getInternationalSharesForHoldings(this.scope.selectedAccount);
                internationalSharesPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var sharesPromise = this.portfolioService.getShares(this.scope.selectedAccount.accountId);
                sharesPromise.then(function (result) {
                    codes_1 = codes_1.concat(_this.extractCodesFromReport(result));
                }, function (error) {
                });
                var allPromises = this.q.all([
                    cashAccountsPromise,
                    highInterestCashPromise,
                    termDepositPromise,
                    internationalSharesPromise,
                    sharesPromise]);
                allPromises.then(function () {
                    _this.loadMorningStarHeatmap(_this.scope.selectedAccount.accountId, codes_1);
                });
            }
            else {
                this.scope.isLoading = true;
                this.reportService.getReport(Patersons.ReportType.Valuation, this.scope.selectedAccount.accountId, new Date(), new Date())
                    .then(function (report) {
                    var codes = [];
                    report.nonLoaSecurities.forEach(function (category) {
                        category.items.forEach(function (item) {
                            codes.push({
                                securityCode: item.code,
                                exchangeCode: item.exchangeCode
                            });
                        });
                    });
                    report.loaSecurities.forEach(function (category) {
                        category.items.forEach(function (item) {
                            codes.push({
                                securityCode: item.code,
                                exchangeCode: item.exchangeCode
                            });
                        });
                    });
                    report.nonLoaUnsettledDividends.items.forEach(function (unsettledDividend) {
                        codes.push({
                            securityCode: unsettledDividend.code,
                            exchangeCode: unsettledDividend.exchangeCode
                        });
                    });
                    report.loaUnsettledDividends.items.forEach(function (unsettledDividend) {
                        codes.push({
                            securityCode: unsettledDividend.code,
                            exchangeCode: unsettledDividend.exchangeCode
                        });
                    });
                    _this.loadMorningStarHeatmap(_this.scope.selectedAccount.accountId, codes);
                }, function (error) {
                    // error handling
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                });
            }
        };
        PortfolioHeatmapCtrl.prototype.loadMorningStarHeatmap = function (accountId, data) {
            var _this = this;
            var tickers = [];
            //need to filter out funds (holdingTypeId = 2)
            Promise.all(data.map(function (code) {
                return new Promise(function (resolveTicker) {
                    _this.morningStarService.getMorningStarDataForSecurityCode(code.exchangeCode, code.securityCode).then(function (res) {
                        if (res) {
                            if (res.holdingTypeId != 2) {
                                tickers.push(res.FundShareClassId);
                            }
                        }
                        resolveTicker();
                    });
                });
            })).then(function () {
                //load data here
                rootMorningstarPromise().then(function (promiseChain) {
                    // $('#component-portfolio-heatmap-container').append('<div class="component-portfolio-heatmap" id="component-portfolio-heatmap-'+ accountId +'"></div>');
                    try {
                        morningstar.components["markets-components-core"].TickersCache.tickers = {};
                    }
                    catch (error) {
                    }
                    loaderConfig.configuration.overrides.components.portfolioHeatmap.settings.tickerList = tickers;
                    initComponent('component-portfolio-heatmap-container', "heatmap-container", "markets-components-heatmap", "portfolioHeatmap").then(function () {
                        _this.scope.$apply(function () {
                            _this.scope.isLoading = false;
                        });
                    });
                });
            });
        };
        PortfolioHeatmapCtrl.$inject = ['$scope', '$q', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'reportService', 'reportDownloadService', 'portfolioService', 'navigationService', 'morningStarService'];
        return PortfolioHeatmapCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.PortfolioHeatmapCtrl = PortfolioHeatmapCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class PortfolioViewCtrl extends AbstractController {
    var PortfolioViewCtrl = (function (_super) {
        __extends(PortfolioViewCtrl, _super);
        function PortfolioViewCtrl($scope, $log, $q, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.q = $q;
            this.filter = $filter;
            this.portfolioService = portfolioService;
            this.scope.events = this;
            this.load();
        }
        PortfolioViewCtrl.prototype.setSelectedAccount = function (accountId) {
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            this.checkCompareMethod();
        };
        PortfolioViewCtrl.prototype.setAccountToCompare = function (accountId) {
            this.scope.accountToCompare = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            this.checkCompareMethod();
        };
        PortfolioViewCtrl.prototype.load = function () {
            var _this = this;
            var promise = this.portfolioService.getCombinedPortfolioData();
            promise.then(function (result) {
                _this.scope.accounts = result;
                if (_this.scope.accounts != undefined && _this.scope.accounts.length > 0) {
                    _this.scope.selectedAccount = _this.scope.accounts[0];
                    _this.loadXray();
                }
            });
        };
        PortfolioViewCtrl.prototype.loadXray = function () {
            var _this = this;
            if (this.scope.selectedAccount == undefined) {
                return;
            }
            this.loadShares([this.scope.selectedAccount])
                .then(function () {
                _this.mapAccountToPortfolio(_this.scope.selectedAccount).then(function (result) {
                    console.log(JSON.stringify(result['holdings']));
                    var xrayComponent = morningstar.asterix.instanceRegistry.get('ecXray');
                    xrayComponent.setParameter('portfolio', result);
                });
            });
        };
        PortfolioViewCtrl.prototype.loadCompare = function () {
            var _this = this;
            this.loadShares([this.scope.selectedAccount, this.scope.accountToCompare])
                .then(function () {
                _this.log.info("compare " + _this.scope.selectedAccount.accountId + ' with ' + _this.scope.accountToCompare.accountId);
                _this.mapAccountToPortfolio(_this.scope.selectedAccount).then(function (myPortfolio1) {
                    _this.mapAccountToPortfolio(_this.scope.accountToCompare).then(function (myPortfolio2) {
                        morningstar.asterix.instanceRegistry.get('ecPortfolioCompare.xrayCurrent').setParameter('portfolio', myPortfolio1);
                        morningstar.asterix.instanceRegistry.get('ecPortfolioCompare.xrayProposed').setParameter('portfolio', myPortfolio2);
                    });
                });
            });
        };
        PortfolioViewCtrl.prototype.loadShares = function (accounts) {
            var q = this.q;
            var portfolioService = this.portfolioService;
            var getShares = [];
            angular.forEach(accounts, function (account) {
                if (account !== undefined && account.holdings === undefined) {
                    var promise = null;
                    if (account.accountType === 'Standard') {
                        promise = portfolioService.getCombinedShares(account.accountId);
                    }
                    else {
                        promise = portfolioService.getAccoladeHoldings(account.accountId);
                    }
                    getShares.push(promise
                        .then(function (result) {
                        console.info('Getting shares for account ' + account.accountId);
                        console.log(result);
                        account.holdings = result;
                    })
                        .catch(function (response) {
                        console.error('Error getting shares for account ' + account.accountId, response.status, response.data);
                    }));
                }
            });
            var deferred = q.defer();
            return q.all(getShares)
                .then(function () {
                deferred.resolve();
                return deferred.promise;
            })
                .catch(function (response) {
                console.error('Error loading shares', response.status, response.data);
                deferred.reject(response);
                return deferred.promise;
            });
        };
        PortfolioViewCtrl.prototype.checkCompareMethod = function () {
            if (this.scope.accountToCompare != null) {
                this.loadCompare();
            }
            else {
                this.loadXray();
            }
        };
        PortfolioViewCtrl.prototype.createHoldingForAssetAllocation = function (item) {
            var holdings = [];
            if (item.assetAllocationDomesticCash != 0) {
                holdings.push(this.createCustomHoldingsForCashAccolade(item.assetAllocationDomesticCash, item.companyName));
            }
            if (item.assetAllocationDomesticEquity != 0) {
                holdings.push(this.createCustomHoldingsForAustralianEquity(item.assetAllocationDomesticEquity, item.companyName));
            }
            if (item.assetAllocationDomesticFixedInterest != 0) {
                holdings.push(this.createCustomHoldingsForAUFixedIncome(item.assetAllocationDomesticFixedInterest, item.companyName));
            }
            if (item.assetAllocationDomesticProperty != 0) {
                // Add addition checks here for the Exchange Code
                if (item.exchange.toLowerCase() === "nsx" || item.exchange.toLowerCase() === "chi-x") {
                    holdings.push(this.createCustomHoldingsForProperty(item.marketValue, item.companyName));
                }
                else {
                    if (item.exchange.toLowerCase() === "axw") {
                        holdings.push(this.createCustomHoldingsForOther(item.assetAllocationOther, item.companyName));
                    }
                    else {
                        holdings.push(this.createCustomHoldingsForUnlistedProperty(item.marketValue, item.companyName));
                    }
                }
            }
            if (item.assetAllocationInternationalCash != 0) {
                holdings.push(this.createCustomHoldingsForCashAccolade(item.assetAllocationInternationalCash, item.companyName));
            }
            if (item.assetAllocationInternationalEquity != 0) {
                holdings.push(this.createCustomHoldingsForInternationalEquity(item.assetAllocationInternationalEquity, item.companyName));
            }
            if (item.assetAllocationInternationalFixedInterest != 0) {
                holdings.push(this.createCustomHoldingsForIntlFixedIncome(item.assetAllocationInternationalFixedInterest, item.companyName));
            }
            if (item.assetAllocationInternationalProperty != 0) {
                holdings.push(this.createCustomHoldingsForInternationalProperty(item.assetAllocationInternationalProperty, item.companyName));
            }
            if (item.assetAllocationOther != 0) {
                holdings.push(this.createCustomHoldingsForOther(item.assetAllocationOther, item.companyName));
            }
            return holdings;
        };
        ;
        PortfolioViewCtrl.prototype.createCustomHoldingsForCashAccolade = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 100,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 100,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForAustralianEquity = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 100,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 100,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForInternationalEquity = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 100,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 100,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForProperty = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 100,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 100,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForUnlistedProperty = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 100,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 100,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForInternationalProperty = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 100,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 100,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForAUFixedIncome = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 100,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 100,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForIntlFixedIncome = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 100,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 100,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForCash = function (balance, securityName) {
            return {
                "identifier": "Cash",
                "identifierType": "ISIN",
                "Name": "Cash",
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 100,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 100,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.createCustomHoldingsForOther = function (balance, securityName) {
            return {
                "identifier": securityName,
                "identifierType": "ISIN",
                "Name": securityName,
                "weight": balance,
                "Proxy": 1,
                "breakdowns": {
                    "assetAllocation": [
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "N",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 100
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "L",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 100
                            }
                        },
                        {
                            "type": "MorningstarAUS10",
                            "salePosition": "S",
                            "values": {
                                "1": 0,
                                "2": 0,
                                "3": 0,
                                "4": 0,
                                "5": 0,
                                "6": 0,
                                "7": 0,
                                "8": 0,
                                "9": 0,
                                "10": 0
                            }
                        }
                    ]
                }
            };
        };
        PortfolioViewCtrl.prototype.mapAccountToPortfolio = function (account) {
            var _this = this;
            return new Promise(function (resolve, reject) {
                console.info('mapAccountToPortfolio:');
                console.info(account);
                var allHoldings = [];
                var totalAccountValue = 0;
                for (var _i = 0, _a = account.holdings; _i < _a.length; _i++) {
                    var holdingItem = _a[_i];
                    totalAccountValue = totalAccountValue + holdingItem.marketValue;
                }
                if (account.accountType === "Standard") {
                    console.log("standard account map account to portfolio");
                    var totalCashHoldingsValue = 0;
                    for (var i = 0; i < account.holdings.length; i++) {
                        if (account.holdings[i].isin === "unknown") {
                            allHoldings.push(_this.createCustomHoldingsForOther(account.holdings[i].marketValue, account.holdings[i].companyName));
                        }
                        else {
                            var holding = {
                                identifier: account.holdings[i].isin,
                                identifierType: 'ISIN',
                                weight: account.holdings[i].marketValue
                            };
                            allHoldings.push(holding);
                        }
                    }
                    // Standard Account Type
                    // Get Cash Accounts
                    _this.portfolioService.getCashAccounts(account.accountId)
                        .then(function (result) {
                        console.info('Getting cash account for: ' + account.accountId);
                        console.log("Cash: " + JSON.stringify(result));
                        if (result && result.length > 0) {
                            result.forEach(function (cashItem) {
                                totalAccountValue += cashItem.balance;
                                totalCashHoldingsValue += cashItem.balance;
                            });
                        }
                    }).then(function () {
                        // Get High Interest Cash Accounts
                        _this.portfolioService.getHighInterestCashAccounts(account.accountId)
                            .then(function (result) {
                            console.info('Getting High Interest Cash account for: ' + account.accountId);
                            console.log("High Interest Cash: " + JSON.stringify(result));
                            /*if (result.length > 0) {
                                totalAccountValue = totalAccountValue + result[0].balance;
                                totalCashHoldingsValue = totalCashHoldingsValue + result[0].balance;
                            }*/
                            if (result && result.length > 0) {
                                result.forEach(function (cashItem) {
                                    totalAccountValue += cashItem.balance;
                                    totalCashHoldingsValue += cashItem.balance;
                                });
                            }
                        }).then(function () {
                            // Get Term Deposits
                            _this.portfolioService.getTermDeposits(account.accountId)
                                .then(function (result) {
                                console.info('Getting Term Deposit account for: ' + account.accountId);
                                console.log("Term Deposit: " + JSON.stringify(result));
                                if (result != null && result.length > 0) {
                                    result.forEach(function (item) {
                                        allHoldings.push(_this.createCustomHoldingsForAUFixedIncome(item.balance, item.provider));
                                    });
                                }
                                ;
                            }).then(function () {
                                if (totalCashHoldingsValue > 0) {
                                    allHoldings.push(_this.createCustomHoldingsForCash(totalCashHoldingsValue, "Cash"));
                                }
                                var portfolio = {
                                    name: _this.filter("accountName")(account.designation ? account.designation.slice(1, -1) : account.accountName),
                                    totalValue: totalAccountValue,
                                    currencyId: 'AUD',
                                    holdings: allHoldings,
                                    benchmark: {
                                        holdings: [{
                                                identifier: 'XXXXXXXXXX',
                                                identifierType: 'MSID',
                                                weight: 100
                                            }]
                                    }
                                };
                                resolve(portfolio);
                            });
                        });
                    });
                }
                else {
                    console.log(account.holdings);
                    account.holdings.forEach(function (item) {
                        if (item.isin === "unknown") {
                            //when no isin is present, assign the holdings to categories based on the asset allocation percentage
                            var assetAllocations = _this.createHoldingForAssetAllocation(item);
                            assetAllocations.forEach(function (allocation) {
                                allHoldings.push(allocation);
                            });
                        }
                        else {
                            var holding = {
                                identifier: item.isin,
                                identifierType: 'ISIN',
                                weight: item.marketValue
                            };
                            allHoldings.push(holding);
                        }
                    });
                    console.log(JSON.stringify(allHoldings));
                    var portfolio = {
                        name: _this.filter("accountName")(account.designation ? account.designation.slice(1, -1) : account.accountName),
                        totalValue: totalAccountValue,
                        currencyId: 'AUD',
                        holdings: allHoldings,
                        benchmark: {
                            holdings: [{
                                    identifier: 'XXXXXXXXXX',
                                    identifierType: 'MSID',
                                    weight: 100
                                }]
                        }
                    };
                    resolve(portfolio);
                }
            });
        };
        ;
        PortfolioViewCtrl.$inject = ['$scope', '$log', '$q', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'navigationService'];
        return PortfolioViewCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.PortfolioViewCtrl = PortfolioViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var PortfolioCompareCtrl = (function (_super) {
        __extends(PortfolioCompareCtrl, _super);
        function PortfolioCompareCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.scope.date = new Date();
            this.scope.parentController = this;
            //this.scope.portfolio = this.portfolioService.getPortfolioData();
            //this.setSelectedAccount(this.scope.accounts[1].AccountId);
            //if (this.location.search().a != null) {
            //    this.scope.selectedAccountId = this.location.search().a;
            //}
            //if (this.location.search().c != null) {
            //    //  the compare account id parameter
            //    this.scope.compareAccountId = this.location.search().c;
            //    this.log.info("CompareAccountId = " + this.scope.compareAccountId);
            //    this.getPortfolioData(this.baseUrl, this.scope.compareAccountId, this.scope.xRayComparePortfolios);
            //}
            //else {
            //    this.log.info("AccountId = " + this.scope.selectedAccountId);
            //    this.getPortfolioData(this.baseUrl, this.scope.selectedAccountId, this.scope.xRayPortfolios);
            //}
            //this.scope.ChangeAccount = function () {
            //    var accId = this.scope.selectedAccountId;
            //    this.scope.xRayPortfolios = this.scope.parentController.getPortfolioData(this.scope.parentController.baseUrl, accId);
            //    this.scope.parentController.setSelectedAccount(accId);
            //}
            //this.scope.CompareAccount = function () {
            //    var accId = this.scope.selectedAccount.AccountId;
            //    var caccId = this.scope.compareaccount.AccountId;
            //    var url = "/comparePortfolios?a=" + accId + "&c=" + caccId;
            //    this.location.url(url);
            //}
        }
        PortfolioCompareCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService'];
        return PortfolioCompareCtrl;
    }(Patersons.AbstractController));
    Patersons.PortfolioCompareCtrl = PortfolioCompareCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var StockReportCtrl = (function (_super) {
        __extends(StockReportCtrl, _super);
        function StockReportCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.salReportScope = [];
            this.scope = $scope;
            this.scope.parentController = this;
            this.scope.date = new Date();
            this.scope.securityId = $stateParams.secId;
            this.timeout = $timeout;
            this.load();
        }
        StockReportCtrl.prototype.salStockReportTransform = function () {
            morningstar.asterix.ng.transforms.register('fromAuClientResearch', function (input) {
                if (!input) {
                    return input;
                }
                return {
                    title: input.title,
                    url: input.url,
                    date: new Date(input.dateWritten),
                    author: input.author,
                    recommendation: input.licenseeRecommendation,
                    recommendationChange: input.recommendationChange
                };
            });
            morningstar.asterix.ng.transforms.register('fromAuDocumentList', function (input) {
                if (!input || !input.arcDocumentList || !input.arcDocumentList.length) {
                    return input;
                }
                return {
                    title: input.arcDocumentList[0].byLine ? input.arcDocumentList[0].byLine : input.arcDocumentList[0].title,
                    url: input.arcDocumentList[0].url,
                    date: new Date(input.arcDocumentList[0].date)
                };
            });
        };
        StockReportCtrl.prototype.load = function () {
            this.log.info("SAL report Ctrl loading...");
            var self = this;
            var isinData = this.state.params['secId']
                ? this.state.params['secId']
                : "";
            if (isinData) {
                $('#SalContainer').data('$injector', '');
                $.ajax(SALauthUrl).then(function (authData) {
                    loaderConfigSalStock.configuration.overrides.settings.shareClassId = isinData;
                    loaderConfigSalStock.apiTokens.apiGatewayToken = authData.body;
                    morningstar.loader.load(loaderConfigSalStock).then(function (manifest) {
                        //setup sal stock report transform
                        self.salStockReportTransform();
                        $('#main-spinner').remove();
                    }).catch(function (error) {
                        console.log(error);
                    });
                });
            }
            else {
                this.state.go('dashboard');
            }
        };
        StockReportCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout', 'navigationService'];
        return StockReportCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.StockReportCtrl = StockReportCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var FundReportCtrl = (function (_super) {
        __extends(FundReportCtrl, _super);
        function FundReportCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.salReportScope = [];
            this.scope = $scope;
            this.timeout = $timeout;
            this.load();
        }
        FundReportCtrl.prototype.load = function () {
            this.log.info("SAL fund Ctrl loading...");
            $('#SalContainer').data('$injector', '');
            var isinData = this.state.params['secId']
                ? this.state.params['secId']
                : "";
            if (isinData) {
                $.ajax(SALauthUrl).then(function (authData) {
                    loaderConfigSalFund.configuration.overrides.settings.shareClassId = isinData;
                    loaderConfigSalFund.apiTokens.apiGatewayToken = authData.body;
                    morningstar.loader.load(loaderConfigSalFund).then(function () {
                        $('#main-spinner').remove();
                    }).catch(function (error) {
                        console.log(error);
                    });
                });
            }
            else {
                this.state.go('dashboard');
            }
        };
        FundReportCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];
        return FundReportCtrl;
    }(Patersons.AbstractController));
    Patersons.FundReportCtrl = FundReportCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var EtfReportCtrl = (function (_super) {
        __extends(EtfReportCtrl, _super);
        function EtfReportCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.scope.securityId = $stateParams.secId;
            this.timeout = $timeout;
            this.load();
        }
        EtfReportCtrl.prototype.load = function () {
            this.log.info("SAL report Ctrl loading...");
            console.log($('#sal-report'));
            //
            var isinData = this.state.params['secId']
                ? this.state.params['secId']
                : "";
            if (isinData) {
                $.ajax(SALauthUrl).then(function (authData) {
                    loaderConfigSalETF.configuration.overrides.settings.shareClassId = isinData;
                    loaderConfigSalETF.apiTokens.apiGatewayToken = authData.body;
                    $('#SalContainer').data('$injector', '');
                    morningstar.loader.load(loaderConfigSalETF).then(function () {
                        $('#main-spinner').remove();
                    }).catch(function (error) {
                        console.log(error);
                    });
                });
            }
            else {
                this.state.go('dashboard');
            }
        };
        EtfReportCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];
        return EtfReportCtrl;
    }(Patersons.AbstractController));
    Patersons.EtfReportCtrl = EtfReportCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class HoldingsCtrl extends AbstractController {
    var HoldingsCtrl = (function (_super) {
        __extends(HoldingsCtrl, _super);
        function HoldingsCtrl($scope, $q, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, reportService, reportDownloadService, navigationService, selectionService, pdfBuilderService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.getBackdatedHolding = function () {
                // if(this.scope.isLoading){
                //     return;
                // }
                this.scope.isError = false;
                this.scope.hasData = false;
                var now = moment();
                var selectedDate = moment(this.scope.asAt);
                this.scope.generatedDate = new Date();
                if (selectedDate.isBefore(now, 'day')) {
                    this.loadBackdatedHoldings();
                }
                else {
                    this.buildReports();
                }
            };
            this.getSummaryText = function () {
                var text = "Report generated at " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                    " AEST on " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".<br/>" +
                    "Australian equity prices are delayed by 20 minutes. International equity prices are from the previous day's close.";
                return text;
            };
            this.order = function (predicate) {
                this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
                this.scope.predicate = predicate;
            };
            this.orderInternational = function (predicate) {
                this.scope.intReverse = (this.scope.intPredicate === predicate) ? !this.scope.intReverse : false;
                this.scope.intPredicate = predicate;
            };
            this.orderHiCash = function (predicate) {
                this.scope.hiReverse = (this.scope.hiPredicate === predicate) ? !this.scope.hiReverse : false;
                this.scope.hiPredicate = predicate;
            };
            this.orderCash = function (predicate) {
                this.scope.cashTableSortOrder = (this.scope.cashTablePredicate === predicate) ? !this.scope.cashTableSortOrder : false;
                this.scope.cashTablePredicate = predicate;
            };
            this.orderTermDeposits = function (predicate) {
                this.scope.termDepositsSortOrder = (this.scope.termDepositsPredicate === predicate) ? !this.scope.termDepositsSortOrder : false;
                this.scope.termDepositsPredicate = predicate;
            };
            this.scope = $scope;
            this.scope.events = this;
            this.q = $q;
            this.stateParams = $stateParams;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.selectionService = selectionService;
            this.scope.accounts = new Array();
            this.scope.reverse = false;
            this.scope.predicate = "securityCode";
            this.scope.intPredicate = "securityCode";
            this.scope.intReverse = false;
            this.scope.filter = $filter;
            this.scope.asAt = moment().toDate();
            this.pdfBuilderService = pdfBuilderService;
            this.userCompanyService = userCompanyService;
            this.scope.cashTableSortOrder = false;
            this.scope.cashTablePredicate = "instituteCode";
            this.scope.hiPredicate = "instituteCode";
            this.scope.hiReverse = false;
            this.scope.termDepositsSortOrder = false;
            this.scope.termDepositsPredicate = "provider";
            this.scope.hasData = false;
            this.scope.isError = false;
            this.scope.generatedDate = new Date();
            this.userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
            if (this.stateParams.accountId) {
                this.selectionService.selectedAccountId = $stateParams.accountId;
            }
            if (this.stateParams.asAt) {
                this.scope.asAt = moment(this.stateParams.asAt).toDate();
            }
            if (this.stateParams.autoDownloadPDF) {
                this.scope.autoDownloadPDF = this.stateParams.autoDownloadPDF;
            }
            this.load();
        }
        HoldingsCtrl.prototype.checkAutoDownloadPDF = function () {
            if (this.stateParams && this.stateParams.autoDownloadPDF && !this.scope.autoDownloaded) {
                this.downloadPdf();
                this.scope.autoDownloaded = true;
            }
        };
        HoldingsCtrl.prototype.setAsAtDate = function (selectedDate) {
            console.info('Selected As At Date: ' + selectedDate);
            this.scope.asAt = selectedDate;
        };
        HoldingsCtrl.prototype.setSelectedAccount = function (accountId) {
            console.info('Selected Account Id: ' + accountId);
            this.scope.hasData = false;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
        };
        HoldingsCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    _this.scope.isLoading = false;
                    if ((!_this.selectionService || !_this.selectionService.selectedAccountId) && result[0]) {
                        _this.setSelectedAccount(result[0].accountId);
                        _this.getBackdatedHolding();
                    }
                });
            })
                .catch(function (reason) {
                _this.scope.$apply(function () {
                    _this.scope.isLoading = false;
                });
            });
        };
        HoldingsCtrl.prototype.loadBackdatedHoldings = function () {
            var _this = this;
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.scope.isLoading = true;
                this.portfolioService.getBackdatedPortfolioData(this.scope.selectedAccount.accountId, this.scope.asAt)
                    .then(function (result) {
                    _this.scope.cashHoldingsReport = new Patersons.CashHoldingsReport();
                    _this.scope.highInterestCashHoldingsReport = new Patersons.CashHoldingsReport();
                    _this.scope.termDepositsReport = new Patersons.TermDepositsHoldingsReport();
                    var domesticHoldings = result.filter(function (h) { return !h.isInternational; });
                    _this.scope.equityHoldingsReport = _this.buildEquityHoldingsReport(domesticHoldings);
                    var internationalHoldings = result.filter(function (h) { return h.isInternational; });
                    _this.scope.internationalHoldingsReport = _this.buildInternationalEquityHoldingsReport(internationalHoldings);
                    _this.scope.totalMarketValue = _this.scope.equityHoldingsReport.total.marketValue + _this.scope.internationalHoldingsReport.total.marketValue;
                    _this.scope.hasData = true;
                    _this.scope.isError = false;
                    _this.checkAutoDownloadPDF();
                }, function (error) {
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                }).finally(function () {
                    _this.scope.isLoading = false;
                });
            }
            else {
                this.loadAccoladeAccount();
            }
        };
        HoldingsCtrl.prototype.downloadPdf = function () {
            console.info('Download PDF');
            var asAtDate = this.scope.asAt;
            var account = this.scope.selectedAccount;
            var fileName = this.getFileName(account.accountId, asAtDate);
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.makeAgilityPdf(account, asAtDate, fileName);
            }
            else {
                this.makeAccoladePdf(account, fileName, asAtDate);
            }
        };
        HoldingsCtrl.prototype.downloadCsv = function () {
            console.info('Download CSV');
            var asAtDate = this.scope.asAt;
            var account = this.scope.selectedAccount;
            var fileName = this.getFileName(account.accountId, asAtDate);
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.makeCsv(account, fileName, asAtDate);
            }
            else {
                this.reportDownloadService.downloadCsvFile(this.scope.valuationReport, account);
            }
        };
        HoldingsCtrl.prototype.makeCsv = function (account, filename, endDate) {
            filename = filename + ".csv";
            var topLine = Patersons.ReportDownloadService.getCsvTopLine(account, new Date(), endDate, endDate, undefined);
            var csvBuilder = new Patersons.CsvBuilder();
            var cashHoldings = this.scope.cashHoldingsReport;
            var highInterestCashHoldings = this.scope.highInterestCashHoldingsReport;
            var termDeposits = this.scope.termDepositsReport;
            var equityHoldings = this.scope.equityHoldingsReport;
            var internationalHoldings = this.scope.internationalHoldingsReport;
            var pricesQuotedAt = this.scope.selectedAccount.pricesQuotedAt;
            var totalMarketValue = this.scope.totalMarketValue;
            var formattedTermDeposits = this.getFormattedTermDeposits(termDeposits);
            var formattedCashHoldings = this.getFormattedCashHoldings(cashHoldings);
            var formattedHighInterestCashHoldings = this.getFormattedCashHoldings(highInterestCashHoldings);
            var formattedEquityHoldings = this.getFormattedHoldings(equityHoldings);
            var formattedInternationalHoldings = this.getFormattedHoldingsInternational(internationalHoldings);
            var allCSVData = [];
            // Term Deposits.
            if (formattedTermDeposits && formattedTermDeposits.length > 0) {
                allCSVData.push(this.getRowHeading("Term Deposits"));
                allCSVData.push([
                    "MATURITY DATE",
                    "INSTITUTION",
                    "BALANCE",
                    "RATE",
                ]);
                formattedTermDeposits.forEach(function (x) {
                    var data = [
                        (x.maturityDate) ? x.maturityDate : "",
                        (x.provider) ? x.provider : "",
                        (x.balance) ? x.balance : "",
                        (x.rate) ? x.rate : "",
                    ];
                    allCSVData.push(data);
                });
            }
            // Cash Accounts.
            if (formattedCashHoldings && formattedCashHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("Cash Accounts"));
                allCSVData.push([
                    "INSTITUTION",
                    "ACCOUNT NAME",
                    "BALANCE",
                    "TYPE",
                ]);
                formattedCashHoldings.forEach(function (x) {
                    var data = [
                        (x.instituteCode) ? x.instituteCode : "",
                        (x.accountName) ? x.accountName : "",
                        (x.balance) ? x.balance : "",
                        (x.type) ? x.type : "",
                    ];
                    allCSVData.push(data);
                });
            }
            // High Interest Cash Holdings
            if (formattedHighInterestCashHoldings && formattedHighInterestCashHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("High Interest Cash Accounts"));
                allCSVData.push([
                    "INSTITUTION",
                    "ACCOUNT NAME",
                    "BALANCE",
                    "RATE",
                ]);
                formattedHighInterestCashHoldings.forEach(function (x) {
                    var data = [
                        (x.instituteCode) ? x.instituteCode : "",
                        (x.accountName) ? x.accountName : "",
                        (x.balance) ? x.balance : "",
                        (x.interestRate) ? x.interestRate : "",
                    ];
                    allCSVData.push(data);
                });
            }
            // Australian Equities.
            if (formattedEquityHoldings && formattedEquityHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("Australian Equities"));
                allCSVData.push([
                    "CODE",
                    "NAME",
                    "QUANTITY",
                    "AVERAGE COST",
                    "MARKET PRICE",
                    "TOTAL COST",
                    "MARKET VALUE",
                    "PROFIT (LOSS)",
                    "Historic DPS **",
                    "Historic Fr. Credits",
                    "Historic Est. Income",
                    "Historic YIELD",
                ]);
                formattedEquityHoldings.forEach(function (x) {
                    var data = [
                        (x.securityCode) ? x.securityCode : "",
                        (x.companyName) ? x.companyName : "",
                        (x.quantity) ? x.quantity : "",
                        (x.averageCost) ? x.averageCost : "",
                        (x.lastPrice) ? x.lastPrice : "",
                        (x.totalCost) ? x.totalCost : "",
                        (x.marketValue) ? x.marketValue : "",
                        (x.profitOrLoss) ? x.profitOrLoss : "",
                        (x.dividendPerShare) ? x.dividendPerShare : "",
                        (x.frankedAmount) ? x.frankedAmount : "",
                        (x.income) ? x.income : "",
                        (x.yield) ? x.yield : "",
                    ];
                    allCSVData.push(data);
                });
            }
            var internationalFields = this.getFieldsInternational();
            // International Holdings.
            if (formattedInternationalHoldings && formattedInternationalHoldings.length > 0) {
                allCSVData.push(this.getRowHeading("International Equities"));
                allCSVData.push([
                    "CODE",
                    "CURRENCY",
                    "NAME",
                    "QUANTITY",
                    "NATIVE COST PRICE",
                    "NATIVE TOTAL COST",
                    "NATIVE MARKET PRICE",
                    "NATIVE MARKET VALUE",
                    "NATIVE PROFIT (LOSS)",
                    "AUD MARKET VALUE",
                ]);
                formattedInternationalHoldings.forEach(function (x) {
                    var data = [
                        (x.securityCode) ? x.securityCode : "",
                        (x.currency) ? x.currency : "",
                        (x.companyName) ? x.companyName : "",
                        (x.quantity) ? x.quantity : "",
                        (x.nativeCostPrice) ? x.nativeCostPrice : "",
                        (x.nativeTotalCost) ? x.nativeTotalCost : "",
                        (x.nativeMarketPrice) ? x.nativeMarketPrice : "",
                        (x.nativeMarketValue) ? x.nativeMarketValue : "",
                        (x.nativeProfitLoss) ? x.nativeProfitLoss : "",
                        (x.marketValue) ? x.marketValue : "",
                    ];
                    allCSVData.push(data);
                });
            }
            // Grand Total
            allCSVData.push([
                "Grand Total",
                "",
                "",
                "",
                "",
                totalMarketValue,
            ]);
            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(allCSVData)
                .build();
        };
        HoldingsCtrl.prototype.getRowHeading = function (title) {
            return [title];
        };
        HoldingsCtrl.prototype.getHeadings = function () {
            return [];
        };
        HoldingsCtrl.prototype.getAccoladeHeadings = function () {
            return [];
        };
        HoldingsCtrl.prototype.getFileName = function (accountId, asAtDate) {
            var asAtDateStr = moment(asAtDate).format("YYYY-MM-DD");
            return accountId + "-Holdings-" + asAtDateStr;
        };
        HoldingsCtrl.prototype.makeAccoladePdf = function (account, filename, asAtDate) {
            var _this = this;
            var reportData = this.scope.valuationReport;
            var asAt = moment(asAtDate).format("D MMM YYYY");
            var generatedAt = moment.tz(reportData.creationDateUtc, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');
            var pricesQuotedAt = moment.tz(this.scope.selectedAccount.pricesQuotedAt, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');
            this.reportDownloadService.report = reportData;
            // Build a valuation statement (aka Accolade Holdings) PDF document definition using an empty content object.
            // We'll inject this document definition into our PDF builder in the next step.
            var docDefinition = this.reportDownloadService.getValuationStatement({ content: [] });
            this.pdfBuilderService.newPdfBuilderInstance().then(function (pdfBuilder) {
                pdfBuilder
                    .setTitle(reportData.title)
                    .setSubTitle(_this.scope.filter("accountName")(account.designation ? account.accountName + ' ' + account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:', account.adviserName, '', '')
                    .addHeaderTableRow('Account:', account.accountId, '', '')
                    .addHeaderTableRow('Report Generated At:', generatedAt, 'As at:', asAt)
                    .addHeading(_this.getStandardDisclaimer())
                    .setFilename(filename)
                    .build(docDefinition.content);
            });
        };
        HoldingsCtrl.prototype.makeAgilityPdf = function (account, asAtDate, filename) {
            var _this = this;
            var nowDate = moment(new Date());
            var asAtDateStr = moment(asAtDate).format("D MMM YYYY");
            var cashHoldings = this.scope.cashHoldingsReport;
            var highInterestCashHoldings = this.scope.highInterestCashHoldingsReport;
            var termDeposits = this.scope.termDepositsReport;
            var equityHoldings = this.scope.equityHoldingsReport;
            var internationalHoldings = this.scope.internationalHoldingsReport;
            var pricesQuotedAt = this.scope.selectedAccount.pricesQuotedAt;
            var totalMarketValue = this.scope.totalMarketValue;
            var formattedTermDeposits = this.getFormattedTermDeposits(termDeposits);
            var formattedCashHoldings = this.getFormattedCashHoldings(cashHoldings);
            var formattedHighInterestCashHoldings = this.getFormattedCashHoldings(highInterestCashHoldings);
            var formattedEquityHoldings = this.getFormattedHoldings(equityHoldings);
            var formattedInternationalHoldings = this.getFormattedHoldingsInternational(internationalHoldings);
            var lastRowIsTotal = true;
            this.pdfBuilderService.newPdfBuilderInstance().then(function (pdfBuilder) {
                pdfBuilder
                    .setTitle('Holdings')
                    .setSubTitle(_this.scope.filter("accountName")(account.designation ? account.accountName + ' ' + account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:', account.adviserName, '', '')
                    .addHeaderTableRow('Account:', account.accountId, '', '')
                    .addHeaderTableRow('Report Generated At:', moment.tz(nowDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), 'As at:', asAtDateStr)
                    .addHeading(_this.getStandardDisclaimer())
                    .addTableAligned('Australian Equities', formattedEquityHoldings, _this.getHoldingsFields(), _this.getHoldingsHeadingsAligned(), _this.getHoldingsFormatHints(), lastRowIsTotal)
                    .addTableAligned('International Equities', formattedInternationalHoldings, _this.getInternationalHoldingsFields(), _this.getInternationalHoldingsHeadingsAligned(), _this.getInternationalHoldingsFormatHints(), lastRowIsTotal)
                    .addTable('Cash Accounts', formattedCashHoldings, _this.getCashHoldingsFields(), _this.getCashHoldingsHeadings(), _this.getCashHoldingsFormatHints(), lastRowIsTotal)
                    .addTable('High Interest Cash Accounts', formattedHighInterestCashHoldings, _this.getCashHoldingsFields(), _this.getCashHoldingsHeadings(), _this.getCashHoldingsFormatHints(), lastRowIsTotal)
                    .addTable('Term Deposits', formattedTermDeposits, _this.getTermDepositsFields(), _this.getTermDepositsHeadings(), _this.getTermDepositsFormatHints(), lastRowIsTotal)
                    .addTable('Grand Total', [{ total: totalMarketValue }], ['total'], null, //['Total Market Value'],
                [Patersons.PdfFormatHint.Currency], false)
                    .setFilename(filename)
                    .build();
            });
        };
        HoldingsCtrl.prototype.getFormattedTermDeposits = function (data) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map(function (record) {
                return {
                    maturityDate: moment(record.maturityDate).format("DD/MM/YYYY"),
                    provider: record.provider,
                    balance: record.balance,
                    rate: record.rate
                };
            });
            return formattedData;
        };
        HoldingsCtrl.prototype.getFormattedCashHoldings = function (data) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map(function (record) {
                return {
                    instituteCode: record.instituteCode,
                    accountName: record.accountName,
                    balance: record.balance,
                    type: record.type
                };
            });
            return formattedData;
        };
        HoldingsCtrl.prototype.getFieldsInternational = function () {
            return [
                "securityCode",
                "currency",
                "companyName",
                "quantity",
                "nativeCostPrice",
                "nativeTotalCost",
                "nativeMarketPrice",
                "nativeMarketValue",
                "nativeProfitLoss",
                "totalCost",
                "marketValue",
                "profitOrLoss",
            ];
        };
        HoldingsCtrl.prototype.getFields = function () {
            return [
                "securityCode",
                "companyName",
                "quantity",
                "averageCost",
                "lastPrice",
                "totalCost",
                "marketValue",
                "profitOrLoss",
                "dividendPerShare",
                "frankedAmount",
                "income",
                "yield" //,
            ];
        };
        HoldingsCtrl.prototype.getAccoladeFields = function () {
            var result = [];
            if (this.scope.userCompany.enableFeature) {
                var result_1 = [
                    "code",
                    "securityName",
                    "quantity",
                    "costPrice",
                    "reducedCostBase",
                    "marketPrice",
                    "marketValue",
                    "profitOrLoss",
                    "pctAssets",
                    "estIncome",
                    "estFrankingCredits",
                    "estGrossYield"
                ];
                return result_1;
            }
            else {
                var result_2 = [
                    "code",
                    "securityName",
                    "quantity",
                    "costPrice",
                    "reducedCostBase",
                    "marketPrice",
                    "marketValue",
                    "profitOrLoss",
                    "pctAssets",
                ];
                return result_2;
            }
        };
        HoldingsCtrl.prototype.getFormattedHoldingsInternational = function (data) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map(function (record) {
                return {
                    securityCode: record.securityCode,
                    currency: record.currency,
                    companyName: record.companyName,
                    quantity: record.quantity,
                    nativeCostPrice: record.nativeCostPrice,
                    nativeTotalCost: record.nativeTotalCost,
                    nativeMarketPrice: record.nativeMarketPrice,
                    nativeMarketValue: record.nativeMarketValue,
                    nativeProfitLoss: record.nativeProfitLoss,
                    totalCost: record.totalCost,
                    marketValue: record.marketValue,
                    profitOrLoss: record.profitOrLoss,
                };
            });
            return formattedData;
        };
        HoldingsCtrl.prototype.getFormattedHoldings = function (data) {
            if (!data || !data.holdings) {
                return null;
            }
            var formattedData = angular.copy(data.holdings);
            if (data.total && data.total.hasData()) {
                formattedData.push(angular.copy(data.total));
            }
            formattedData = formattedData.map(function (record) {
                return {
                    securityCode: record.securityCode,
                    companyName: record.companyName,
                    quantity: record.quantity,
                    averageCost: record.averageCost,
                    lastPrice: record.lastPrice,
                    totalCost: record.totalCost,
                    marketValue: record.marketValue,
                    profitOrLoss: record.profitOrLoss,
                    dividendPerShare: record.dividendPerShare,
                    frankedAmount: record.frankedAmount,
                    income: record.income,
                    "yield": record.yield,
                };
            });
            return formattedData;
        };
        HoldingsCtrl.prototype.getTermDepositsFields = function () {
            return ["maturityDate", "provider", "balance", "rate"];
        };
        HoldingsCtrl.prototype.getCashHoldingsFields = function () {
            return ["instituteCode", "accountName", "balance", "type"];
        };
        HoldingsCtrl.prototype.getInternationalHoldingsFields = function () {
            return [
                "securityCode",
                "currency",
                "companyName",
                "quantity",
                "nativeCostPrice",
                "nativeTotalCost",
                "nativeMarketPrice",
                "nativeMarketValue",
                "nativeProfitLoss",
                "marketValue",
            ];
        };
        HoldingsCtrl.prototype.getHoldingsFields = function () {
            return ["securityCode",
                "companyName",
                "quantity",
                "averageCost",
                "lastPrice",
                "totalCost",
                "marketValue",
                "profitOrLoss",
                "dividendPerShare",
                "frankedAmount",
                "income",
                "yield",
            ];
        };
        HoldingsCtrl.prototype.getTermDepositsFormatHints = function () {
            return [
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.None
            ];
        };
        HoldingsCtrl.prototype.getCashHoldingsFormatHints = function () {
            return [
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.None
            ];
        };
        HoldingsCtrl.prototype.getInternationalHoldingsFormatHints = function () {
            return [
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.Currency4decPts,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency4decPts,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
            ];
        };
        HoldingsCtrl.prototype.getHoldingsFormatHints = function () {
            return [
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.Currency4decPts,
                Patersons.PdfFormatHint.Currency4decPts,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency,
                Patersons.PdfFormatHint.Currency
            ];
        };
        HoldingsCtrl.prototype.getTermDepositsHeadings = function () {
            return ["Maturity Date", "Institution", "Balance", "Rate"];
        };
        HoldingsCtrl.prototype.getCashHoldingsHeadings = function () {
            return ["Institution", "Account Name", "Balance", "Type"];
        };
        HoldingsCtrl.prototype.getHoldingsHeadings = function () {
            return ["Code", "Name", "Quantity", "Average Cost",
                "Market Price", "Total Cost", "Market Value",
                "Profit (Loss)", "Historic DPS**", "Historic Fr. Credits", "Historic Est. Income",
                "Yield",];
        };
        HoldingsCtrl.prototype.getInternationalHoldingsHeadingsAligned = function () {
            return [
                { text: "Code", type: "string" },
                { text: "Currency", type: "string" },
                { text: "Name", type: "string" },
                { text: "Quantity", type: "number" },
                { text: "Native Cost Price", type: "number" },
                { text: "Native Total Cost", type: "number" },
                { text: "Native Market Price", type: "number" },
                { text: "Native Market Value", type: "number" },
                { text: "Native Profit (Loss)", type: "number" },
                { text: "AUD Market Value", type: "number" },
            ];
        };
        HoldingsCtrl.prototype.getHoldingsHeadingsAligned = function () {
            return [
                { text: "Code", type: "string" },
                { text: "Name", type: "string" },
                { text: "Quantity", type: "number" },
                { text: "Average Cost", type: "number" },
                { text: "Market Price", type: "number" },
                { text: "Total Cost", type: "number" },
                { text: "Market Value", type: "number" },
                { text: "Profit (Loss)", type: "number" },
                { text: "Historic DPS**", type: "number" },
                { text: "Historic Fr. Credits", type: "number" },
                { text: "Historic Est. Income", type: "number" },
                { text: "Historic Yield", type: "number" },
            ];
        };
        HoldingsCtrl.prototype.getStandardDisclaimer = function () {
            return '* Australian Equity prices are delayed by 20 mins. International equity prices are the previous day\'s closing price.';
        };
        HoldingsCtrl.prototype.buildReports = function () {
            if (this.scope.selectedAccount == undefined) {
                return;
            }
            this.scope.isLoading = true;
            if (this.scope.selectedAccount.accountType == "Standard") {
                this.loadStandardAccount();
            }
            else {
                this.loadAccoladeAccount();
            }
        };
        HoldingsCtrl.prototype.loadStandardAccount = function () {
            var _this = this;
            var cashAccountsPromise = this.portfolioService.getCashAccounts(this.scope.selectedAccount.accountId);
            cashAccountsPromise.then(function (result) {
                _this.scope.selectedAccount.cashDeposits = result;
                _this.scope.cashHoldingsReport = _this.buildCashHoldingReport(result);
            }, function (error) {
                _this.scope.selectedAccount.cashDeposits = null;
                _this.scope.cashHoldingsReport = null;
            });
            var highInterestCashPromise = this.portfolioService.getHighInterestCashAccounts(this.scope.selectedAccount.accountId);
            highInterestCashPromise.then(function (result) {
                _this.scope.highInterestCashHoldingsReport = _this.buildCashHoldingReport(result);
            }, function (error) {
                _this.scope.highInterestCashHoldingsReport = null;
            });
            var termDepositPromise = this.portfolioService.getTermDeposits(this.scope.selectedAccount.accountId);
            termDepositPromise.then(function (result) {
                _this.scope.selectedAccount.termDeposits = result;
                _this.scope.termDepositsReport = _this.buildTermDepositsReport(_this.scope.selectedAccount);
            }, function (error) {
                _this.scope.selectedAccount.termDeposits = null;
                _this.scope.termDepositsReport = null;
            });
            var internationalSharesPromise = this.portfolioService.getInternationalSharesForHoldings(this.scope.selectedAccount);
            internationalSharesPromise.then(function (result) {
                _this.scope.internationalHoldingsReport = _this.buildInternationalEquityHoldingsReport(result);
            }, function (error) {
                _this.scope.internationalHoldingsReport = null;
            });
            var sharesPromise = this.portfolioService.getShares(this.scope.selectedAccount.accountId);
            sharesPromise.then(function (result) {
                _this.scope.selectedAccount.holdings = result;
                _this.scope.equityHoldingsReport = _this.buildEquityHoldingsReport(_this.scope.selectedAccount.holdings);
                if (_this.scope.selectedAccount.holdings[0]) {
                    _this.scope.selectedAccount.pricesQuotedAt = _this.scope.selectedAccount.holdings[0].asOf;
                }
            }, function (error) {
                _this.scope.selectedAccount.holdings = null;
                _this.scope.equityHoldingsReport = null;
            });
            var allPromises = this.q.all([
                cashAccountsPromise,
                highInterestCashPromise,
                termDepositPromise,
                internationalSharesPromise,
                sharesPromise]);
            allPromises.then(function () {
                _this.scope.totalMarketValue = _this.scope.equityHoldingsReport.total.marketValue + _this.scope.internationalHoldingsReport.total.marketValue + _this.scope.cashHoldingsReport.total.balance + _this.scope.termDepositsReport.total.balance;
            }, function (error) {
                _this.scope.totalMarketValue = null;
            });
            allPromises.finally(function () {
                _this.scope.isLoading = false;
                _this.scope.hasData = true;
                _this.checkAutoDownloadPDF();
            });
        };
        HoldingsCtrl.prototype.loadAccoladeAccount = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.reportService.getReport(Patersons.ReportType.Valuation, this.scope.selectedAccount.accountId, this.scope.asAt, this.scope.asAt)
                .then(function (result) {
                _this.scope.selectedAccount.pricesQuotedAt = _this.scope.asAt;
                _this.scope.valuationReport = result;
                _this.scope.hasData = true;
                _this.scope.isError = false;
                _this.checkAutoDownloadPDF();
            }, function (error) {
                // error handling
                _this.scope.selectedAccount.pricesQuotedAt = _this.scope.asAt;
                _this.scope.valuationReport = null;
                _this.scope.isError = true;
                _this.scope.hasData = false;
            }).finally(function () {
                _this.scope.isLoading = false;
            });
        };
        HoldingsCtrl.prototype.buildCashHoldingReport = function (cashDeposits) {
            var report = new Patersons.CashHoldingsReport();
            var holdings = new Array();
            var total = new Patersons.CashHolding();
            total.balance = 0;
            for (var i = 0; i < cashDeposits.length; i++) {
                var cashDeposit = cashDeposits[i];
                var rec = new Patersons.CashHolding();
                rec.instituteCode = cashDeposit.instituteCode;
                rec.accountName = cashDeposit.accountName;
                rec.balance = cashDeposit.balance;
                rec.type = cashDeposit.type;
                rec.interestRate = cashDeposit.interestRate;
                holdings.push(rec);
                total.balance += cashDeposit.balance;
            }
            report.holdings = holdings;
            report.total = total;
            return report;
        };
        HoldingsCtrl.prototype.buildEquityHoldingsReport = function (inputHoldings) {
            var report = new Patersons.EquityHoldingsReport();
            var holdings = new Array();
            var total = new Patersons.EquityHolding();
            total.totalCost = 0;
            total.marketValue = 0;
            total.profitOrLoss = 0;
            total.income = 0;
            for (var i = 0; i < inputHoldings.length; i++) {
                var holding = inputHoldings[i];
                if (!holding.isInternational) {
                    var rec = new Patersons.EquityHolding();
                    rec.exchange = holding.exchange;
                    rec.securityCode = holding.securityCode;
                    rec.companyName = holding.companyName;
                    rec.quantity = holding.quantity;
                    rec.averageCost = holding.averageCost;
                    rec.lastPrice = holding.lastPrice;
                    rec.totalCost = holding.totalCost;
                    rec.marketValue = holding.marketValue;
                    rec.profitOrLoss = holding.profitOrLoss;
                    rec.dividendPerShare = holding.dividendPerShare;
                    rec.frankedAmount = holding.frankedAmount;
                    rec.income = holding.income;
                    rec.yield = holding.yield;
                    //rec.priceToEarnings = holding.priceToEarnings;
                    holdings.push(rec);
                    total.totalCost += holding.totalCost;
                    total.marketValue += holding.marketValue;
                    total.profitOrLoss += holding.profitOrLoss;
                    total.income += holding.income;
                }
            }
            report.holdings = holdings;
            report.total = total;
            return report;
        };
        HoldingsCtrl.prototype.buildInternationalEquityHoldingsReport = function (intHoldings) {
            var report = new Patersons.EquityHoldingsReport();
            var holdings = new Array();
            var total = new Patersons.EquityHolding();
            total.totalCost = 0;
            total.marketValue = 0;
            total.profitOrLoss = 0;
            total.income = 0;
            total.nativeTotalCost = 0;
            total.nativeMarketValue = 0;
            total.nativeProfitLoss = 0;
            for (var i = 0; i < intHoldings.length; i++) {
                var holding = intHoldings[i];
                var rec = new Patersons.EquityHolding();
                rec.exchange = holding.exchange;
                rec.securityCode = holding.securityCode;
                rec.companyName = holding.companyName;
                rec.quantity = holding.quantity;
                rec.averageCost = holding.averageCost;
                rec.lastPrice = holding.lastPrice;
                rec.totalCost = holding.totalCost;
                rec.marketValue = holding.marketValue;
                rec.profitOrLoss = holding.profitOrLoss;
                rec.dividendPerShare = holding.dividendPerShare;
                rec.frankedAmount = holding.frankedAmount;
                rec.income = holding.income;
                rec.yield = holding.yield;
                rec.currency = holding.currency;
                rec.nativeCostPrice = holding.nativeCostPrice;
                rec.nativeTotalCost = holding.nativeTotalCost;
                rec.nativeMarketPrice = holding.nativeMarketPrice;
                rec.nativeMarketValue = holding.nativeMarketValue;
                rec.nativeProfitLoss = holding.nativeProfitLoss;
                //rec.priceToEarnings = holding.priceToEarnings;
                holdings.push(rec);
                total.totalCost += holding.totalCost;
                total.nativeTotalCost += holding.nativeTotalCost;
                total.nativeMarketValue += holding.nativeMarketValue;
                total.nativeProfitLoss += holding.nativeProfitLoss;
                total.marketValue += holding.marketValue;
                total.profitOrLoss += holding.profitOrLoss;
                total.income += holding.income;
            }
            report.holdings = holdings;
            report.total = total;
            return report;
        };
        HoldingsCtrl.prototype.buildTermDepositsReport = function (account) {
            var report = new Patersons.TermDepositsHoldingsReport();
            var holdings = new Array();
            var total = new Patersons.TermDeposit();
            total.balance = 0;
            for (var i = 0; i < account.termDeposits.length; i++) {
                var termDeposit = account.termDeposits[i];
                var rec = new Patersons.TermDeposit();
                rec.accountCode = termDeposit.accountCode;
                rec.balance = termDeposit.balance;
                rec.maturityDate = termDeposit.maturityDate;
                rec.provider = termDeposit.provider;
                rec.rate = termDeposit.rate;
                holdings.push(rec);
                total.balance += termDeposit.balance;
            }
            report.holdings = holdings;
            report.total = total;
            return report;
        };
        HoldingsCtrl.$inject = ['$scope', '$q', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'reportService', 'reportDownloadService', 'navigationService', 'selectionService', 'pdfBuilderService', 'userCompanyService'];
        return HoldingsCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.HoldingsCtrl = HoldingsCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class ConfirmationNotesCtrl extends AbstractController {
    var ConfirmationNotesCtrl = (function (_super) {
        __extends(ConfirmationNotesCtrl, _super);
        function ConfirmationNotesCtrl($q, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, bulkDownloadService, navigationService, pdfBuilderService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.order = function (predicate) {
                this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
                this.scope.predicate = predicate;
            };
            this.getSummaryText = function () {
                var text = "Report generated at " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                    " AEST on " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
                return text;
            };
            this.q = $q;
            this.state = $state;
            this.http = $http;
            this.scope = $scope;
            this.scope.events = this;
            this.scope.filter = $filter;
            this.portfolioService = portfolioService;
            this.bulkDownloadService = bulkDownloadService;
            this.pdfBuilderService = pdfBuilderService;
            this.scope.accounts = new Array();
            this.scope.reverse = true;
            this.scope.predicate = "conDate";
            this.scope.isSelectAll = false;
            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();
            this.scope.generatedDate = new Date();
            this.scope.hasData = false;
            this.scope.isError = false;
            this.load();
        }
        ConfirmationNotesCtrl.prototype.hasNotesInRange = function () {
            var start = moment(this.scope.startDate);
            var end = moment(this.scope.endDate);
            return this.scope.selectedAccount &&
                this.scope.selectedAccount.confirmationNotes &&
                this.scope.selectedAccount.confirmationNotes.some(function (m) { return moment(m.conDate).isBetween(start, end, 'days', '[]'); });
        };
        ConfirmationNotesCtrl.prototype.selectAll = function (e) {
            e.stopPropagation();
            this.scope.isSelectAll = !this.scope.isSelectAll;
            var selectAll = this.scope.isSelectAll;
            console.log("Selected : " + selectAll);
            var log = [];
            var selectableContractNotes = this.scope.selectedAccount.confirmationNotes.filter(function (x) { return x.uri !== null; });
            angular.forEach(selectableContractNotes, function (cn, key) {
                cn.isSelected = selectAll;
                console.log("Set : " + cn.isSelected);
            });
            if (selectAll === true) {
                this.scope.checkedItems = selectableContractNotes;
            }
            else {
                this.scope.checkedItems = [];
            }
        };
        ;
        ConfirmationNotesCtrl.prototype.isDownloadButtonDisabled = function () {
            return this.scope.checkedItems == undefined || this.scope.checkedItems.length <= 0;
        };
        ConfirmationNotesCtrl.prototype.toggleSelection = function (item, e) {
            e.stopPropagation();
            if (this.scope.checkedItems == undefined) {
                this.scope.checkedItems = [];
            }
            var idx = this.scope.checkedItems.indexOf(item);
            if (idx > -1) {
                this.scope.checkedItems.splice(idx, 1);
            }
            else {
                this.scope.checkedItems.push(item);
            }
        };
        ;
        ConfirmationNotesCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    _this.scope.isLoading = false;
                });
            });
        };
        ConfirmationNotesCtrl.prototype.loadConfirmationNotes = function (accountId, startDate, endDate) {
            var _this = this;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            this.scope.startDate = startDate;
            this.scope.endDate = endDate;
            this.scope.generatedDate = new Date();
            this.scope.isLoading = true;
            this.scope.isDownloadReady = false;
            this.scope.hasData = false;
            this.scope.isError = false;
            this.portfolioService.getContractNotes(this.scope.selectedAccount.accountId, startDate, endDate)
                .then(function (result) {
                _this.scope.selectedAccount.confirmationNotes = result;
                _this.scope.isDownloadReady = true;
                _this.scope.hasData = true;
                _this.scope.isError = false;
            }, function (reason) {
                _this.scope.reportError = reason.data.message;
                _this.scope.hasData = false;
                _this.scope.isError = true;
            })
                .finally(function () {
                _this.scope.isLoading = false;
            });
        };
        ConfirmationNotesCtrl.prototype.downloadPdf = function () {
            console.info('Download PDF');
            var account = this.scope.selectedAccount;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var fileName = this.getFileName(account.accountId, startDate, endDate);
            var filteredData = account.confirmationNotes;
            var sortedData = this.orderBy(filteredData, this.scope.predicate, this.scope.reverse);
            this.makePdf(sortedData, account, startDate, endDate, fileName + ".pdf");
        };
        ConfirmationNotesCtrl.prototype.downloadCsv = function () {
            console.info('Download CSV');
            var account = this.scope.selectedAccount;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var fileName = this.getFileName(account.accountId, startDate, endDate);
            var filteredData = account.confirmationNotes;
            var sortedData = this.orderBy(filteredData, this.scope.predicate, this.scope.reverse);
            this.makeCsv(sortedData, account, startDate, endDate, fileName);
        };
        ConfirmationNotesCtrl.prototype.downloadContractNote = function (item, e) {
            var _this = this;
            this.http.get(item.uri, { headers: { 'Accept': 'application/pdf' }, responseType: 'arraybuffer' })
                .then(function (response) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    // Open BLOB in IE and Edge
                    window.navigator.msSaveOrOpenBlob(blob, item.prettyFileName);
                }
                else {
                    // Open BLOB in Chrome, Firefox etc.
                    var downloadLink = document.createElement('a');
                    downloadLink.href = window.URL.createObjectURL(blob);
                    downloadLink.target = '_blank';
                    downloadLink.setAttribute('download', item.prettyFileName);
                    document.body.appendChild(downloadLink);
                    downloadLink.click();
                    downloadLink.remove();
                }
            }, function (reason) {
                if (reason.status === 403) {
                    _this.state.go('forbidden');
                }
                throw reason;
            });
        };
        ConfirmationNotesCtrl.prototype.download = function () {
            var _this = this;
            if (this.scope.checkedItems == undefined || this.scope.checkedItems.length <= 0) {
                return null;
            }
            this.scope.isDownloading = true;
            var filename = this.scope.selectedAccount.accountId + "-" + moment(new Date()).format("YYYY-MM-DD") + ".zip";
            this.bulkDownloadService.downloadItems(this.scope.checkedItems, filename)
                .finally(function () {
                _this.scope.isDownloading = false;
            });
        };
        ConfirmationNotesCtrl.prototype.orderBy = function (notes, predicate, reverse) {
            return this.scope.filter('orderBy')(notes, predicate, reverse);
        };
        ConfirmationNotesCtrl.prototype.makePdf = function (notes, account, startDate, endDate, filename) {
            var _this = this;
            filename = filename + ".pdf";
            var nowDate = moment(new Date());
            var formattedData = this.getFormattedData(notes);
            var startDateStr = moment(startDate).format("D MMM YYYY");
            var endDateStr = moment(endDate).format("D MMM YYYY");
            var generatedAt = moment.tz(nowDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY');
            this.pdfBuilderService.newPdfBuilderInstance().then(function (pdfBuilder) {
                pdfBuilder.setTitle('Contract Notes')
                    .setSubTitle(_this.scope.filter("accountName")(account.designation ? account.accountName + ' ' + account.designation : account.accountName))
                    .addHeaderTableRow('Adviser:', account.adviserName, '', '')
                    .addHeaderTableRow('Account:', account.accountId, '', '')
                    .addHeaderTableRow('From:', startDateStr, '', '')
                    .addHeaderTableRow('To:', endDateStr, '', '')
                    .addHeaderTableRow('Report Generated At:', generatedAt, '', '')
                    .addTable('Contract Notes', formattedData, _this.getFields(), _this.getHeadings(), _this.getFormatHints())
                    .setFilename(filename)
                    .build();
            });
        };
        ConfirmationNotesCtrl.prototype.makeCsv = function (notes, account, startDate, endDate, filename) {
            filename = filename + ".csv";
            var formattedData = this.getFormattedDataCsv(notes);
            var topLine = Patersons.ReportDownloadService.getCsvTopLine(account, new Date(), startDate, endDate, undefined);
            var csvBuilder = new Patersons.CsvBuilder();
            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(formattedData)
                .build();
        };
        ConfirmationNotesCtrl.prototype.getFormattedDataCsv = function (data) {
            var _this = this;
            var formattedData = angular.copy(data);
            formattedData = formattedData.map(function (note) {
                var fields = _this.getFields();
                var data = {
                    conNumber: note.conNumber,
                    conDate: moment(note.conDate).format("DD/MM/YYYY"),
                    securityCode: note.securityCode,
                    securityDescription: note.securityDescription,
                    type: note.type,
                    units: note.units,
                    currencyCode: note.currencyCode,
                    nett: note.nett
                };
                return fields.map(function (field) { return data[field]; });
            });
            return formattedData;
        };
        ConfirmationNotesCtrl.prototype.getFormattedData = function (data) {
            var formattedData = angular.copy(data);
            formattedData = formattedData.map(function (note) {
                return {
                    conNumber: note.conNumber,
                    conDate: moment(note.conDate).format("DD/MM/YYYY"),
                    securityCode: note.securityCode,
                    securityDescription: note.securityDescription,
                    type: note.type,
                    units: note.units,
                    currencyCode: note.currencyCode,
                    nett: note.nett
                };
            });
            return formattedData;
        };
        ConfirmationNotesCtrl.prototype.getFileName = function (accountId, startDate, endDate) {
            var startDateStr = moment(startDate).format("YYYY-MM-DD");
            var endDateStr = moment(endDate).format("YYYY-MM-DD");
            return accountId + "-ContractNotes-" + startDateStr + "_" + endDateStr;
        };
        ConfirmationNotesCtrl.prototype.getFields = function () {
            return ["conDate", "conNumber", "type", "units", "securityCode", "securityDescription", "currencyCode", "nett"];
        };
        ConfirmationNotesCtrl.prototype.getFormatHints = function () {
            return [
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.None,
                Patersons.PdfFormatHint.Currency
            ];
        };
        ConfirmationNotesCtrl.prototype.getHeadings = function () {
            return ["Date", "Number", "Type", "Units", "Security Code", "Description", "Currency", "Nett"];
        };
        ConfirmationNotesCtrl.$inject = ['$q', '$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'bulkDownloadService', 'navigationService', 'pdfBuilderService'];
        return ConfirmationNotesCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.ConfirmationNotesCtrl = ConfirmationNotesCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class MarketOrdersCtrl extends AbstractController {
    var MarketOrdersCtrl = (function (_super) {
        __extends(MarketOrdersCtrl, _super);
        function MarketOrdersCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $filter, portfolioService, navigationService, pdfBuilderService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.getSummaryText = function () {
                var text = "Report generated at " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                    " AEST on " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
                return text;
            };
            this.scope = $scope;
            this.scope.filter = $filter;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.scope.accounts = new Array();
            this.scope.reverse = true;
            this.scope.predicate = "orderDate";
            this.pdfBuilderService = pdfBuilderService;
            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();
            this.scope.isError = false;
            this.scope.hasData = false;
            this.scope.csvData = [];
            this.load();
        }
        MarketOrdersCtrl.prototype.order = function (predicate) {
            this.scope.reverse = (this.scope.predicate === predicate) ? !this.scope.reverse : false;
            this.scope.predicate = predicate;
        };
        MarketOrdersCtrl.prototype.hasOrdersInRange = function () {
            var start = moment(this.scope.startDate);
            var end = moment(this.scope.endDate);
            return this.scope.selectedAccount &&
                this.scope.selectedAccount.marketOrders &&
                this.scope.selectedAccount.marketOrders.some(function (m) { return moment(m.orderDate).isBetween(start, end, 'days', '[]'); });
        };
        MarketOrdersCtrl.prototype.buildTableBody = function (data, columns, headers) {
            var body = [];
            body.push(headers);
            data.forEach(function (row) {
                var dataRow = [];
                columns.forEach(function (column) {
                    dataRow.push(row[column].toString());
                });
                body.push(dataRow);
            });
            return body;
        };
        MarketOrdersCtrl.prototype.table = function (data, columns, headers) {
            return {
                table: {
                    headerRows: 1,
                    body: this.buildTableBody(data, columns, headers)
                }
            };
        };
        MarketOrdersCtrl.prototype.downloadCsv = function () {
            console.info('Download CSV');
            var account = this.scope.selectedAccount;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var fileName = this.getFileName();
            this.makeCsv(fileName);
        };
        MarketOrdersCtrl.prototype.makeCsv = function (filename) {
            var account = this.scope.selectedAccount;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var topLine = Patersons.ReportDownloadService.getCsvTopLine(account, new Date(), startDate, endDate, undefined);
            var csvBuilder = new Patersons.CsvBuilder();
            csvBuilder.setFilename(filename)
                .setTopLine(topLine)
                .setHeaders(this.getHeadings())
                .setData(this.getFormattedData())
                .build();
        };
        MarketOrdersCtrl.prototype.getFields = function () {
            return ["orderDate", "orderNumber", "orderStatus", "type", "quantity", "securityCode", "securityDescription", "limit", "quantityMatched", "quantityAllocated", "unfilled"];
        };
        MarketOrdersCtrl.prototype.getHeadings = function () {
            return ["Date", "Order Number", "Status", "Type", "Units", "Security Code", "Description", "Limit", "Matched", "Allocated", "Unbooked"];
        };
        MarketOrdersCtrl.prototype.makeOrdersPdf = function (account, filename) {
            var _this = this;
            var rawData = this.scope.selectedAccount.marketOrders;
            var data = this.getFormattedDataPdf(rawData);
            var asAtDateStr = moment(new Date()).format("D MMM YYYY");
            var startDate = moment(this.scope.startDate).format("D MMM YYYY");
            var endDate = moment(this.scope.endDate).format("D MMM YYYY");
            var timestamp = moment.tz(this.scope.generatedDate, 'Australia/Sydney').format("h:mm AEST a [on] D MMM YYYY");
            this.pdfBuilderService.newPdfBuilderInstance().then(function (pdfBuilder) {
                pdfBuilder
                    .setTitle('Market Orders')
                    .addHeaderTableRow('Adviser:', account.adviserName, '', '')
                    .addHeaderTableRow('Account:', account.accountId, '', '')
                    .addHeaderTableRow('From Date:', moment.tz(startDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addHeaderTableRow('To Date:', moment.tz(endDate, 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addHeaderTableRow('Report Generated at:', moment.tz(new Date(), 'Australia/Sydney').format('h:mm a [AEST on] D MMM YYYY'), '', '')
                    .addTable('Market Orders', data, _this.getRawHeader(), _this.getPdfHeader(), null, false)
                    .setFilename(filename)
                    .build();
            });
        };
        MarketOrdersCtrl.prototype.downloadPdf = function () {
            console.info('Download PDF');
            var fileName = this.getFileName();
            this.makeOrdersPdf(this.scope.selectedAccount, fileName);
        };
        MarketOrdersCtrl.prototype.getRawHeader = function () {
            return ["orderDate", "orderNumber", "orderStatus", "type", "quantity", "securityCode", "securityDescription", "limit", "quantityMatched", "quantityAllocated", "unfilled"]; //, "accountNumber", "adviserCode", "reportTitle", "dateRangeSelected"];
        };
        MarketOrdersCtrl.prototype.getPdfHeader = function () {
            /*return [
            { text: "Date", style: "tableHeader" },
            { text: "Order Number", style: "tableHeader" },
            { text: "Status", style: "tableHeader" },
            { text: "Type", style: "tableHeader" },
            { text: "Units", style: "tableHeader" },
            { text: "Security Code", style: "tableHeader" },
            { text: "Description", style: "tableHeader" },
            { text: "Limit", style: "tableHeader" },
            { text: "Matched", style: "tableHeader" },
            { text: "Allocated", style: "tableHeader" },
            { text: "Unbooked", style: "tableHeader" }
          ];*/
            return [
                "Date",
                "Order Number",
                "Status",
                "Type",
                "Units",
                "Security Code",
                "Description",
                "Limit",
                "Matched",
                "Allocated",
                "Unbooked"
            ];
        };
        MarketOrdersCtrl.prototype.getFileName = function () {
            var accountId = this.scope.selectedAccount.accountId;
            var startDate = moment(this.scope.startDate).format("YYYY-MM-DD");
            var endDate = moment(this.scope.endDate).format("YYYY-MM-DD");
            return accountId + "-MarketOrders-" + startDate + "_" + endDate;
        };
        MarketOrdersCtrl.prototype.getFormattedDataPdf = function (data) {
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            var filtered = this.scope.filter('dateFilter')(data, 'orderDate', startDate, endDate);
            var pdfData = angular.copy(filtered);
            pdfData.map(function (order) {
                delete order.id;
                delete order.investorPortfolioId;
                order.orderDate = moment(order.orderDate).format("DD-MM-YYYY");
            });
            return pdfData;
        };
        MarketOrdersCtrl.prototype.getFormattedData = function () {
            var data = this.scope.selectedAccount.marketOrders;
            var accountId = this.scope.selectedAccount.accountId;
            var accountName = this.scope.filter("accountName")(this.scope.selectedAccount.designation ? this.scope.selectedAccount.accountName + ' ' + this.scope.selectedAccount.designation : this.scope.selectedAccount.accountName);
            var adviserCode = this.scope.selectedAccount.adviserCode;
            var startDate = this.scope.startDate;
            var endDate = this.scope.endDate;
            this.scope.filename = this.getFileName();
            var filtered = this.scope.filter('dateFilter')(data, 'orderDate', startDate, endDate);
            var csvData = angular.copy(filtered);
            var fields = this.getFields();
            csvData.map(function (order) {
                delete order.id;
                delete order.investorPortfolioId;
                order.orderDate = moment(order.orderDate).format("YYYY-MM-DD");
                order.accountNumber = accountId;
                order.adviserCode = adviserCode;
                order.reportTitle = "Market Orders for " + accountName;
                order.dateRangeSelected = startDate + " to " + endDate;
                return fields.map(function (field) { return order[field]; });
            });
            return csvData;
        };
        MarketOrdersCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    _this.scope.isLoading = false;
                });
            });
        };
        MarketOrdersCtrl.prototype.loadMarketOrders = function (accountId, startDate, endDate) {
            var _this = this;
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            this.scope.startDate = startDate;
            this.scope.endDate = endDate;
            this.scope.generatedDate = new Date();
            this.scope.isError = false;
            this.scope.hasData = false;
            // Ensure the date range is inclusive
            this.scope.startDate.setHours(0, 0, 0, 0);
            this.scope.endDate.setHours(23, 59, 59, 0);
            this.scope.isLoading = true;
            this.scope.isDownloadReady = false;
            this.portfolioService.getMarketOrders(this.scope.selectedAccount.accountId)
                .then(function (result) {
                _this.scope.selectedAccount.marketOrders = result;
                _this.scope.isDownloadReady = true;
                _this.scope.isError = false;
                _this.scope.hasData = true;
            }, function (reason) {
                //this.scope.reportError = reason.data.message;
                _this.scope.selectedAccount.marketOrders = null;
                _this.scope.isDownloadReady = true;
                _this.scope.isError = true;
                _this.scope.hasData = false;
            })
                .finally(function () {
                _this.scope.isLoading = false;
            });
        };
        MarketOrdersCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$filter', 'portfolioService', 'navigationService', 'pdfBuilderService'];
        return MarketOrdersCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.MarketOrdersCtrl = MarketOrdersCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var MarketDepthCtrl = (function (_super) {
        __extends(MarketDepthCtrl, _super);
        function MarketDepthCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.scope.events = this;
            this.portfolioService = portfolioService;
        }
        MarketDepthCtrl.prototype.load = function () {
            var _this = this;
            if (this.scope.securityCode == null || this.scope.securityCode == "") {
                return;
            }
            this.scope.isLoading = true;
            this.portfolioService.getOrderDepthData(this.scope.securityCode)
                .then(function (result) {
                _this.scope.marketDepthInformation = result;
            }).finally(function () {
                _this.scope.isLoading = false;
            });
        };
        MarketDepthCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService', 'navigationService'];
        return MarketDepthCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.MarketDepthCtrl = MarketDepthCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class ReportViewCtrl extends AbstractController {
    var ReportViewCtrl = (function (_super) {
        __extends(ReportViewCtrl, _super);
        function ReportViewCtrl($q, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, portfolioService, reportService, reportDownloadService, bulkDownloadService, navigationService, userCompanyService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.renderReport = function () {
                var _this = this;
                this.scope.isRendering = true;
                this.scope.isDownloadReady = false;
                this.scope.isError = false;
                this.scope.hasData = false;
                this.scope.initialReportGenerated = true;
                this.scope.showNewReportBtn = true;
                if (this.scope.reportType === "TaxReports" || this.scope.reportType === "QuarterlyReports" || this.scope.reportType === "InvoiceReports") {
                    this.scope.hidePdf = true;
                    this.scope.hideCsv = true;
                }
                else {
                    this.scope.hidePdf = false;
                    this.scope.hideCsv = false;
                }
                this.reportService.getReport(this.scope.reportType, this.scope.selectedAccount.accountId, this.scope.startDate, this.scope.endDate)
                    .then(function (result) {
                    _this.scope.report = result;
                    _this.scope.generatedDateTime = moment.tz(_this.scope.report.creationDateUtc, 'Australia/Sydney').format('h:mm a');
                    _this.scope.generatedDate = moment(_this.scope.report.creationDateUtc).tz('Australia/Sydney').toDate();
                    _this.scope.isDownloadReady = true;
                    _this.scope.isError = false;
                    _this.scope.hasData = true;
                }, function (reason) {
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                })
                    .finally(function () {
                    _this.scope.reportStartDate = _this.scope.startDate;
                    _this.scope.reportEndDate = _this.scope.endDate;
                    _this.scope.isRendering = false;
                });
            };
            this.q = $q;
            this.scope = $scope;
            this.scope.events = this;
            this.portfolioService = portfolioService;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.bulkDownloadService = bulkDownloadService;
            this.scope.loaded = null;
            this.scope.accounts = new Array();
            this.scope.currentPage = this.state.current.name;
            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(1, 'year').toDate();
            this.scope.showNewReportBtn = true;
            this.scope.isError = false;
            this.scope.hasData = false;
            this.scope.searchtextRun = "Run another report";
            this.scope.searchtext = {
                open: "Run another report",
                close: "Hide report form"
            };
            this.scope.isPreselected = false;
            this.scope.collapsedBanner = false;
            if ($stateParams.hasAccoladeAccounts) {
                this.scope.hasAccoladeAccounts = $stateParams.hasAccoladeAccounts;
            }
            else {
                this.scope.hasAccoladeAccounts = null;
            }
            if ($stateParams.collapsedBanner == true) {
                this.scope.collapsedBanner = true;
                this.scope.loaded = true;
            }
            if (this.state.current.name == "report.tax") {
                this.scope.isPreselected = true;
                this.scope.reportType = "TaxReports";
            }
            else if (this.state.current.name == "report.quarterly") {
                this.scope.isPreselected = true;
                this.scope.reportType = "QuarterlyReports";
            }
            else if (this.state.current.name == "report.invoices") {
                this.scope.isPreselected = true;
                this.scope.reportType = "InvoiceReports";
            }
            if (this.scope.isPreselected) {
                this.scope.loaded = true;
                this.scope.collapsedBanner = true;
                this.scope.searchtextRun = "Run another search";
                this.scope.searchtext = {
                    open: "Run another search",
                    close: "Hide search form"
                };
            }
            this.scope.hideCsv = false;
            this.scope.hidePdf = false;
            if (!this.scope.loaded) {
                this.scope.loaded = false;
            }
            userCompanyService.getUserCompany().then(function (company) {
                _this.scope.userCompany = company;
            });
            this.load();
        }
        ReportViewCtrl.prototype.load = function () {
            var _this = this;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.loaded = true;
                _this.scope.$apply(function () {
                    _this.scope.accounts = result.filter(function (r) { return r.accountType == "Accolade"; });
                    _this.scope.hasAccoladeAccounts = _this.scope.accounts.some(function (a) { return a.isAccolade; });
                    if (_this.scope.isPreselected && !_this.scope.hasAccoladeAccounts) {
                        _this.scope.collapsedBanner = false;
                        _this.state.go('report');
                    }
                });
            });
        };
        ;
        ReportViewCtrl.prototype.setSelectedAccount = function (accountId) {
            this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
            console.info('selected account id: ' + this.scope.selectedAccount.accountId);
            this.scope.isError = false;
            console.log(this.scope.selectedAccount);
            this.scope.hasData = false;
        };
        ReportViewCtrl.prototype.toggleNewReportBtn = function () {
            this.scope.showNewReportBtn = !this.scope.showNewReportBtn;
        };
        ReportViewCtrl.prototype.setFromDate = function (fromDate) {
            this.scope.startDate = fromDate;
            console.info('from date: ' + this.scope.startDate);
        };
        ReportViewCtrl.prototype.setToDate = function (toDate) {
            this.scope.endDate = toDate;
            console.info('to date: ' + this.scope.endDate);
        };
        ReportViewCtrl.prototype.setReportType = function (reportType) {
            this.scope.reportType = reportType;
            console.info('report types: ' + this.scope.reportType);
            this.scope.isError = false;
            this.scope.hasData = false;
        };
        Object.defineProperty(ReportViewCtrl.prototype, "showFromDate", {
            get: function () {
                if (this.scope.reportType === Patersons.ReportType.UnrealisedCapitalGains.toString()) {
                    return false;
                }
                else if (this.scope.reportType === Patersons.ReportType.Valuation.toString()) {
                    return false;
                }
                else {
                    return true;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ReportViewCtrl.prototype, "toDateLabel", {
            get: function () {
                return this.showFromDate ? 'To:' : 'As at:';
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ReportViewCtrl.prototype, "dateRangeLabel", {
            get: function () {
                if (this.showFromDate) {
                    var fromDateString = moment(this.scope.report.dateFrom).format('D MMM YYYY');
                    var toDateString = moment(this.scope.report.dateTo).format('D MMM YYYY');
                    return "From " + fromDateString + " to " + toDateString;
                }
                else {
                    var asAtDateString = moment(this.scope.report.asAtDate).format('D MMM YYYY');
                    return "As at: " + asAtDateString;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(ReportViewCtrl.prototype, "areReportComponentsVisible", {
            get: function () {
                return this.scope.report != null && this.scope.report.reportType.toString() == this.scope.reportType;
            },
            enumerable: true,
            configurable: true
        });
        ReportViewCtrl.prototype.downloadPdf = function () {
            console.info('Download PDF');
            this.reportDownloadService.downloadPdfFile(this.scope.report, this.scope.selectedAccount);
        };
        ReportViewCtrl.prototype.downloadCsv = function () {
            console.info('Download CSV');
            this.reportDownloadService.downloadCsvFile(this.scope.report, this.scope.selectedAccount);
        };
        ReportViewCtrl.prototype.downloadInvestorDocuments = function (investorDocs) {
            var _this = this;
            if (investorDocs.length <= 0) {
                return;
            }
            this.scope.isDownloading = true;
            var filename = this.scope.selectedAccount.accountId + "-" + moment(new Date()).format("YYYY-MM-DD") + ".zip";
            this.bulkDownloadService.downloadItems(investorDocs, filename)
                .finally(function () {
                _this.scope.isDownloading = false;
            });
        };
        ReportViewCtrl.$inject = ['$q', '$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'portfolioService', 'reportService', 'reportDownloadService', 'bulkDownloadService', 'navigationService', 'userCompanyService'];
        return ReportViewCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.ReportViewCtrl = ReportViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    //export class LedgerViewCtrl extends AbstractController {
    var LedgerViewCtrl = (function (_super) {
        __extends(LedgerViewCtrl, _super);
        function LedgerViewCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, reportService, reportDownloadService, portfolioService, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.renderLedger = function (accountId, startDate, endDate) {
                var _this = this;
                this.scope.selectedAccount = this.scope.accounts.filter(function (a) { return a.accountId == accountId; })[0];
                this.scope.startDate = startDate;
                this.scope.endDate = endDate;
                this.scope.generatedDate = new Date();
                this.scope.isRendering = true;
                this.scope.isDownloadReady = false;
                this.scope.isError = false;
                this.scope.hasData = false;
                this.reportService.getReport(Patersons.ReportType.StandardLedger, this.scope.selectedAccount.accountId, this.scope.startDate, this.scope.endDate)
                    .then(function (result) {
                    _this.scope.report = result;
                    _this.scope.isDownloadReady = true;
                    _this.scope.isError = false;
                    _this.scope.hasData = true;
                }, function (reason) {
                    //this.scope.reportError = reason.data.message;
                    _this.scope.report = null;
                    _this.scope.isDownloadReady = true;
                    _this.scope.isError = true;
                    _this.scope.hasData = false;
                })
                    .finally(function () {
                    _this.scope.isRendering = false;
                });
            };
            this.getSummaryText = function () {
                var text = "Report generated at " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('h:mm a') +
                    " AEST on " +
                    moment.tz(this.scope.generatedDate, 'Australia/Sydney').format('D MMM YYYY') + ".";
                return text;
            };
            this.scope = $scope;
            this.scope.events = this;
            this.reportService = reportService;
            this.reportDownloadService = reportDownloadService;
            this.portfolioService = portfolioService;
            this.scope.isError = false;
            this.scope.hasData = false;
            this.load();
            this.scope.endDate = moment().toDate();
            this.scope.startDate = moment().subtract(30, 'days').toDate();
        }
        LedgerViewCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isRendering = true;
            this.portfolioService.getCombinedPortfolioData()
                .then(function (result) {
                _this.scope.$apply(function () {
                    _this.scope.accounts = result;
                    _this.scope.isRendering = false;
                });
            });
        };
        LedgerViewCtrl.prototype.downloadPdf = function () {
            console.info('Download PDF');
            this.reportDownloadService.downloadPdfFile(this.scope.report, this.scope.selectedAccount);
        };
        LedgerViewCtrl.prototype.downloadCsv = function () {
            console.info('Download CSV');
            this.reportDownloadService.downloadCsvFile(this.scope.report, this.scope.selectedAccount);
        };
        LedgerViewCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'reportService', 'reportDownloadService', 'portfolioService', 'navigationService'];
        return LedgerViewCtrl;
    }(Patersons.PortfolioBaseCtrl));
    Patersons.LedgerViewCtrl = LedgerViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var XrayCtrl = (function (_super) {
        __extends(XrayCtrl, _super);
        function XrayCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.load();
        }
        XrayCtrl.prototype.load = function () {
            this.log.info("Xray Ctrl loading...");
            var portfolio_xray = {
                name: 'demo portfolio 1',
                totalValue: 10000,
                currencyId: 'USD',
                holdings: [{
                        identifier: 'AU000000SFY4',
                        identifierType: 'ISIN',
                        weight: 50
                    }, {
                        identifier: 'AU000000VAP7',
                        identifierType: 'ISIN',
                        weight: 30
                    }, {
                        identifier: 'AU000000BHP4',
                        identifierType: 'ISIN',
                        weight: 10
                    }, {
                        identifier: 'AU60PLA00028',
                        identifierType: 'ISIN',
                        weight: 10
                    }],
                benchmark: {
                    holdings: [{
                            identifier: 'XIUSA04GJ2',
                            identifierType: 'MSID',
                            weight: 100
                        }]
                }
            };
            rootMorningstarPromise().then(function (promiseChain) {
                console.log("initializing component");
                initComponent('component-xray', 'ec-xray-container', 'ec-xray', 'ecXrayPats').then(function () {
                    morningstar.asterix.instanceRegistry.get('ecXrayPats').setParameter('portfolio', portfolio_xray);
                });
            });
        };
        XrayCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];
        return XrayCtrl;
    }(Patersons.AbstractController));
    Patersons.XrayCtrl = XrayCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var UATPortfolioCompareCtrl = (function (_super) {
        __extends(UATPortfolioCompareCtrl, _super);
        function UATPortfolioCompareCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, $timeout) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.scope = $scope;
            this.load();
        }
        UATPortfolioCompareCtrl.prototype.load = function () {
            this.log.info("UATPortfolioCompare Ctrl loading...");
            var portfolioDemo = {
                "current": {
                    "name": "demo portfolio 1",
                    "totalValue": 10000,
                    "currencyId": "AUD",
                    "holdings": [
                        {
                            "identifier": "AU000000SFY4",
                            "identifierType": "ISIN",
                            "weight": 50
                        },
                        {
                            "identifier": "AU000000VAP7",
                            "identifierType": "ISIN",
                            "weight": 50
                        }
                    ],
                    "benchmark": {
                        "holdings": [
                            {
                                "identifier": "XIUSA04GJ2",
                                "identifierType": "MSID",
                                "weight": 100
                            }
                        ]
                    }
                },
                "proposed": {
                    "name": "demo portfolio 2",
                    "totalValue": 10000,
                    "currencyId": "AUD",
                    "holdings": [
                        {
                            "identifier": "AU000000SFY4",
                            "identifierType": "ISIN",
                            "weight": 50
                        },
                        {
                            "identifier": "AU000000VAP7",
                            "identifierType": "ISIN",
                            "weight": 30
                        },
                        {
                            "identifier": "AU000000BHP4",
                            "identifierType": "ISIN",
                            "weight": 10
                        },
                        {
                            "identifier": "AU60PLA00028",
                            "identifierType": "ISIN",
                            "weight": 10
                        }
                    ],
                    "benchmark": {
                        "holdings": [
                            {
                                "identifier": "XIUSA04GJ2",
                                "identifierType": "MSID",
                                "weight": 100
                            }
                        ]
                    }
                }
            };
            rootMorningstarPromise().then(function (promiseChain) {
                console.log("initializing component");
                initComponent('component-container', 'ec-portfolio-compare-container', 'ec-portfolio-compare', 'ecPortfolioCompare').then(function () {
                    morningstar.asterix.instanceRegistry.find("ecPortfolioCompare").setParameter("portfolio", portfolioDemo);
                });
            });
        };
        UATPortfolioCompareCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', '$timeout'];
        return UATPortfolioCompareCtrl;
    }(Patersons.AbstractController));
    Patersons.UATPortfolioCompareCtrl = UATPortfolioCompareCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var portfolioModule = angular.module("app.portfolioModule", []);
portfolioModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.portfolioModule config...');
        $stateProvider
            .state("dashboard", {
            url: "/dashboard",
            templateUrl: "assets/templates/portfolioSummary/dashboard.html",
            controller: 'portfolioDashboardCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Dashboard" };
                    }],
            }
        })
            .state("portfolioHeatmap", {
            url: "/portfolioHeatmap",
            templateUrl: "assets/templates/portfolioSummary/portfolioHeatmap.html",
            controller: 'portfolioHeatmapCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Heatmap" };
                    }],
            }
        })
            .state("portfolioSnapshot", {
            url: "/portfolioSnapshot",
            templateUrl: "assets/templates/portfolioSummary/portfolioSnapshot.html",
            controller: 'portfolioSnapshotCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Snapshot" };
                    }],
            }
        })
            .state("viewPortfolio", {
            url: "/portfolioOverview?accountId",
            templateUrl: "assets/templates/PortfolioSummary/portfolioOverview.html",
            controller: 'portfolioViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Portfolio Overview" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("comparePortfolios", {
            url: "/comparePortfolios",
            templateUrl: "assets/templates/PortfolioSummary/compare.html",
            controller: 'portfolioCompareCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Portfolio Compare" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("stockReport", {
            url: "/stockReport?secId",
            templateUrl: "assets/templates/PortfolioSummary/stockReport.html",
            controller: 'stockReportCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Stock Report" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("fundReport", {
            url: "/fundReport?secId",
            templateUrl: "assets/templates/PortfolioSummary/fundReport.html",
            controller: 'fundReportCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Fund Report" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("etfReport", {
            url: "/etfReport?secId",
            templateUrl: "assets/templates/PortfolioSummary/etfReport.html",
            controller: 'etfReportCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "ETF Report" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("holdings", {
            url: "/holdings",
            templateUrl: "assets/templates/PortfolioSummary/holdings.html",
            controller: 'holdingsCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Holdings" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            },
            params: {
                accountId: null,
                autoDownloadPDF: null,
                asAt: null
            }
        })
            .state('incomeProjection', {
            url: '/incomeProjection',
            templateUrl: 'assets/templates/PortfolioSummary/IncomeProjection.html'
        })
            .state('confirmationNotes', {
            url: '/confirmationNotes',
            templateUrl: 'assets/templates/portfolioSummary/confirmationNotes.html',
            controller: "confirmationNotesCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Confirmation Notes" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state('marketOrders', {
            url: '/marketOrders',
            templateUrl: 'assets/templates/PortfolioSummary/marketOrders.html',
            controller: "marketOrdersCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Market Orders" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("placeOrderRequest", {
            url: "/placeOrderRequest",
            templateUrl: "assets/templates/portfolioSummary/placeOrderRequest.html",
            controller: "placeOrderRequestViewCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Place Order Request" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("viewOrderRequests", {
            url: "/viewOrderRequests",
            templateUrl: "assets/templates/portfolioSummary/viewOrderRequests.html",
            controller: "viewOrderRequestsViewCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "View Order Requests" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("report", {
            url: "/report",
            templateUrl: "assets/templates/portfolioSummary/reports.html",
            controller: 'reportViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Accolade Reports" };
                    }],
            },
            params: {
                hasAccoladeAccounts: null,
                collapsedBanner: null,
            },
        })
            .state("report.quarterly", {
            url: "/quarterly",
            templateUrl: "assets/templates/portfolioSummary/reports.html",
            controller: 'reportViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Accolade Quarterly Reports" };
                    }],
            },
            params: {
                hasAccoladeAccounts: null,
            },
        })
            .state("report.tax", {
            url: "/tax",
            templateUrl: "assets/templates/portfolioSummary/reports.html",
            controller: 'reportViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Accolade Tax Reports" };
                    }],
            },
            params: {
                hasAccoladeAccounts: null,
            },
        })
            .state("report.invoices", {
            url: "/invoices",
            templateUrl: "assets/templates/portfolioSummary/reports.html",
            controller: 'reportViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Accolade Invoices" };
                    }],
            },
            params: {
                hasAccoladeAccounts: null,
            },
        })
            .state("marketDepth", {
            url: "/marketDepth",
            templateUrl: "assets/templates/portfolioSummary/marketDepth.html",
            controller: 'marketDepthCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Market Depth" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("ledger", {
            url: "/ledger",
            templateUrl: "assets/templates/portfolioSummary/ledger.html",
            controller: "ledgerViewCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Ledger" };
                    }],
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("uatxray", {
            url: "/uatxray",
            templateUrl: "assets/templates/portfolioSummary/uat_xray.html",
            controller: "xrayCtrl",
            resolve: {
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state("uatportfoliocompare", {
            url: "/uatportfoliocompare",
            templateUrl: "assets/templates/portfolioSummary/uat_portfolioCompare.html",
            controller: "uatPortfolioCompareCtrl",
            resolve: {
                checkUserProfile: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        var profile = sessionService.getCurrentUserProfile();
                        if (profile) {
                            deferred.resolve();
                        }
                        else {
                            deferred.reject();
                        }
                        return deferred.promise;
                    }]
            }
        });
    }]);
portfolioModule.controller('portfolioBaseCtrl', Patersons.PortfolioBaseCtrl);
portfolioModule.controller('portfolioDashboardCtrl', Patersons.PortfolioDashboardCtrl);
portfolioModule.controller('portfolioHeatmapCtrl', Patersons.PortfolioHeatmapCtrl);
portfolioModule.controller('portfolioSnapshotCtrl', Patersons.PortfolioSnapshotCtrl);
portfolioModule.controller('portfolioViewCtrl', Patersons.PortfolioViewCtrl);
portfolioModule.controller('portfolioCompareCtrl', Patersons.PortfolioCompareCtrl);
portfolioModule.controller('stockReportCtrl', Patersons.StockReportCtrl);
portfolioModule.controller('fundReportCtrl', Patersons.FundReportCtrl);
portfolioModule.controller('etfReportCtrl', Patersons.EtfReportCtrl);
portfolioModule.controller('holdingsCtrl', Patersons.HoldingsCtrl);
portfolioModule.controller('confirmationNotesCtrl', Patersons.ConfirmationNotesCtrl);
portfolioModule.controller('marketOrdersCtrl', Patersons.MarketOrdersCtrl);
portfolioModule.controller('placeOrderRequestViewCtrl', Patersons.PlaceOrderRequestViewCtrl);
portfolioModule.controller('viewOrderRequestsViewCtrl', Patersons.ViewOrderRequestsViewCtrl);
portfolioModule.controller('reportViewCtrl', Patersons.ReportViewCtrl);
portfolioModule.controller('ledgerViewCtrl', Patersons.LedgerViewCtrl);
portfolioModule.controller('marketDepthCtrl', Patersons.MarketDepthCtrl);
portfolioModule.controller('xrayCtrl', Patersons.XrayCtrl);
portfolioModule.controller('uatPortfolioCompareCtrl', Patersons.UATPortfolioCompareCtrl);
portfolioModule.component('investorDocs', new Patersons.InvestorDocsComponent());
portfolioModule.component('reportTypeSelect', new Patersons.ReportTypeSelectComponent());
portfolioModule.component('accountDateRangeFilter', new Patersons.AccountDateRangeFilterComponent());
portfolioModule.component('portfolioSummary', new Patersons.PortfolioSummaryComponent());
portfolioModule.component('incomeReport', new Patersons.IncomeReportComponent());
portfolioModule.component('cashReport', new Patersons.CashReportComponent());
portfolioModule.component('capitalTransactionStatement', new Patersons.CapitalTransactionStatementComponent());
portfolioModule.component('standardLedgerReport', new Patersons.StandardLedgerReportComponent());
portfolioModule.component('performanceReport', new Patersons.PerformanceReportComponent());
portfolioModule.component('portfolioGraph', new Patersons.PortfolioGraphComponent());
portfolioModule.component('realisedCapitalGainsReport', new Patersons.RealisedCapitalGainsReportComponent());
portfolioModule.component('unrealisedCapitalGainsReport', new Patersons.UnrealisedCapitalGainsReportComponent());
portfolioModule.component('valuationReport', new Patersons.ValuationStatementComponent());
portfolioModule.component('marketValueReport', new Patersons.MarketValueReportComponent());
portfolioModule.component('reportDisclaimer', new Patersons.ReportDisclaimerComponent());
portfolioModule.component('holdingsDisclaimer', new Patersons.HoldingsDisclaimerComponent());
portfolioModule.component('cashHoldingsReport', new Patersons.CashHoldingsReportComponent());
portfolioModule.component('cashHighInterestHoldingsReport', new Patersons.CashHighInterestHoldingsReportComponent());
portfolioModule.component('termDepositsHoldingsReport', new Patersons.TermDepositsHoldingsReportComponent());
portfolioModule.component('equityHoldingsReport', new Patersons.EquityHoldingsReportComponent());
portfolioModule.component('totalMarketValue', new Patersons.TotalMarketValueComponent());
portfolioModule.component('portfolioNavigation', new Patersons.PortfolioNavigationComponent());

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ChangeRequestBaseCtrl = (function (_super) {
        __extends(ChangeRequestBaseCtrl, _super);
        function ChangeRequestBaseCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope);
            this.navigationService = navigationService;
            this.navigationService.deactivateAll();
        }
        ChangeRequestBaseCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'navigationService'];
        return ChangeRequestBaseCtrl;
    }(Patersons.AbstractController));
    Patersons.ChangeRequestBaseCtrl = ChangeRequestBaseCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ChangeRequestViewCtrl = (function (_super) {
        __extends(ChangeRequestViewCtrl, _super);
        function ChangeRequestViewCtrl($scope, $uibModal, $log, $location, $window, $state, $stateParams, $http, $rootScope, changeRequestService, tokenService, navigationService, identityService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.rootScope = $rootScope;
            this.changeRequestService = changeRequestService;
            this.tokenService = tokenService;
            this.identityService = identityService;
            this.scope.events = this;
            this.scope.currentIndex = 0;
            this.scope.isBusy = false;
            this.modal = $uibModal;
            this.load();
        }
        ChangeRequestViewCtrl.prototype.load = function () {
            var _this = this;
            this.scope.isLoading = true;
            this.scope.hasChangeRequests = false;
            this.changeRequestService.getChangeRequestsForApproval()
                .then(function (result) {
                _this.scope.changeRequests = result;
                if (_this.scope.changeRequests && _this.scope.changeRequests.length > 0) {
                    _this.scope.hasChangeRequests = true;
                }
                else {
                    return;
                }
                _this.setCurrentChangeRequest(0);
            }, function (error) {
                _this.scope.isError = true;
                _this.scope.isLoading = false;
            }).finally(function () {
                _this.scope.isLoading = false;
            });
        };
        ChangeRequestViewCtrl.prototype.goToPreviousChangeRequest = function () {
            this.scope.currentIndex -= 1;
            if (this.scope.currentIndex < 0) {
                this.scope.currentIndex = 0;
                ;
            }
            this.setCurrentChangeRequest(this.scope.currentIndex);
        };
        ChangeRequestViewCtrl.prototype.goToNextChangeRequest = function () {
            this.scope.currentIndex += 1;
            if (this.scope.currentIndex >= this.scope.changeRequests.length) {
                this.scope.currentIndex = this.scope.changeRequests.length - 1;
            }
            this.setCurrentChangeRequest(this.scope.currentIndex);
        };
        ChangeRequestViewCtrl.prototype.approveChangeRequest = function () {
            var _this = this;
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.identityService.getIsPhoneNumberVerifyed().
                then(function (phone_number_verified) {
                if (phone_number_verified !== true) {
                    _this.scope.submissionFailedVerifyPhoneNumber = true;
                    return;
                }
                var modalPopup = _this.modal.open({
                    templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
                    controller: Patersons.ApproveChangeRequestCtrl,
                    keyboard: false,
                    backdrop: 'static',
                    resolve: {
                        changeRequestId: _this.scope.currentChangeRequest.id
                    }
                });
                modalPopup.result
                    .then(function (result) {
                    if (result === true) {
                        _this.scope.currentChangeRequest.isApproved = true;
                        _this.setApprovalStatusDescription(_this.scope.currentChangeRequest);
                        _this.rootScope.$emit('changeRequestActioned', null);
                    }
                }, function (error) {
                    _this.scope.isError = true;
                    _this.scope.isLoading = false;
                });
            });
            /*if (this.tokenService.tokenManager.profile.phone_number_verified !== 'true') {
              this.scope.submissionFailedVerifyPhoneNumber = true;
              return;
            }
      
            var modalPopup = this.modal.open({
              templateUrl: 'assets/templates/common/twoFactorAuthentication.html',
              controller: ApproveChangeRequestCtrl,
              keyboard: false,
              backdrop: 'static',
              resolve: {
                changeRequestId: this.scope.currentChangeRequest.id
              }
            });
      
            modalPopup.result
              .then((result) => {
                if (result === true) {
                  this.scope.currentChangeRequest.isApproved = true;
                  this.setApprovalStatusDescription(this.scope.currentChangeRequest);
                  this.rootScope.$emit('changeRequestActioned', null);
                }
              }, (error) => { // error handling
                this.scope.isError = true;
                this.scope.isLoading = false;
              });*/
        };
        ChangeRequestViewCtrl.prototype.rejectChangeRequest = function () {
            var _this = this;
            this.scope.isBusy = true;
            this.scope.currentChangeRequest.isRejected = true;
            this.setApprovalStatusDescription(this.scope.currentChangeRequest);
            this.changeRequestService.rejectChangeRequest(this.scope.currentChangeRequest.id)
                .then(function (result) {
                _this.rootScope.$emit('changeRequestActioned', null);
            }, function (error) {
                _this.scope.isError = true;
                _this.scope.isLoading = false;
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        ChangeRequestViewCtrl.prototype.setCurrentChangeRequest = function (index) {
            this.scope.submissionFailedVerifyPhoneNumber = false;
            this.scope.currentChangeRequest = this.scope.changeRequests[index];
            this.setChangeRequestTypeDescription(this.scope.currentChangeRequest);
            this.setApprovalStatusDescription(this.scope.currentChangeRequest);
            this.constructOriginalDataObject(this.scope.currentChangeRequest);
            this.constructModifiedDataObject(this.scope.currentChangeRequest);
        };
        ChangeRequestViewCtrl.prototype.constructOriginalDataObject = function (changeRequest) {
            this.scope.originalData = null;
            this.scope.originalDataKeys = null;
            if (changeRequest.originalData === null) {
                return;
            }
            this.scope.originalData = JSON.parse(changeRequest.originalData);
            this.scope.originalDataKeys = Object.keys(this.scope.originalData);
        };
        ChangeRequestViewCtrl.prototype.constructModifiedDataObject = function (changeRequest) {
            this.scope.modifiedData = null;
            this.scope.modifiedDataKeys = null;
            if (changeRequest.modifiedData === null) {
                return;
            }
            this.scope.modifiedData = JSON.parse(changeRequest.modifiedData);
            this.scope.modifiedDataKeys = Object.keys(this.scope.modifiedData);
        };
        ChangeRequestViewCtrl.prototype.setApprovalStatusDescription = function (changeRequest) {
            if (changeRequest.isApproved) {
                changeRequest.approvalStatusDescription = 'Approved';
            }
            else if (changeRequest.isRejected) {
                changeRequest.approvalStatusDescription = 'Rejected';
            }
            else {
                changeRequest.approvalStatusDescription = 'Pending';
            }
        };
        ChangeRequestViewCtrl.prototype.setChangeRequestTypeDescription = function (changeRequest) {
            switch (changeRequest.changeRequestType) {
                case 'AccoladeOptions':
                    changeRequest.changeRequestTypeDescription = 'Accolade Options';
                    break;
                case 'AddressDetails':
                    changeRequest.changeRequestTypeDescription = 'Address Details';
                    break;
                case 'RegistrationAddressDetails':
                    changeRequest.changeRequestTypeDescription = 'Registration Address Details';
                    break;
                case 'AccountEmailAddress':
                    changeRequest.changeRequestTypeDescription = 'Account Email Address';
                    break;
                case 'ContractNoteEmailAddress':
                    changeRequest.changeRequestTypeDescription = 'Contract Note Email Address';
                    break;
                case 'PhoneNumbers':
                    changeRequest.changeRequestTypeDescription = 'Phone Numbers';
                    break;
                case 'BankAccountDetails':
                    changeRequest.changeRequestTypeDescription = 'Bank Account Details';
                    break;
                case 'TaxFileNumber':
                    changeRequest.changeRequestTypeDescription = 'Tax File Number';
                    break;
                default:
                    changeRequest.changeRequestTypeDescription = changeRequest.changeRequestType;
            }
        };
        ChangeRequestViewCtrl.$inject = ['$scope', '$uibModal', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'changeRequestService', 'tokenService', 'navigationService', 'identityService'];
        return ChangeRequestViewCtrl;
    }(Patersons.ChangeRequestBaseCtrl));
    Patersons.ChangeRequestViewCtrl = ChangeRequestViewCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var changeRequestModule = angular.module("app.changeRequestModule", []);
changeRequestModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.changeRequestModule config...');
        $stateProvider
            .state("changeRequests", {
            url: "/changeRequests",
            templateUrl: "assets/templates/changeRequests/changeRequest.html",
            controller: 'changeRequestViewCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Account Information Change Requests" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        });
    }]);
changeRequestModule.controller('changeRequestBaseCtrl', Patersons.ChangeRequestBaseCtrl);
changeRequestModule.controller('changeRequestViewCtrl', Patersons.ChangeRequestViewCtrl);

'use strict';
var Patersons;
(function (Patersons) {
    var VerifyPhoneCtrl = (function () {
        function VerifyPhoneCtrl($scope, $location, $window, $state, $stateParams, $http, identityService) {
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.scope.events = this;
            var userId = $stateParams.userId;
        }
        VerifyPhoneCtrl.prototype.save = function () {
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.phoneForm.$invalid) {
                return;
            }
            alert('checking phone...');
        };
        VerifyPhoneCtrl.$inject = ['$scope', '$location', '$window', '$state', '$stateParams', '$http', 'identityService'];
        return VerifyPhoneCtrl;
    }());
    Patersons.VerifyPhoneCtrl = VerifyPhoneCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ChangePasswordCtrl = (function (_super) {
        __extends(ChangePasswordCtrl, _super);
        function ChangePasswordCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, navigationService) {
            var _this = this;
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.onValidation = function (isValid) {
                if (_this.scope) {
                    _this.scope.isValidPassword = isValid;
                }
            };
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.scope.events = this;
            this.scope.passwordInputType = "password";
            this.scope.isBusy = false;
            this.scope.changePasswordDetails = new Patersons.ChangePasswordDetails;
        }
        ChangePasswordCtrl.prototype.togglePasswordVisibility = function () {
            if (this.scope.passwordInputType === "password") {
                this.scope.passwordInputType = "text";
            }
            else {
                this.scope.passwordInputType = "password";
            }
        };
        ChangePasswordCtrl.prototype.changePassword = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.changePasswordForm.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.identityService.changePassword(this.scope.changePasswordDetails)
                .then(function (result) {
                location.href = '/dashboard';
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        ChangePasswordCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'navigationService'];
        return ChangePasswordCtrl;
    }(Patersons.IdentityBaseCtrl));
    Patersons.ChangePasswordCtrl = ChangePasswordCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var Patersons;
(function (Patersons) {
    var ChangeEmailCtrl = (function (_super) {
        __extends(ChangeEmailCtrl, _super);
        function ChangeEmailCtrl($scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, identityService, navigationService, tokenService, sessionService) {
            _super.call(this, $scope, $log, $location, $window, $state, $stateParams, $http, $rootScope, navigationService);
            this.scope = $scope;
            this.location = $location;
            this.window = $window;
            this.state = $state;
            this.stateParams = $stateParams;
            this.http = $http;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.scope.profile = this.tokenService.tokenManager.profile;
            if (!this.scope.profile) {
                window.localStorage.setItem('$psl.redirect_uri', window.location.href);
                this.tokenService.tokenManager.redirectForToken();
            }
            this.scope.events = this;
            this.scope.isBusy = false;
            this.scope.emailChanged = false;
            this.scope.profileAddressDetails = new Patersons.ProfileAddress;
            this.scope.changeEmailForm = { form: null };
            this.scope.changeEmailDetails = new Patersons.ChangeEmailDetails;
            this.scope.changeEmailDetails.newEmail = this.scope.profile.email;
            this.load();
        }
        ChangeEmailCtrl.prototype.load = function () {
            var _this = this;
            var promise = this.identityService.getUserAddressDetails();
            promise.then(function (result) {
                _this.scope.profileAddressDetails.addressLine1 = result["addressLine1"];
                _this.scope.profileAddressDetails.addressLine2 = result["addressLine2"];
                _this.scope.profileAddressDetails.addressLine3 = result["addressLine3"];
                _this.scope.profileAddressDetails.addressLine4 = result["addressLine4"];
                _this.scope.profileAddressDetails.postcode = result["postcode"];
                _this.scope.profileAddressDetails.country = result["country"];
                console.log(_this.scope.profileAddressDetails);
            });
        };
        ChangeEmailCtrl.prototype.changeEmail = function () {
            var _this = this;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.changeEmailForm.form.$invalid) {
                return;
            }
            this.scope.isBusy = true;
            this.identityService.changeEmail(this.scope.changeEmailDetails)
                .then(function (result) {
                _this.scope.emailChanged = true;
                setTimeout(function () {
                    _this.tokenService.tokenManager.redirectForToken();
                }, 2000);
            }, function (reason) {
                _this.scope.errorHandler = reason.data;
            })
                .finally(function () {
                _this.scope.isBusy = false;
            });
        };
        ChangeEmailCtrl.$inject = ['$scope', '$log', '$location', '$window', '$state', '$stateParams', '$http', '$rootScope', 'identityService', 'navigationService', 'tokenService', 'sessionService'];
        return ChangeEmailCtrl;
    }(Patersons.IdentityBaseCtrl));
    Patersons.ChangeEmailCtrl = ChangeEmailCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var Patersons;
(function (Patersons) {
    var SetPasswordCtrl = (function () {
        function SetPasswordCtrl($scope, identityService, tokenService) {
            var _this = this;
            this.onValidation = function (isValid) {
                if (_this.scope) {
                    _this.scope.isValidPassword = isValid;
                }
            };
            this.scope = $scope;
            this.identityService = identityService;
            this.tokenService = tokenService;
            this.scope.events = this;
            this.scope.isSubmitted = false;
            this.scope.isSuccess = false;
            this.scope.passwordInputType = "password";
            this.scope.setPasswordDetails = new Patersons.SetPasswordDetails();
        }
        SetPasswordCtrl.prototype.togglePasswordVisibility = function () {
            if (this.scope.passwordInputType === "password") {
                this.scope.passwordInputType = "text";
            }
            else {
                this.scope.passwordInputType = "password";
            }
        };
        SetPasswordCtrl.prototype.save = function () {
            var _this = this;
            this.scope.errorHandler = null;
            this.scope.isSubmitted = true;
            this.scope.$broadcast('show-errors-check-validity');
            if (this.scope.setPasswordForm.$invalid) {
                return;
            }
            this.scope.isLoading = true;
            this.identityService.setPassword(this.scope.setPasswordDetails)
                .then(function (result) {
                _this.scope.isSuccess = true;
                _this.sleep(2000).then(function () {
                    _this.tokenService.tokenManager.redirectForToken();
                });
            }, function (response) {
                _this.scope.isSuccess = false;
                _this.scope.errorHandler = response.data;
            }).finally(function () {
                _this.scope.isLoading = false;
            });
        };
        SetPasswordCtrl.prototype.sleep = function (time) {
            return new Promise(function (resolve) { return setTimeout(resolve, time); });
        };
        SetPasswordCtrl.$inject = ['$scope', 'identityService', 'tokenService'];
        return SetPasswordCtrl;
    }());
    Patersons.SetPasswordCtrl = SetPasswordCtrl;
})(Patersons || (Patersons = {}));

'use strict';
var identityModule = angular.module("app.identityModule", []);
identityModule.config(["$stateProvider", "$locationProvider",
    function ($stateProvider, $locationProvider) {
        console.log('app.identityModule config...');
        $stateProvider
            .state('forgottenPan', {
            url: '/forgottenPan',
            templateUrl: 'assets/templates/identity/forgottenPan.html',
            controller: "forgottenPanCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Forgotten Pan" };
                    }],
            }
        })
            .state('forgottenPassword', {
            url: '/forgottenPassword',
            templateUrl: 'assets/templates/identity/forgottenPassword.html',
            controller: "forgottenPasswordCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Forgotten Password" };
                    }],
            }
        })
            .state('changeMobile', {
            url: '/changeMobile',
            templateUrl: 'assets/templates/identity/changeMobile.html',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Change Mobile" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state('registerMobile', {
            url: '/registerMobile',
            templateUrl: 'assets/templates/identity/registerMobile.html',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Register Mobile" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state('changePassword', {
            url: '/changePassword',
            templateUrl: 'assets/templates/identity/changePassword.html',
            controller: "changePasswordCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Change Password" };
                    }],
            }
        })
            .state('changeEmail', {
            url: '/changeEmail',
            templateUrl: 'assets/templates/identity/changeEmail.html',
            controller: "changeEmailCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Update User Profile" };
                    }],
            }
        })
            .state('verifyPhone', {
            url: '/verifyPhone?userId',
            templateUrl: 'assets/templates/identity/verifyPhone.html',
            controller: "verifyPhoneCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Verify Phone" };
                    }],
                impersonatorCheck: ['sessionService', '$q', '$state', function (sessionService, $q, $state) {
                        var deferred = $q.defer();
                        if (sessionService.getCurrentUserProfile().impersonator === 'True') {
                            $state.go('dashboard');
                            deferred.reject();
                        }
                        else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    }]
            }
        })
            .state('confirmPassword', {
            url: '/confirmPassword',
            templateUrl: 'assets/templates/identity/confirmPassword.html',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Confirm Password" };
                    }],
            }
        })
            .state('callbackAction', {
            url: '/callback/:response',
            templateUrl: 'assets/templates/common/loading.html',
            controller: 'identityCallbackCtrl'
        })
            .state('setPassword', {
            url: '/setPassword',
            templateUrl: 'assets/templates/identity/setPassword.html',
            controller: 'setPasswordCtrl',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Set Password" };
                    }],
            }
        });
    }]);
identityModule.controller('IdentityBaseCtrl', Patersons.IdentityBaseCtrl);
identityModule.controller('identityCallbackCtrl', Patersons.CallbackCtrl);
identityModule.controller('verifyPhoneCtrl', Patersons.VerifyPhoneCtrl);
identityModule.controller('changePhoneCtrl', Patersons.ChangePhoneCtrl);
identityModule.controller('forgottenPanCtrl', Patersons.ForgottenPanCtrl);
identityModule.controller('forgottenPasswordCtrl', Patersons.ForgottenPasswordCtrl);
identityModule.controller('changePasswordCtrl', Patersons.ChangePasswordCtrl);
identityModule.controller('changeEmailCtrl', Patersons.ChangeEmailCtrl);
identityModule.controller('setPasswordCtrl', Patersons.SetPasswordCtrl);

"use strict";
var controllerModule = angular.module("app.controllers", ["ui.bootstrap"]);
controllerModule.controller('navbarCtrl', Patersons.NavbarCtrl);
controllerModule.controller('footerCtrl', Patersons.FooterCtrl);
controllerModule.controller('abstractController', Patersons.AbstractController);
controllerModule.controller('clientAdviserViewCtrl', Patersons.ClientAdviserViewCtrl);
controllerModule.controller('helpViewCtrl', Patersons.HelpViewCtrl);
controllerModule.controller('landingCtrl', Patersons.LandingCtrl);

"use strict";
var compareTo = function () {
    return {
        require: "ngModel",
        scope: {
            otherModelValue: "=compareTo"
        },
        link: function (scope, element, attributes, ngModel) {
            ngModel.$validators.compareTo = function (modelValue) {
                return modelValue == scope.otherModelValue;
            };
            scope.$watch("otherModelValue", function () {
                ngModel.$validate();
            });
        }
    };
};
var appDirectives = angular.module("app.directives", []);
appDirectives.config(function () {
    var model = document.getElementById("model").textContent.trim();
    var dictionary = JSON.parse(model);
    for (var key in dictionary) {
        module.constant(key, dictionary[key]);
    }
});
appDirectives.directive("appVersion", function () {
    var model = document.getElementById("model").textContent.trim();
    var dictionary = JSON.parse(model);
    var version = dictionary['websiteVersionNumber'];
    return {
        template: 'Version: ' + version
    };
});
appDirectives.directive("compareTo", compareTo);
appDirectives.directive('showErrors', function () {
    return {
        restrict: 'A',
        require: '^form',
        link: function (scope, el, attrs, formCtrl) {
            // find the text box element, which has the 'name' attribute
            var inputEl = el[0].querySelector("[name]");
            // convert the native text box element to an angular element
            var inputNgEl = angular.element(inputEl);
            // get the name on the text box so we know the property to check
            // on the form controller
            var inputName = inputNgEl.attr('name');
            // only apply the has-error class after the user leaves the text box
            inputNgEl.bind('blur', function () {
                el.toggleClass('has-error', formCtrl[inputName].$invalid);
            });
        }
    };
});
appDirectives.directive('addressForm', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/accountDetails/addressForm.html',
        scope: {
            addressTitle: '@',
            address: '=',
            selectedAccount: '<',
            mailAddressForm: '=',
            isDisabled: '<'
        }
    };
});
// Note: rendered as <market-depth-form></market-depth-form>
appDirectives.directive('marketDepthForm', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/portfolioSummary/components/marketDepth.component.html'
    };
});
appDirectives.directive('holdingsSummary', function () {
    return {
        restrict: 'E',
        templateUrl: 'assets/templates/portfolioSummary/holdingsSummary.html',
    };
});
appDirectives.directive('marketOrdersSummary', function () {
    return {
        restrict: 'E',
        controller: Patersons.MarketOrdersCtrl,
        templateUrl: 'assets/templates/portfolioSummary/marketOrdersSummary.html'
    };
});
appDirectives.directive('errSrc', function () {
    return {
        link: function (scope, element, attrs) {
            element.bind('error', function () {
                if (attrs.src != attrs.errSrc) {
                    attrs.$set('src', attrs.errSrc);
                }
            });
            attrs.$observe('ngSrc', function (value) {
                if (!value && attrs.errSrc) {
                    attrs.$set('src', attrs.errSrc);
                }
            });
        }
    };
});
appDirectives.directive("isNotDuplicate", ["$q", function ($q) {
        return {
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$asyncValidators.isNotDuplicate = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(viewValue)) {
                        return $q.resolve();
                    }
                    var existing = attrs.isNotDuplicate.split("|");
                    var def = $q.defer();
                    if (existing.indexOf(viewValue.toLowerCase()) === -1) {
                        def.resolve();
                    }
                    else {
                        def.reject();
                    }
                    return def.promise;
                };
            }
        };
    }]);
appDirectives.directive("dateFormat", ["$q", function ($q) {
        return {
            require: "ngModel",
            link: function (scope, elm, attrs, ctrl) {
                ctrl.$asyncValidators.dateFormat = function (modelValue, viewValue) {
                    if (ctrl.$isEmpty(viewValue)) {
                        return $q.resolve();
                    }
                    // Validate format against dd/dd/dddd
                    if (!/^\d\d\/\d\d\/\d\d\d\d$/.test(viewValue)) {
                        return $q.reject();
                    }
                    if (!moment(viewValue, "DD/MM/YYYY").isValid()) {
                        return $q.reject();
                    }
                    return $q.resolve();
                };
            }
        };
    }]);
appDirectives.directive('passwordMatch', ["$q", function ($q) {
        return {
            restrict: 'A',
            scope: true,
            require: 'ngModel',
            link: function (scope, elem, attrs, control) {
                var checker = function () {
                    //get the value of the first password
                    var e1 = scope.$eval(attrs.ngModel);
                    //get the value of the other password
                    var e2 = scope.$eval(attrs.passwordMatch);
                    return e1 == e2;
                };
                scope.$watch(checker, function (n) {
                    //set the form control to valid if both
                    //passwords are the same, else invalid
                    control.$setValidity("unique", n);
                    //attrs.passwordMatch.$setValidity("pattern", n);
                });
            }
        };
    }]);
var defaultTitle = '';
appDirectives.directive('pageTitle', ['$rootScope', '$interpolate', '$state', 'userCompanyService', function ($rootScope, $interpolate, $state, userCompanyService) {
        return {
            restrict: 'A',
            link: function (scope, element) {
                $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    //reset the meta data when a route changes - the document title should be updated by the resolve meta property on each state
                    $rootScope.meta = undefined;
                });
                $rootScope.$on('$stateChangeSuccess', function (event, toState) {
                    userCompanyService.getUserCompany().then(function (company) {
                        defaultTitle = company.companyName;
                        var separateBy = ' - ';
                        if ($rootScope.meta && $rootScope.meta.title) {
                            var stateTitle = $rootScope.meta.title;
                            element.html(stateTitle + separateBy + defaultTitle);
                            $rootScope.$emit('$titleChangeSuccess', stateTitle + separateBy + defaultTitle);
                        }
                        else {
                            element.html(defaultTitle);
                            $rootScope.$emit('$titleChangeSuccess', defaultTitle);
                        }
                    });
                });
            }
        };
    }]);

'use strict';
var appComponents = angular.module("app.components", []);
appComponents.component('changeRequestSubmitted', new Patersons.ChangeRequestSubmittedComponent());
appComponents.component('phoneNotRegistered', new Patersons.PhoneNotRegisteredComponent());
appComponents.component('changePhone', new Patersons.ChangePhoneComponent());
appComponents.component('approversNotRegistered', new Patersons.ApproversNotRegisteredComponent());
appComponents.component('sectionHeader', new Patersons.SectionHeaderComponent());
appComponents.component('spinner', new Patersons.SpinnerComponent());
appComponents.component('accountSelect', new Patersons.AccountSelectComponent());
appComponents.component('actionButton', new Patersons.ActionButtonComponent());
appComponents.component('passwordValidation', new Patersons.PasswordValidationComponent());
appComponents.component('dateSelect', new Patersons.DateSelectComponent());
appComponents.component('morningstarError', new Patersons.MorningstarErrorComponent());
appComponents.component('featuredItem', new Patersons.FeaturedItemComponent());
appComponents.component('feedList', new Patersons.feedListComponent());

"use strict";
var apiGatewayToken = '';
Chart.defaults.LineWithLine = Chart.defaults.line;
Chart.defaults.global.defaultFontFamily = "'Neue Helvetica W01', 'sans-serif'";
Chart.controllers.LineWithLine = Chart.controllers.line.extend({
    draw: function (ease) {
        Chart.controllers.line.prototype.draw.call(this, ease);
        if (this.chart.tooltip._active && this.chart.tooltip._active.length) {
            var activePoint = this.chart.tooltip._active[0], ctx = this.chart.ctx, x = activePoint.tooltipPosition().x, topY = this.chart.legend.bottom, bottomY = this.chart.chartArea.bottom;
            // draw line
            ctx.save();
            ctx.beginPath();
            ctx.moveTo(x, topY);
            ctx.lineTo(x, bottomY);
            ctx.lineWidth = 1;
            ctx.strokeStyle = '#333';
            ctx.setLineDash([5, 5]);
            ctx.stroke();
            ctx.restore();
        }
    }
});
//init css vars ponyfill
function rootMorningstarPromise() {
    return new Promise(function (resolve, reject) {
        loaderConfig.apiTokens.apiGatewayToken = _marketsApiToken;
        console.log('initializing morningstar');
        //loads Morningstar
        morningstar.loader.load(loaderConfig).then(function () {
            resolve(); //returns a promise object
        });
    });
}
function fetchFromObject(obj, prop) {
    //property not found
    if (typeof obj === "undefined")
        return false;
    //index of next property split
    var _index = prop.indexOf(".");
    //property split found; recursive call
    if (_index > -1) {
        //get object at property (before split), pass on remainder
        return fetchFromObject(obj[prop.substring(0, _index)], prop.substr(_index + 1));
    }
    //no split; get property
    return obj[prop];
}
function loadMarketsComponent(elementId, containerId, componentTagName, componentId) {
    var container = document.createElement("div");
    var containerParent = document.getElementById(elementId);
    container.setAttribute("id", containerId);
    containerParent.appendChild(container);
    var marketsComponentSettings = fetchFromObject(loaderConfig.configuration.overrides.components, componentId + ".settings");
    return new Promise(function (resolve, reject) {
        var component = morningstar.components[componentTagName];
        if (component) {
            component.createComponent({
                element: container,
                initialConfiguration: {
                    component: {
                        configuration: marketsComponentSettings,
                        id: containerId,
                        callbacks: marketsComponentSettings.callbacks
                    }
                }
            });
            resolve();
        }
        else {
            reject('Could not find component with tagname in morningstar components: ' + componentTagName);
        }
    });
}
var waitForEle = function (element, callback) {
    var checkExist = setInterval(function () {
        if ($(element).length) {
            clearInterval(checkExist);
            callback();
        }
    }, 1000); // check every 100ms
};
var initComponent = function (elementId, containerId, componentTagName, componentId) {
    var count = 0;
    var maxRetries = 3;
    var init = function (element) {
        var component = morningstar.asterix.instanceRegistry.find(componentId);
        if (component) {
            var path = component.modulePath;
            var componentTag = document.createElement(componentTagName);
            var container = document.createElement('div');
            if (componentId.indexOf('ecWatchList') === -1 && !morningstar.asterix.instanceRegistry.find(componentId).isActive) {
                console.log('Destroying watchlist first..');
                morningstar.asterix.instanceRegistry.get(path).destroy();
            }
            morningstar.asterix.instanceRegistry.init(path);
            componentTag.setAttribute('mstar-component-id', componentId);
            // ... and attach it to the container.
            container.setAttribute('id', containerId);
            container.appendChild(componentTag);
            // Bootstrap the element
            angular.bootstrap(container, morningstar.asterix.ng.getAngularModuleDependencies());
            element.innerHTML = '';
            element.appendChild(container);
        }
        else {
            console.error("Could not find component with ID " + componentId);
        }
    };
    var promiseChain = new Promise(function (resolve) {
        waitForEle('#' + elementId, function () {
            var element = document.getElementById(elementId);
            init(element);
            resolve();
        });
    });
    if (loaderConfig.lazy.initializeMarketsComponent && componentTagName.indexOf('markets-') == 0) {
        promiseChain.then(function () { loadMarketsComponent(elementId, containerId, componentTagName, componentId); });
    }
    return promiseChain;
};
// var morningstarDependencies = morningstar.asterix.ng.getAngularModuleDependencies();
var allDependencies = [
    "ui.router",
    "ui.router.state.events",
    "app.filters",
    "app.services",
    "app.directives",
    "app.components",
    "app.controllers",
    'ui.bootstrap',
    'ui.bootstrap.showErrors',
    'ui.bootstrap.modal',
    'validation.match',
    'app.identityModule',
    'app.portfolioModule',
    'app.analysisModule',
    'app.myDetailsModule',
    'app.researchModule',
    'app.accountDetailsModule',
    'app.changeRequestModule',
    'angular-smart-chartist',
    'ngSanitize',
    'ngCsv',
    'chart.js',
    // 'SALModule',
    'ngRoute',
    'duScroll',
    'ngTagsInput',
    //analytics
    "ApplicationInsightsModule",
    'angulartics',
    'angulartics.google.tagmanager'
];
var module = angular.module("app", allDependencies);
module.config([
    "$provide",
    "$stateProvider",
    "$locationProvider",
    "$httpProvider",
    "applicationInsightsServiceProvider",
    "showErrorsConfigProvider",
    '$compileProvider',
    '$analyticsProvider',
    function ($provide, $stateProvider, $locationProvider, $httpProvider, applicationInsightsServiceProvider, showErrorsConfigProvider, $compileProvider, $analyticsProvider) {
        $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel):/);
        $locationProvider.html5Mode(true);
        $stateProvider
            .state("home", {
            url: "/",
            templateUrl: 'assets/templates/common/loading.html',
            controller: 'landingCtrl'
        })
            .state('help', {
            url: '/help',
            templateUrl: 'assets/templates/common/help.html',
            controller: "helpViewCtrl",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Help" };
                    }],
            }
        })
            .state('forbidden', {
            url: '/forbidden',
            templateUrl: 'assets/templates/common/forbidden.html',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Forbidden" };
                    }],
            }
        })
            .state('error', {
            url: '/error',
            templateUrl: 'assets/templates/common/error.html',
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Error" };
                    }],
            }
        })
            .state("otherwise", {
            url: "*path",
            templateUrl: "assets/templates/common/404.html",
            resolve: {
                meta: ['$rootScope', '$stateParams', function ($rootScope, $stateParams) {
                        $rootScope.meta = { title: "Not Found" };
                    }],
            }
        });
        var model = document.getElementById("model").textContent.trim();
        //var trustedLoginMessage = $sceProvider.trustAsHtml(model['content']['loginMessage']);
        var dictionary = JSON.parse(model);
        var applicationInsightsInstrumentationKey = dictionary['applicationInsightsInstrumentationKey'];
        var options = { applicationName: 'Investor Website', autoPageViewTracking: true, autoLogTracking: false, autoExceptionTracking: true };
        applicationInsightsServiceProvider.configure(applicationInsightsInstrumentationKey, options);
        $provide.decorator("applicationInsightsService", ["tokenService", "$delegate", function myDecorate(tokenService, $delegate) {
                var original = $delegate.trackPageView;
                $delegate.trackPageView = function decoratedWarn(msg) {
                    var propertyInfo = {};
                    propertyInfo.ComponentName = "Investor Website";
                    if (tokenService.tokenManager.profile) {
                        propertyInfo.email = tokenService.tokenManager.profile.email;
                        propertyInfo.account = tokenService.tokenManager.profile.account;
                        //propertyInfo.agaccount = tokenService.tokenManager.profile.agaccount;
                        propertyInfo.auth_time = new Date(tokenService.tokenManager.profile.auth_time * 1000);
                        propertyInfo.given_name = tokenService.tokenManager.profile.given_name;
                        propertyInfo.family_name = tokenService.tokenManager.profile.family_name;
                        propertyInfo.pan = tokenService.tokenManager.profile.preferred_username;
                        propertyInfo.role = tokenService.tokenManager.profile.role;
                        propertyInfo.sub = tokenService.tokenManager.profile.sub;
                        propertyInfo.sid = tokenService.tokenManager.profile.sid;
                    }
                    $delegate.setCommonProperties(propertyInfo);
                    original.apply($delegate, arguments);
                };
                return $delegate;
            }]);
        $provide.decorator("$analytics", ["tokenService", "$delegate", function (tokenService, $delegate) {
                if (tokenService.tokenManager.profile) {
                    $analyticsProvider.settings.ga = {
                        userId: tokenService.tokenManager.profile.preferred_username
                    };
                }
                return $delegate;
            }]);
        $analyticsProvider.excludeRoutes(['/callback', '/forbidden']);
        $analyticsProvider.withBase(false);
        $analyticsProvider.firstPageview(false);
        //handle page tracking manually to work around dynamic titles
        $analyticsProvider.virtualPageviews(false);
        showErrorsConfigProvider.showSuccess(true);
        $httpProvider.interceptors.push('bearerInjector');
    }]);
module.run([
    '$templateCache',
    '$rootScope',
    '$state',
    '$stateParams',
    '$http',
    'tokenService',
    'sessionService',
    '$analytics',
    '$location',
    'userCompanyService',
    function ($templateCache, $rootScope, $state, $stateParams, $http, tokenService, sessionService, $analytics, $location, userCompanyService) {
        console.log("Running App");
        // Allows to retrieve UI Router state information from inside templates
        $rootScope.$state = $state;
        $rootScope.$stateParams = $stateParams;
        $rootScope.$on("$stateChangeError", console.log.bind(console));
        $rootScope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
            $http.pendingRequests.forEach(function (request) {
                var url = request.url;
                var stringsToMatch = [
                    "dataService/api/adviser",
                    "dataService/odata/changeRequests/ChangeRequestService.GetChangeRequestsForApprovalCount",
                    "dataService/api/userCompany",
                    "dataService/api/Reporting/CheckFreezeWindow"
                ];
                var match = false;
                stringsToMatch.forEach(function (string) {
                    if (!match && url.indexOf(string) > -1) {
                        match = true;
                    }
                });
                //Check if the requests are within the nav bar or footer - if so do not cancel them 
                if (!match) {
                    if (request.cancel) {
                        request.cancel.resolve();
                    }
                }
            });
            console.log('destroying sal-report');
            //remove the SAL reports
            $('#sal-report').empty();
            $('#app').removeClass(function (index, className) {
                return (className.match(/(^|\s)page-\S+/g) || []).join(' ');
            });
            $('#app').addClass('page-' + toState.name);
        });
        //only track the page when title is resolved
        $rootScope.$on('$titleChangeSuccess', function (event, route) {
            $analytics.pageTrack($location.path());
        });
        //profit loss class
        $rootScope.getProfitLossClass = function (number) {
            var _class = "";
            var _number = parseFloat(number);
            if (!isNaN(_number)) {
                if (number === 0) {
                    _class = "";
                }
                else if (_number > 0) {
                    _class = "success";
                }
                else {
                    _class = "danger";
                }
            }
            return _class;
        };
    }]);
